var D1 = { exports: {} }, C = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cl;
function Pl() {
  if (cl)
    return C;
  cl = 1;
  var e = Symbol.for("react.element"), o = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), re = Symbol.for("react.provider"), te = Symbol.for("react.context"), oe = Symbol.for("react.forward_ref"), q = Symbol.for("react.suspense"), ne = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), N = Symbol.iterator;
  function ie(c) {
    return c === null || typeof c != "object" ? null : (c = N && c[N] || c["@@iterator"], typeof c == "function" ? c : null);
  }
  var J = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, we = Object.assign, Ee = {};
  function ae(c, m, M) {
    this.props = c, this.context = m, this.refs = Ee, this.updater = M || J;
  }
  ae.prototype.isReactComponent = {}, ae.prototype.setState = function(c, m) {
    if (typeof c != "object" && typeof c != "function" && c != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, c, m, "setState");
  }, ae.prototype.forceUpdate = function(c) {
    this.updater.enqueueForceUpdate(this, c, "forceUpdate");
  };
  function se() {
  }
  se.prototype = ae.prototype;
  function P(c, m, M) {
    this.props = c, this.context = m, this.refs = Ee, this.updater = M || J;
  }
  var ue = P.prototype = new se();
  ue.constructor = P, we(ue, ae.prototype), ue.isPureReactComponent = !0;
  var de = Array.isArray, Z = Object.prototype.hasOwnProperty, K = { current: null }, ve = { key: !0, ref: !0, __self: !0, __source: !0 };
  function pe(c, m, M) {
    var z, y = {}, B = null, A = null;
    if (m != null)
      for (z in m.ref !== void 0 && (A = m.ref), m.key !== void 0 && (B = "" + m.key), m)
        Z.call(m, z) && !ve.hasOwnProperty(z) && (y[z] = m[z]);
    var F = arguments.length - 2;
    if (F === 1)
      y.children = M;
    else if (1 < F) {
      for (var S = Array(F), G = 0; G < F; G++)
        S[G] = arguments[G + 2];
      y.children = S;
    }
    if (c && c.defaultProps)
      for (z in F = c.defaultProps, F)
        y[z] === void 0 && (y[z] = F[z]);
    return { $$typeof: e, type: c, key: B, ref: A, props: y, _owner: K.current };
  }
  function Ce(c, m) {
    return { $$typeof: e, type: c.type, key: m, ref: c.ref, props: c.props, _owner: c._owner };
  }
  function ye(c) {
    return typeof c == "object" && c !== null && c.$$typeof === e;
  }
  function Ze(c) {
    var m = { "=": "=0", ":": "=2" };
    return "$" + c.replace(/[=:]/g, function(M) {
      return m[M];
    });
  }
  var be = /\/+/g;
  function X(c, m) {
    return typeof c == "object" && c !== null && c.key != null ? Ze("" + c.key) : m.toString(36);
  }
  function ee(c, m, M, z, y) {
    var B = typeof c;
    (B === "undefined" || B === "boolean") && (c = null);
    var A = !1;
    if (c === null)
      A = !0;
    else
      switch (B) {
        case "string":
        case "number":
          A = !0;
          break;
        case "object":
          switch (c.$$typeof) {
            case e:
            case o:
              A = !0;
          }
      }
    if (A)
      return A = c, y = y(A), c = z === "" ? "." + X(A, 0) : z, de(y) ? (M = "", c != null && (M = c.replace(be, "$&/") + "/"), ee(y, m, M, "", function(G) {
        return G;
      })) : y != null && (ye(y) && (y = Ce(y, M + (!y.key || A && A.key === y.key ? "" : ("" + y.key).replace(be, "$&/") + "/") + c)), m.push(y)), 1;
    if (A = 0, z = z === "" ? "." : z + ":", de(c))
      for (var F = 0; F < c.length; F++) {
        B = c[F];
        var S = z + X(B, F);
        A += ee(B, m, M, S, y);
      }
    else if (S = ie(c), typeof S == "function")
      for (c = S.call(c), F = 0; !(B = c.next()).done; )
        B = B.value, S = z + X(B, F++), A += ee(B, m, M, S, y);
    else if (B === "object")
      throw m = String(c), Error("Objects are not valid as a React child (found: " + (m === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : m) + "). If you meant to render a collection of children, use an array instead.");
    return A;
  }
  function U(c, m, M) {
    if (c == null)
      return c;
    var z = [], y = 0;
    return ee(c, z, "", "", function(B) {
      return m.call(M, B, y++);
    }), z;
  }
  function ce(c) {
    if (c._status === -1) {
      var m = c._result;
      m = m(), m.then(function(M) {
        (c._status === 0 || c._status === -1) && (c._status = 1, c._result = M);
      }, function(M) {
        (c._status === 0 || c._status === -1) && (c._status = 2, c._result = M);
      }), c._status === -1 && (c._status = 0, c._result = m);
    }
    if (c._status === 1)
      return c._result.default;
    throw c._result;
  }
  var x = { current: null }, fe = { transition: null }, Ve = { ReactCurrentDispatcher: x, ReactCurrentBatchConfig: fe, ReactCurrentOwner: K };
  return C.Children = { map: U, forEach: function(c, m, M) {
    U(c, function() {
      m.apply(this, arguments);
    }, M);
  }, count: function(c) {
    var m = 0;
    return U(c, function() {
      m++;
    }), m;
  }, toArray: function(c) {
    return U(c, function(m) {
      return m;
    }) || [];
  }, only: function(c) {
    if (!ye(c))
      throw Error("React.Children.only expected to receive a single React element child.");
    return c;
  } }, C.Component = ae, C.Fragment = r, C.Profiler = i, C.PureComponent = P, C.StrictMode = n, C.Suspense = q, C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ve, C.cloneElement = function(c, m, M) {
    if (c == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + c + ".");
    var z = we({}, c.props), y = c.key, B = c.ref, A = c._owner;
    if (m != null) {
      if (m.ref !== void 0 && (B = m.ref, A = K.current), m.key !== void 0 && (y = "" + m.key), c.type && c.type.defaultProps)
        var F = c.type.defaultProps;
      for (S in m)
        Z.call(m, S) && !ve.hasOwnProperty(S) && (z[S] = m[S] === void 0 && F !== void 0 ? F[S] : m[S]);
    }
    var S = arguments.length - 2;
    if (S === 1)
      z.children = M;
    else if (1 < S) {
      F = Array(S);
      for (var G = 0; G < S; G++)
        F[G] = arguments[G + 2];
      z.children = F;
    }
    return { $$typeof: e, type: c.type, key: y, ref: B, props: z, _owner: A };
  }, C.createContext = function(c) {
    return c = { $$typeof: te, _currentValue: c, _currentValue2: c, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, c.Provider = { $$typeof: re, _context: c }, c.Consumer = c;
  }, C.createElement = pe, C.createFactory = function(c) {
    var m = pe.bind(null, c);
    return m.type = c, m;
  }, C.createRef = function() {
    return { current: null };
  }, C.forwardRef = function(c) {
    return { $$typeof: oe, render: c };
  }, C.isValidElement = ye, C.lazy = function(c) {
    return { $$typeof: I, _payload: { _status: -1, _result: c }, _init: ce };
  }, C.memo = function(c, m) {
    return { $$typeof: ne, type: c, compare: m === void 0 ? null : m };
  }, C.startTransition = function(c) {
    var m = fe.transition;
    fe.transition = {};
    try {
      c();
    } finally {
      fe.transition = m;
    }
  }, C.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, C.useCallback = function(c, m) {
    return x.current.useCallback(c, m);
  }, C.useContext = function(c) {
    return x.current.useContext(c);
  }, C.useDebugValue = function() {
  }, C.useDeferredValue = function(c) {
    return x.current.useDeferredValue(c);
  }, C.useEffect = function(c, m) {
    return x.current.useEffect(c, m);
  }, C.useId = function() {
    return x.current.useId();
  }, C.useImperativeHandle = function(c, m, M) {
    return x.current.useImperativeHandle(c, m, M);
  }, C.useInsertionEffect = function(c, m) {
    return x.current.useInsertionEffect(c, m);
  }, C.useLayoutEffect = function(c, m) {
    return x.current.useLayoutEffect(c, m);
  }, C.useMemo = function(c, m) {
    return x.current.useMemo(c, m);
  }, C.useReducer = function(c, m, M) {
    return x.current.useReducer(c, m, M);
  }, C.useRef = function(c) {
    return x.current.useRef(c);
  }, C.useState = function(c) {
    return x.current.useState(c);
  }, C.useSyncExternalStore = function(c, m, M) {
    return x.current.useSyncExternalStore(c, m, M);
  }, C.useTransition = function() {
    return x.current.useTransition();
  }, C.version = "18.2.0", C;
}
var Ke = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Ke.exports;
var hl;
function Tl() {
  return hl || (hl = 1, function(e, o) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var r = "18.2.0", n = Symbol.for("react.element"), i = Symbol.for("react.portal"), re = Symbol.for("react.fragment"), te = Symbol.for("react.strict_mode"), oe = Symbol.for("react.profiler"), q = Symbol.for("react.provider"), ne = Symbol.for("react.context"), I = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), ie = Symbol.for("react.suspense_list"), J = Symbol.for("react.memo"), we = Symbol.for("react.lazy"), Ee = Symbol.for("react.offscreen"), ae = Symbol.iterator, se = "@@iterator";
      function P(a) {
        if (a === null || typeof a != "object")
          return null;
        var s = ae && a[ae] || a[se];
        return typeof s == "function" ? s : null;
      }
      var ue = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, de = {
        transition: null
      }, Z = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, K = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, ve = {}, pe = null;
      function Ce(a) {
        pe = a;
      }
      ve.setExtraStackFrame = function(a) {
        pe = a;
      }, ve.getCurrentStack = null, ve.getStackAddendum = function() {
        var a = "";
        pe && (a += pe);
        var s = ve.getCurrentStack;
        return s && (a += s() || ""), a;
      };
      var ye = !1, Ze = !1, be = !1, X = !1, ee = !1, U = {
        ReactCurrentDispatcher: ue,
        ReactCurrentBatchConfig: de,
        ReactCurrentOwner: K
      };
      U.ReactDebugCurrentFrame = ve, U.ReactCurrentActQueue = Z;
      function ce(a) {
        {
          for (var s = arguments.length, h = new Array(s > 1 ? s - 1 : 0), w = 1; w < s; w++)
            h[w - 1] = arguments[w];
          fe("warn", a, h);
        }
      }
      function x(a) {
        {
          for (var s = arguments.length, h = new Array(s > 1 ? s - 1 : 0), w = 1; w < s; w++)
            h[w - 1] = arguments[w];
          fe("error", a, h);
        }
      }
      function fe(a, s, h) {
        {
          var w = U.ReactDebugCurrentFrame, f = w.getStackAddendum();
          f !== "" && (s += "%s", h = h.concat([f]));
          var R = h.map(function(u) {
            return String(u);
          });
          R.unshift("Warning: " + s), Function.prototype.apply.call(console[a], console, R);
        }
      }
      var Ve = {};
      function c(a, s) {
        {
          var h = a.constructor, w = h && (h.displayName || h.name) || "ReactClass", f = w + "." + s;
          if (Ve[f])
            return;
          x("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", s, w), Ve[f] = !0;
        }
      }
      var m = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(a) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(a, s, h) {
          c(a, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(a, s, h, w) {
          c(a, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(a, s, h, w) {
          c(a, "setState");
        }
      }, M = Object.assign, z = {};
      Object.freeze(z);
      function y(a, s, h) {
        this.props = a, this.context = s, this.refs = z, this.updater = h || m;
      }
      y.prototype.isReactComponent = {}, y.prototype.setState = function(a, s) {
        if (typeof a != "object" && typeof a != "function" && a != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, a, s, "setState");
      }, y.prototype.forceUpdate = function(a) {
        this.updater.enqueueForceUpdate(this, a, "forceUpdate");
      };
      {
        var B = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, A = function(a, s) {
          Object.defineProperty(y.prototype, a, {
            get: function() {
              ce("%s(...) is deprecated in plain JavaScript React classes. %s", s[0], s[1]);
            }
          });
        };
        for (var F in B)
          B.hasOwnProperty(F) && A(F, B[F]);
      }
      function S() {
      }
      S.prototype = y.prototype;
      function G(a, s, h) {
        this.props = a, this.context = s, this.refs = z, this.updater = h || m;
      }
      var xe = G.prototype = new S();
      xe.constructor = G, M(xe, y.prototype), xe.isPureReactComponent = !0;
      function g1() {
        var a = {
          current: null
        };
        return Object.seal(a), a;
      }
      var Xe = Array.isArray;
      function _e(a) {
        return Xe(a);
      }
      function u1(a) {
        {
          var s = typeof Symbol == "function" && Symbol.toStringTag, h = s && a[Symbol.toStringTag] || a.constructor.name || "Object";
          return h;
        }
      }
      function Oe(a) {
        try {
          return Le(a), !1;
        } catch {
          return !0;
        }
      }
      function Le(a) {
        return "" + a;
      }
      function ze(a) {
        if (Oe(a))
          return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", u1(a)), Le(a);
      }
      function Je(a, s, h) {
        var w = a.displayName;
        if (w)
          return w;
        var f = s.displayName || s.name || "";
        return f !== "" ? h + "(" + f + ")" : h;
      }
      function Se(a) {
        return a.displayName || "Context";
      }
      function me(a) {
        if (a == null)
          return null;
        if (typeof a.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
          return a.displayName || a.name || null;
        if (typeof a == "string")
          return a;
        switch (a) {
          case re:
            return "Fragment";
          case i:
            return "Portal";
          case oe:
            return "Profiler";
          case te:
            return "StrictMode";
          case N:
            return "Suspense";
          case ie:
            return "SuspenseList";
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case ne:
              var s = a;
              return Se(s) + ".Consumer";
            case q:
              var h = a;
              return Se(h._context) + ".Provider";
            case I:
              return Je(a, a.render, "ForwardRef");
            case J:
              var w = a.displayName || null;
              return w !== null ? w : me(a.type) || "Memo";
            case we: {
              var f = a, R = f._payload, u = f._init;
              try {
                return me(u(R));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var ke = Object.prototype.hasOwnProperty, De = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, e1, l1, Pe;
      Pe = {};
      function We(a) {
        if (ke.call(a, "ref")) {
          var s = Object.getOwnPropertyDescriptor(a, "ref").get;
          if (s && s.isReactWarning)
            return !1;
        }
        return a.ref !== void 0;
      }
      function Re(a) {
        if (ke.call(a, "key")) {
          var s = Object.getOwnPropertyDescriptor(a, "key").get;
          if (s && s.isReactWarning)
            return !1;
        }
        return a.key !== void 0;
      }
      function x1(a, s) {
        var h = function() {
          e1 || (e1 = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: h,
          configurable: !0
        });
      }
      function o1(a, s) {
        var h = function() {
          l1 || (l1 = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: h,
          configurable: !0
        });
      }
      function n1(a) {
        if (typeof a.ref == "string" && K.current && a.__self && K.current.stateNode !== a.__self) {
          var s = me(K.current.type);
          Pe[s] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', s, a.ref), Pe[s] = !0);
        }
      }
      var Fe = function(a, s, h, w, f, R, u) {
        var j = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: a,
          key: s,
          ref: h,
          props: u,
          // Record the component responsible for creating this element.
          _owner: R
        };
        return j._store = {}, Object.defineProperty(j._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(j, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: w
        }), Object.defineProperty(j, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
      };
      function R1(a, s, h) {
        var w, f = {}, R = null, u = null, j = null, V = null;
        if (s != null) {
          We(s) && (u = s.ref, n1(s)), Re(s) && (ze(s.key), R = "" + s.key), j = s.__self === void 0 ? null : s.__self, V = s.__source === void 0 ? null : s.__source;
          for (w in s)
            ke.call(s, w) && !De.hasOwnProperty(w) && (f[w] = s[w]);
        }
        var $ = arguments.length - 2;
        if ($ === 1)
          f.children = h;
        else if ($ > 1) {
          for (var E = Array($), _ = 0; _ < $; _++)
            E[_] = arguments[_ + 2];
          Object.freeze && Object.freeze(E), f.children = E;
        }
        if (a && a.defaultProps) {
          var D = a.defaultProps;
          for (w in D)
            f[w] === void 0 && (f[w] = D[w]);
        }
        if (R || u) {
          var W = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          R && x1(f, W), u && o1(f, W);
        }
        return Fe(a, R, u, j, V, K.current, f);
      }
      function j1(a, s) {
        var h = Fe(a.type, s, a.ref, a._self, a._source, a._owner, a.props);
        return h;
      }
      function M1(a, s, h) {
        if (a == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
        var w, f = M({}, a.props), R = a.key, u = a.ref, j = a._self, V = a._source, $ = a._owner;
        if (s != null) {
          We(s) && (u = s.ref, $ = K.current), Re(s) && (ze(s.key), R = "" + s.key);
          var E;
          a.type && a.type.defaultProps && (E = a.type.defaultProps);
          for (w in s)
            ke.call(s, w) && !De.hasOwnProperty(w) && (s[w] === void 0 && E !== void 0 ? f[w] = E[w] : f[w] = s[w]);
        }
        var _ = arguments.length - 2;
        if (_ === 1)
          f.children = h;
        else if (_ > 1) {
          for (var D = Array(_), W = 0; W < _; W++)
            D[W] = arguments[W + 2];
          f.children = D;
        }
        return Fe(a.type, R, u, j, V, $, f);
      }
      function je(a) {
        return typeof a == "object" && a !== null && a.$$typeof === n;
      }
      var i1 = ".", H1 = ":";
      function C1(a) {
        var s = /[=:]/g, h = {
          "=": "=0",
          ":": "=2"
        }, w = a.replace(s, function(f) {
          return h[f];
        });
        return "$" + w;
      }
      var Te = !1, r1 = /\/+/g;
      function ge(a) {
        return a.replace(r1, "$&/");
      }
      function $e(a, s) {
        return typeof a == "object" && a !== null && a.key != null ? (ze(a.key), C1("" + a.key)) : s.toString(36);
      }
      function Me(a, s, h, w, f) {
        var R = typeof a;
        (R === "undefined" || R === "boolean") && (a = null);
        var u = !1;
        if (a === null)
          u = !0;
        else
          switch (R) {
            case "string":
            case "number":
              u = !0;
              break;
            case "object":
              switch (a.$$typeof) {
                case n:
                case i:
                  u = !0;
              }
          }
        if (u) {
          var j = a, V = f(j), $ = w === "" ? i1 + $e(j, 0) : w;
          if (_e(V)) {
            var E = "";
            $ != null && (E = ge($) + "/"), Me(V, s, E, "", function(Dl) {
              return Dl;
            });
          } else
            V != null && (je(V) && (V.key && (!j || j.key !== V.key) && ze(V.key), V = j1(
              V,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              h + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (V.key && (!j || j.key !== V.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                ge("" + V.key) + "/"
              ) : "") + $
            )), s.push(V));
          return 1;
        }
        var _, D, W = 0, Q = w === "" ? i1 : w + H1;
        if (_e(a))
          for (var p1 = 0; p1 < a.length; p1++)
            _ = a[p1], D = Q + $e(_, p1), W += Me(_, s, h, D, f);
        else {
          var O1 = P(a);
          if (typeof O1 == "function") {
            var al = a;
            O1 === al.entries && (Te || ce("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Te = !0);
            for (var _l = O1.call(al), sl, Ol = 0; !(sl = _l.next()).done; )
              _ = sl.value, D = Q + $e(_, Ol++), W += Me(_, s, h, D, f);
          } else if (R === "object") {
            var dl = String(a);
            throw new Error("Objects are not valid as a React child (found: " + (dl === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : dl) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return W;
      }
      function Be(a, s, h) {
        if (a == null)
          return a;
        var w = [], f = 0;
        return Me(a, w, "", "", function(R) {
          return s.call(h, R, f++);
        }), w;
      }
      function y1(a) {
        var s = 0;
        return Be(a, function() {
          s++;
        }), s;
      }
      function t1(a, s, h) {
        Be(a, function() {
          s.apply(this, arguments);
        }, h);
      }
      function b1(a) {
        return Be(a, function(s) {
          return s;
        }) || [];
      }
      function a1(a) {
        if (!je(a))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return a;
      }
      function s1(a) {
        var s = {
          $$typeof: ne,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: a,
          _currentValue2: a,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        s.Provider = {
          $$typeof: q,
          _context: s
        };
        var h = !1, w = !1, f = !1;
        {
          var R = {
            $$typeof: ne,
            _context: s
          };
          Object.defineProperties(R, {
            Provider: {
              get: function() {
                return w || (w = !0, x("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), s.Provider;
              },
              set: function(u) {
                s.Provider = u;
              }
            },
            _currentValue: {
              get: function() {
                return s._currentValue;
              },
              set: function(u) {
                s._currentValue = u;
              }
            },
            _currentValue2: {
              get: function() {
                return s._currentValue2;
              },
              set: function(u) {
                s._currentValue2 = u;
              }
            },
            _threadCount: {
              get: function() {
                return s._threadCount;
              },
              set: function(u) {
                s._threadCount = u;
              }
            },
            Consumer: {
              get: function() {
                return h || (h = !0, x("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), s.Consumer;
              }
            },
            displayName: {
              get: function() {
                return s.displayName;
              },
              set: function(u) {
                f || (ce("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", u), f = !0);
              }
            }
          }), s.Consumer = R;
        }
        return s._currentRenderer = null, s._currentRenderer2 = null, s;
      }
      var Ae = -1, Ge = 0, Ne = 1, V1 = 2;
      function L1(a) {
        if (a._status === Ae) {
          var s = a._result, h = s();
          if (h.then(function(R) {
            if (a._status === Ge || a._status === Ae) {
              var u = a;
              u._status = Ne, u._result = R;
            }
          }, function(R) {
            if (a._status === Ge || a._status === Ae) {
              var u = a;
              u._status = V1, u._result = R;
            }
          }), a._status === Ae) {
            var w = a;
            w._status = Ge, w._result = h;
          }
        }
        if (a._status === Ne) {
          var f = a._result;
          return f === void 0 && x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, f), "default" in f || x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, f), f.default;
        } else
          throw a._result;
      }
      function z1(a) {
        var s = {
          // We use these fields to store the result.
          _status: Ae,
          _result: a
        }, h = {
          $$typeof: we,
          _payload: s,
          _init: L1
        };
        {
          var w, f;
          Object.defineProperties(h, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return w;
              },
              set: function(R) {
                x("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), w = R, Object.defineProperty(h, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return f;
              },
              set: function(R) {
                x("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), f = R, Object.defineProperty(h, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return h;
      }
      function S1(a) {
        a != null && a.$$typeof === J ? x("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof a != "function" ? x("forwardRef requires a render function but was given %s.", a === null ? "null" : typeof a) : a.length !== 0 && a.length !== 2 && x("forwardRef render functions accept exactly two parameters: props and ref. %s", a.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), a != null && (a.defaultProps != null || a.propTypes != null) && x("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var s = {
          $$typeof: I,
          render: a
        };
        {
          var h;
          Object.defineProperty(s, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return h;
            },
            set: function(w) {
              h = w, !a.name && !a.displayName && (a.displayName = w);
            }
          });
        }
        return s;
      }
      var d;
      d = Symbol.for("react.module.reference");
      function v(a) {
        return !!(typeof a == "string" || typeof a == "function" || a === re || a === oe || ee || a === te || a === N || a === ie || X || a === Ee || ye || Ze || be || typeof a == "object" && a !== null && (a.$$typeof === we || a.$$typeof === J || a.$$typeof === q || a.$$typeof === ne || a.$$typeof === I || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        a.$$typeof === d || a.getModuleId !== void 0));
      }
      function p(a, s) {
        v(a) || x("memo: The first argument must be a component. Instead received: %s", a === null ? "null" : typeof a);
        var h = {
          $$typeof: J,
          type: a,
          compare: s === void 0 ? null : s
        };
        {
          var w;
          Object.defineProperty(h, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return w;
            },
            set: function(f) {
              w = f, !a.name && !a.displayName && (a.displayName = f);
            }
          });
        }
        return h;
      }
      function g() {
        var a = ue.current;
        return a === null && x(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), a;
      }
      function L(a) {
        var s = g();
        if (a._context !== void 0) {
          var h = a._context;
          h.Consumer === a ? x("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : h.Provider === a && x("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return s.useContext(a);
      }
      function k(a) {
        var s = g();
        return s.useState(a);
      }
      function b(a, s, h) {
        var w = g();
        return w.useReducer(a, s, h);
      }
      function H(a) {
        var s = g();
        return s.useRef(a);
      }
      function Y(a, s) {
        var h = g();
        return h.useEffect(a, s);
      }
      function O(a, s) {
        var h = g();
        return h.useInsertionEffect(a, s);
      }
      function T(a, s) {
        var h = g();
        return h.useLayoutEffect(a, s);
      }
      function le(a, s) {
        var h = g();
        return h.useCallback(a, s);
      }
      function He(a, s) {
        var h = g();
        return h.useMemo(a, s);
      }
      function d1(a, s, h) {
        var w = g();
        return w.useImperativeHandle(a, s, h);
      }
      function he(a, s) {
        {
          var h = g();
          return h.useDebugValue(a, s);
        }
      }
      function fl() {
        var a = g();
        return a.useTransition();
      }
      function ml(a) {
        var s = g();
        return s.useDeferredValue(a);
      }
      function pl() {
        var a = g();
        return a.useId();
      }
      function gl(a, s, h) {
        var w = g();
        return w.useSyncExternalStore(a, s, h);
      }
      var Ue = 0, T1, q1, I1, Z1, W1, G1, N1;
      function U1() {
      }
      U1.__reactDisabledLog = !0;
      function ul() {
        {
          if (Ue === 0) {
            T1 = console.log, q1 = console.info, I1 = console.warn, Z1 = console.error, W1 = console.group, G1 = console.groupCollapsed, N1 = console.groupEnd;
            var a = {
              configurable: !0,
              enumerable: !0,
              value: U1,
              writable: !0
            };
            Object.defineProperties(console, {
              info: a,
              log: a,
              warn: a,
              error: a,
              group: a,
              groupCollapsed: a,
              groupEnd: a
            });
          }
          Ue++;
        }
      }
      function xl() {
        {
          if (Ue--, Ue === 0) {
            var a = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: M({}, a, {
                value: T1
              }),
              info: M({}, a, {
                value: q1
              }),
              warn: M({}, a, {
                value: I1
              }),
              error: M({}, a, {
                value: Z1
              }),
              group: M({}, a, {
                value: W1
              }),
              groupCollapsed: M({}, a, {
                value: G1
              }),
              groupEnd: M({}, a, {
                value: N1
              })
            });
          }
          Ue < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var k1 = U.ReactCurrentDispatcher, F1;
      function c1(a, s, h) {
        {
          if (F1 === void 0)
            try {
              throw Error();
            } catch (f) {
              var w = f.stack.trim().match(/\n( *(at )?)/);
              F1 = w && w[1] || "";
            }
          return `
` + F1 + a;
        }
      }
      var $1 = !1, h1;
      {
        var Rl = typeof WeakMap == "function" ? WeakMap : Map;
        h1 = new Rl();
      }
      function Y1(a, s) {
        if (!a || $1)
          return "";
        {
          var h = h1.get(a);
          if (h !== void 0)
            return h;
        }
        var w;
        $1 = !0;
        var f = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var R;
        R = k1.current, k1.current = null, ul();
        try {
          if (s) {
            var u = function() {
              throw Error();
            };
            if (Object.defineProperty(u.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(u, []);
              } catch (Q) {
                w = Q;
              }
              Reflect.construct(a, [], u);
            } else {
              try {
                u.call();
              } catch (Q) {
                w = Q;
              }
              a.call(u.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Q) {
              w = Q;
            }
            a();
          }
        } catch (Q) {
          if (Q && w && typeof Q.stack == "string") {
            for (var j = Q.stack.split(`
`), V = w.stack.split(`
`), $ = j.length - 1, E = V.length - 1; $ >= 1 && E >= 0 && j[$] !== V[E]; )
              E--;
            for (; $ >= 1 && E >= 0; $--, E--)
              if (j[$] !== V[E]) {
                if ($ !== 1 || E !== 1)
                  do
                    if ($--, E--, E < 0 || j[$] !== V[E]) {
                      var _ = `
` + j[$].replace(" at new ", " at ");
                      return a.displayName && _.includes("<anonymous>") && (_ = _.replace("<anonymous>", a.displayName)), typeof a == "function" && h1.set(a, _), _;
                    }
                  while ($ >= 1 && E >= 0);
                break;
              }
          }
        } finally {
          $1 = !1, k1.current = R, xl(), Error.prepareStackTrace = f;
        }
        var D = a ? a.displayName || a.name : "", W = D ? c1(D) : "";
        return typeof a == "function" && h1.set(a, W), W;
      }
      function jl(a, s, h) {
        return Y1(a, !1);
      }
      function Ml(a) {
        var s = a.prototype;
        return !!(s && s.isReactComponent);
      }
      function w1(a, s, h) {
        if (a == null)
          return "";
        if (typeof a == "function")
          return Y1(a, Ml(a));
        if (typeof a == "string")
          return c1(a);
        switch (a) {
          case N:
            return c1("Suspense");
          case ie:
            return c1("SuspenseList");
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case I:
              return jl(a.render);
            case J:
              return w1(a.type, s, h);
            case we: {
              var w = a, f = w._payload, R = w._init;
              try {
                return w1(R(f), s, h);
              } catch {
              }
            }
          }
        return "";
      }
      var Q1 = {}, K1 = U.ReactDebugCurrentFrame;
      function v1(a) {
        if (a) {
          var s = a._owner, h = w1(a.type, a._source, s ? s.type : null);
          K1.setExtraStackFrame(h);
        } else
          K1.setExtraStackFrame(null);
      }
      function Hl(a, s, h, w, f) {
        {
          var R = Function.call.bind(ke);
          for (var u in a)
            if (R(a, u)) {
              var j = void 0;
              try {
                if (typeof a[u] != "function") {
                  var V = Error((w || "React class") + ": " + h + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw V.name = "Invariant Violation", V;
                }
                j = a[u](s, u, w, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch ($) {
                j = $;
              }
              j && !(j instanceof Error) && (v1(f), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", w || "React class", h, u, typeof j), v1(null)), j instanceof Error && !(j.message in Q1) && (Q1[j.message] = !0, v1(f), x("Failed %s type: %s", h, j.message), v1(null));
            }
        }
      }
      function qe(a) {
        if (a) {
          var s = a._owner, h = w1(a.type, a._source, s ? s.type : null);
          Ce(h);
        } else
          Ce(null);
      }
      var B1;
      B1 = !1;
      function X1() {
        if (K.current) {
          var a = me(K.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
      function Cl(a) {
        if (a !== void 0) {
          var s = a.fileName.replace(/^.*[\\\/]/, ""), h = a.lineNumber;
          return `

Check your code at ` + s + ":" + h + ".";
        }
        return "";
      }
      function yl(a) {
        return a != null ? Cl(a.__source) : "";
      }
      var J1 = {};
      function bl(a) {
        var s = X1();
        if (!s) {
          var h = typeof a == "string" ? a : a.displayName || a.name;
          h && (s = `

Check the top-level render call using <` + h + ">.");
        }
        return s;
      }
      function el(a, s) {
        if (!(!a._store || a._store.validated || a.key != null)) {
          a._store.validated = !0;
          var h = bl(s);
          if (!J1[h]) {
            J1[h] = !0;
            var w = "";
            a && a._owner && a._owner !== K.current && (w = " It was passed a child from " + me(a._owner.type) + "."), qe(a), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, w), qe(null);
          }
        }
      }
      function ll(a, s) {
        if (typeof a == "object") {
          if (_e(a))
            for (var h = 0; h < a.length; h++) {
              var w = a[h];
              je(w) && el(w, s);
            }
          else if (je(a))
            a._store && (a._store.validated = !0);
          else if (a) {
            var f = P(a);
            if (typeof f == "function" && f !== a.entries)
              for (var R = f.call(a), u; !(u = R.next()).done; )
                je(u.value) && el(u.value, s);
          }
        }
      }
      function ol(a) {
        {
          var s = a.type;
          if (s == null || typeof s == "string")
            return;
          var h;
          if (typeof s == "function")
            h = s.propTypes;
          else if (typeof s == "object" && (s.$$typeof === I || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          s.$$typeof === J))
            h = s.propTypes;
          else
            return;
          if (h) {
            var w = me(s);
            Hl(h, a.props, "prop", w, a);
          } else if (s.PropTypes !== void 0 && !B1) {
            B1 = !0;
            var f = me(s);
            x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", f || "Unknown");
          }
          typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Vl(a) {
        {
          for (var s = Object.keys(a.props), h = 0; h < s.length; h++) {
            var w = s[h];
            if (w !== "children" && w !== "key") {
              qe(a), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", w), qe(null);
              break;
            }
          }
          a.ref !== null && (qe(a), x("Invalid attribute `ref` supplied to `React.Fragment`."), qe(null));
        }
      }
      function nl(a, s, h) {
        var w = v(a);
        if (!w) {
          var f = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = yl(s);
          R ? f += R : f += X1();
          var u;
          a === null ? u = "null" : _e(a) ? u = "array" : a !== void 0 && a.$$typeof === n ? (u = "<" + (me(a.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : u = typeof a, x("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, f);
        }
        var j = R1.apply(this, arguments);
        if (j == null)
          return j;
        if (w)
          for (var V = 2; V < arguments.length; V++)
            ll(arguments[V], a);
        return a === re ? Vl(j) : ol(j), j;
      }
      var il = !1;
      function Ll(a) {
        var s = nl.bind(null, a);
        return s.type = a, il || (il = !0, ce("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(s, "type", {
          enumerable: !1,
          get: function() {
            return ce("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: a
            }), a;
          }
        }), s;
      }
      function zl(a, s, h) {
        for (var w = M1.apply(this, arguments), f = 2; f < arguments.length; f++)
          ll(arguments[f], w.type);
        return ol(w), w;
      }
      function Sl(a, s) {
        var h = de.transition;
        de.transition = {};
        var w = de.transition;
        de.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          a();
        } finally {
          if (de.transition = h, h === null && w._updatedFibers) {
            var f = w._updatedFibers.size;
            f > 10 && ce("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), w._updatedFibers.clear();
          }
        }
      }
      var rl = !1, f1 = null;
      function kl(a) {
        if (f1 === null)
          try {
            var s = ("require" + Math.random()).slice(0, 7), h = e && e[s];
            f1 = h.call(e, "timers").setImmediate;
          } catch {
            f1 = function(f) {
              rl === !1 && (rl = !0, typeof MessageChannel > "u" && x("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var R = new MessageChannel();
              R.port1.onmessage = f, R.port2.postMessage(void 0);
            };
          }
        return f1(a);
      }
      var Ie = 0, tl = !1;
      function Fl(a) {
        {
          var s = Ie;
          Ie++, Z.current === null && (Z.current = []);
          var h = Z.isBatchingLegacy, w;
          try {
            if (Z.isBatchingLegacy = !0, w = a(), !h && Z.didScheduleLegacyUpdate) {
              var f = Z.current;
              f !== null && (Z.didScheduleLegacyUpdate = !1, _1(f));
            }
          } catch (D) {
            throw m1(s), D;
          } finally {
            Z.isBatchingLegacy = h;
          }
          if (w !== null && typeof w == "object" && typeof w.then == "function") {
            var R = w, u = !1, j = {
              then: function(D, W) {
                u = !0, R.then(function(Q) {
                  m1(s), Ie === 0 ? A1(Q, D, W) : D(Q);
                }, function(Q) {
                  m1(s), W(Q);
                });
              }
            };
            return !tl && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              u || (tl = !0, x("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), j;
          } else {
            var V = w;
            if (m1(s), Ie === 0) {
              var $ = Z.current;
              $ !== null && (_1($), Z.current = null);
              var E = {
                then: function(D, W) {
                  Z.current === null ? (Z.current = [], A1(V, D, W)) : D(V);
                }
              };
              return E;
            } else {
              var _ = {
                then: function(D, W) {
                  D(V);
                }
              };
              return _;
            }
          }
        }
      }
      function m1(a) {
        a !== Ie - 1 && x("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Ie = a;
      }
      function A1(a, s, h) {
        {
          var w = Z.current;
          if (w !== null)
            try {
              _1(w), kl(function() {
                w.length === 0 ? (Z.current = null, s(a)) : A1(a, s, h);
              });
            } catch (f) {
              h(f);
            }
          else
            s(a);
        }
      }
      var E1 = !1;
      function _1(a) {
        if (!E1) {
          E1 = !0;
          var s = 0;
          try {
            for (; s < a.length; s++) {
              var h = a[s];
              do
                h = h(!0);
              while (h !== null);
            }
            a.length = 0;
          } catch (w) {
            throw a = a.slice(s + 1), w;
          } finally {
            E1 = !1;
          }
        }
      }
      var $l = nl, Bl = zl, Al = Ll, El = {
        map: Be,
        forEach: t1,
        count: y1,
        toArray: b1,
        only: a1
      };
      o.Children = El, o.Component = y, o.Fragment = re, o.Profiler = oe, o.PureComponent = G, o.StrictMode = te, o.Suspense = N, o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = U, o.cloneElement = Bl, o.createContext = s1, o.createElement = $l, o.createFactory = Al, o.createRef = g1, o.forwardRef = S1, o.isValidElement = je, o.lazy = z1, o.memo = p, o.startTransition = Sl, o.unstable_act = Fl, o.useCallback = le, o.useContext = L, o.useDebugValue = he, o.useDeferredValue = ml, o.useEffect = Y, o.useId = pl, o.useImperativeHandle = d1, o.useInsertionEffect = O, o.useLayoutEffect = T, o.useMemo = He, o.useReducer = b, o.useRef = H, o.useState = k, o.useSyncExternalStore = gl, o.useTransition = fl, o.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Ke, Ke.exports)), Ke.exports;
}
process.env.NODE_ENV === "production" ? D1.exports = Pl() : D1.exports = Tl();
var t = D1.exports, P1 = { exports: {} }, Ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wl;
function ql() {
  if (wl)
    return Ye;
  wl = 1;
  var e = t, o = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, re = { key: !0, ref: !0, __self: !0, __source: !0 };
  function te(oe, q, ne) {
    var I, N = {}, ie = null, J = null;
    ne !== void 0 && (ie = "" + ne), q.key !== void 0 && (ie = "" + q.key), q.ref !== void 0 && (J = q.ref);
    for (I in q)
      n.call(q, I) && !re.hasOwnProperty(I) && (N[I] = q[I]);
    if (oe && oe.defaultProps)
      for (I in q = oe.defaultProps, q)
        N[I] === void 0 && (N[I] = q[I]);
    return { $$typeof: o, type: oe, key: ie, ref: J, props: N, _owner: i.current };
  }
  return Ye.Fragment = r, Ye.jsx = te, Ye.jsxs = te, Ye;
}
var Qe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vl;
function Il() {
  return vl || (vl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = t, o = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), re = Symbol.for("react.profiler"), te = Symbol.for("react.provider"), oe = Symbol.for("react.context"), q = Symbol.for("react.forward_ref"), ne = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), ie = Symbol.for("react.lazy"), J = Symbol.for("react.offscreen"), we = Symbol.iterator, Ee = "@@iterator";
    function ae(d) {
      if (d === null || typeof d != "object")
        return null;
      var v = we && d[we] || d[Ee];
      return typeof v == "function" ? v : null;
    }
    var se = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(d) {
      {
        for (var v = arguments.length, p = new Array(v > 1 ? v - 1 : 0), g = 1; g < v; g++)
          p[g - 1] = arguments[g];
        ue("error", d, p);
      }
    }
    function ue(d, v, p) {
      {
        var g = se.ReactDebugCurrentFrame, L = g.getStackAddendum();
        L !== "" && (v += "%s", p = p.concat([L]));
        var k = p.map(function(b) {
          return String(b);
        });
        k.unshift("Warning: " + v), Function.prototype.apply.call(console[d], console, k);
      }
    }
    var de = !1, Z = !1, K = !1, ve = !1, pe = !1, Ce;
    Ce = Symbol.for("react.module.reference");
    function ye(d) {
      return !!(typeof d == "string" || typeof d == "function" || d === n || d === re || pe || d === i || d === ne || d === I || ve || d === J || de || Z || K || typeof d == "object" && d !== null && (d.$$typeof === ie || d.$$typeof === N || d.$$typeof === te || d.$$typeof === oe || d.$$typeof === q || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      d.$$typeof === Ce || d.getModuleId !== void 0));
    }
    function Ze(d, v, p) {
      var g = d.displayName;
      if (g)
        return g;
      var L = v.displayName || v.name || "";
      return L !== "" ? p + "(" + L + ")" : p;
    }
    function be(d) {
      return d.displayName || "Context";
    }
    function X(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case re:
          return "Profiler";
        case i:
          return "StrictMode";
        case ne:
          return "Suspense";
        case I:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case oe:
            var v = d;
            return be(v) + ".Consumer";
          case te:
            var p = d;
            return be(p._context) + ".Provider";
          case q:
            return Ze(d, d.render, "ForwardRef");
          case N:
            var g = d.displayName || null;
            return g !== null ? g : X(d.type) || "Memo";
          case ie: {
            var L = d, k = L._payload, b = L._init;
            try {
              return X(b(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, U = 0, ce, x, fe, Ve, c, m, M;
    function z() {
    }
    z.__reactDisabledLog = !0;
    function y() {
      {
        if (U === 0) {
          ce = console.log, x = console.info, fe = console.warn, Ve = console.error, c = console.group, m = console.groupCollapsed, M = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        U++;
      }
    }
    function B() {
      {
        if (U--, U === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, d, {
              value: ce
            }),
            info: ee({}, d, {
              value: x
            }),
            warn: ee({}, d, {
              value: fe
            }),
            error: ee({}, d, {
              value: Ve
            }),
            group: ee({}, d, {
              value: c
            }),
            groupCollapsed: ee({}, d, {
              value: m
            }),
            groupEnd: ee({}, d, {
              value: M
            })
          });
        }
        U < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var A = se.ReactCurrentDispatcher, F;
    function S(d, v, p) {
      {
        if (F === void 0)
          try {
            throw Error();
          } catch (L) {
            var g = L.stack.trim().match(/\n( *(at )?)/);
            F = g && g[1] || "";
          }
        return `
` + F + d;
      }
    }
    var G = !1, xe;
    {
      var g1 = typeof WeakMap == "function" ? WeakMap : Map;
      xe = new g1();
    }
    function Xe(d, v) {
      if (!d || G)
        return "";
      {
        var p = xe.get(d);
        if (p !== void 0)
          return p;
      }
      var g;
      G = !0;
      var L = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = A.current, A.current = null, y();
      try {
        if (v) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (he) {
              g = he;
            }
            Reflect.construct(d, [], b);
          } else {
            try {
              b.call();
            } catch (he) {
              g = he;
            }
            d.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (he) {
            g = he;
          }
          d();
        }
      } catch (he) {
        if (he && g && typeof he.stack == "string") {
          for (var H = he.stack.split(`
`), Y = g.stack.split(`
`), O = H.length - 1, T = Y.length - 1; O >= 1 && T >= 0 && H[O] !== Y[T]; )
            T--;
          for (; O >= 1 && T >= 0; O--, T--)
            if (H[O] !== Y[T]) {
              if (O !== 1 || T !== 1)
                do
                  if (O--, T--, T < 0 || H[O] !== Y[T]) {
                    var le = `
` + H[O].replace(" at new ", " at ");
                    return d.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", d.displayName)), typeof d == "function" && xe.set(d, le), le;
                  }
                while (O >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        G = !1, A.current = k, B(), Error.prepareStackTrace = L;
      }
      var He = d ? d.displayName || d.name : "", d1 = He ? S(He) : "";
      return typeof d == "function" && xe.set(d, d1), d1;
    }
    function _e(d, v, p) {
      return Xe(d, !1);
    }
    function u1(d) {
      var v = d.prototype;
      return !!(v && v.isReactComponent);
    }
    function Oe(d, v, p) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return Xe(d, u1(d));
      if (typeof d == "string")
        return S(d);
      switch (d) {
        case ne:
          return S("Suspense");
        case I:
          return S("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case q:
            return _e(d.render);
          case N:
            return Oe(d.type, v, p);
          case ie: {
            var g = d, L = g._payload, k = g._init;
            try {
              return Oe(k(L), v, p);
            } catch {
            }
          }
        }
      return "";
    }
    var Le = Object.prototype.hasOwnProperty, ze = {}, Je = se.ReactDebugCurrentFrame;
    function Se(d) {
      if (d) {
        var v = d._owner, p = Oe(d.type, d._source, v ? v.type : null);
        Je.setExtraStackFrame(p);
      } else
        Je.setExtraStackFrame(null);
    }
    function me(d, v, p, g, L) {
      {
        var k = Function.call.bind(Le);
        for (var b in d)
          if (k(d, b)) {
            var H = void 0;
            try {
              if (typeof d[b] != "function") {
                var Y = Error((g || "React class") + ": " + p + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Y.name = "Invariant Violation", Y;
              }
              H = d[b](v, b, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              H = O;
            }
            H && !(H instanceof Error) && (Se(L), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, b, typeof H), Se(null)), H instanceof Error && !(H.message in ze) && (ze[H.message] = !0, Se(L), P("Failed %s type: %s", p, H.message), Se(null));
          }
      }
    }
    var ke = Array.isArray;
    function De(d) {
      return ke(d);
    }
    function e1(d) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, p = v && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return p;
      }
    }
    function l1(d) {
      try {
        return Pe(d), !1;
      } catch {
        return !0;
      }
    }
    function Pe(d) {
      return "" + d;
    }
    function We(d) {
      if (l1(d))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", e1(d)), Pe(d);
    }
    var Re = se.ReactCurrentOwner, x1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, o1, n1, Fe;
    Fe = {};
    function R1(d) {
      if (Le.call(d, "ref")) {
        var v = Object.getOwnPropertyDescriptor(d, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return d.ref !== void 0;
    }
    function j1(d) {
      if (Le.call(d, "key")) {
        var v = Object.getOwnPropertyDescriptor(d, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return d.key !== void 0;
    }
    function M1(d, v) {
      if (typeof d.ref == "string" && Re.current && v && Re.current.stateNode !== v) {
        var p = X(Re.current.type);
        Fe[p] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Re.current.type), d.ref), Fe[p] = !0);
      }
    }
    function je(d, v) {
      {
        var p = function() {
          o1 || (o1 = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        p.isReactWarning = !0, Object.defineProperty(d, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function i1(d, v) {
      {
        var p = function() {
          n1 || (n1 = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        p.isReactWarning = !0, Object.defineProperty(d, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var H1 = function(d, v, p, g, L, k, b) {
      var H = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: d,
        key: v,
        ref: p,
        props: b,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return H._store = {}, Object.defineProperty(H._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(H, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(H, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: L
      }), Object.freeze && (Object.freeze(H.props), Object.freeze(H)), H;
    };
    function C1(d, v, p, g, L) {
      {
        var k, b = {}, H = null, Y = null;
        p !== void 0 && (We(p), H = "" + p), j1(v) && (We(v.key), H = "" + v.key), R1(v) && (Y = v.ref, M1(v, L));
        for (k in v)
          Le.call(v, k) && !x1.hasOwnProperty(k) && (b[k] = v[k]);
        if (d && d.defaultProps) {
          var O = d.defaultProps;
          for (k in O)
            b[k] === void 0 && (b[k] = O[k]);
        }
        if (H || Y) {
          var T = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
          H && je(b, T), Y && i1(b, T);
        }
        return H1(d, H, Y, L, g, Re.current, b);
      }
    }
    var Te = se.ReactCurrentOwner, r1 = se.ReactDebugCurrentFrame;
    function ge(d) {
      if (d) {
        var v = d._owner, p = Oe(d.type, d._source, v ? v.type : null);
        r1.setExtraStackFrame(p);
      } else
        r1.setExtraStackFrame(null);
    }
    var $e;
    $e = !1;
    function Me(d) {
      return typeof d == "object" && d !== null && d.$$typeof === o;
    }
    function Be() {
      {
        if (Te.current) {
          var d = X(Te.current.type);
          if (d)
            return `

Check the render method of \`` + d + "`.";
        }
        return "";
      }
    }
    function y1(d) {
      {
        if (d !== void 0) {
          var v = d.fileName.replace(/^.*[\\\/]/, ""), p = d.lineNumber;
          return `

Check your code at ` + v + ":" + p + ".";
        }
        return "";
      }
    }
    var t1 = {};
    function b1(d) {
      {
        var v = Be();
        if (!v) {
          var p = typeof d == "string" ? d : d.displayName || d.name;
          p && (v = `

Check the top-level render call using <` + p + ">.");
        }
        return v;
      }
    }
    function a1(d, v) {
      {
        if (!d._store || d._store.validated || d.key != null)
          return;
        d._store.validated = !0;
        var p = b1(v);
        if (t1[p])
          return;
        t1[p] = !0;
        var g = "";
        d && d._owner && d._owner !== Te.current && (g = " It was passed a child from " + X(d._owner.type) + "."), ge(d), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), ge(null);
      }
    }
    function s1(d, v) {
      {
        if (typeof d != "object")
          return;
        if (De(d))
          for (var p = 0; p < d.length; p++) {
            var g = d[p];
            Me(g) && a1(g, v);
          }
        else if (Me(d))
          d._store && (d._store.validated = !0);
        else if (d) {
          var L = ae(d);
          if (typeof L == "function" && L !== d.entries)
            for (var k = L.call(d), b; !(b = k.next()).done; )
              Me(b.value) && a1(b.value, v);
        }
      }
    }
    function Ae(d) {
      {
        var v = d.type;
        if (v == null || typeof v == "string")
          return;
        var p;
        if (typeof v == "function")
          p = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === q || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === N))
          p = v.propTypes;
        else
          return;
        if (p) {
          var g = X(v);
          me(p, d.props, "prop", g, d);
        } else if (v.PropTypes !== void 0 && !$e) {
          $e = !0;
          var L = X(v);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", L || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ge(d) {
      {
        for (var v = Object.keys(d.props), p = 0; p < v.length; p++) {
          var g = v[p];
          if (g !== "children" && g !== "key") {
            ge(d), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ge(null);
            break;
          }
        }
        d.ref !== null && (ge(d), P("Invalid attribute `ref` supplied to `React.Fragment`."), ge(null));
      }
    }
    function Ne(d, v, p, g, L, k) {
      {
        var b = ye(d);
        if (!b) {
          var H = "";
          (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (H += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Y = y1(L);
          Y ? H += Y : H += Be();
          var O;
          d === null ? O = "null" : De(d) ? O = "array" : d !== void 0 && d.$$typeof === o ? (O = "<" + (X(d.type) || "Unknown") + " />", H = " Did you accidentally export a JSX literal instead of a component?") : O = typeof d, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, H);
        }
        var T = C1(d, v, p, L, k);
        if (T == null)
          return T;
        if (b) {
          var le = v.children;
          if (le !== void 0)
            if (g)
              if (De(le)) {
                for (var He = 0; He < le.length; He++)
                  s1(le[He], d);
                Object.freeze && Object.freeze(le);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              s1(le, d);
        }
        return d === n ? Ge(T) : Ae(T), T;
      }
    }
    function V1(d, v, p) {
      return Ne(d, v, p, !0);
    }
    function L1(d, v, p) {
      return Ne(d, v, p, !1);
    }
    var z1 = L1, S1 = V1;
    Qe.Fragment = n, Qe.jsx = z1, Qe.jsxs = S1;
  }()), Qe;
}
process.env.NODE_ENV === "production" ? P1.exports = ql() : P1.exports = Il();
var l = P1.exports;
const Zl = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.354 4.646 8 2.293 5.647 4.646l.707.708L7.5 4.207v4.504l-3.9 2.252.419-1.566-.966-.258-.862 3.215 3.215.861.26-.966-1.567-.42L8 9.578l3.901 2.252-1.566.42.259.966 3.215-.861-.862-3.215-.966.258.42 1.566-3.9-2.252V4.207l1.146 1.147z"
      }
    )
  }
), Wl = /* @__PURE__ */ t.forwardRef(Zl), Gl = Wl, Nl = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 3a1 1 0 1 1 1.762.648l-1.056.945L2 7.887V9h3v6.239l3-1.2 3 1.2V9h3V7.886L8.849 4.912l.623-.558.019-.02A2 2 0 1 0 6 3h.999Zm3 6H6v4.761l2-.8 2 .8zM3.804 8l4.197-2.423L12.197 8z",
        clipRule: "evenodd"
      }
    )
  }
), Ul = /* @__PURE__ */ t.forwardRef(Nl), Yl = Ul, Ql = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.001 1.072-6 3.464v6.928l6 3.464 6-3.464V4.536zm-.5 12.413-4.5-2.598V5.69l4.5 2.598zm1 0 4.5-2.598V5.69l-4.5 2.598zm4-8.66-4.5 2.598-4.5-2.598 4.5-2.599z",
        clipRule: "evenodd"
      }
    )
  }
), Kl = /* @__PURE__ */ t.forwardRef(Ql), Xl = Kl, Jl = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.3 3.6 8 1.875 5.7 3.6l.6.8 1.2-.9v8.915l-2.674-2.298-.652.758L8 14.164l3.826-3.29-.652-.758-2.674 2.3V3.5l1.2.9z"
      }
    )
  }
), eo = /* @__PURE__ */ t.forwardRef(Jl), lo = eo, oo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a5.97 5.97 0 0 0-3 .803l-.5-.866A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.501.937l-.5.866A5.97 5.97 0 0 0 8 2m0 2a4 4 0 0 0-2 .535l-.5-.866A5 5 0 0 1 8 3c.91 0 1.765.244 2.5.67l-.5.865A4 4 0 0 0 8 4M2.803 5A5.97 5.97 0 0 0 2 8a5.97 5.97 0 0 0 .803 3l-.866.5A6.97 6.97 0 0 1 1 8c0-1.274.341-2.47.937-3.501zM14 8a5.97 5.97 0 0 0-.803-3l.866-.501A6.97 6.97 0 0 1 15 8a6.97 6.97 0 0 1-.937 3.501l-.866-.5A5.97 5.97 0 0 0 14 8M4.535 6A4 4 0 0 0 4 8c0 .73.195 1.412.535 2l-.866.5A5 5 0 0 1 3 8c0-.91.244-1.765.67-2.5zM12 8a4 4 0 0 0-.535-2l.866-.5c.425.735.669 1.59.669 2.5a5 5 0 0 1-.67 2.5l-.865-.5A4 4 0 0 0 12 8M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 3.465A4 4 0 0 0 8 12a4 4 0 0 0 2-.535l.5.866A5 5 0 0 1 8 13a5 5 0 0 1-2.5-.67zm-1 1.732A5.97 5.97 0 0 0 8 14a5.97 5.97 0 0 0 3-.803l.501.866A6.97 6.97 0 0 1 8 15a6.97 6.97 0 0 1-3.501-.937z",
        clipRule: "evenodd"
      }
    )
  }
), no = /* @__PURE__ */ t.forwardRef(oo), io = no, ro = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.5 3.598 8 .423 2.5 3.598l2.815 1.625L4 5.983v1.481L1 5.732v6.35l5.5 3.176v-3.214l1.5.866 1.5-.866v3.214l5.5-3.175v-6.35l-3 1.731V5.982l-1.315-.759zm-8 2.673.815-.47L8 6.773 9.685 5.8l.815.47L8 7.715zm-.5.866v.904l1.5.866v1.982l1 .578V8.58zm3.5 4.33 1-.578V8.908l1.5-.866v-.904L8.5 8.58zM8 5.619l-3.5-2.02L8 1.576l3.5 2.021zm-2.5 7.907L2 11.506V7.464l3.5 2.02zm5-4.041 3.5-2.02v4.04l-3.5 2.021z",
        clipRule: "evenodd"
      }
    )
  }
), to = /* @__PURE__ */ t.forwardRef(ro), ao = to, so = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.938 3.291 8 2.173 6.062 3.29l.5.866L8 3.327l1.438.83zM4.5 5.348l.938-.541-.5-.866L3 5.059v2.238h1V6.214l.938.541.5-.866-.938-.54Zm7 0-.938-.541.5-.866L13 5.059v2.238h-1V6.214l-.938.541-.5-.866.938-.54ZM4 8.596v1.66l1.438.83-.5.865L3 10.833V8.596zm8 0v1.66l-1.438.83.5.865L13 10.833V8.596zm-3.5 3.68v-1.082h-1v1.082l-.938-.541-.5.866L8 13.72l1.938-1.12-.5-.866zm.938-5.737L8 7.369l-1.438-.83-.5.866 1.438.83v1.66h1v-1.66l1.438-.83z"
      }
    )
  }
), co = /* @__PURE__ */ t.forwardRef(so), ho = co, wo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3zm5 2a2 2 0 0 0-2 2c0 .486.293.917.701 1.36q.133.143.266.279l.031.032c.097.1.197.203.285.303.08.092.162.194.229.304h.976c.067-.11.15-.212.23-.304.087-.1.187-.204.284-.303l.03-.032q.134-.136.267-.28C9.707 7.918 10 7.487 10 7a2 2 0 0 0-2-2m.333 5.278h-.666v.126l.262.263h.142l.262-.263zM5 7a3 3 0 0 1 6 0c0 .895-.54 1.575-.966 2.037a16 16 0 0 1-.314.33 7 7 0 0 0-.25.266 1.2 1.2 0 0 0-.137.18v1.005l-.848.849h-.97l-.848-.849V9.814a7 7 0 0 0-.386-.447l-.032-.032a15 15 0 0 1-.283-.298C5.54 8.575 5 7.895 5 7m1.674 2.829v-.002zM8 7.44l-.776-.388-.448.894L8 8.56l1.224-.612-.448-.894z",
        clipRule: "evenodd"
      }
    )
  }
), vo = /* @__PURE__ */ t.forwardRef(wo), fo = vo, mo = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zm-11.646.354L2 7.707V8a6 6 0 0 0 6 6v-1a5 5 0 0 1-5-5v-.293l.647.647.707-.708L2.5 5.793.647 7.646z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.833 10.638V9.154a1 1 0 0 0-.084-.107 6 6 0 0 0-.196-.209l-.025-.025c-.07-.073-.15-.155-.23-.24-.341-.372-.798-.94-.798-1.698a2.5 2.5 0 0 1 5 0c0 .757-.457 1.326-.799 1.697q-.121.13-.229.24l-.025.026a6 6 0 0 0-.196.21 1 1 0 0 0-.084.106v1.484l-.738.737h-.858zM6.5 6.875a1.5 1.5 0 1 1 3 0c0 .348-.21.668-.534 1.02q-.105.113-.212.221l-.024.026c-.078.08-.16.164-.231.247-.071.08-.148.176-.208.28a.86.86 0 0 0-.124.428v1.126l-.152.152h-.03l-.152-.152V9.097a.86.86 0 0 0-.124-.428c-.06-.104-.137-.2-.208-.28a7 7 0 0 0-.23-.247l-.025-.026a12 12 0 0 1-.212-.221c-.324-.352-.534-.672-.534-1.02",
          clipRule: "evenodd"
        }
      )
    ]
  }
), po = /* @__PURE__ */ t.forwardRef(mo), go = po, uo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4.054-2.552c-.21.042-.469.173-.702.406a1.44 1.44 0 0 0-.406.702c-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68ZM8 11a3 3 0 0 0 3-3h1a4 4 0 0 1-4 4zm-2.286.283.503-.86 1 .482-.36.93a4 4 0 0 1-1.143-.552",
        clipRule: "evenodd"
      }
    )
  }
), xo = /* @__PURE__ */ t.forwardRef(uo), Ro = xo, jo = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#3d-move-global_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "M10.354 3.271 8 .918 5.646 3.27l.708.708L7.5 2.832V4.5h1V2.832L9.646 3.98l.707-.708Z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M2.832 7.5 3.98 6.354l-.708-.708L.918 8l2.353 2.354.708-.708L2.832 8.5H4.5v-1zm12.25.5-2.354-2.354-.707.708L13.168 7.5H11.5v1h1.668L12.02 9.646l.707.708zM8 15.082l2.354-2.353-.708-.708L8.5 13.168V11.5h-1v1.668l-1.146-1.146-.708.707z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "3d-move-global_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Mo = /* @__PURE__ */ t.forwardRef(jo), Ho = Mo, Co = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 2h4v4h-1V3.707l-3.646 3.647-.708-.708L13.293 3H11zM8.938 3.291 7 2.173 5.062 3.29l.5.866L7 3.327l1.438.83zM3.5 5.348l.938-.541-.5-.866L2 5.059v2.238h1V6.214l.938.541.5-.866-.938-.54ZM3 8.596v1.66l1.438.83-.5.865L2 10.833V8.596zm8 0v1.66l-1.438.83.5.865L12 10.833V8.596zm-3.5 3.68v-1.082h-1v1.082l-.938-.541-.5.866L7 13.72l1.938-1.12-.5-.866zm0-4.618-1.938-1.12-.5.867 1.438.83v1.66h1z"
      }
    )
  }
), yo = /* @__PURE__ */ t.forwardRef(Co), bo = yo, Vo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.016 7.31c.034-.708.118-1.387.246-2.02a8.4 8.4 0 0 0-1.649.543C2.474 6.359 2 6.984 2 7.5s.474 1.142 1.613 1.667C4.71 9.674 6.261 10 8 10h.293l-.647-.646.708-.708 1.853 1.854-1.853 1.854-.708-.708.647-.646H8c-1.85 0-3.55-.345-4.806-.925C1.981 9.515 1 8.641 1 7.5s.981-2.015 2.194-2.575c.67-.31 1.465-.551 2.342-.71q.171-.549.389-1.02C6.485 1.98 7.359 1 8.5 1s2.015.981 2.575 2.194c.178.384.333.81.463 1.268.458.13.884.286 1.268.463C14.019 5.485 15 6.359 15 7.5c0 1.007-.769 1.806-1.757 2.354l-.486-.874C13.642 8.489 14 7.95 14 7.5c0-.516-.474-1.141-1.613-1.667a7 7 0 0 0-.591-.24C11.928 6.346 12 7.157 12 8c0 1.85-.345 3.55-.925 4.806C10.515 14.019 9.641 15 8.5 15c-.663 0-1.24-.34-1.704-.84-.462-.499-.842-1.19-1.131-1.99l.94-.34c.26.721.582 1.28.925 1.651.342.37.672.519.97.519.516 0 1.142-.474 1.667-1.613C10.674 11.29 11 9.739 11 8c0-.98-.104-1.902-.285-2.715A12.6 12.6 0 0 0 8 5c-.582 0-1.143.037-1.673.104a12 12 0 0 0-.308 2.17l.627-.628.708.708L5.5 9.207 3.646 7.354l.708-.708zm1.817-3.697a7 7 0 0 0-.188.45 14.5 14.5 0 0 1 3.762.141 7 7 0 0 0-.24-.59C9.642 2.473 9.016 2 8.5 2s-1.141.474-1.667 1.613",
        clipRule: "evenodd"
      }
    )
  }
), Lo = /* @__PURE__ */ t.forwardRef(Vo), zo = Lo, So = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zm-11.646.354L2 7.707V8a6 6 0 0 0 6 6v-1a5 5 0 0 1-5-5v-.293l.647.647.707-.708L2.5 5.793.647 7.646z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ko = /* @__PURE__ */ t.forwardRef(So), Fo = ko, $o = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m7 1.226 5.5 3.176-5 2.887v5.773L2 9.887V4.113zM3 9.31V5.268l3.5 2.02v4.042zm7.5-4.907L7 6.422l-3.5-2.02L7 2.382z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m9.5 15.062 5.5-3.175V5.536L9.5 8.71zm1-1.732V9.29L14 7.268v4.041z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Bo = /* @__PURE__ */ t.forwardRef($o), Ao = Bo, Eo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M2.5 6.5a5.5 5.5 0 1 1 9.283 3.992c.305.097.578.207.81.331.236.125.451.276.614.459.165.186.293.429.293.718v1c0 .45-.302.777-.604.992-.315.223-.738.404-1.217.548-.963.289-2.264.46-3.679.46s-2.716-.171-3.68-.46c-.478-.144-.901-.325-1.216-.548-.302-.215-.604-.543-.604-.992v-1c0-.289.128-.532.293-.718.163-.183.378-.334.613-.459a5 5 0 0 1 .811-.33A5.49 5.49 0 0 1 2.5 6.5m2.741 4.76c-.587.122-1.051.279-1.365.446a1.2 1.2 0 0 0-.334.24.2.2 0 0 0-.042.06v.987c.004.012.032.076.182.183.191.135.5.278.926.406C5.455 13.836 6.654 14 8 14s2.545-.164 3.392-.418c.426-.128.735-.27.926-.406.15-.107.178-.17.182-.183v-.988a.2.2 0 0 0-.042-.06 1.2 1.2 0 0 0-.334-.239c-.314-.167-.778-.324-1.365-.447A5.5 5.5 0 0 1 8 12a5.5 5.5 0 0 1-2.759-.74m1.313-6.812c-.21.042-.469.173-.702.406a1.44 1.44 0 0 0-.406.702c-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68ZM8 9.5a3 3 0 0 0 3-3h1a4 4 0 0 1-4 4zm-1.285-.288q.4.19.856.258l-.142.99a4 4 0 0 1-1.144-.345z",
        clipRule: "evenodd"
      }
    )
  }
), _o = /* @__PURE__ */ t.forwardRef(Eo), Oo = _o, Do = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 0 0-1.568 9.75l-.313.95a6 6 0 1 1 7.58-7.58l-.95.312A5 5 0 0 0 8 3M6.054 5.448c-.21.042-.469.173-.702.406a1.44 1.44 0 0 0-.406.702c-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68ZM11 9.05a2.5 2.5 0 0 0-1.371.792l-.91-.525-.5.866.91.525a2.5 2.5 0 0 0 0 1.584l-.91.525.5.866.91-.525A2.5 2.5 0 0 0 11 13.95V15h1v-1.05a2.5 2.5 0 0 0 1.371-.792l.91.525.5-.866-.91-.525a2.5 2.5 0 0 0 0-1.584l.91-.525-.5-.866-.91.525A2.5 2.5 0 0 0 12 9.05V8h-1zm.5.95a1.5 1.5 0 1 0-.001 3 1.5 1.5 0 0 0 .001-3",
        clipRule: "evenodd"
      }
    )
  }
), Po = /* @__PURE__ */ t.forwardRef(Do), To = Po, qo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m5.84 5.854-3-3 .708-.708 3 3zm-9.389-.708 3-3 .707.708-3 3zM8.5 5v5h-1V5zm-3.946 9.87 1.34-5 .966.26-1.34 5zm5.926.26-1.34-5 .966-.26 1.34 5z",
        clipRule: "evenodd"
      }
    )
  }
), Io = /* @__PURE__ */ t.forwardRef(qo), Zo = Io, Wo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4.5h2V5h1.91l.804 3h.403l.803-3h1.58v1h-.812l-.804 3h-.902l.518 1.934V11c0 .424-.332.685-.56.82-.262.154-.607.276-.99.372-.774.194-1.817.308-2.95.308s-2.176-.114-2.95-.308c-.383-.096-.729-.218-.99-.372-.229-.135-.56-.396-.56-.82v-.066L3.75 10H1.848L2.92 6h1.902l.268-1H7zM4.554 7h-.866l-.536 2h.866zm1.303-1-1.323 4.938.034.02c.144.085.384.179.725.264.673.168 1.63.278 2.707.278s2.033-.11 2.707-.278c.34-.085.58-.179.724-.263l.034-.021L10.143 6zm5.675 4.884s0 .002-.005.006zm-7.065 0 .005.006z",
        clipRule: "evenodd"
      }
    )
  }
), Go = /* @__PURE__ */ t.forwardRef(Wo), No = Go, Uo = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.848 5.675h6.304L9.189 13H6.81zm1.304 1L7.578 12h.844l1.426-5.325zm-4.033 5.611c-.108.115-.119.186-.119.214 0 .04.027.172.305.374.267.194.684.39 1.246.562C4.668 13.78 6.24 14 8 14s3.332-.22 4.45-.564c.56-.172.979-.368 1.245-.562.278-.202.305-.335.305-.374 0-.028-.01-.099-.119-.214-.11-.117-.296-.252-.574-.39-.552-.275-1.373-.514-2.386-.677l.158-.987c1.067.17 1.996.432 2.673.769.338.168.637.366.858.6.223.239.39.542.39.899 0 .513-.336.906-.717 1.183-.39.284-.925.52-1.54.71C11.507 14.772 9.831 15 8 15c-1.83 0-3.507-.228-4.743-.608-.615-.19-1.15-.425-1.54-.71-.38-.276-.717-.67-.717-1.182 0-.357.167-.66.39-.898.22-.235.52-.434.858-.601.677-.337 1.606-.598 2.673-.77l.158.988c-1.013.163-1.834.402-2.386.677-.278.138-.464.272-.574.39",
        clipRule: "evenodd"
      }
    )
  }
), Yo = /* @__PURE__ */ t.forwardRef(Uo), Qo = Yo, Ko = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2H2v12h12zM3 3.293V3h.293zm0 1.414v1.586L6.293 3H4.707zM7.707 3 3 7.707v1.586L9.293 3zm3 0L3 10.707v1.586L12.293 3zM13 3.707 3.707 13h1.586L13 5.293zm0 3L6.707 13h1.586L13 8.293zm0 3L9.707 13h1.586L13 11.293zm0 3-.293.293H13z",
        clipRule: "evenodd"
      }
    )
  }
), Xo = /* @__PURE__ */ t.forwardRef(Ko), Jo = Xo, en = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707-4.63-4.63a2 2 0 0 1-2.74-2.74L4.84 5.548a4.002 4.002 0 0 0 1.844 6.232 1.5 1.5 0 1 1-.158 1 5.002 5.002 0 0 1-2.397-7.943L1.646 2.354zm4.68 6.095a1 1 0 0 0 1.225 1.225zM8 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 0 0-1.036.135l-.791-.79a5 5 0 0 1 6.784 3.992l.69-.69.707.707L12 9.707V8a4 4 0 0 0-4-4"
        }
      )
    ]
  }
), ln = /* @__PURE__ */ t.forwardRef(en), on = ln, nn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 0 0-1.315 7.779 1.5 1.5 0 1 1-.16 1A5.002 5.002 0 0 1 8 3a5 5 0 0 1 4.956 4.337l.69-.69.707.707L12 9.707V8a4 4 0 0 0-4-4m0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
        clipRule: "evenodd"
      }
    )
  }
), rn = /* @__PURE__ */ t.forwardRef(nn), tn = rn, an = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 13.062 3.502L13.197 11a6 6 0 1 0-10.394 0l-.865.5A6.97 6.97 0 0 1 1 8m3 0a4 4 0 1 1 7.464 2.002l-.866-.501a3 3 0 1 0-5.197 0l-.865.5A4 4 0 0 1 4 8m3 0a1 1 0 1 1 1.706.708l1.517 5.663-.966.258-.302-1.129H7.043l-.303 1.13-.966-.26 1.518-5.664A1 1 0 0 1 7 8m.999 1.932L7.311 12.5h1.376z",
        clipRule: "evenodd"
      }
    )
  }
), sn = /* @__PURE__ */ t.forwardRef(an), dn = sn, cn = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v3.177h-1V5h-2.809l-1-2H6.809l-1 2H3v7h3.563v1H2V4h3.191z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 6a2 2 0 0 0-1.042 3.707l-.522.853a3 3 0 1 1 4.125-4.125l-.854.523A2 2 0 0 0 8 6m3 5V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
        }
      )
    ]
  }
), hn = /* @__PURE__ */ t.forwardRef(cn), wn = hn, vn = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.293 13 1.354 1.354.707-.708-12-12-.708.708L3.293 4H2v9zm-1-1-1.555-1.555a3 3 0 0 1-4.184-4.184L4.294 5H3v7zM6.277 6.984a2 2 0 0 0 2.74 2.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 4v7.172l-1-1V5h-2.809l-1-2H6.809l-.327.654-.745-.746L6.19 2h3.618l1 2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 8q0 .084-.005.167L7.833 5.005A3 3 0 0 1 11 8"
        }
      )
    ]
  }
), fn = /* @__PURE__ */ t.forwardRef(vn), mn = fn, pn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.191 2h3.618l1 2H14v9H2V4h3.191zm.618 1-1 2H3v7h10V5h-2.809l-1-2zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
), gn = /* @__PURE__ */ t.forwardRef(pn), un = gn, xn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v11H2zm1 1v2h1.216l.536-2zm2.788 0-.536 2h1.964l.536-2zm3 0-.536 2h1.964l.536-2zm3 0-.536 2H13V3zM13 6H3v6h10z",
        clipRule: "evenodd"
      }
    )
  }
), Rn = /* @__PURE__ */ t.forwardRef(xn), jn = Rn, Mn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3.5h1.134l.116.067C3.215 4.123 5.407 5 8 5s4.785-.877 5.75-1.433l.116-.067H15v9h-1.134l-.116-.067C12.785 11.877 10.593 11 8 11s-4.785.877-5.75 1.433l-.116.067H1zm1 1.07v6.86C3.176 10.81 5.401 10 8 10s4.824.81 6 1.43V4.57C12.824 5.19 10.599 6 8 6s-4.824-.81-6-1.43",
        clipRule: "evenodd"
      }
    )
  }
), Hn = /* @__PURE__ */ t.forwardRef(Mn), Cn = Hn, yn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.753 13.623 9H2.377zM4.623 8h6.754L8 4.247zM2.5 12v-1h11v1z",
        clipRule: "evenodd"
      }
    )
  }
), bn = /* @__PURE__ */ t.forwardRef(yn), Vn = bn, Ln = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4H6V3h4zm0 2H6V5h4zm0 2H6V7h4zm5 0h-4V7h4zM5 10H1V9h4zm5 0H6V9h4zm5 0h-4V9h4zM5 12H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4zM5 14H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4z",
        clipRule: "evenodd"
      }
    )
  }
), zn = /* @__PURE__ */ t.forwardRef(Ln), Sn = zn, kn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5H2v3h2v2h1V8h2V5H5V1H4zm7-2V1h1v2h2v3h-2v4h-1V6H9V3zm-1 1v1h3V4zM3 6v1h3V6zm1.5 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m8.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Fn = /* @__PURE__ */ t.forwardRef(kn), $n = Fn, Bn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3.63 15.492 8 8 12.37v-3.5l-6 3.5V3.63l6 3.49zm1 7L13.508 8 9 5.37zM7.515 7.995 3 5.369v5.26z",
        clipRule: "evenodd"
      }
    )
  }
), An = /* @__PURE__ */ t.forwardRef(Bn), En = An, _n = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3.63v3.49l6-3.49v8.74l-6-3.5v3.5L.508 8zM7 5.37 2.492 8 7 10.63zm1.485 2.626L13 10.629V5.37z",
        clipRule: "evenodd"
      }
    )
  }
), On = /* @__PURE__ */ t.forwardRef(_n), Dn = On, Pn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 1h12v6h-1V6h-1v1h-1V2H5v5h4v1H5v5h2v1H2zm2 12v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm0-2h1V2H3zm9-1v1h1V2zm1 2h-1v1h1zm-2 7V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Tn = /* @__PURE__ */ t.forwardRef(Pn), qn = Tn, In = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h10v9H2zm8 8h1v-1h-1zm0-2h1V8h-1zM9 8v3H5V8zm1-1h1V6h-1zm0-2h1V4h-1zM9 4v3H5V4zM4 4H3v1h1zm0 2H3v1h1zm0 2H3v1h1zm0 2H3v1h1zm9 3H4v1h10V5h-1z",
        clipRule: "evenodd"
      }
    )
  }
), Zn = /* @__PURE__ */ t.forwardRef(In), Wn = Zn, Gn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 1h12v13H2zm1 1v1h1V2zm2 0v5h6V2zm7 0v1h1V2zm1 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm-2 1V8H5v5zm-7 0v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3z",
        clipRule: "evenodd"
      }
    )
  }
), Nn = /* @__PURE__ */ t.forwardRef(Gn), Un = Nn, Yn = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 8a5 5 0 1 0-5 5v1a6 6 0 1 1 5.898-7.105l1.248-1.249.708.708L12 9.207z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 5h1.01v1.125H5v3.75h.01V11H4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6.125C6 5.422 6.649 5 7.25 5h1.5C9.351 5 10 5.422 10 6.125v3.75C10 10.578 9.351 11 8.75 11h-1.5C6.649 11 6 10.578 6 9.875zm1.04-.058C7 6.1 7 6.123 7 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067C9 9.9 9 9.877 9 9.875v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 8.75 6h-1.5a.33.33 0 0 0-.21.067",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Qn = /* @__PURE__ */ t.forwardRef(Yn), Kn = Qn, Xn = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM3 4v6h10V4zm4 1h1a1.5 1.5 0 0 1 0 3v1H7zm1 2a.5.5 0 1 0 0-1zM4 5h2.5v1H5v.5h1v1H5V9H4zm7.114 1.098c-.09.049-.114.13-.114.152 0 .095.024.143.3.35l.029.021c.234.175.671.5.671 1.129a1.2 1.2 0 0 1-.636 1.03c-.433.236-.987.218-1.588-.083l.448-.894c.399.2.595.136.662.1.09-.05.114-.131.114-.153 0-.095-.024-.143-.3-.35l-.029-.021c-.234-.175-.671-.5-.671-1.129a1.2 1.2 0 0 1 .636-1.03c.433-.236.987-.218 1.588.083l-.448.894c-.399-.2-.595-.136-.662-.1Z",
        clipRule: "evenodd"
      }
    )
  }
), Jn = /* @__PURE__ */ t.forwardRef(Xn), ei = Jn, li = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0 2h16v11H0zm1 1v9h14V3zm2 7V5h1v2h2V5h1v5H6V8H4v2zm7.5-4a1.5 1.5 0 1 0 .647 2.854l-.5-.5.707-.708.5.5A1.5 1.5 0 0 0 10.5 6m2.086 2.879a2.5 2.5 0 1 0-.707.707l.767.768.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), oi = /* @__PURE__ */ t.forwardRef(li), ni = oi, ii = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm5.367 7H3V4h10v6zM8 11.5l-.134.5h.268zM12 6h-1V5h1zM7.51 9H4.5V8h3.01zM10 9H9V8h1zm2 0h-1V8h1z",
        clipRule: "evenodd"
      }
    )
  }
), ri = /* @__PURE__ */ t.forwardRef(ii), ti = ri, ai = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.708.708-9.285-9.286A3.001 3.001 0 0 0 5 11h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.707L7.293 12H5a4 4 0 0 1-1.44-7.733L1.646 2.354zM15 8a3.99 3.99 0 0 1-1.259 2.913l-.707-.708A3 3 0 0 0 11 5H7.828l-1-1H11a4 4 0 0 1 4 4"
      }
    )
  }
), si = /* @__PURE__ */ t.forwardRef(ai), di = si, ci = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a4 4 0 1 0 0 8h2.293l-1.147 1.146.708.708L9.207 11.5 6.854 9.146l-.708.708L7.293 11H5a3 3 0 0 1 0-6h6a3 3 0 1 1 0 6v1a4 4 0 0 0 0-8z"
      }
    )
  }
), hi = /* @__PURE__ */ t.forwardRef(ci), wi = hi, vi = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0 .645-.122 1.261-.344 1.827l-.792-.79Q12 8.537 12 8zm-2 0q0 .084-.005.167L10 7.172V4a2 2 0 0 0-3.873-.702l-.752-.751A3 3 0 0 1 11 4z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.738 10.445A3 3 0 0 1 5 8V5.707L1.646 2.354l.708-.708 12 12-.708.707-2.482-2.482a5 5 0 0 1-1.612.883L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 6.453 3.16zm-.722-.722L6 6.707V8a2 2 0 0 0 3.016 1.723m-1.588 3.245L7.152 14h1.697l-.275-1.033a5 5 0 0 1-1.146 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), fi = /* @__PURE__ */ t.forwardRef(vi), mi = fi, pi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zm3-2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m-.103 9.999a4 4 0 0 0 .238-.001A4 4 0 0 0 12 8h1a5 5 0 0 1-3.448 4.755L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 3.897 3.999m-.469.969L7.152 14h1.697l-.275-1.033a5 5 0 0 1-1.146 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gi = /* @__PURE__ */ t.forwardRef(pi), ui = gi, xi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 7.713V3.5h1v9h-1V8.287L4 12.37V3.63zM5 5.37 9.508 8 5 10.63z",
        clipRule: "evenodd"
      }
    )
  }
), Ri = /* @__PURE__ */ t.forwardRef(xi), ji = Ri, Mi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3h8v9a2 2 0 1 1-2-2h1V6H6v6a2 2 0 1 1-2-2h1zm0 8H4a1 1 0 1 0 1 1zm1-6h6V4H6zm6 6h-1a1 1 0 1 0 1 1z",
        clipRule: "evenodd"
      }
    )
  }
), Hi = /* @__PURE__ */ t.forwardRef(Mi), Ci = Hi, yi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 12V4h1v8zm5 0V4h1v8z",
        clipRule: "evenodd"
      }
    )
  }
), bi = /* @__PURE__ */ t.forwardRef(yi), Vi = bi, Li = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v10H1zm1 1v8h12V4zm5 1h6v4H7zm1 1v2h4V6z",
        clipRule: "evenodd"
      }
    )
  }
), zi = /* @__PURE__ */ t.forwardRef(Li), Si = zi, ki = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3.63 12.492 8 5 12.37zm1 1.74v5.26L10.508 8z",
        clipRule: "evenodd"
      }
    )
  }
), Fi = /* @__PURE__ */ t.forwardRef(ki), $i = Fi, Bi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 12.5v-9h1v4.213l7-4.084v8.741L5 8.287V12.5zM6.492 8 11 10.63V5.37z",
        clipRule: "evenodd"
      }
    )
  }
), Ai = /* @__PURE__ */ t.forwardRef(Bi), Ei = Ai, _i = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Oi = /* @__PURE__ */ t.forwardRef(_i), Di = Oi, Pi = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707-2.482-2.482c-.7.573-1.56.96-2.5 1.085l.69.69-.708.707L6.293 12H8c.924 0 1.775-.314 2.453-.84L9.016 9.723a2 2 0 0 1-2.74-2.74L4.84 5.548a3.997 3.997 0 0 0 1.044 5.848l-.53.848a4.997 4.997 0 0 1-1.225-7.407L1.646 2.354zm4.68 6.095a1.002 1.002 0 0 0 1.225 1.225z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0 .874-.224 1.696-.619 2.41l-.658-.945a4 4 0 0 0-1.607-4.86l.53-.848A5 5 0 0 1 13 8M8 4c-.358 0-.706.047-1.036.136l-.791-.791a5 5 0 0 1 1.164-.301l-.69-.69.707-.708L9.707 4z"
        }
      )
    ]
  }
), Ti = /* @__PURE__ */ t.forwardRef(Pi), qi = Ti, Ii = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.354 1.646 9.707 4H8a4 4 0 0 0-2.116 7.395l-.53.848a5.001 5.001 0 0 1 1.983-9.2l-.69-.69zM12 8a4 4 0 0 0-1.884-3.395l.53-.848a5.001 5.001 0 0 1-1.983 9.2l.69.69-.707.707L6.293 12H8a4 4 0 0 0 4-4M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Zi = /* @__PURE__ */ t.forwardRef(Ii), Wi = Zi, Gi = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 8a5 5 0 1 1 5 5v1a6 6 0 1 0-5.898-7.105L1.854 5.646l-.708.708L4 9.207z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 5h1.01v1.125H7v3.75h.01V11H6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6.125C8 5.422 8.649 5 9.25 5h1.5c.601 0 1.25.422 1.25 1.125v3.75c0 .703-.649 1.125-1.25 1.125h-1.5C8.649 11 8 10.578 8 9.875zm1.04-.058C9 6.1 9 6.123 9 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067c.04-.033.04-.056.04-.058v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 10.75 6h-1.5a.33.33 0 0 0-.21.067",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ni = /* @__PURE__ */ t.forwardRef(Gi), Ui = Ni, Yi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 13V3h1v10zm-2-2V5h1v6zm4 0V5h1v6zm4 0V5h1v6zm-2-1V6h1v4zM2 9V7h1v2z",
        clipRule: "evenodd"
      }
    )
  }
), Qi = /* @__PURE__ */ t.forwardRef(Yi), Ki = Qi, Xi = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.413v11.174L3.815 10H2V6h1.815zM7 4.587 4.185 7H3v2h1.185L7 11.413zM13 12V4h1v8zm-2-1V5h1v6zm-2-1V6h1v4z",
        clipRule: "evenodd"
      }
    )
  }
), Ji = /* @__PURE__ */ t.forwardRef(Xi), e0 = Ji, l0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2.413v11.174L5.815 10H4V6h1.815zM9 4.587 6.185 7H5v2h1.185L9 11.413zM11 10V6h1v4z",
        clipRule: "evenodd"
      }
    )
  }
), o0 = /* @__PURE__ */ t.forwardRef(l0), n0 = o0, i0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2.413v11.174L4.815 10H3V6h1.815zM8 4.587 5.185 7H4v2h1.185L8 11.413zM12 11V5h1v6zm-2-1V6h1v4z",
        clipRule: "evenodd"
      }
    )
  }
), r0 = /* @__PURE__ */ t.forwardRef(i0), t0 = r0, a0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.413v11.174L3.815 10H2V6h1.815zM7 4.587 4.185 7H3v2h1.185L7 11.413zM10.793 8.5 9.146 6.854l.708-.708L11.5 7.793l1.646-1.647.708.708L12.207 8.5l1.647 1.646-.708.707L11.5 9.207l-1.646 1.646-.708-.707z",
        clipRule: "evenodd"
      }
    )
  }
), s0 = /* @__PURE__ */ t.forwardRef(a0), d0 = s0, c0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708L10 10.707v2.88L5.815 10H4V6h1.293L1.646 2.354zM6.243 6.95 6.185 7H5v2h1.185L9 11.413V9.707z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 2.413v4.759l-1-1V4.587l-.853.731-.71-.709z"
        }
      )
    ]
  }
), h0 = /* @__PURE__ */ t.forwardRef(c0), w0 = h0, v0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2.413v11.174L6.815 10H5V6h1.815zm-1 2.174L7.185 7H6v2h1.185L10 11.413z",
        clipRule: "evenodd"
      }
    )
  }
), f0 = /* @__PURE__ */ t.forwardRef(v0), m0 = f0, p0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12.5v-9h1v9zm3-8.87L13.492 8 6 12.37zm1 1.74v5.26L11.508 8z",
        clipRule: "evenodd"
      }
    )
  }
), g0 = /* @__PURE__ */ t.forwardRef(p0), u0 = g0, x0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 12.5h-1v-9h1zm-3-8.87v8.74L2.508 8zM4.492 8 9 10.63V5.37z",
        clipRule: "evenodd"
      }
    )
  }
), R0 = /* @__PURE__ */ t.forwardRef(x0), j0 = R0, M0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4h8v8H4zm1 1v6h6V5z",
        clipRule: "evenodd"
      }
    )
  }
), H0 = /* @__PURE__ */ t.forwardRef(M0), C0 = H0, y0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708L11.293 12H1V4h2.293L1.646 2.354zM4.293 5H2v6h8.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 5H7.828l-1-1H12v1.691l3-1.5v7.618l-2.224-1.112.448-.894.776.388V5.809l-3 1.5z"
        }
      )
    ]
  }
), b0 = /* @__PURE__ */ t.forwardRef(y0), V0 = b0, L0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4h11v1.691l3-1.5v7.618l-3-1.5V12H1zm1 1v6h9V8.691l3 1.5V5.809l-3 1.5V5z",
        clipRule: "evenodd"
      }
    )
  }
), z0 = /* @__PURE__ */ t.forwardRef(L0), S0 = z0, k0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 1H1v9h1V2h12v8h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 3.254 9.992 5 7 6.745zm1 1.75L8.008 5 8 4.995v.01ZM8 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 10a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3.11 11H5.5v1H3.89l-.25 1H5v1H2.36zm9.78 0H10.5v1h1.61l.25 1H11v1h2.64z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.39 12H6.61l-.75 3h4.28zm-2.25 2 .25-1h1.22l.25 1zm4.36-6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 9a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M3 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), F0 = /* @__PURE__ */ t.forwardRef(k0), $0 = F0, B0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8.5 12V8.5H12v-1H8.5V4h-1v3.5H4v1h3.5V12z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), A0 = /* @__PURE__ */ t.forwardRef(B0), E0 = A0, _0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 7.5V2h1v5.5H14v1H8.5V14h-1V8.5H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), O0 = /* @__PURE__ */ t.forwardRef(_0), D0 = O0, P0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.354 2.354-2 2-.708-.708 2-2zm6-.708 2 2-.707.708-2-2zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 8a5 5 0 1 1 8.504 3.567l.483 1.804-.966.258-.372-1.388A5 5 0 0 1 8 13a5 5 0 0 1-2.646-.757l-.371 1.386-.966-.258.482-1.8A4.99 4.99 0 0 1 3 8m5.408-.408-.702-2.62-.966.259.852 3.177 3.177.852.259-.966z",
        clipRule: "evenodd"
      }
    )
  }
), T0 = /* @__PURE__ */ t.forwardRef(P0), q0 = T0, I0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 7v3.172l-1-1V7a4 4 0 0 0-2.657-3.769L9.1 3.144 8.78 2H7.22L6.9 3.144l-.243.087q-.216.076-.42.177l-.739-.738a5 5 0 0 1 .577-.286L6.46 1h3.078l.386 1.384A5 5 0 0 1 13 7"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.293 13 1.353 1.354.707-.708-12-12-.707.708 2.069 2.068A5 5 0 0 0 3 7v3.382L1.691 13H6a2 2 0 1 0 4 0zM4.449 5.156A4 4 0 0 0 4 7v3.618L3.309 12h7.984zM7 13a1 1 0 1 0 2 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Z0 = /* @__PURE__ */ t.forwardRef(I0), W0 = Z0, G0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.46 1h3.08l.385 1.384A5 5 0 0 1 13 7v3.382L14.31 13H10a2 2 0 0 1-4 0H1.691l1.31-2.618V7a5 5 0 0 1 3.073-4.616zM7 13a1 1 0 1 0 2 0zm.22-11L6.9 3.144l-.244.087A4 4 0 0 0 4 7v3.618L3.31 12h9.381l-.69-1.382V7a4 4 0 0 0-2.658-3.769L9.1 3.144 8.78 2z",
        clipRule: "evenodd"
      }
    )
  }
), N0 = /* @__PURE__ */ t.forwardRef(G0), U0 = N0, Y0 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.641 9.169 8 7.87l-.641 1.3-1.433.208 1.037 1.011-.245 1.428L8 11.142l1.282.674-.245-1.428 1.037-1.01z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 2v1H2v11h12V3h-3V2h-1v1H6V2zM3 4h2v1h1V4h4v1h1V4h2v2H3zm0 3h10v6H3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Q0 = /* @__PURE__ */ t.forwardRef(Y0), K0 = Q0, X0 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3V2h1v1h4V2h1v1h3v11H2V3zm0 1H3v2h10V4h-2v1h-1V4H6v1H5zm8 3H3v6h10z",
        clipRule: "evenodd"
      }
    )
  }
), J0 = /* @__PURE__ */ t.forwardRef(X0), er = J0, lr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.418 4.126a6 6 0 0 0 8.456 8.456zm.708-.708 8.455 8.456a6 6 0 0 0-8.456-8.456ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
        clipRule: "evenodd"
      }
    )
  }
), or = /* @__PURE__ */ t.forwardRef(lr), nr = or, ir = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m7 10.707 4.854-4.853-.707-.708L7 9.293 4.854 7.146l-.708.708z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), rr = /* @__PURE__ */ t.forwardRef(ir), tr = rr, ar = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.646 5.646 8.5 9.793 6.353 7.646l-.707.707L8.5 11.207l4.854-4.854z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m7.646 7.646 2.5-2.5.707.707-2.5 2.5zM6.207 10.5 3.353 7.646l-.707.707L5.5 11.207z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), sr = /* @__PURE__ */ t.forwardRef(ar), dr = sr, cr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.354 4.354 6 12.707 1.646 8.354l.708-.708L6 11.293l7.646-7.647z",
        clipRule: "evenodd"
      }
    )
  }
), hr = /* @__PURE__ */ t.forwardRef(cr), wr = hr, vr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.348 2h5.304l-.268 1H13v11H3V3h2.616zm.536 2H4v9h8V4h-1.884l-.268 1H6.152zm3.464-1H6.652l.268 1h2.16zM11 8H5V7h6zm0 3H5v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), fr = /* @__PURE__ */ t.forwardRef(vr), mr = fr, pr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6.5-4h1v3.616l3.494.937-.259.965L7.5 8.384z",
        clipRule: "evenodd"
      }
    )
  }
), gr = /* @__PURE__ */ t.forwardRef(pr), ur = gr, xr = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.646 5.354 7.293 8l-2.647 2.646.708.708L8 8.707l2.646 2.647.708-.707L8.707 8l2.647-2.646-.707-.708L8 7.293 5.354 4.646z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Rr = /* @__PURE__ */ t.forwardRef(xr), jr = Rr, Mr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.293 8 2.646 3.354l.708-.708L8 7.293l4.646-4.647.708.708L8.707 8l4.647 4.646-.707.708L8 8.707l-4.646 4.647-.708-.707z",
        clipRule: "evenodd"
      }
    )
  }
), Hr = /* @__PURE__ */ t.forwardRef(Mr), Cr = Hr, yr = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-2.756-2.756-.116-.055c-.33.259-.698.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359A6 6 0 0 1 3.42 4.126L1.646 2.354zM4.523 5.23l-.512-.245a5 5 0 0 0-.618 1.067l1.261.864-.072.329a3.5 3.5 0 0 0 0 1.51l.072.33-1.26.863c.161.382.37.74.617 1.067l1.378-.66.25.228c.37.34.815.6 1.305.755l.322.102.117 1.522a5 5 0 0 0 1.234 0l.117-1.522.322-.102a3.5 3.5 0 0 0 1.04-.535l-1.08-1.08a2 2 0 0 1-2.74-2.74L4.524 5.231Zm2.51 2.511A1.001 1.001 0 0 0 8.26 8.966z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.687 9.917q-.116.345-.272.67l-1.97-1.97a3.5 3.5 0 0 0-.027-1.372l-.072-.33 1.26-.863a5 5 0 0 0-.617-1.067l-1.378.66-.25-.228c-.37-.34-.815-.6-1.305-.755l-.322-.102-.117-1.522a5 5 0 0 0-1.234 0l-.108 1.408-.931-.93.101-1.325.372-.074a6 6 0 0 1 2.366 0l.372.074.125 1.633c.397.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926a4.5 4.5 0 0 1 0 1.264l1.352.926-.12.359Z"
        }
      )
    ]
  }
), br = /* @__PURE__ */ t.forwardRef(yr), Vr = br, Lr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.817 2.117a6 6 0 0 1 2.366 0l.372.074.125 1.633c.396.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926a4.5 4.5 0 0 1 0 1.264l1.352.926-.12.359a6 6 0 0 1-1.186 2.05l-.25.283-1.477-.707c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.186-2.05l.25-.283 1.477.707c.33-.259.699-.473 1.095-.633l.125-1.633zm.566.92L7.266 4.56l-.322.102c-.49.155-.935.415-1.306.755l-.249.228-1.378-.66a5 5 0 0 0-.618 1.067l1.26.864-.071.329a3.5 3.5 0 0 0 0 1.51l.072.33-1.26.863c.161.382.37.74.617 1.067l1.378-.66.25.228c.37.34.815.6 1.305.755l.322.102.117 1.522a5 5 0 0 0 1.234 0l.117-1.522.322-.102c.49-.155.935-.415 1.306-.755l.249-.228 1.378.66q.373-.492.618-1.068l-1.26-.863.072-.329a3.5 3.5 0 0 0 0-1.51l-.073-.33 1.26-.863a5 5 0 0 0-.617-1.067l-1.378.66-.25-.228c-.37-.34-.815-.6-1.305-.755l-.322-.102-.117-1.522a5 5 0 0 0-1.234 0ZM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), zr = /* @__PURE__ */ t.forwardRef(Lr), Sr = zr, kr = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.707 2H3v10h8V4.293zM4 11V3h4v2h2v6zm5.293-7L9 3.707V4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 14V5h-1v8H6v1z" })
    ]
  }
), Fr = /* @__PURE__ */ t.forwardRef(kr), $r = Fr, Br = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h10v10H2zm1 1v8h8V3zm10 10V4h1v10H4v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Ar = /* @__PURE__ */ t.forwardRef(Br), Er = Ar, _r = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 2h8v12H6v-2h1v1h6V3H7v1H6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.207 8 8.354 5.146l-.708.708L9.293 7.5H1v1h8.293l-1.647 1.646.708.708z"
        }
      )
    ]
  }
), Or = /* @__PURE__ */ t.forwardRef(_r), Dr = Or, Pr = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#common-error_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "M7.5 5.5V9h1V5.5zm0 4.5v1h1v-1z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M15.707 8 8 .293.293 8 8 15.707zM8 14.293 1.707 8 8 1.707 14.293 8z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "common-error_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Tr = /* @__PURE__ */ t.forwardRef(Pr), qr = Tr, Ir = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 2H2v12h8v-2H9v1H3V3h6v1h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.293 7.5H5v1h8.293l-1.646 1.646.707.708L15.207 8l-2.853-2.854-.707.708z"
        }
      )
    ]
  }
), Zr = /* @__PURE__ */ t.forwardRef(Ir), Wr = Zr, Gr = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707-2.907-2.907C9.894 11.78 8.965 12 8 12c-1.69 0-3.267-.674-4.48-1.455-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3.243-.156.502-.31.773-.453L1.646 2.354zm2.684 4.099a10 10 0 0 0-.976.55c-.931.6-1.62 1.265-1.96 1.705.34.44 1.029 1.104 1.96 1.705C5.178 10.424 6.568 11 8 11c.67 0 1.33-.126 1.959-.334l-.943-.943a2 2 0 0 1-2.74-2.74L5.039 5.746ZM7.034 7.74a1 1 0 0 0 1.225 1.225z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14.935 8.246c-.286.506-.988 1.25-1.925 1.935l-.717-.716c.752-.532 1.31-1.083 1.604-1.465-.34-.44-1.027-1.104-1.96-1.705C10.823 5.576 9.433 5 8 5q-.085 0-.169.003l-.913-.914A7 7 0 0 1 8 4c1.69 0 3.267.674 4.48 1.455 1.2.773 2.117 1.701 2.455 2.299l.14.246z"
        }
      )
    ]
  }
), Nr = /* @__PURE__ */ t.forwardRef(Gr), Ur = Nr, Yr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.103 8c.34.44 1.028 1.104 1.96 1.705C5.177 10.424 6.567 11 8 11s2.822-.576 3.938-1.295c.931-.6 1.62-1.265 1.96-1.705-.34-.44-1.028-1.104-1.96-1.705C10.822 5.576 9.432 5 8 5s-2.822.576-3.938 1.295c-.931.6-1.62 1.265-1.96 1.705ZM3.52 5.455C4.733 4.674 6.31 4 8 4s3.267.674 4.48 1.455c1.2.773 2.117 1.701 2.455 2.299l.14.246-.14.246c-.338.598-1.256 1.526-2.456 2.3C11.267 11.325 9.69 12 8 12s-3.267-.674-4.48-1.455c-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3ZM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Qr = /* @__PURE__ */ t.forwardRef(Yr), Kr = Qr, Xr = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 6H3V5h10zm-2 3H5V8h6zm-2 3H7v-1h2z",
        clipRule: "evenodd"
      }
    )
  }
), Jr = /* @__PURE__ */ t.forwardRef(Xr), et = Jr, lt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-3a1 1 0 0 0-1 1H6a2 2 0 1 1 4 0c0 .466-.119.839-.31 1.146a2.8 2.8 0 0 1-.62.676l-.137.112c-.14.115-.238.196-.319.29-.082.096-.114.172-.114.276V10h-1V8.5c0-.396.156-.695.355-.927a3.6 3.6 0 0 1 .482-.443l.093-.077c.178-.148.314-.278.41-.434C8.932 6.473 9 6.284 9 6a1 1 0 0 0-1-1m-.5 7v-1h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), ot = /* @__PURE__ */ t.forwardRef(lt), nt = ot, it = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4m.5 1v2.616l2.528.678-.259.966L7.5 8.384V5z",
        clipRule: "evenodd"
      }
    )
  }
), rt = /* @__PURE__ */ t.forwardRef(it), tt = rt, at = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 7.707v2.465l-1-1V6.707l-4-4L6.768 3.94l-.707-.707L8 1.292l6.854 6.854-.707.708z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m13 13.707.646.647.708-.708-12-12-.708.708L4.293 5 1.146 8.146l.708.708L3 7.707V14h4v-4h2v4h4zm-3-3V13h2v-.293zm-5-5L8.293 9H6v4H4V6.707z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), st = /* @__PURE__ */ t.forwardRef(at), dt = st, ct = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.293 6.854 6.853-.707.708L13 7.707V14H9v-4H7v4H3V7.707L1.854 8.854l-.708-.708zM4 6.707V13h2V9h4v4h2V6.707l-4-4z",
        clipRule: "evenodd"
      }
    )
  }
), ht = /* @__PURE__ */ t.forwardRef(ct), wt = ht, vt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5-4v1h-1V4zm0 2v6h-1V6z",
        clipRule: "evenodd"
      }
    )
  }
), ft = /* @__PURE__ */ t.forwardRef(vt), mt = ft, pt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 2.5V5h-1V2.5zM5.854 3.646l1.5 1.5-.708.708-1.5-1.5zm5 .708-1.5 1.5-.708-.708 1.5-1.5zM5.268 5.438l.507 1.892 1.088-.31.274.96-1.103.316.528 1.972-4.83 1.294-1.294-4.83zm-.455 2.167-1.45.414.274.962 1.435-.41.265.99-2.897.776-.777-2.898 2.898-.776zm5.92-2.167 4.829 1.294-1.294 4.83-4.83-1.294.529-1.972-1.104-.315.274-.962 1.088.311zm.195 3.133 1.435.41.274-.962-1.45-.414.252-.942 2.898.776-.776 2.898-2.898-.776z",
        clipRule: "evenodd"
      }
    )
  }
), gt = /* @__PURE__ */ t.forwardRef(pt), ut = gt, xt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6h5v2h2V6h5v5H9V9H7v2H2zm4 2H4.5v1H6v1H3V7h3zm4 1v1h3V7h-3v1h1.5v1z",
        clipRule: "evenodd"
      }
    )
  }
), Rt = /* @__PURE__ */ t.forwardRef(xt), jt = Rt, Mt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a3 3 0 0 1 6 0v2h1v7H4V7h1zm0 3v5h6V8zm5-1H6V5a2 2 0 1 1 4 0z",
        clipRule: "evenodd"
      }
    )
  }
), Ht = /* @__PURE__ */ t.forwardRef(Mt), Ct = Ht, yt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 5a3 3 0 0 1 5.94-.6l.01.05V7h-1V4.553A2.001 2.001 0 0 0 9 5v2h1v7H2V7h6zm1 3H3v5h6z",
        clipRule: "evenodd"
      }
    )
  }
), bt = /* @__PURE__ */ t.forwardRef(yt), Vt = bt, Lt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M9 7H4V6h5z",
        clipRule: "evenodd"
      }
    )
  }
), zt = /* @__PURE__ */ t.forwardRef(Lt), St = zt, kt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M6 6V4h1v2h2v1H7v2H6V7H4V6z",
        clipRule: "evenodd"
      }
    )
  }
), Ft = /* @__PURE__ */ t.forwardRef(kt), $t = Ft, Bt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.338-.707.707-4.338-4.338A4.5 4.5 0 0 1 2 6.5",
        clipRule: "evenodd"
      }
    )
  }
), At = /* @__PURE__ */ t.forwardRef(Bt), Et = At, _t = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4H3V3h10zm0 4H3V7h10zm0 4H3v-1h10z",
        clipRule: "evenodd"
      }
    )
  }
), Ot = /* @__PURE__ */ t.forwardRef(_t), Dt = Ot, Pt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Tt = /* @__PURE__ */ t.forwardRef(Pt), qt = Tt, It = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Zt = /* @__PURE__ */ t.forwardRef(It), Wt = Zt, Gt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M.747 1.623 15.242 8 .747 14.377 2.456 8zM3.357 8.5l-1.104 4.123L12.758 8 2.253 3.377 3.357 7.5H8v1z",
        clipRule: "evenodd"
      }
    )
  }
), Nt = /* @__PURE__ */ t.forwardRef(Gt), Ut = Nt, Yt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.175 5.172c1.536-1.536 3.881-1.409 5.471.182l1.646 1.645L10 7v1l3.998-.002L14 4h-1v2.292l-1.646-1.646c-1.925-1.924-4.906-2.161-6.886-.182a5 5 0 0 0 0 7.072l.707-.708a4 4 0 0 1 0-5.656"
      }
    )
  }
), Qt = /* @__PURE__ */ t.forwardRef(Yt), Kt = Qt, Xt = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 3a5 5 0 1 0 1.294 9.83l-.258-.965A4.004 4.004 0 0 1 4 8a4 4 0 1 1 8 0v1.293l-1.646-1.647-.708.708 2.854 2.853 2.854-2.853-.707-.708L13 9.293V8a5 5 0 0 0-5-5"
      }
    )
  }
), Jt = /* @__PURE__ */ t.forwardRef(Xt), ea = Jt, la = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 8a4 4 0 1 1 2.964 3.865l-.258.966A5.005 5.005 0 0 0 13 8 5 5 0 0 0 3 8v1.293L1.354 7.646l-.708.708L3.5 11.207l2.854-2.853-.708-.708L4 9.293z"
      }
    )
  }
), oa = /* @__PURE__ */ t.forwardRef(la), na = oa, ia = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.207 3.5 8.354.646l-.708.708L9.293 3H8a5 5 0 1 0 5 5h-1a4 4 0 1 1-4-4h1.293L7.646 5.646l.708.708z"
      }
    )
  }
), ra = /* @__PURE__ */ t.forwardRef(ia), ta = ra, aa = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 3.5a2.5 2.5 0 1 1 .688 1.722l-2.53 1.582-.53-.848 2.53-1.581A2.5 2.5 0 0 1 9 3.5M3.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 8.5a2.5 2.5 0 1 1 4.915.648l2.23 1.116-.447.894-2.23-1.115A2.5 2.5 0 0 1 1 8.5m10 1.55a2.5 2.5 0 1 0 1 0V7.5h-1zm.5.95a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), sa = /* @__PURE__ */ t.forwardRef(aa), da = sa, ca = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 6H3V5h10zM9 9H3V8h6zm-3 3H3v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), ha = /* @__PURE__ */ t.forwardRef(ca), wa = ha, va = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.37 2.186 4.43 4.889.71-3.538 3.448.835 4.869L8 12.528l-4.372 2.299.835-4.869L.926 6.51l4.888-.71zm0 2.26L6.478 6.714l-3.403.494L5.537 9.61 4.956 13 8 11.399l3.044 1.6-.581-3.39 2.463-2.4-3.404-.495z",
        clipRule: "evenodd"
      }
    )
  }
), fa = /* @__PURE__ */ t.forwardRef(va), ma = fa, pa = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 7.5H4v1h8z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ga = /* @__PURE__ */ t.forwardRef(pa), ua = ga, xa = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 7.5h9v1h-9z",
        clipRule: "evenodd"
      }
    )
  }
), Ra = /* @__PURE__ */ t.forwardRef(xa), ja = Ra, Ma = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13.003 7.996c0 .647-.123 1.265-.346 1.832l-.79-.79a4 4 0 0 0 .001-2.078l.966-.259c.11.414.17.848.17 1.295ZM9.294 4.005 8.06 5.233l.707.707 2.443-2.435L8.354.646l-.708.707 1.65 1.652H8.005c-.645 0-1.261.122-1.827.344l.791.79q.497-.132 1.036-.134h1.29Zm1.158 7.154L4.844 5.551a4 4 0 0 0-.705 3.49l-.966.258a5 5 0 0 1 .96-4.46L1.646 2.355l.707-.708 12 12-.707.708-2.483-2.483a4.98 4.98 0 0 1-3.16 1.125H6.708l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.642h1.292c.923 0 1.772-.313 2.449-.837Z"
      }
    )
  }
), Ha = /* @__PURE__ */ t.forwardRef(Ma), Ca = Ha, ya = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.211 3.505 8.354.646l-.708.707 1.65 1.652H8.005a5 5 0 0 0-4.831 6.294l.966-.258a4 4 0 0 1 3.865-5.036h1.29l-1.647 1.64.706.71 2.858-2.85Zm1.623 3.196a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.642h1.292a4 4 0 0 0 3.865-5.036z"
      }
    )
  }
), ba = /* @__PURE__ */ t.forwardRef(ya), Va = ba, La = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 3H6V2h4v1H9v1.1A5.002 5.002 0 0 1 8 14a5 5 0 0 1-1-9.9zm1 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-.707 3.293a1 1 0 1 0 .966-.26l-.553-2.06-.966.258z",
        clipRule: "evenodd"
      }
    )
  }
), za = /* @__PURE__ */ t.forwardRef(La), Sa = za, ka = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 1h4v2h3v1H3V3h3zm1 2h2V2H7zM5 13V5H4v9h8V5h-1v8z",
        clipRule: "evenodd"
      }
    )
  }
), Fa = /* @__PURE__ */ t.forwardRef(ka), $a = Fa, Ba = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.532 4.464c-1.98-1.98-4.96-1.742-6.886.182L3.001 6.292 3 4H2l.002 3.998L6 8V7l-2.292-.001 1.646-1.645c1.59-1.59 3.935-1.718 5.47-.182a4 4 0 0 1 0 5.656l.708.708a5 5 0 0 0 0-7.072"
      }
    )
  }
), Aa = /* @__PURE__ */ t.forwardRef(Ba), Ea = Aa, _a = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .984 7.357 13.014H.643zM2.357 12.998h11.286L8 3.016zM7.5 10V6.5h1V10zm0 2v-1h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), Oa = /* @__PURE__ */ t.forwardRef(_a), Da = Oa, Pa = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-1.566-1.566A4.3 4.3 0 0 1 10.75 13H4.5a3.5 3.5 0 0 1-.986-6.86c.043-.54.18-1.052.397-1.522L1.646 2.354zM4.68 5.388c-.117.35-.18.723-.18 1.112v.036l.005.428-.422.07A2.5 2.5 0 0 0 4.5 12h6.25q.257 0 .504-.039z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 8.75c0 .962-.32 1.85-.86 2.563l-.715-.716a3.252 3.252 0 0 0-1.797-4.977l-.248-.07-.088-.242A3.502 3.502 0 0 0 6.28 3.451l-.728-.727a4.5 4.5 0 0 1 6.587 2.009A4.25 4.25 0 0 1 15 8.75"
        }
      )
    ]
  }
), Ta = /* @__PURE__ */ t.forwardRef(Pa), qa = Ta, Ia = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a3.5 3.5 0 0 0-3.5 3.5v.036l.005.428-.422.07A2.5 2.5 0 0 0 4.5 12h6.25a3.25 3.25 0 0 0 .877-6.38l-.247-.07-.088-.242A3.5 3.5 0 0 0 8 3M3.514 6.14a4.5 4.5 0 0 1 8.625-1.408A4.251 4.251 0 0 1 10.75 13H4.5a3.5 3.5 0 0 1-.986-6.86",
        clipRule: "evenodd"
      }
    )
  }
), Za = /* @__PURE__ */ t.forwardRef(Ia), Wa = Za, Ga = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M11 2h1v5h-1zM5 9v5H4V9zm6.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 11.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
        clipRule: "evenodd"
      }
    )
  }
), Na = /* @__PURE__ */ t.forwardRef(Ga), Ua = Na, Ya = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 9.793V2h-1v7.793L4.354 6.646l-.708.708L8 11.707l4.354-4.353-.708-.708z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.813 10.87.57 2.13h9.233l.57-2.13.967.26-.77 2.87H2.617l-.769-2.87z"
        }
      )
    ]
  }
), Qa = /* @__PURE__ */ t.forwardRef(Ya), Ka = Qa, Xa = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.708.708L12.293 13H2V3h.293L.646 1.354zM3.293 4H3v1.226l4.176 2.657zM8.54 9.248 8 9.593 3 6.41V12h8.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14 11.172-1-1V6.41l-2.298 1.462-.725-.724L13 5.226V4H6.828l-1-1H14z"
        }
      )
    ]
  }
), Ja = /* @__PURE__ */ t.forwardRef(Xa), es = Ja, ls = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v1.226l5 3.181 5-3.181V4zm10 2.41L8 9.594 3 6.41V12h10z",
        clipRule: "evenodd"
      }
    )
  }
), os = /* @__PURE__ */ t.forwardRef(ls), ns = os, is = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#communication-firewall-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-2H2V2.707L.646 1.354zM3 3.707V5h1.293zM5.293 6H3v1h3.293zm2 2H6v1h2.293zm2 2H8.5v2H10v1h2.293zM7 14h2v-1H7zM5 9V8H3v1z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "m12.828 10-1-1H13V8h-2.172l-1-1H13V6H8.828l-1-1H13V3h-1v1H9V3H7v1h-.172L6 3.172V2h4v1h1V2h3v8z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "communication-firewall-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), rs = /* @__PURE__ */ t.forwardRef(is), ts = rs, as = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h3v1h1V2h4v1h1V2h3v8H8.5v2H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5v-2H2zm5 12h2v-1H7zm5-11v1H9V3H7v1H4V3H3v2h10V3zm1 3H8.5v1H13zm0 2h-2v1h2zm-3 1V8H6v1zM5 9V8H3v1zM3 7h4.5V6H3z",
        clipRule: "evenodd"
      }
    )
  }
), ss = /* @__PURE__ */ t.forwardRef(as), ds = ss, cs = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m13.207 5.5-2.854-2.854-.707.708L11.293 5H2.678l2.045 7.63.966-.26L3.982 6h7.31L9.647 7.646l.707.708z"
      }
    )
  }
), hs = /* @__PURE__ */ t.forwardRef(cs), ws = hs, vs = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "g",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipPath: "url(#communication-isp-off_svg__a)",
          clipRule: "evenodd",
          children: /* @__PURE__ */ l.jsx("path", { d: "m1.354.646 14 14-.708.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-1.025a5 5 0 0 1-4.12-6.889L.645 1.354l.708-.708ZM4.293 5h-.167a4 4 0 0 0 0 2h1.91a8 8 0 0 1-.017-.274zm3 3h-.13L8 10l.008-.002a.2.2 0 0 0 .033-.016.6.6 0 0 0 .15-.145 2.4 2.4 0 0 0 .324-.615zm2.62 2.62a5 5 0 0 1-1.413.355V12H10v1h2.293zm-3.29-.863a5 5 0 0 1-.158-.417A8.4 8.4 0 0 1 6.149 8H4.535a4 4 0 0 0 2.088 1.757M9 14v-1H7v1zm4-8c0 1.17-.402 2.245-1.075 3.097l-.713-.713q.137-.184.253-.384h-.637l-1.83-1.83A13 13 0 0 0 8.962 5H7.828L6.256 3.428q.09-.414.209-.768.072-.218.158-.417a4 4 0 0 0-1.007.545l-.713-.714A5 5 0 0 1 13 6M8 2l.008.002a.2.2 0 0 1 .033.016.6.6 0 0 1 .15.145c.13.165.27.435.395.813.099.296.184.64.25 1.024H7.164c.067-.383.152-.728.25-1.024.127-.378.266-.648.396-.813a.6.6 0 0 1 .15-.145.2.2 0 0 1 .033-.016zm1.964 3a14 14 0 0 1 0 2h1.91a4 4 0 0 0 0-2zm1.5-1a4 4 0 0 0-2.087-1.757q.086.2.158.417c.13.392.237.845.316 1.34h1.614Z" })
        }
      ),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "communication-isp-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), fs = /* @__PURE__ */ t.forwardRef(vs), ms = fs, ps = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a5 5 0 1 1 5.5 4.975V12H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5v-1.025A5 5 0 0 1 3 6m1 0q.001-.519.126-1h1.91a14 14 0 0 0 0 2h-1.91A4 4 0 0 1 4 6m.535 2H6.15c.079.495.185.948.316 1.34q.071.218.158.417A4 4 0 0 1 4.535 8m3.473 1.998L8 10l-.008-.002a.2.2 0 0 1-.033-.016.6.6 0 0 1-.15-.145c-.13-.165-.27-.435-.395-.813A7 7 0 0 1 7.164 8h1.673a7 7 0 0 1-.25 1.024c-.127.378-.266.648-.396.813a.6.6 0 0 1-.15.145.2.2 0 0 1-.033.016M8.96 7H7.04a13 13 0 0 1 0-2h1.92a13 13 0 0 1 0 2M6.15 4H4.535a4 4 0 0 1 2.088-1.757q-.086.2-.158.417c-.13.392-.237.845-.316 1.34Zm1.859-1.998L8 2l-.008.002a.2.2 0 0 0-.033.016.6.6 0 0 0-.15.145c-.13.165-.27.435-.395.813-.099.296-.184.64-.25 1.024h1.673a7 7 0 0 0-.25-1.024c-.127-.378-.266-.648-.396-.813a.6.6 0 0 0-.15-.145.2.2 0 0 0-.033-.016ZM10 6q0-.514-.036-1h1.91a4 4 0 0 1 0 2h-1.91Q10 6.513 10 6m-.623-3.757A4 4 0 0 1 11.465 4H9.85a8.4 8.4 0 0 0-.316-1.34 5 5 0 0 0-.158-.417ZM9.851 8h1.614a4 4 0 0 1-2.088 1.757q.086-.2.158-.417c.13-.392.237-.845.316-1.34M9 14v-1H7v1z",
        clipRule: "evenodd"
      }
    )
  }
), gs = /* @__PURE__ */ t.forwardRef(ps), us = gs, xs = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708-4.63-4.63a2 2 0 0 1-2.74-2.74l-4.63-4.63zm4.68 6.095a1 1 0 0 0 1.225 1.225z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m11.83 9 .761.763C12.853 9.231 13 8.633 13 8a4 4 0 0 0-1.172-2.828l-.707.707A3 3 0 0 1 11.83 9"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 8a5.97 5.97 0 0 1-.942 3.23l-.728-.728c.426-.736.67-1.59.67-2.502 0-1.38-.56-2.63-1.464-3.536l.707-.707A5.98 5.98 0 0 1 15 8M4.393 6.514l-.726-.726A4 4 0 0 0 3 8c0 1.104.448 2.105 1.172 2.828l.707-.707A3 3 0 0 1 4 8c0-.54.143-1.048.393-1.486"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 8c0-1.095.351-2.107.948-2.93l-.714-.715A5.98 5.98 0 0 0 1 8c0 1.657.672 3.157 1.757 4.243l.707-.707A4.98 4.98 0 0 1 2 8"
        }
      )
    ]
  }
), Rs = /* @__PURE__ */ t.forwardRef(xs), js = Rs, Ms = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8c0-1.657.672-3.157 1.757-4.243l.708.707A4.98 4.98 0 0 0 2 8c0 1.38.56 2.63 1.465 3.536l-.708.707A5.98 5.98 0 0 1 1 8m12.243-4.243A5.98 5.98 0 0 1 15 8a5.98 5.98 0 0 1-1.757 4.243l-.707-.707A4.98 4.98 0 0 0 14 8c0-1.38-.559-2.63-1.464-3.536zM3 8c0-1.104.448-2.105 1.172-2.828l.707.707A3 3 0 0 0 4 8c0 .829.335 1.578.879 2.121l-.707.707A4 4 0 0 1 3 8m8.829-2.828A4 4 0 0 1 13 8a4 4 0 0 1-1.171 2.828l-.708-.707A3 3 0 0 0 12.001 8a3 3 0 0 0-.88-2.121l.707-.707ZM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Hs = /* @__PURE__ */ t.forwardRef(Ms), Cs = Hs, ys = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m4.707 5 1.647-1.646-.708-.708L2.793 5.5l2.853 2.854.708-.708L4.707 6h7.311l-1.707 6.37.966.26L13.322 5z"
      }
    )
  }
), bs = /* @__PURE__ */ t.forwardRef(ys), Vs = bs, Ls = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.354.647 3.357 3.358H8.003A4 4 0 0 0 4.139 9.04l-.966.258a5.006 5.006 0 0 1 4.83-6.294h1.294l-1.65-1.652.707-.706ZM8.002 5.5 10.6 10H5.404zM7.136 9h1.732l-.866-1.5zm5.698-2.299a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-3.347-3.357h3.704a4 4 0 0 0 3.865-5.036z",
        clipRule: "evenodd"
      }
    )
  }
), zs = /* @__PURE__ */ t.forwardRef(Ls), Ss = zs, ks = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m6.854 1.854-.708-.708L2.793 4.5l3.353 3.354.708-.708L4.707 5H12V4H4.707zM4 11h7.293L9.146 8.854l.708-.708 3.353 3.354-3.353 3.354-.708-.707L11.293 12H4z"
      }
    )
  }
), Fs = /* @__PURE__ */ t.forwardRef(
  ks
), $s = Fs, Bs = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14.854 6.146 11.5 2.793 8.146 6.146l.708.708L11 4.707V12h1V4.707l2.146 2.147zm-13 3-.708.708L4.5 13.207l3.354-3.353-.708-.708L5 11.293V4H4v7.293z"
      }
    )
  }
), As = /* @__PURE__ */ t.forwardRef(Bs), Es = As, _s = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2.813 5.13 3.383 3h9.233l.57 2.13.967-.26-.77-2.87H2.617l-.769 2.87z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 6.207V14h1V6.207l3.146 3.147.707-.708L8 4.293 3.646 8.646l.708.708z"
        }
      )
    ]
  }
), Os = /* @__PURE__ */ t.forwardRef(_s), Ds = Os, Ps = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.707-3.672-3.671a2 2 0 1 1-1.657-1.657L6.486 7.193a6 6 0 0 0-2.729 1.564L3.05 8.05a7 7 0 0 1 2.635-1.658L4.154 4.861a9 9 0 0 0-2.518 1.775l-.707-.707a10 10 0 0 1 2.479-1.814L1.646 2.354zM8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.243 8.757a6 6 0 0 0-1.969-1.311l-1.39-1.39A6.97 6.97 0 0 1 12.95 8.05zM8 4q-.561 0-1.105.067l-.871-.872Q6.984 3.002 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4"
        }
      )
    ]
  }
), Ts = /* @__PURE__ */ t.forwardRef(Ps), qs = Ts, Is = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a8.97 8.97 0 0 0-6.364 2.636l-.707-.707A9.97 9.97 0 0 1 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4m0 3a5.98 5.98 0 0 0-4.243 1.757L3.05 8.05A6.98 6.98 0 0 1 8 6a6.98 6.98 0 0 1 4.95 2.05l-.707.707A5.98 5.98 0 0 0 8 7m0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Zs = /* @__PURE__ */ t.forwardRef(Is), Ws = Zs, Gs = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.75 1.75 15 7.5l-3.5 2 3 3-2 2-3-3-2 3.5zm1.926 1.926 3.946 9.094 1.66-2.903 3.218 3.219.586-.586-3.219-3.219 2.903-1.659z",
        clipRule: "evenodd"
      }
    )
  }
), Ns = /* @__PURE__ */ t.forwardRef(Gs), Us = Ns, Ys = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2.02V1h1v1.02a6 6 0 0 1 5.48 5.48H15v1h-1.02a6 6 0 0 1-5.48 5.48V15h-1v-1.02A6 6 0 0 1 2.02 8.5H1v-1h1.02A6 6 0 0 1 7.5 2.02m0 1.005A5 5 0 0 0 3.025 7.5H4v1h-.975A5 5 0 0 0 7.5 12.975V12h1v.975A5 5 0 0 0 12.975 8.5H12v-1h.975A5 5 0 0 0 8.5 3.025V4h-1zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Qs = /* @__PURE__ */ t.forwardRef(Ys), Ks = Qs, Xs = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 5.5A.5.5 0 0 0 8 6v1H7v-.5a.5.5 0 0 0-1 0V9H5v-.915A1.5 1.5 0 0 0 4 9.5v1.038c0 .398.158.779.44 1.06L6.84 14h3.66a2.5 2.5 0 0 0 2.5-2.5V7a.5.5 0 0 0-1 0v.5h-1v-1a.5.5 0 0 0-1 0V7H9V6a.5.5 0 0 0-.5-.5m1.264-.308a1.5 1.5 0 0 1 2 .5A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.537V9.5a2.5 2.5 0 0 1 2-2.45V6.5a1.5 1.5 0 0 1 2.236-1.308 1.5 1.5 0 0 1 2.528 0",
        clipRule: "evenodd"
      }
    )
  }
), Js = /* @__PURE__ */ t.forwardRef(Xs), ed = Js, ld = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2.5a1.5 1.5 0 0 1 2.948-.395A1.5 1.5 0 0 1 12 3.5v.085A1.5 1.5 0 0 1 14 5v6.5a3.5 3.5 0 0 1-3.5 3.5H6.408l-.15-.168.375-.332-.374.332-.538-.608-1.214-1.37a529 529 0 0 1-2.046-2.32c-.535-.622-.574-1.495.026-2.095.613-.613 1.393-.48 1.988-.203.082.038.269.132.524.263V4a1.5 1.5 0 0 1 2-1.415V2.5Zm1 5H7V4a.5.5 0 1 0-1 0v6.14l-.73-.378a61 61 0 0 0-1.216-.62c-.448-.208-.692-.163-.86.004-.18.182-.214.456.026.735.191.222 1.136 1.291 2.037 2.31l1.213 1.37.389.439H10.5a2.5 2.5 0 0 0 2.5-2.5V5a.5.5 0 0 0-1 0v2.5h-1v-4a.5.5 0 0 0-1 0v4H9v-5a.5.5 0 1 0-1 0z",
        clipRule: "evenodd"
      }
    )
  }
), od = /* @__PURE__ */ t.forwardRef(ld), nd = od, id = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 1H5v1h1.293L2 6.293V5H1v3h3V7H2.707L7 2.707V4h1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 5.5a1.5 1.5 0 0 1 3 0v1.616l2.147.576A2.5 2.5 0 0 1 15 10.106V12.5a2.5 2.5 0 0 1-2.5 2.5H8.523l-.15-.168a882 882 0 0 1-2.911-3.299c-.535-.62-.575-1.494.025-2.094.614-.613 1.394-.48 1.988-.203.083.038.27.132.525.263zM9.5 5a.5.5 0 0 0-.5.5v5.64l-.73-.378a61 61 0 0 0-1.216-.62c-.449-.208-.692-.163-.86.005-.18.18-.215.455.026.734.244.284 1.716 1.947 2.753 3.119H12.5a1.5 1.5 0 0 0 1.5-1.5v-2.394a1.5 1.5 0 0 0-1.112-1.448L10 7.884V5.5a.5.5 0 0 0-.5-.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
), rd = /* @__PURE__ */ t.forwardRef(id), td = rd, ad = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a.5.5 0 0 0-.5.5V9H5v-.915A1.5 1.5 0 0 0 4 9.5v1.038c0 .398.158.779.44 1.06L6.84 14h3.66a2.5 2.5 0 0 0 2.5-2.5V7a.5.5 0 0 0-1 0v.5h-1v-1a.5.5 0 0 0-1 0V7H9V6a.5.5 0 0 0-1-.001V6.5H7v-3a.5.5 0 0 0-.5-.5M8 4.585V3.5a1.5 1.5 0 1 0-3 0v3.55A2.5 2.5 0 0 0 3 9.5v1.038c0 .664.264 1.299.732 1.768L6.427 15H10.5a3.5 3.5 0 0 0 3.5-3.5V7a1.5 1.5 0 0 0-2.236-1.308 1.5 1.5 0 0 0-2-.5A1.5 1.5 0 0 0 8 4.585",
        clipRule: "evenodd"
      }
    )
  }
), sd = /* @__PURE__ */ t.forwardRef(ad), dd = sd, cd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M12.5 12.5v2h-9v-2m9 0L9.902 8 12.5 3.5m0 9h-9m0 0L6.098 8 3.5 3.5m9 0v-2h-9v2m9 0h-9m2.5 7h4m-3-2h2"
      }
    )
  }
), hd = /* @__PURE__ */ t.forwardRef(cd), wd = hd, vd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M12.5 12.5v2h-9v-2m9 0L9.902 8 12.5 3.5m0 9h-9m0 0L6.098 8 3.5 3.5m9 0v-2h-9v2m9 0h-9m3 3h3m-3 3h3M7.5 8h1"
      }
    )
  }
), fd = /* @__PURE__ */ t.forwardRef(vd), md = fd, pd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M12.5 12.5v2h-9v-2m9 0L9.902 8 12.5 3.5m0 9h-9m0 0L6.098 8 3.5 3.5m9 0v-2h-9v2m9 0h-9m2.5 2h4m-3 2h2"
      }
    )
  }
), gd = /* @__PURE__ */ t.forwardRef(pd), ud = gd, xd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v2.634L10.48 8 13 12.366V15H3v-2.634L5.52 8 3 3.634zm1 2h8V2H4zm7.634 1H4.366l2.31 4-2.31 4h7.268l-2.31-4zM4 14v-1h8v1z",
        clipRule: "evenodd"
      }
    )
  }
), Rd = /* @__PURE__ */ t.forwardRef(xd), jd = Rd, Md = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm1 1v8h8V4zm2 2h4v4H6zm1 1v2h2V7z",
        clipRule: "evenodd"
      }
    )
  }
), Hd = /* @__PURE__ */ t.forwardRef(Md), Cd = Hd, yd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm9 6V7h-2v2zm0-3H9v4h3v2H4V4h8zM7 7H6V6h1zm0 3H6V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), bd = /* @__PURE__ */ t.forwardRef(yd), Vd = bd, Ld = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm6 1H7v2h2zM6 4v3h4V4h2v8H4V4zm1 5v1H6V9zm3 0v1H9V9z",
        clipRule: "evenodd"
      }
    )
  }
), zd = /* @__PURE__ */ t.forwardRef(Ld), Sd = zd, kd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm9 3V4h-2v2zM9 4v3h3v5H4V4zM7 7H6V6h1zm0 3H6V9h1zm3-1v1H9V9z",
        clipRule: "evenodd"
      }
    )
  }
), Fd = /* @__PURE__ */ t.forwardRef(kd), $d = Fd, Bd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm1 4v5h8V4H7v3zm2-3H4v2h2zm4 3H9V6h1zM7 9v1H6V9zm3 1H9V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), Ad = /* @__PURE__ */ t.forwardRef(Bd), Ed = Ad, _d = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm4 9h2v-2H7zm3 0V9H6v3H4V4h8v8zM7 7H6V6h1zm3 0H9V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), Od = /* @__PURE__ */ t.forwardRef(_d), Dd = Od, Pd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm7 9h2v-2h-2zm2-3H9v3H4V4h8zM7 7H6V6h1zm3 0H9V6h1zm-3 3H6V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), Td = /* @__PURE__ */ t.forwardRef(Pd), qd = Td, Id = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm1 7v2h2v-2zm3 2V9H4V4h8v8zm0-5H6V6h1zm3 0H9V6h1zm0 3H9V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), Zd = /* @__PURE__ */ t.forwardRef(Id), Wd = Zd, Gd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm1 4v2h2V7zm0 3h3V6H4V4h8v8H4zm6-3H9V6h1zm0 3H9V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), Nd = /* @__PURE__ */ t.forwardRef(Gd), Ud = Nd, Yd = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 2h7.414L14 4.293v4.414l-1.985 1.985-2.366-.634-.942.942H5.793L5 10.207V8.793l.741-.741L9 7.179v-.972L8.793 6H6.207l-.353.354-.708-.708L5.793 5h3.414l.793.793v3.323l1.717.46L13 8.293V4.707L11.293 3H4.707L3 4.707v6.586L4.707 13h6.586l.853-.854.708.708L11.707 14H4.293L2 11.707V4.293zM9 9.293v-1.08l-2.741.735-.259.26v.585l.207.207h2.086z",
        clipRule: "evenodd"
      }
    )
  }
), Qd = /* @__PURE__ */ t.forwardRef(Yd), Kd = Qd, Xd = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.646 6.354 8.293 8 6.646 9.646l.708.708L9 8.707l1.646 1.647.708-.708L9.707 8l1.647-1.646-.707-.708L9 7.293 7.354 5.646z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 3H3.81L.922 8l2.886 5H14zM2.077 8l2.31-4H13v8H4.387z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Jd = /* @__PURE__ */ t.forwardRef(Xd), e2 = Jd, l2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3h3.5a2.5 2.5 0 0 1 1.76 4.276A3 3 0 0 1 9 13H5zm1 5v4h3a2 2 0 1 0 0-4zm0-1h2.5a1.5 1.5 0 1 0 0-3H6z",
        clipRule: "evenodd"
      }
    )
  }
), o2 = /* @__PURE__ */ t.forwardRef(l2), n2 = o2, i2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h4v4H4.5v4H6v.268l5.5-3.175V6H10V2h4v4h-1.5v1.67L6 11.423V14H2v-4h1.5V6H2zm1 1v2h2V3zm2 8H3v2h2zm6-6V3h2v2z",
        clipRule: "evenodd"
      }
    )
  }
), r2 = /* @__PURE__ */ t.forwardRef(i2), t2 = r2, a2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2h4v12H3v-4h3V6h3zm1 11h2V3h-2zm-1 0V7H7v6zm-3 0v-2H4v2z",
        clipRule: "evenodd"
      }
    )
  }
), s2 = /* @__PURE__ */ t.forwardRef(a2), d2 = s2, c2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h5v5H5v2.05c.98.199 1.751.97 1.95 1.95h2.343L12 8.293l3.207 3.207L12 14.707 9.293 12H6.95A2.5 2.5 0 1 1 4 9.05V7H2zm8.207 9.5L12 13.293l1.793-1.793L12 9.707zM3 3v3h3V3zm1.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), h2 = /* @__PURE__ */ t.forwardRef(c2), w2 = h2, v2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 1h4v4H8.5v2.5h5V11H15v4h-4v-4h1.5V8.5h-4V11H10v4H6v-4h1.5V8.5h-4V11H5v4H1v-4h1.5V7.5h5V5H6zm1 1v2h2V2zM2 12v2h2v-2zm5 0v2h2v-2zm5 0v2h2v-2z",
        clipRule: "evenodd"
      }
    )
  }
), f2 = /* @__PURE__ */ t.forwardRef(v2), m2 = f2, p2 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2H5v1h1.293L2.646 6.646l.708.708L7 3.707V5h1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 6H9v2H6v2H3v4h10zm-1 7h-2V7h2zM7 9h2v4H7zm-1 2v2H4v-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), g2 = /* @__PURE__ */ t.forwardRef(p2), u2 = g2, x2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.214 3.005 1.01 3.77 3.771 1.01a5 5 0 0 0-4.78-4.78Zm-.687-.987a6 6 0 0 1 6.455 6.454l-.047.6-5.527-1.48-1.48-5.527zm-1.566.305 1.63 6.085 6.086 1.63-.26.543a6 6 0 1 1-7.999-7.999zM5.316 3.78a5 5 0 1 0 6.903 6.903L6.776 9.226z",
        clipRule: "evenodd"
      }
    )
  }
), R2 = /* @__PURE__ */ t.forwardRef(x2), j2 = R2, M2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v3H4.5v3H8V7h3v3H8V9H4.5v3H8v-1h3v3H8v-1H3.5V5H2zm7 10v1h1v-1zm0-4v1h1V8zM3 3v1h10V3z",
        clipRule: "evenodd"
      }
    )
  }
), H2 = /* @__PURE__ */ t.forwardRef(M2), C2 = H2, y2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.854 4.854 9.5 10.207l-3-3-4.646 4.647-.708-.707L6.5 5.792l3 3 4.646-4.647.708.708Z",
        clipRule: "evenodd"
      }
    )
  }
), b2 = /* @__PURE__ */ t.forwardRef(y2), V2 = b2, L2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 7h4V6h-2.293l2.646-2.646-.707-.708L10 5.293V3H9zM7 9H3v1h2.293l-2.647 2.646.708.708L6 10.707V13h1z"
      }
    )
  }
), z2 = /* @__PURE__ */ t.forwardRef(L2), S2 = z2, k2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 5V2h-1v3H5v6h2.5v3h1v-3H11V5zM6 10V6h4v4z",
        clipRule: "evenodd"
      }
    )
  }
), F2 = /* @__PURE__ */ t.forwardRef(k2), $2 = F2, B2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.354 5.646 9.207 4.5H11.5V10H10v4h4v-4h-1.5V3.5H9.207l1.146-1.146-.707-.708L7.293 4l2.353 2.354zM11 13v-2h2v2zM6 2H2v4h1.5v6.5h3.293l-1.147 1.146.708.708L8.707 12 6.354 9.646l-.708.708L6.793 11.5H4.5V6H6zM3 5V3h2v2z",
        clipRule: "evenodd"
      }
    )
  }
), A2 = /* @__PURE__ */ t.forwardRef(B2), E2 = A2, _2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h5v5H5v4h4V9h5v5H9v-2H4V7H2zm1 1v3h3V3zm7 7v3h3v-3z",
        clipRule: "evenodd"
      }
    )
  }
), O2 = /* @__PURE__ */ t.forwardRef(_2), D2 = O2, P2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 3H9v1h2.293L8.647 6.646l.707.708L12 4.707V7h1zM3 13h4v-1H4.707l2.647-2.646-.708-.708L4 11.293V9H3z"
      }
    )
  }
), T2 = /* @__PURE__ */ t.forwardRef(P2), q2 = T2, I2 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.652 2H5.348l.268 1H3v4h1V4h1.884l.268 1h3.696l.268-1H12v9H4v-1H3v2h10V3h-2.616zM6.92 4l-.268-1h2.696L9.08 4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.293 9 5.646 7.354l.708-.708L9.208 9.5l-2.854 2.854-.708-.708L7.293 10H2V9z"
        }
      )
    ]
  }
), Z2 = /* @__PURE__ */ t.forwardRef(I2), W2 = Z2, G2 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.002 10.291V8.997h-1v3h3l.001-1H5.711l5.291-5.29V7h1V4H9v1h1.295l-5.293 5.29Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h12v12H2zm1 1v10h10V3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), N2 = /* @__PURE__ */ t.forwardRef(G2), U2 = N2, Y2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2H2v4h2.018l.804 3H7.5v1H6v4h4v-4H8.5V9h2.678l.804-3H14V2h-4v4h.947l-.536 2H5.59l-.536-2H6zM3 5V3h2v2zm8 0V3h2v2zm-4 8v-2h2v2z",
        clipRule: "evenodd"
      }
    )
  }
), Q2 = /* @__PURE__ */ t.forwardRef(Y2), K2 = Q2, X2 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.736 5.53.006.005-.707.707c-.528-.528-1.482-1.482-2.388-2.215-.456-.37-.874-.661-1.202-.818a1.4 1.4 0 0 0-.27-.102q.007.03.02.071.088.285.443.794c.472.67 1.202 1.482 1.966 2.322l.104.115c.716.79 1.45 1.598 1.95 2.28.26.354.483.71.6 1.035.11.306.185.768-.161 1.114-.317.317-.738.304-1.054.226-.322-.08-.671-.257-1.014-.468-.693-.424-1.503-1.077-2.273-1.715l-.475-.395c-.608-.506-1.175-.98-1.65-1.326a7 7 0 0 0-.377-.26 4 4 0 0 0 .096.179c.272.48.696 1.075 1.143 1.701l.012.017c.433.606.887 1.242 1.188 1.773.15.266.28.539.344.79.058.224.102.607-.183.893-.245.244-.567.275-.811.254a2.8 2.8 0 0 1-.77-.21c-.513-.208-1.106-.549-1.656-.883-.215-.13-.422-.26-.619-.382l-.355-.22.192.257.01.014c.258.343.534.711.723 1.018.094.153.185.32.237.481.026.08.052.188.048.306a.63.63 0 0 1-.182.426.72.72 0 0 1-.56.201 1.3 1.3 0 0 1-.414-.104 5.5 5.5 0 0 1-.677-.364L4 13.034q-.207-.126-.367-.214.03.135.083.29a6 6 0 0 0 .276.674l.005.01v.002l-.446.223-.448.224v-.002l-.003-.004-.007-.014a4 4 0 0 1-.105-.229 7 7 0 0 1-.221-.568 3.2 3.2 0 0 1-.162-.704c-.018-.203-.02-.565.239-.824a.72.72 0 0 1 .56-.202c.154.009.3.057.414.104.167.069.347.17.514.267l-.297-.399-.011-.014c-.257-.343-.533-.711-.722-1.018a2.4 2.4 0 0 1-.238-.481.9.9 0 0 1-.048-.306.63.63 0 0 1 .181-.426.63.63 0 0 1 .501-.17c.115.009.225.043.312.076.18.068.39.179.606.301.272.156.598.358.936.568.194.12.391.243.585.36.55.335 1.081.637 1.511.812q.238.095.385.124a3 3 0 0 0-.211-.433c-.271-.48-.695-1.074-1.143-1.7l-.012-.018C6.234 8.737 5.78 8.101 5.48 7.57c-.15-.265-.282-.538-.345-.789-.057-.225-.102-.608.183-.893a.73.73 0 0 1 .57-.203c.162.01.317.064.449.122.266.117.571.316.884.544.503.368 1.105.87 1.715 1.378l.458.381c.777.644 1.535 1.25 2.158 1.633.314.193.559.306.732.349l.047.01-.014-.04q-.099-.281-.466-.783c-.467-.639-1.17-1.412-1.904-2.221l-.084-.092c-.75-.827-1.528-1.689-2.043-2.42-.254-.362-.471-.729-.579-1.068-.104-.332-.143-.784.199-1.126a.93.93 0 0 1 .75-.254c.235.02.471.104.688.208.436.209.926.56 1.398.943.95.768 1.936 1.755 2.46 2.28Zm-.386 4.675.001-.01v.01Zm.069-.095.007-.001-.007.002ZM8.08 11.68v-.009zM6.09 6.463v.008zm2.078-3.44-.002.009q.001-.01.002-.01Z",
        clipRule: "evenodd"
      }
    )
  }
), J2 = /* @__PURE__ */ t.forwardRef(X2), ec = J2, lc = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m14.354 13.646-12-12-.708.708L4.293 5H2v1h3v4H2v1h3v3h1v-3h4v3h1v-2.293l2.646 2.647zM6 10V6.707L9.293 10z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 8.172V6h3V5h-3V2h-1v3H7.828l1 1H10v1.172z"
        }
      )
    ]
  }
), oc = /* @__PURE__ */ t.forwardRef(lc), nc = oc, ic = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5V2h1v3h4V2h1v3h3v1h-3v4h3v1h-3v3h-1v-3H6v3H5v-3H2v-1h3V6H2V5zm1 1v4h4V6z",
        clipRule: "evenodd"
      }
    )
  }
), rc = /* @__PURE__ */ t.forwardRef(ic), tc = rc, ac = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4H8.5V2h-1v2H3v3h4.5v1H5v3h2.5v3h1v-3H11V8H8.5V7H13zM4 5v1h8V5zm2 5V9h4v1z",
        clipRule: "evenodd"
      }
    )
  }
), sc = /* @__PURE__ */ t.forwardRef(ac), dc = sc, cc = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 2v12h1V2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 4H5v3h9zM6 6V5h7v1zm5 2H5v3h6zm-5 2V9h4v1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), hc = /* @__PURE__ */ t.forwardRef(cc), wc = hc, vc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 14h-1V2h1zM2 4h9v3H2zm1 1v1h7V5zm2 3h6v3H5zm1 1v1h4V9z",
        clipRule: "evenodd"
      }
    )
  }
), fc = /* @__PURE__ */ t.forwardRef(vc), mc = fc, pc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3h1v4h4V3h1v9h-1V8H6v4H5z",
        clipRule: "evenodd"
      }
    )
  }
), gc = /* @__PURE__ */ t.forwardRef(pc), uc = gc, xc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v5.211l3.534 2.036 3.483-2.007L13 9.96V3zm10 8.113-2.983-1.719-3.483 2.007L3 9.365V13h10zM6.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Rc = /* @__PURE__ */ t.forwardRef(xc), jc = Rc, Mc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.55 4H7.2V3h4v1H9.585l-2.143 8H8.79v1h-4v-1h1.616z",
        clipRule: "evenodd"
      }
    )
  }
), Hc = /* @__PURE__ */ t.forwardRef(Mc), Cc = Hc, yc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m11.646 4.354.708-.708L15.207 6.5l-2.853 2.854-.707-.708L13.293 7H7a2 2 0 1 0 1.932 1.482l.966-.258A3.003 3.003 0 0 1 7 12a3 3 0 1 1 0-6h6.293zM4 7H1V6h3z"
      }
    )
  }
), bc = /* @__PURE__ */ t.forwardRef(yc), Vc = bc, Lc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.293 13.707 8 8 13.707 2.293 8zM3.707 8 8 12.293 12.293 8 8 3.707z",
        clipRule: "evenodd"
      }
    )
  }
), zc = /* @__PURE__ */ t.forwardRef(Lc), Sc = zc, kc = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.762 10.926-.624.384-.727-.727.827-.509zm0-3-2.481 1.527-.727-.727 2.684-1.652z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m9.365 10.073-1.13-1.131L8 9.079 1.008 5l2.075-1.21-1.437-1.436.708-.708 12 12-.708.708-1.697-1.697L8 15.087l-6.762-4.161.524-.852L8 13.913l3.223-1.983-1.13-1.13L8 12.087 1.238 7.926l.524-.852L8 10.913zM3.814 4.52 2.992 5l3.122 1.82z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.992 5-4.524 2.64-.731-.732L13.007 5 8 2.079l-1.953 1.14-.731-.732L8 .921z"
        }
      )
    ]
  }
), Fc = /* @__PURE__ */ t.forwardRef(kc), $c = Fc, Bc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 .921 14.992 5 8 9.079 1.008 5zM2.992 5 8 7.921 13.008 5 8 2.079zM1.238 7.926l.524-.852L8 10.913l6.238-3.839.524.852L8 12.087zm0 3 .524-.852L8 13.913l6.238-3.839.524.852L8 15.087z",
        clipRule: "evenodd"
      }
    )
  }
), Ac = /* @__PURE__ */ t.forwardRef(Bc), Ec = Ac, _c = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 .984 1.723l-5.261 5.26a2 2 0 1 1-.707-.707l5.26-5.26A2 2 0 0 1 10 4m-6 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
        clipRule: "evenodd"
      }
    )
  }
), Oc = /* @__PURE__ */ t.forwardRef(_c), Dc = Oc, Pc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14 5H9V4h5zm-9.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 11.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m12 .5H9v-1h5z",
        clipRule: "evenodd"
      }
    )
  }
), Tc = /* @__PURE__ */ t.forwardRef(Pc), qc = Tc, Ic = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.354 2.354 3.5 6.207 1.646 4.354l.708-.708L3.5 4.793l3.146-3.147zM14 5H9V4h5zM7.354 9.354 3.5 13.207l-1.854-1.854.708-.707L3.5 11.793l3.146-3.147zM14 12H9v-1h5z",
        clipRule: "evenodd"
      }
    )
  }
), Zc = /* @__PURE__ */ t.forwardRef(Ic), Wc = Zc, Gc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h1.01v1H4v3h.01v1H3zm11 3H7V4h7zM2 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3v1h1v-.01h1V14H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1H3v.01H2zm12 3H7v-1h7z",
        clipRule: "evenodd"
      }
    )
  }
), Nc = /* @__PURE__ */ t.forwardRef(Gc), Uc = Nc, Yc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 7.098 4.289 5H2v6h1V6h.711L5.5 9.098 7.289 6H8v5h1V5H6.711zM13 9.293V5h-1v4.293l-1.646-1.647-.708.708 2.854 2.853 2.854-2.853-.707-.708z"
      }
    )
  }
), Qc = /* @__PURE__ */ t.forwardRef(Yc), Kc = Qc, Xc = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h4v2.577l6.5 3.753V10H14v4h-4v-4h1.5V8.908L6 5.732V6H4.5v4H6v4H2v-4h1.5V6H2zm3 3V3H3v2zm-2 6v2h2v-2zm8 2v-2h2v2z",
        clipRule: "evenodd"
      }
    )
  }
), Jc = /* @__PURE__ */ t.forwardRef(Xc), eh = Jc, lh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V7.5h4.293l-1.146-1.146.707-.708L14.707 8l-2.353 2.354-.707-.708L12.793 8.5H8.5v4.293l1.146-1.146.708.707L8 14.707l-2.354-2.353.708-.707L7.5 12.793V8.5H3.207l1.147 1.146-.708.708L1.293 8l2.353-2.354.708.708L3.207 7.5H7.5V3.207L6.354 4.354l-.708-.708z"
      }
    )
  }
), oh = /* @__PURE__ */ t.forwardRef(lh), nh = oh, ih = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 1.5h1v5h-1zm1 7a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1h2v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1h-1v.01h-1V8.5zm3-2h2v1h-1v1h1v1h-2v1h2a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2z"
      }
    )
  }
), rh = /* @__PURE__ */ t.forwardRef(ih), th = rh, ah = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.725 8.732a2.5 2.5 0 0 0 3.535 3.536l4.89-4.89.707.708-4.89 4.889a3.5 3.5 0 0 1-4.95-4.95l5.658-5.657a2.5 2.5 0 1 1 3.535 3.536L6.553 11.56a1.5 1.5 0 0 1-2.121-2.122L9.32 4.55l.707.707-4.889 4.89a.5.5 0 0 0 .707.707l5.657-5.657a1.5 1.5 0 1 0-2.121-2.122z",
        clipRule: "evenodd"
      }
    )
  }
), sh = /* @__PURE__ */ t.forwardRef(ah), dh = sh, ch = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4h2V3H5.5a2.5 2.5 0 0 0 0 5H6v5h1V4h2v9h1zM6 4v3h-.5a1.5 1.5 0 1 1 0-3z",
        clipRule: "evenodd"
      }
    )
  }
), hh = /* @__PURE__ */ t.forwardRef(ch), wh = hh, vh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 1.793 14.207 4.5l-9.5 9.5H2v-2.707zM3 11.707V13h1.293l6.5-6.5L9.5 5.207zM10.207 4.5 11.5 5.793 12.793 4.5 11.5 3.207z",
        clipRule: "evenodd"
      }
    )
  }
), fh = /* @__PURE__ */ t.forwardRef(vh), mh = fh, ph = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.646 2.354 11.293 4 9.646 5.646l.708.708L12 4.707l1.646 1.647.708-.708L12.707 4l1.647-1.646-.707-.708L12 3.293l-1.646-1.647z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 2H2v4h1.5v4H2v4h4v-4H4.5V6H6zM3 5V3h2v2zm0 8v-2h2v2zm7-3h1.5V7h1v3H14v4h-4zm1 3v-2h2v2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), gh = /* @__PURE__ */ t.forwardRef(ph), uh = gh, xh = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h4v4H4.5v4H6v4H2v-4h1.5V6H2zm1 1v2h2V3zm0 8v2h2v-2zm7-1h4v4h-4zm1 1v2h2v-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 6h2v2h-2zm2-3h-2v2h2z" })
    ]
  }
), Rh = /* @__PURE__ */ t.forwardRef(xh), jh = Rh, Mh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.354 2.354 9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5H9.207l1.146 1.146-.707.708L7.293 4l2.353-2.354zM11 13v-2h2v2zM4.5 6H6V2H2v4h1.5v4H2v4h4v-4H4.5zM3 5V3h2v2zm0 6v2h2v-2z",
        clipRule: "evenodd"
      }
    )
  }
), Hh = /* @__PURE__ */ t.forwardRef(Mh), Ch = Hh, yh = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.793 3.5 6.646 2.354l.708-.708L9.707 4 7.354 6.354l-.708-.708L7.793 4.5H6.5A2.5 2.5 0 0 0 4 7H3a3.5 3.5 0 0 1 3.5-3.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 7h6v6H5zm1 1v4h4V8z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), bh = /* @__PURE__ */ t.forwardRef(yh), Vh = bh, Lh = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m8.207 3.5 1.147-1.146-.708-.708L6.293 4l2.353 2.354.708-.708L8.207 4.5H9.5A2.5 2.5 0 0 1 12 7h1a3.5 3.5 0 0 0-3.5-3.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 7h6v6H5zm1 1v4h4V8z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), zh = /* @__PURE__ */ t.forwardRef(Lh), Sh = zh, kh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 7.5c0-.516.474-1.141 1.613-1.667C4.71 5.326 6.261 5 8 5c1.74 0 3.29.326 4.387.833C13.526 6.359 14 6.984 14 7.5c0 .298-.15.628-.519.97-.37.343-.93.664-1.65.925l.339.94c.8-.289 1.491-.67 1.99-1.131.5-.463.84-1.041.84-1.704 0-1.141-.981-2.015-2.194-2.575C11.55 4.345 9.85 4 8 4s-3.55.345-4.806.925C1.981 5.485 1 6.359 1 7.5s.981 2.015 2.194 2.575C4.45 10.655 6.15 11 8 11h.293l-.647.646.708.708 1.853-1.854-1.853-1.854-.708.708.647.646H8c-1.74 0-3.29-.326-4.387-.833C2.474 8.642 2 8.016 2 7.5"
      }
    )
  }
), Fh = /* @__PURE__ */ t.forwardRef(kh), $h = Fh, Bh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 1.293 14.707 5 5 14.707 1.293 11zM2.707 11 5 13.293l.793-.793-.647-.646.708-.708.646.647.793-.793-1.647-1.646.708-.708L8 10.293l.793-.793-.647-.646.708-.708.646.647.793-.793-1.647-1.646.708-.708L11 7.293l.793-.793-.647-.646.707-.708.647.647.793-.793L11 2.707z",
        clipRule: "evenodd"
      }
    )
  }
), Ah = /* @__PURE__ */ t.forwardRef(Bh), Eh = Ah, _h = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 3.793 6.354 2.646l-.708.708L8 5.707l2.354-2.353-.708-.708L8.5 3.793V1h-1zM14 7.5H2v-1h12zm-12 1h12v1H2zm4.354 4.854L7.5 12.207V15h1v-2.793l1.146 1.146.708-.707L8 10.293l-2.354 2.353z"
      }
    )
  }
), Oh = /* @__PURE__ */ t.forwardRef(_h), Dh = Oh, Ph = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 3h12V2H2zm6 1a4 4 0 0 0-4 4v.293l-.646-.647-.708.708L4.5 10.207l1.854-1.853-.708-.708L5 8.293V8a3 3 0 1 1 3 3v1a4 4 0 0 0 0-8m6 10v-1H2v1z"
      }
    )
  }
), Th = /* @__PURE__ */ t.forwardRef(Ph), qh = Th, Ih = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14 3H2V2h12zM8.5 5.207v5.586l1.146-1.147.708.708L8 12.707l-2.354-2.353.708-.708L7.5 10.793V5.207L6.354 6.354l-.708-.708L8 3.293l2.354 2.353-.708.708zM14 14H2v-1h12z"
      }
    )
  }
), Zh = /* @__PURE__ */ t.forwardRef(Ih), Wh = Zh, Gh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 4.45 1.564l2.354 1.359 4.946-2.856.5.866L9.804 8l4.446 2.567-.5.866-4.946-2.856-2.354 1.36a2.5 2.5 0 1 1-.834-.673L7.804 8 5.617 6.737A2.5 2.5 0 0 1 2 4.5M4.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), Nh = /* @__PURE__ */ t.forwardRef(Gh), Uh = Nh, Yh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.02 7.5a6 6 0 0 1 11.96 0l1.266-.002.002 1H.752l.002-1 1.267.001Zm1.005 0h9.95a5 5 0 0 0-9.95 0m.4 4.357a6 6 0 0 1-1.044-1.804l.94-.342c.2.553.497 1.06.869 1.503l-.766.643Zm10.235-1.804a6 6 0 0 1-1.044 1.804l-.765-.643c.371-.443.668-.95.869-1.503zM6.979 13.91a6 6 0 0 1-1.96-.713l.501-.866a5 5 0 0 0 1.631.594zm4.042-.713a6 6 0 0 1-1.96.713l-.172-.985a5 5 0 0 0 1.631-.594l.5.866Z",
        clipRule: "evenodd"
      }
    )
  }
), Qh = /* @__PURE__ */ t.forwardRef(Yh), Kh = Qh, Xh = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.52 3.666a5 5 0 0 0-1.631-.594l.172-.985a6 6 0 0 1 1.96.713zm-3.37-.594a5 5 0 0 0-1.63.594L5.019 2.8a6 6 0 0 1 1.96-.713zm5.57 3.214a5 5 0 0 0-.87-1.503l.766-.643c.446.53.801 1.14 1.043 1.804l-.94.342ZM4.19 4.783c-.373.443-.669.95-.87 1.503l-.94-.342A6 6 0 0 1 3.424 4.14l.765.643ZM2.5 7.497h11l1.747.002-.001 1-1.267-.001a6 6 0 0 1-11.959 0l-1.267.001-.001-1zm10.475 1h-9.95a5 5 0 0 0 9.95 0",
        clipRule: "evenodd"
      }
    )
  }
), Jh = /* @__PURE__ */ t.forwardRef(Xh), e3 = Jh, l3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.967 13.666-.325 1.204.966.26L10.36 1.129 9.393.87l-.331 1.244a6 6 0 0 0-3.095 11.551ZM8.803 3.085l-2.576 9.611a5 5 0 0 1 2.576-9.611m-.37 9.918a5 5 0 0 0 1.678-.451l.423.906a6 6 0 0 1-2.013.54l-.087-.995Zm3.101-1.447c.406-.405.746-.883.996-1.422l.907.422a6 6 0 0 1-1.196 1.708zm1.446-3.1a5 5 0 0 0-.152-1.73l.966-.26c.179.665.245 1.367.182 2.078zm-.886-3.304a5 5 0 0 0-1.227-1.229l.573-.819c.58.406 1.076.907 1.473 1.475z",
        clipRule: "evenodd"
      }
    )
  }
), o3 = /* @__PURE__ */ t.forwardRef(l3), n3 = o3, i3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.25 1.543 2.207 2.207L10 8.207v.043c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 7.792 6l4.457-4.457ZM9 8.24 7.76 7h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055C8.33 9.878 9 9.23 9 8.25zm1.293-1.74-.81.81-.792-.794.809-.81zM11 5.793 10.207 5l2.043-2.043.793.793z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3.224 7.768q-.343.226-.63.489l.677.737a4 4 0 0 1 .505-.392zm10.181.489a5 5 0 0 0-.63-.49l-.55.835q.281.187.504.392zM1.65 9.63a2.62 2.62 0 0 0 .105 1.999l.907-.422a1.62 1.62 0 0 1-.068-1.247zm12.85.87q-.002-.452-.15-.87l-.944.33a1.62 1.62 0 0 1-.068 1.247l.907.422A2.7 2.7 0 0 0 14.5 10.5M3.198 13.215a7.1 7.1 0 0 0 1.847.857l.295-.956a6.1 6.1 0 0 1-1.586-.732zm7.757.857a7.1 7.1 0 0 0 1.847-.857l-.556-.832a6.1 6.1 0 0 1-1.586.733zm-3.949.382a11 11 0 0 0 1.988 0l-.092-.995a10 10 0 0 1-1.804 0z"
        }
      )
    ]
  }
), r3 = /* @__PURE__ */ t.forwardRef(i3), t3 = r3, a3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 3.793 10.207 5.5l-6.5 6.5H2v-1.707zM3 10.707V11h.293l5.5-5.5-.293-.293zM14 12H6v-1h8z",
        clipRule: "evenodd"
      }
    )
  }
), s3 = /* @__PURE__ */ t.forwardRef(a3), d3 = s3, c3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 0 0-5 5v1h1V8a4 4 0 1 1 8 0v.293l-.646-.647-.707.708 1.853 1.853 1.854-1.853-.707-.708-.647.647V8a5 5 0 0 0-5-5"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h3 = /* @__PURE__ */ t.forwardRef(c3), w3 = h3, v3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2h3v2h6v1H8v2H5V5H2V4h3zm1 1v3h1V3zm2 5h3v2h3v1h-3v2H8v-2H2v-1h6zm1 1v3h1V9z",
        clipRule: "evenodd"
      }
    )
  }
), f3 = /* @__PURE__ */ t.forwardRef(v3), m3 = f3, p3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14.854 5.147 12 2.293 9.146 5.147l.708.707L11.5 4.207V9h1V4.207l1.646 1.647zM3 12h10v1H3zm0-3h6v1H3zm0-3h3v1H3z"
      }
    )
  }
), g3 = /* @__PURE__ */ t.forwardRef(p3), u3 = g3, x3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4h10V3H3zm0 3h6V6H3zm0 3h3V9H3zm11.854.854L12 13.707l-2.854-2.854.708-.707 1.646 1.647V7h1v4.793l1.646-1.647z"
      }
    )
  }
), R3 = /* @__PURE__ */ t.forwardRef(x3), j3 = R3, M3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M6 6.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v7.707L6.293 14H14zM3 9V3h10v6.959L10.017 8.24 7.75 9.546l.5.866 1.767-1.018L13 11.113V13H7V9zm.707 1L6 12.293V10z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), H3 = /* @__PURE__ */ t.forwardRef(M3), C3 = H3, y3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.26 5.921 8 3.371 6.74 5.92l-2.814.41L5.65 8.012l.698-.716-.275-.267 1.331-.194L8 5.63l.595 1.205 1.33.194-.962.938.227 1.325-.457-.24-.466.885 2.251 1.183-.48-2.804 2.037-1.985z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v7.707L6.293 14H14zM3 9V3h10v10H7V9zm.707 1L6 12.293V10z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), b3 = /* @__PURE__ */ t.forwardRef(y3), V3 = b3, L3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 6h2v5h1V6h2V5H6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v7.707L6.293 14H14zM3 9V3h10v10H7V9zm.707 1L6 12.293V10z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), z3 = /* @__PURE__ */ t.forwardRef(L3), S3 = z3, k3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.5 4a2.5 2.5 0 1 0 1.379 4.586l1.768 1.768.707-.707-1.768-1.768A2.5 2.5 0 0 0 8.5 4M7 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v7.707L6.293 14H14zM3 9V3h10v10H7V9zm.707 1L6 12.293V10z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), F3 = /* @__PURE__ */ t.forwardRef(k3), $3 = F3, B3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2H2v7.707L6.293 14H14zM3 9V3h10v10H7V9zm.707 1L6 12.293V10z",
        clipRule: "evenodd"
      }
    )
  }
), A3 = /* @__PURE__ */ t.forwardRef(B3), E3 = A3, _3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4c-1.299 0-2 .846-2 1.5 0 .596.21.917.514 1.15.348.265.836.43 1.45.623l.072.023c.198.063.408.129.62.204H14v1h-3.671c.324.357.564.817.664 1.418.152.911-.16 1.702-.746 2.251C9.673 12.71 8.858 13 8 13c-1.683 0-3-1.035-3-2.5h1c0 .744.683 1.5 2 1.5.642 0 1.2-.219 1.563-.56.351-.33.538-.79.444-1.358-.1-.598-.386-.952-.777-1.213a3.7 3.7 0 0 0-.752-.369H2v-1h3.983l-.076-.056C5.353 7.021 5 6.404 5 5.5 5 4.154 6.299 3 8 3c1.683 0 3 1.035 3 2.5h-1C10 4.756 9.317 4 8 4",
        clipRule: "evenodd"
      }
    )
  }
), O3 = /* @__PURE__ */ t.forwardRef(_3), D3 = O3, P3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zM2 5h12v3H2zm1 1v1h10V6zM2 9h12v4H2zm1 1v2h10v-2z",
        clipRule: "evenodd"
      }
    )
  }
), T3 = /* @__PURE__ */ t.forwardRef(P3), q3 = T3, I3 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m13.25.543 2.207 2.207-4.458 4.457.001.043c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 8.792 5zM10 7.24 8.76 6h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055C9.33 8.878 10 8.23 10 7.25zm1.293-1.74-.81.81-.792-.794.809-.81zM12 4.793 11.207 4l2.043-2.043.793.793z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 3H1v10h14V6h-1v6H2V4h6z" })
    ]
  }
), Z3 = /* @__PURE__ */ t.forwardRef(I3), W3 = Z3, G3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.976 2.194 5.797 1.554-2.588 9.66L6.935 12h-1.37l-1.867.5-2.071-7.727L5 3.87V3h3.76zM8.492 4H6v7h.616zm-.88 7.146.966.26 2.9.776 2.07-7.727-3.865-1.036-2.07 7.727ZM5 11.117V4.905l-2.148.575 1.553 5.796.595-.16Z",
        clipRule: "evenodd"
      }
    )
  }
), N3 = /* @__PURE__ */ t.forwardRef(G3), U3 = N3, Y3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm-2 3H4V6h8zm1 3H3V9h10zm-2 3H5v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), Q3 = /* @__PURE__ */ t.forwardRef(Y3), K3 = Q3, X3 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm0 3H2V6h12zm0 3H2V9h12zm-6 3H2v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), J3 = /* @__PURE__ */ t.forwardRef(X3), e5 = J3, l5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm-4 3H2V6h8zm2 3H2V9h10zm-4 3H2v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), o5 = /* @__PURE__ */ t.forwardRef(l5), n5 = o5, i5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm0 3H6V6h8zm0 3H4V9h10zm0 3H8v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), r5 = /* @__PURE__ */ t.forwardRef(i5), t5 = r5, a5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3zm4.5 3H5V5h6v1H8.5v5h-1z",
        clipRule: "evenodd"
      }
    )
  }
), s5 = /* @__PURE__ */ t.forwardRef(a5), d5 = s5, c5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 4H4V3h8v1H8.5v9h-1z",
        clipRule: "evenodd"
      }
    )
  }
), h5 = /* @__PURE__ */ t.forwardRef(c5), w5 = h5, v5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 1h4v2h3v1H3V3h3zm1 2h2V2H7zM4 5h1v8h1.89v1H4zm6.793 6.5L8.646 9.354l.708-.708 2.146 2.147 2.146-2.147.708.708-2.147 2.146 2.147 2.146-.708.708-2.146-2.147-2.146 2.147-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), f5 = /* @__PURE__ */ t.forwardRef(v5), m5 = f5, p5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.76 11.87 5.383 3H3.616L1.24 11.87l.966.26.877-3.273h2.836l.876 3.272zM5.65 7.858h-2.3L4.384 4h.232zM13.207 6H9.793l-.647.646.708.708.353-.354h2.586l.207.207v.972l-3.259.873-.741.74v1.415l.793.793h2.914l.534-.534.178.663.966-.258L14 10.434V6.793zM10.26 9.948 13 9.214v1.079l-.707.707h-2.086L10 10.793v-.586z",
        clipRule: "evenodd"
      }
    )
  }
), g5 = /* @__PURE__ */ t.forwardRef(p5), u5 = g5, x5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 3v6.5a2.5 2.5 0 0 0 5 0V3h1v6.5a3.5 3.5 0 1 1-7 0V3zM14 14v1H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), R5 = /* @__PURE__ */ t.forwardRef(x5), j5 = R5, M5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3v7h1V3zm2-1v9H4V2zm2 4v4h1V6zm2-1v6H8V5zm3 7v1H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), H5 = /* @__PURE__ */ t.forwardRef(M5), C5 = H5, y5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 13V8.5H2v-1h2V3h3v4.5h1V5h3v2.5h3v1h-3V11H8V8.5H7V13zm1-1h1V4H5zm5-2H9V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), b5 = /* @__PURE__ */ t.forwardRef(y5), V5 = b5, L5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zM7 5v9H4V5zM5 6v7h1V6zm3-1h3v6H8zm1 1v4h1V6z",
        clipRule: "evenodd"
      }
    )
  }
), z5 = /* @__PURE__ */ t.forwardRef(L5), S5 = z5, k5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.61 2.748 8.094.815 9.06.557l.518 1.932-.966.259Zm3.511.424 1.414-1.415.708.707-1.415 1.415zM10 3.792 12.207 6 3.5 14.707 1.293 12.5zM6.489 5.578 4.557 5.06l.258-.966 1.933.518zM8.457 6.75l.793.793L10.793 6 10 5.207zm.086 1.5-.793-.793L2.707 12.5l.793.793zm4.968-1.827 1.932.518-.259.966-1.932-.518zm-2.122 2.83.518 1.931-.966.26-.518-1.933z",
        clipRule: "evenodd"
      }
    )
  }
), F5 = /* @__PURE__ */ t.forwardRef(k5), $5 = F5, B5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 6a4 4 0 0 1 7.66-1.616l.31.702h-3.66L9.852 6l.457.914h3.661l-.31.702a4 4 0 0 1-4.79 2.222l-5.37 5.37L.793 12.5l5.37-5.37A4 4 0 0 1 6 6m4-3a3 3 0 0 0-2.798 4.084l.117.304L2.207 12.5 3.5 13.793 8.612 8.68l.304.117a2.99 2.99 0 0 0 3.394-.884H9.691L8.734 6l.957-1.914h2.62A3 3 0 0 0 10 3",
        clipRule: "evenodd"
      }
    )
  }
), A5 = /* @__PURE__ */ t.forwardRef(B5), E5 = A5, _5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v3h-1v7H3V6H2zm11 2V4H3v1zM4 6v6h8V6zm6 2H6V7h4z",
        clipRule: "evenodd"
      }
    )
  }
), O5 = /* @__PURE__ */ t.forwardRef(_5), D5 = O5, P5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.318 3.687C3.356 4.125 3 4.627 3 5c0 .374.356.875 1.318 1.313C5.234 6.729 6.536 7 8 7s2.766-.27 3.682-.687C12.644 5.875 13 5.373 13 5c0-.374-.356-.875-1.318-1.313C10.766 3.271 9.464 3 8 3s-2.766.27-3.682.687M13 6.698a5 5 0 0 1-.904.525C11.022 7.711 9.573 8 8 8s-3.022-.289-4.096-.777A5 5 0 0 1 3 6.698V8c0 .374.356.875 1.318 1.313C5.234 9.729 6.536 10 8 10s2.766-.27 3.682-.687C12.644 8.875 13 8.373 13 8zm0 3c-.271.202-.58.378-.904.525C11.022 10.71 9.573 11 8 11s-3.022-.289-4.096-.777A5 5 0 0 1 3 9.698V11c0 .374.356.875 1.318 1.313C5.234 12.729 6.536 13 8 13s2.766-.27 3.682-.687C12.644 11.875 13 11.373 13 11zM14 11c0 1.007-.875 1.755-1.904 2.223C11.022 13.71 9.573 14 8 14s-3.022-.289-4.096-.777C2.875 12.755 2 12.007 2 11V5c0-1.007.875-1.755 1.904-2.223C4.978 2.289 6.427 2 8 2s3.022.289 4.096.777C13.125 3.245 14 3.993 14 5z",
        clipRule: "evenodd"
      }
    )
  }
), T5 = /* @__PURE__ */ t.forwardRef(P5), q5 = T5, I5 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 2h6.707L13 5.293V8h-1V6H9V3H4v10h3v1H3zm7 1.707L11.293 5H10z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10.5 14.207 4.854-4.853-.707-.708-4.147 4.147-1.646-1.646-.708.707z"
        }
      )
    ]
  }
), Z5 = /* @__PURE__ */ t.forwardRef(I5), W5 = Z5, G5 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.707 2H3v12h4v-1H4V3h5v3h3v1h1V5.293zm1.586 3L10 3.707V5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z" })
    ]
  }
), N5 = /* @__PURE__ */ t.forwardRef(G5), U5 = N5, Y5 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.5 6.5a2 2 0 1 0 1.016 3.723l1.63 1.63.707-.707-1.63-1.63A2 2 0 0 0 7.5 6.5m-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.707 2H3v12h10V5.293zM4 13V3h5v3h3v7zm7.293-8L10 3.707V5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Q5 = /* @__PURE__ */ t.forwardRef(Y5), K5 = Q5, X5 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 2H3v12h10V5.293zM4 13V3h5v3h3v7zm7.293-8L10 3.707V5z",
        clipRule: "evenodd"
      }
    )
  }
), J5 = /* @__PURE__ */ t.forwardRef(X5), e6 = J5, l6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.5 9h-1V2h1zM3 5h2v1H4v6h8V6h-1V5h2v8H3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m8 1.293 2.354 2.353-.708.708L8 2.707 6.354 4.354l-.708-.708z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), o6 = /* @__PURE__ */ t.forwardRef(l6), n6 = o6, i6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h9.977L14 4.312V14H2zm1 1v10h1V8h8v5h1V4.688L11.523 3H11v4H5V3zm3 0v3h4V3zm5 10V9H5v4z",
        clipRule: "evenodd"
      }
    )
  }
), r6 = /* @__PURE__ */ t.forwardRef(i6), t6 = r6, a6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.884 3 .536 2H14v8H2V3zM3 4v8h10V6H6.652l-.536-2z",
        clipRule: "evenodd"
      }
    )
  }
), s6 = /* @__PURE__ */ t.forwardRef(a6), d6 = s6, c6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.884 3 .536 2H13v2h2.239l-2.402 6H1.001L1 3zM12 7V6H5.652l-.536-2H2v5.9L3.163 7zm-9.762 5h9.922l1.601-4H3.84z",
        clipRule: "evenodd"
      }
    )
  }
), h6 = /* @__PURE__ */ t.forwardRef(c6), w6 = h6, v6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m8.5 8.793 1.146-1.147.708.708L8 10.707 5.646 8.354l.708-.708L7.5 8.793V3h1z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5 5H3v8h10V5h-2v1h1v6H4V6h1z" })
    ]
  }
), f6 = /* @__PURE__ */ t.forwardRef(v6), m6 = f6, p6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 0 0 8 0zm-6.25-3a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-1.25.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
        clipRule: "evenodd"
      }
    )
  }
), g6 = /* @__PURE__ */ t.forwardRef(p6), u6 = g6, x6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708L10.293 11H2V5h2.293L1.646 2.354zM5.293 6H3v4h6.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 9v1.172l-1-1V6H8.828l-1-1H13v2h1v2z" })
    ]
  }
), R6 = /* @__PURE__ */ t.forwardRef(x6), j6 = R6, M6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1zM3 10V6h9v4z",
        clipRule: "evenodd"
      }
    )
  }
), H6 = /* @__PURE__ */ t.forwardRef(M6), C6 = H6, y6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 7v2h1V7zm2 2V7h1v2zm2-2v2h1V7zm2 2V7h1v2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 5H2v6h11V9h1V7h-1zM3 10V6h9v4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), b6 = /* @__PURE__ */ t.forwardRef(y6), V6 = b6, L6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 9V7h1v2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 5H2v6h11V9h1V7h-1zM3 10V6h9v4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), z6 = /* @__PURE__ */ t.forwardRef(L6), S6 = z6, k6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 7v2h1V7zm2 2V7h1v2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 5H2v6h11V9h1V7h-1zM3 10V6h9v4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), F6 = /* @__PURE__ */ t.forwardRef(k6), $6 = F6, B6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 9V7h1v2zm2-2v2h1V7zm2 2V7h1v2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 5H2v6h11V9h1V7h-1zM3 10V6h9v4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), A6 = /* @__PURE__ */ t.forwardRef(B6), E6 = A6, _6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.001 10.887 5 12.04V5h2V4h2v1h2v7.042l2.001-1.155V5.113l-5-2.886-5 2.886zM10 12.619v-.831l-1.999-1.155L6 11.79v.83l2.001 1.155zm-4-1.985 2.001-1.155L10 10.633V9.288L8.001 8.133 6 9.29zm0-2.5 2.001-1.155L10 8.133V6H6zM2.001 4.536l6-3.464 6 3.464v6.928l-6 3.464-6-3.464z",
        clipRule: "evenodd"
      }
    )
  }
), O6 = /* @__PURE__ */ t.forwardRef(_6), D6 = O6, P6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 7V2.07L5.15 9H7v4.93L10.85 7zM8 8H6.85L8 5.93zm0 0h1.15L8 10.07z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 7h-1V5h-3v1h2v4h-1v1h2V9h1zM5 5H2v6h4v-1H3V6h2z"
        }
      )
    ]
  }
), T6 = /* @__PURE__ */ t.forwardRef(P6), q6 = T6, I6 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m9.518 6.69-.707-.708L9.793 5 8 3.207v1.965l-1-1V.793L11.207 5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.5 11.707-3.5 3.5v-6l-2.646 2.647-.707-.707L6.793 8 1.146 2.354l.708-.708 12 12-.707.708zM8 9.207 9.793 11 8 12.793z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Z6 = /* @__PURE__ */ t.forwardRef(I6), W6 = Z6, G6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 .793 11.207 5l-3 3 3 3L7 15.207v-6l-2.646 2.647-.708-.707L6.793 8 3.646 4.854l.708-.707L7 6.793zm1 8.414L9.793 11 8 12.793zm0-2.414V3.207L9.793 5z",
        clipRule: "evenodd"
      }
    )
  }
), N6 = /* @__PURE__ */ t.forwardRef(G6), U6 = N6, Y6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 2h9v12h-9zm1 1v2h7V3zm7 3h-7v7h7zm-5 2h-1V7h1zm2 0h-1V7h1zm2 0h-1V7h1zm-4 2h-1V9h1zm2 0h-1V9h1zm2 0h-1V9h1zm-4 2h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1z",
        clipRule: "evenodd"
      }
    )
  }
), Q6 = /* @__PURE__ */ t.forwardRef(Y6), K6 = Q6, X6 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 3H3v2.5H2v1h1v1H2v1h1v1H2v1h1V13h2.5v1h1v-1h1v1h1v-1h1v1h1v-1H13v-2.5h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1V3h-2.5V2h-1v1h-1V2h-1v1h-1V2h-1zM4 4v8h8V4zm2 2h4v4H6zm1 1v2h2V7z",
        clipRule: "evenodd"
      }
    )
  }
), J6 = /* @__PURE__ */ t.forwardRef(X6), e4 = J6, l4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 2H1v8h1V3h11z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 4H3v8h5.1l-.269 1H6v1h6v-1h-1.83l-.268-1H15zm-6.133 9L9 12.5l.134.5zM4 11V5h10v6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), o4 = /* @__PURE__ */ t.forwardRef(l4), n4 = o4, i4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.707.708L10.293 11H8.902l.268 1H11v1H5v-1h1.831l.268-1H2V3h.293L.646 1.354zM3.293 4H3v6h6.293zM8 11.5l-.133.5h.267z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 11h-.172l-1-1H13V4H6.828l-1-1H14z" })
    ]
  }
), r4 = /* @__PURE__ */ t.forwardRef(i4), t4 = r4, a4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.133.5h.267zM3 4v6h10V4z",
        clipRule: "evenodd"
      }
    )
  }
), s4 = /* @__PURE__ */ t.forwardRef(a4), d4 = s4, c4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.707-.861-.861a3 3 0 0 1-1.67.508h-3.5C7.242 15 6 13.95 6 12.5a2.5 2.5 0 0 1 .74-1.742c.207-.206.464-.385.758-.504a2.66 2.66 0 0 1 .732-1.317L4.293 5H2v3h4.654v1H1V4h2.293L1.646 2.354zm6.583 7.998a1.8 1.8 0 0 0-.346.483 1.36 1.36 0 0 0-.082 1.002 1.12 1.12 0 0 0-.969.251A1.5 1.5 0 0 0 7 12.5c0 .828.723 1.5 1.615 1.5h3.5c.344 0 .666-.085.943-.235z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14.274 10.438c.417.451.703 1.08.725 1.732l-4.15-4.15a3.4 3.4 0 0 1 1.727.74c.302.248.615.609.787 1.052.367.139.678.372.911.626M14 5H7.828l-1-1H15v5h-1zM4 7H3V6h1z"
        }
      )
    ]
  }
), h4 = /* @__PURE__ */ t.forwardRef(c4), w4 = h4, v4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4h14v5h-1V5H2v3h4.654v1H1zm3 3H3V6h1zm4.615 8C7.242 15 6 13.95 6 12.5a2.5 2.5 0 0 1 .74-1.742 2.3 2.3 0 0 1 .758-.504c.108-.51.38-.96.72-1.305A3.25 3.25 0 0 1 10.5 8c.767 0 1.527.309 2.076.76.302.248.615.609.787 1.052.367.139.678.372.911.626.434.47.726 1.13.726 1.812 0 1.587-1.363 2.75-2.885 2.75zm4.64-4.128a1.07 1.07 0 0 0-.783-.174.97.97 0 0 0-.128-.703C12.024 9.437 11.234 9 10.5 9c-.815 0-1.598.476-1.91 1.127-.146.306-.188.65-.081 1.002a1.12 1.12 0 0 0-.969.251A1.5 1.5 0 0 0 7 12.5c0 .828.723 1.5 1.615 1.5h3.5C13.156 14 14 13.216 14 12.25c0-.53-.307-1.092-.746-1.378Z",
        clipRule: "evenodd"
      }
    )
  }
), f4 = /* @__PURE__ */ t.forwardRef(v4), m4 = f4, p4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 7H3V6h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5V9H1V4h2.293L1.646 2.354zM4.293 5H2v3h5.293zM8.5 9.207V12H10v1h2.293zM7 14h2v-1H7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "m11.828 9-1-1H14V5H7.828l-1-1H15v5z" })
    ]
  }
), g4 = /* @__PURE__ */ t.forwardRef(p4), u4 = g4, x4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4h14v5H8.5v3H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5V9H1zm6 10h2v-1H7zM2 5v3h12V5zm2 2H3V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), R4 = /* @__PURE__ */ t.forwardRef(x4), j4 = R4, M4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 8H3V7h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708L9.293 10H1V5h3.293L1.646 2.354zM5.293 6H2v3h6.293l-1-1H6V7h.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "m12.828 10-1-1H14V6H8.828l-1-1H15v5z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 8h-2.172l-1-1H13z" })
    ]
  }
), H4 = /* @__PURE__ */ t.forwardRef(M4), C4 = H4, y4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5h14v5H1zm1 1v3h12V6zm2 2H3V7h1zm9 0H6V7h7z",
        clipRule: "evenodd"
      }
    )
  }
), b4 = /* @__PURE__ */ t.forwardRef(y4), V4 = b4, L4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708L11 11.707v1.507l-3 .804-3-.804V5.707L1.646 2.354zM6 6.707v5.74l2 .535 2-.535v-1.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m11 8.172-1-1V6H8.828l-1-1H9V3H7v1.172l-1-1V2h4v3h1z"
        }
      )
    ]
  }
), z4 = /* @__PURE__ */ t.forwardRef(L4), S4 = z4, k4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2H6v3H5v8.214l3 .804 3-.804V5h-1zM9 5V3H7v2zm-3 7.446V6h4v6.446l-2 .536z",
        clipRule: "evenodd"
      }
    )
  }
), F4 = /* @__PURE__ */ t.forwardRef(k4), $4 = F4, B4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3zm2.5 2h5v1h1v5h-7V6h1zm0 2v3h1V8h1v2h1V8h1v2h1V7h-1V6h-3v1z",
        clipRule: "evenodd"
      }
    )
  }
), A4 = /* @__PURE__ */ t.forwardRef(B4), E4 = A4, _4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.5 3h2a2 2 0 0 1 2 2c0 .213-.058.433-.14.64.207-.082.427-.14.64-.14h2v2a2 2 0 0 1-2 2c-.213 0-.433-.058-.64-.14.082.207.14.427.14.64v2h-2a2 2 0 0 1-2-2c0-.213.058-.433.14-.64-.207.082-.427.14-.64.14H1v-2a2 2 0 0 1 2-2c.213 0 .433.058.64.14A1.8 1.8 0 0 1 3.5 5zm2 3.722c.106-.134.225-.288.344-.453.18-.25.352-.515.477-.758.133-.258.179-.429.179-.511a1 1 0 0 0-1-1h-1v1c0 .082.046.253.179.511.125.243.297.507.477.758.119.165.238.32.344.453m-.344 2.01c.119-.166.238-.32.344-.454.106.134.225.288.344.453.18.25.352.515.477.758.133.258.179.429.179.511v1h-1a1 1 0 0 1-1-1c0-.082.046-.253.179-.511.125-.243.297-.507.477-.758ZM4.722 7.5a12 12 0 0 0-.453-.344 6 6 0 0 0-.758-.477C3.253 6.546 3.082 6.5 3 6.5a1 1 0 0 0-1 1v1h1c.082 0 .253-.046.511-.179.243-.125.507-.297.758-.477.165-.119.32-.238.453-.344m2.01.344c-.166-.119-.32-.238-.454-.344.134-.106.288-.225.453-.344.25-.18.515-.352.758-.477.258-.133.429-.179.511-.179h1v1a1 1 0 0 1-1 1c-.082 0-.253-.046-.511-.179a6 6 0 0 1-.758-.477Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 3v8h1V3zm-2 2v4h1V5z" })
    ]
  }
), O4 = /* @__PURE__ */ t.forwardRef(_4), D4 = O4, P4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.5 3h2a2 2 0 0 1 2 2c0 .213-.058.433-.14.64.207-.082.427-.14.64-.14h2v2a2 2 0 0 1-2 2c-.213 0-.433-.058-.64-.14.082.207.14.427.14.64v2h-2a2 2 0 0 1-2-2c0-.213.058-.433.14-.64-.207.082-.427.14-.64.14H2v-2a2 2 0 0 1 2-2c.213 0 .433.058.64.14A1.8 1.8 0 0 1 4.5 5zm2 3.722c.106-.134.225-.288.344-.453.18-.25.352-.515.477-.758.133-.258.179-.429.179-.511a1 1 0 0 0-1-1h-1v1c0 .082.046.253.179.511.125.243.297.507.477.758.119.165.238.32.344.453m-.344 2.01c.119-.166.238-.32.344-.454.106.134.225.288.344.453.18.25.352.515.477.758.133.258.179.429.179.511v1h-1a1 1 0 0 1-1-1c0-.082.046-.253.179-.511.125-.243.297-.507.477-.758ZM5.722 7.5a12 12 0 0 0-.453-.344 6 6 0 0 0-.758-.477C4.253 6.546 4.082 6.5 4 6.5a1 1 0 0 0-1 1v1h1c.082 0 .253-.046.511-.179.243-.125.507-.297.758-.477.165-.119.32-.238.453-.344m2.01.344c-.166-.119-.32-.238-.454-.344.134-.106.288-.225.453-.344.25-.18.515-.352.758-.477.258-.133.429-.179.511-.179h1v1a1 1 0 0 1-1 1c-.082 0-.253-.046-.511-.179a6 6 0 0 1-.758-.477Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 9V5h1v4z" })
    ]
  }
), T4 = /* @__PURE__ */ t.forwardRef(P4), q4 = T4, I4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2h2.5A2.5 2.5 0 0 1 10 4.5c0 .367-.074.749-.188 1.12a6 6 0 0 1 .255-.16c.43-.254.929-.46 1.433-.46H14v2.5a2.5 2.5 0 0 1-2.5 2.5c-.367 0-.749-.074-1.12-.188q.084.126.16.255c.254.43.46.929.46 1.433V14H8.5A2.5 2.5 0 0 1 6 11.5c0-.367.074-.749.188-1.12q-.126.084-.255.16c-.43.254-.929.46-1.433.46H2V8.5A2.5 2.5 0 0 1 4.5 6c.367 0 .749.074 1.12.188a6 6 0 0 1-.16-.255C5.206 5.503 5 5.004 5 4.5zm1 1v1.5c0 .246.106.56.322.926.21.358.498.72.798 1.05.28.31.563.58.784.78.12-.186.264-.42.407-.683C8.681 5.895 9 5.116 9 4.5A1.5 1.5 0 0 0 7.5 3zm1.256 5.096c-.2.22-.47.503-.78.784-.33.3-.692.588-1.05.798-.366.216-.68.322-.926.322H3V8.5A1.5 1.5 0 0 1 4.5 7c.616 0 1.395.32 2.073.689.262.143.497.286.683.407m.84.648c-.12.186-.264.42-.407.683C7.319 10.105 7 10.884 7 11.5A1.5 1.5 0 0 0 8.5 13H10v-1.5c0-.246-.106-.56-.322-.926a6.6 6.6 0 0 0-.798-1.05c-.28-.31-.563-.58-.784-.78m.648-.84c.2-.22.47-.503.78-.784a6.6 6.6 0 0 1 1.05-.798c.366-.216.68-.322.926-.322H13v1.5A1.5 1.5 0 0 1 11.5 9c-.616 0-1.396-.32-2.073-.689a11 11 0 0 1-.683-.407",
        clipRule: "evenodd"
      }
    )
  }
), Z4 = /* @__PURE__ */ t.forwardRef(I4), W4 = Z4, G4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707-1.064-1.064-.013.005-1.441-.386-.393-1.466-.677-.677L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162.218-.058-1.677-1.676zm1.785 3.2-.245.066-1.685 5.36.434 1.62.854.35.559-.15.536-2L8 9.179l.644.172L7 7.707V8H6v1H5V8H4V7h1V6h.293zM6 6.707V7h.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.833 10.25-.37 1.384-.817-.817.145-.544-1.685-5.361L10 4.348l-1.435.384H7.56L6.193 3.364l1.373.368h.869L10 3.312l2.894.776z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.5c0 .458-.205.868-.528 1.143l-.715-.714a.5.5 0 1 0-.686-.686l-.714-.714A1.5 1.5 0 0 1 12 7.5"
        }
      )
    ]
  }
), N4 = /* @__PURE__ */ t.forwardRef(G4), U4 = N4, Y4 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.566 2.732 6 2.312l-2.895.776L1.167 9.25l.638 2.38 1.626.664 1.441-.386.536-2L8 9.214l.87.233.26-.966L8 8.18l-3.408.913-.536 2-.559.15-.854-.35-.434-1.62 1.685-5.36L6 3.348l1.434.384h1.132l1.435-.384 2.105.564 1.685 5.36-.13.488.966.258.206-.768-1.938-6.162-2.894-.776-1.566.42h-.87Z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5 5v1H4v1h1v1h1V7h1V6H6V5z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M10 6.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m4.92 5L10 8.63v5.74zm-1.984 0L11 12.63v-2.26z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Q4 = /* @__PURE__ */ t.forwardRef(Y4), K4 = Q4, X4 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6 3.313 1.566.42h.869L10 3.312l2.894.775 1.938 6.162-.638 2.38-1.626.664-1.441-.386-.536-2L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162L6 3.312Zm0 1.035-2.106.564-1.685 5.36.434 1.62.854.35.559-.15.536-2L8 9.179l3.409.913.535 2 .559.15.854-.35.434-1.62-1.685-5.36L10 4.348l-1.435.384H7.434zM5 7V6h1v1h1v1H6v1H5V8H4V7zm5.5 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), J4 = /* @__PURE__ */ t.forwardRef(X4), e7 = J4, l7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3H0V2h2v1h11v6H8v1H3V9H2v1H1zm1 1v4h2v1h3V8h5V4zm8 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M8.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m5.5-.5h1V11h-5v1H5v-1h4v-1h5z",
        clipRule: "evenodd"
      }
    )
  }
), o7 = /* @__PURE__ */ t.forwardRef(l7), n7 = o7, i7 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707L10.293 11H9v1H4v-1H3v1H2V5H1V4h2v1h1.293L1.646 2.354zM5.293 6H3v4h2v1h3v-1h1.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 11h-.172l-1-1H13V6H8.828l-1-1H14z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 8c0 .458-.205.868-.529 1.143l-.714-.714a.5.5 0 1 0-.686-.686l-.714-.714A1.5 1.5 0 0 1 12.5 8"
        }
      )
    ]
  }
), r7 = /* @__PURE__ */ t.forwardRef(i7), t7 = r7, a7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5H1V4h2v1h11v6H9v1H4v-1H3v1H2zm1 1v4h2v1h3v-1h5V6zm8 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), s7 = /* @__PURE__ */ t.forwardRef(a7), d7 = s7, c7 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#hardware-gpu-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "M4 7h2v2H4zm0 3h2v2H4zm3 0h2v2H7z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m.854.146 15 15-.707.707-.854-.853H1V1.707L.146.854zM2 2.707V6h.5v4H2v4h4v-.5h4v.5h3.293l-2-2H10v-1.293L8.293 9H7V7.707L5.293 6H4V4.707z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "m15 12.172-1-1V10h-.5V6h.5V2h-4v.5H6V2H4.828l-1-1H15z" }),
        /* @__PURE__ */ l.jsx("path", { d: "M12 9h-.172L10 7.172V7h2zM9 6h-.172L7 4.172V4h2zm1-2h2v2h-2z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "hardware-gpu-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), h7 = /* @__PURE__ */ t.forwardRef(c7), w7 = h7, v7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1h14v14H1zm1 1v4h.5v4H2v4h4v-.5h4v.5h4v-4h-.5V6h.5V2h-4v.5H6V2zm2 2h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zM4 7h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zm-6 3h2v2H4zm3 0h2v2H7zm3 0h2v2h-2z",
        clipRule: "evenodd"
      }
    )
  }
), f7 = /* @__PURE__ */ t.forwardRef(v7), m7 = f7, p7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.076 7c.171-1.086.624-1.978 1.285-2.64C5.214 3.508 6.455 3 8 3s2.786.507 3.64 1.36c.66.662 1.113 1.554 1.284 2.64H12v4h1v2H9v-.5H7v2h2V14h5v-3h.36l.667-2-.667-2h-.425c-.18-1.339-.728-2.486-1.589-3.346C11.278 2.586 9.77 2 8 2s-3.278.586-4.346 1.654c-.86.86-1.408 2.007-1.588 3.346H1.64L.973 9l.667 2H4V7zM2.36 8l-.334 1 .334 1H3V8zm11.278 0H13v2h.64l.333-1-.334-1Z",
        clipRule: "evenodd"
      }
    )
  }
), g7 = /* @__PURE__ */ t.forwardRef(p7), u7 = g7, x7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v9H1zm1 1v7h12V4zm2 2H3V5h1zm1.5 0h-1V5h1zM7 6H6V5h1zm1.5 0h-1V5h1zM10 6H9V5h1zm1.5 0h-1V5h1zM13 6h-1V5h1zM4 8H3V7h1zm1.5 0h-1V7h1zM7 8H6V7h1zm1.5 0h-1V7h1zM10 8H9V7h1zm1.5 0h-1V7h1zM13 8h-1V7h1zm-9 2H3V9h1zm7 0H5V9h6zm2 0h-1V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), R7 = /* @__PURE__ */ t.forwardRef(x7), j7 = R7, M7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v7H3zm1 1v5h8V4zm10 8H2v-1h12z",
        clipRule: "evenodd"
      }
    )
  }
), H7 = /* @__PURE__ */ t.forwardRef(M7), C7 = H7, y7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.116 2h4.035L9.08 6h3.283L7 15.383V10H3.972zm.767 1L5.276 9H8v2.617L10.638 7H7.776l1.072-4z",
        clipRule: "evenodd"
      }
    )
  }
), b7 = /* @__PURE__ */ t.forwardRef(y7), V7 = b7, L7 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.707.708L10.293 11h-.391l.268 1H11v1H5v-1h.831l.268-1H2V3h.293L.646 1.354zM3.293 4H3v4h4.293zm5 5H3v1h6.293zm-1.159 2-.268 1h2.268l-.268-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 11h-.172l-1-1H13V9h-1.172l-1-1H13V4H6.828l-1-1H14z"
        }
      )
    ]
  }
), z7 = /* @__PURE__ */ t.forwardRef(L7), S7 = z7, k7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H9.902l.268 1H11v1H5v-1h.831l.268-1H2zm5.134 8-.268 1h2.268l-.268-1zM3 4v4h10V4zm10 5H3v1h10z",
        clipRule: "evenodd"
      }
    )
  }
), F7 = /* @__PURE__ */ t.forwardRef(k7), $7 = F7, B7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.065 2.579 7.982 6H8a2 2 0 1 1-1.927 1.465L3.005 5.694a5.5 5.5 0 1 0 4.06-3.115M3.506 4.83 6.573 6.6q.197-.2.443-.34l-.917-3.422a5.5 5.5 0 0 0-2.593 1.991Zm2.812-3.11a6.5 6.5 0 1 1 3.365 12.56A6.5 6.5 0 0 1 6.317 1.72ZM8 7a1 1 0 0 0-.866.5A1 1 0 1 0 8 7",
        clipRule: "evenodd"
      }
    )
  }
), A7 = /* @__PURE__ */ t.forwardRef(B7), E7 = A7, _7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1.86 5.562 3h4.876L15 1.86v12.28L10.438 13H5.562L1 14.14zM6 12h4v-2H6zm0-3h4V7H6zm0-3h4V4H6zM5 3.89l-3-.75v2.42l3 .375zm0 3.051-3-.375v2.868l3-.375zm0 3.125-3 .375v2.419l3-.75zm6-6.176v2.044l3-.375V3.14zm3 2.676-3 .375V9.06l3 .375zm0 3.875-3-.375v2.044l3 .75z",
        clipRule: "evenodd"
      }
    )
  }
), O7 = /* @__PURE__ */ t.forwardRef(_7), D7 = O7, P7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 0 0 8 0zm-1.75-3a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M9 3.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
        clipRule: "evenodd"
      }
    )
  }
), T7 = /* @__PURE__ */ t.forwardRef(P7), q7 = T7, I7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 0 0 8 0z",
        clipRule: "evenodd"
      }
    )
  }
), Z7 = /* @__PURE__ */ t.forwardRef(I7), W7 = Z7, G7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2V2zm3 0v3.5h2V2zm3 0v3.5h2V2zm2 4.5H4V10a4 4 0 0 0 8 0z",
        clipRule: "evenodd"
      }
    )
  }
), N7 = /* @__PURE__ */ t.forwardRef(G7), U7 = N7, Y7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2.5V5a1.5 1.5 0 0 1 1-1.415V2zm4.5 0v1.585A1.5 1.5 0 0 1 9.5 5v.5H12V2zM12 6.5H9.5V7a1.5 1.5 0 1 1-3 0v-.5H4V10a4 4 0 0 0 8 0zM7.5 6a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
        clipRule: "evenodd"
      }
    )
  }
), Q7 = /* @__PURE__ */ t.forwardRef(
  Y7
), K7 = Q7, X7 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2.5V5a1.5 1.5 0 0 1 1-1.415V2zm4.5 0v1.585A1.5 1.5 0 0 1 9.5 5v.5H12V2zM12 6.5H9.5V7a1.5 1.5 0 1 1-3 0v-.5H4V10a4 4 0 0 0 8 0zm-4-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5",
        clipRule: "evenodd"
      }
    )
  }
), J7 = /* @__PURE__ */ t.forwardRef(X7), ew = J7, lw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v9H1zm1 1v3h12V4zm12 4H2v3h12zM4 6H3V5h1zm0 4H3V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), ow = /* @__PURE__ */ t.forwardRef(lw), nw = ow, iw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m4.147 4.646.707.708L2.207 8l2.647 2.646-.707.708L.793 8zM13.793 8l-2.646-2.646.707-.708L15.207 8l-3.353 3.354-.707-.707zM4 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), rw = /* @__PURE__ */ t.forwardRef(iw), tw = rw, aw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2h4v3H6zm1 1v1h2V3zm3 4H6V6h4zm-1.5 3.08 1.63.437-.26.966L8 10.982l-1.87.501-.26-.966 1.63-.437V7.964h1zM1 9h4v3H1zm1 1v1h2v-1zm9-1h4v3h-4zm1 1v1h2v-1zm-7 4H1v-1h4zm10 0h-4v-1h4z",
        clipRule: "evenodd"
      }
    )
  }
), sw = /* @__PURE__ */ t.forwardRef(aw), dw = sw, cw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 2.5 1.937v1.626c.512.132.944.461 1.211.902l1.29-.387a2 2 0 1 1 .287.958l-1.29.386a2 2 0 0 1-.508 1.411l.852 1.278a2 2 0 1 1-.832.555l-.852-1.277a2 2 0 0 1-1.316 0l-.852 1.277a2 2 0 1 1-.832-.555l.852-1.277A2 2 0 0 1 6 8.422l-1.29-.387a2 2 0 1 1 .287-.958l1.29.388c.268-.44.7-.77 1.212-.902V4.937A2 2 0 0 1 6 3M3 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 7.5a1 1 0 1 0 0 2.001A1 1 0 0 0 8 7.5M5 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 0 0-1 1 1 1 0 1 0 1-1",
        clipRule: "evenodd"
      }
    )
  }
), hw = /* @__PURE__ */ t.forwardRef(cw), ww = hw, vw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.5 15v-1.23L4 12.484V1h8v14zM5 11.627l.89-.764 3.15-5.85L5 2.416zm4.884-6.072L6.947 11.01 11 13.59V6.272zM11 5.084l-.64-.412.64-1.189zM9.516 4.13 6.203 2h4.46zM3.768 14l2.563-2.197L9.782 14z",
        clipRule: "evenodd"
      }
    )
  }
), fw = /* @__PURE__ */ t.forwardRef(vw), mw = fw, pw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 4H1v8h14zM2 5.337v4.446l2.107-3.311zm2.99 1.61L2.41 11h7.317l.717-1.116zm6.337 3.413-.411.64h1.6zm2.673.303-2.13-1.147L14 6.202v4.46ZM10.987 9.04 3.483 5h10.101z",
        clipRule: "evenodd"
      }
    )
  }
), gw = /* @__PURE__ */ t.forwardRef(pw), uw = gw, xw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m0 5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 0 1 2.995-.117l2.982.799-.259.966-2.981-.799A1.5 1.5 0 0 1 6.5 8",
        clipRule: "evenodd"
      }
    )
  }
), Rw = /* @__PURE__ */ t.forwardRef(xw), jw = Rw, Mw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m0 5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.496.383a1.5 1.5 0 1 1 .26.966l-2.982.799-.26-.966z",
        clipRule: "evenodd"
      }
    )
  }
), Hw = /* @__PURE__ */ t.forwardRef(Mw), Cw = Hw, yw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m.273 4.525a1.5 1.5 0 1 0 .866.5l1.544-2.675-.866-.5zM8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
        clipRule: "evenodd"
      }
    )
  }
), bw = /* @__PURE__ */ t.forwardRef(yw), Vw = bw, Lw = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 2H4v3h1V3h8v5H8v1h6zm-6 9h7v-1H8z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 6H2v8h5zm-4 5V7h1v1h1V7h1v4zm0 1v1h3v-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), zw = /* @__PURE__ */ t.forwardRef(Lw), Sw = zw, kw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12 3.293-.901-.901-2.395 1.197L8 4.293l-.646-.647-.707.708L11 8.707l.647.647.707-.708L11.707 8l.704-.704 1.197-2.395-.9-.901 1.646-1.646-.707-.708zm-1 4 .59-.59.802-1.604-1.49-1.49-1.606.802L8.707 5zm-5.5.5 1.646-1.647.708.708L6.207 8.5 7.5 9.793l1.646-1.647.708.707L8.207 10.5l1.147 1.146-.708.707L8 11.707l-.704.704-2.395 1.197-.901-.9-1.646 1.646-.708-.708L3.293 12l-.901-.901 1.197-2.395L4.293 8l-.647-.646.708-.708.646.647zm-.5.914-.589.59-.803 1.604 1.49 1.49 1.606-.802.589-.589z",
        clipRule: "evenodd"
      }
    )
  }
), Fw = /* @__PURE__ */ t.forwardRef(kw), $w = Fw, Bw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 1h8v7h1v3.678l-3 .804V15H6v-2.518l-3-.804V8h1zm0 8v1.91l4 1.072 4-1.071V9zm7-1H5V2h6zm-4 4.75V14h2v-1.25l-1 .268zM6 5V3h1v2zm3 0V3h1v2z",
        clipRule: "evenodd"
      }
    )
  }
), Aw = /* @__PURE__ */ t.forwardRef(Bw), Ew = Aw, _w = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 4V1h1v3h2V1h1v3h3v1h-1v2.365L11.294 10H8.5v1.5A2.5 2.5 0 0 1 6 14H3v-1h3a1.5 1.5 0 0 0 1.5-1.5V10H4.706L4 7.365V5H3V4zM5 5v2.233L5.473 9h5.054L11 7.233V5z",
        clipRule: "evenodd"
      }
    )
  }
), Ow = /* @__PURE__ */ t.forwardRef(_w), Dw = Ow, Pw = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7.5 1v7h1V1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 3.669a5 5 0 1 1-5 0L5 2.803a6 6 0 1 0 6.002 0z"
        }
      )
    ]
  }
), Tw = /* @__PURE__ */ t.forwardRef(Pw), qw = Tw, Iw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 5H2v6h1.5v2h1v-2h1v2h1v-2h1v2h1v-2h1v2h1v-2h1v2h1v-2H14V5h-1.5V3h-1v2h-1V3h-1v2h-1V3h-1v2h-1V3h-1v2h-1V3h-1zM3 6v4h10V6z",
        clipRule: "evenodd"
      }
    )
  }
), Zw = /* @__PURE__ */ t.forwardRef(Iw), Ww = Zw, Gw = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.25 2.236A5.5 5.5 0 0 1 8 1.5c1.003 0 1.941.268 2.75.736l.5-.866A6.5 6.5 0 0 0 8 .5a6.5 6.5 0 0 0-3.251.87zm1 1.732A3.5 3.5 0 0 1 8 3.5c.638 0 1.236.17 1.75.468l.5-.865A4.5 4.5 0 0 0 8 2.5a4.5 4.5 0 0 0-2.25.603z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.75 11.5v-1h1v1zm1.5-1v1h1v-1zM6.75 13v-1h1v1zm1.5-1v1h1v-1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5h6v10H5zm1 1v8h4V6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Nw = /* @__PURE__ */ t.forwardRef(Gw), Uw = Nw, Yw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a2 2 0 1 0-3.723 1.016L4.879 5.414a2.5 2.5 0 1 0-1.477 4.584L5.404 12H2.117l-.804 3h13.375l-.804-3H9.646L5.888 8.242a2.5 2.5 0 0 0-.302-2.12l1.398-1.399a1.99 1.99 0 0 0 1.995.021l.003-.001 1.807 1.761-.289.289v1.914l1.646 1.647.707-.708L11.5 8.293V7.207l.354-.353.353-.354h1.086l1.353 1.354.707-.708L13.707 5.5h-1.914l-.297.297L9.703 4.05C9.89 3.744 10 3.385 10 3M5.38 9.148 8.232 12H6.818L4.576 9.757c.308-.147.581-.355.804-.61ZM8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2M3.5 6a1.5 1.5 0 0 1 1.27.702c.146.23.23.504.23.798A1.5 1.5 0 1 1 3.5 6m9.617 7 .267 1H2.616l.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), Qw = /* @__PURE__ */ t.forwardRef(Yw), Kw = Qw, Xw = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.793 2H13v3h-.5v1h.5v8H3V3.793zM12 7h-.5V4h.5V3H5.207L4 4.207V13h8zM7 7V4h1v3zm2 0V4h1v3zM5 7V4.5h1V7z",
        clipRule: "evenodd"
      }
    )
  }
), Jw = /* @__PURE__ */ t.forwardRef(Xw), ev = Jw, lv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 2.5v6.672l-1-1V2.5a.5.5 0 0 0-.5-.5H9v1H7V2H5.5a.5.5 0 0 0-.429.243l-.714-.714A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5m-3.5 11h-1v-1h1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12 12.707 1.646 1.647.708-.708-12-12-.708.708L4 4.707V13.5A1.5 1.5 0 0 0 5.5 15h5a1.5 1.5 0 0 0 1.5-1.5zm-7-7V11h5.293zM11 12H5v1.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ov = /* @__PURE__ */ t.forwardRef(lv), nv = ov, iv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2.5A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5zM5.5 2a.5.5 0 0 0-.5.5V11h6V2.5a.5.5 0 0 0-.5-.5H9v1H7V2zM11 12H5v1.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5zm-2.5 1.5h-1v-1h1z",
        clipRule: "evenodd"
      }
    )
  }
), rv = /* @__PURE__ */ t.forwardRef(iv), tv = rv, av = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 2.5v7.672l-1-1V2.5a.5.5 0 0 0-.5-.5H4.828l-.89-.89q.26-.109.562-.11h7A1.5 1.5 0 0 1 13 2.5m-4.5 11h-1v-1h1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.988 13.695A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V3.707L1.646 2.354l.708-.708 13 13-.707.708-1.66-1.66ZM4 4.707V11h6.293zM11.293 12H4v1.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.793z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), sv = /* @__PURE__ */ t.forwardRef(av), dv = sv, cv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5zM4.5 2a.5.5 0 0 0-.5.5V11h8V2.5a.5.5 0 0 0-.5-.5zM12 12H4v1.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zm-3.5 1.5h-1v-1h1z",
        clipRule: "evenodd"
      }
    )
  }
), hv = /* @__PURE__ */ t.forwardRef(cv), wv = hv, vv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-2.935-2.935c-1.966 1.815-3.81 2.426-5.217 2.554a6.2 6.2 0 0 1-1.776-.086 5 5 0 0 1-.643-.178l-.041-.016-.013-.005-.004-.002-.002-.001.197-.46-.198.46-.222-.097-.669-2.495 3.528-2.037 1.76 1.016a4.5 4.5 0 0 0 1.213-.74L1.646 2.354zm6.98 8.396c-.638.547-1.257.873-1.819 1.054l-.211.069-1.652-.954-2.363 1.365.338 1.262q.116.034.29.07c.347.07.857.127 1.487.07 1.174-.107 2.802-.618 4.6-2.267z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.975 5.52c-.099 1.124-.507 2.523-1.594 4.033l-.717-.718c.912-1.313 1.235-2.493 1.315-3.403a5.2 5.2 0 0 0-.078-1.496 4 4 0 0 0-.074-.296l-1.264-.34L10.2 5.665l.99 1.716-.077.218a5 5 0 0 1-.203.481L9.797 6.968l-.753-1.303 2.037-3.528 2.494.668.096.22-.458.2.458-.2.002.003.001.004.006.013a2 2 0 0 1 .066.182c.04.12.09.29.134.506.09.431.16 1.043.095 1.786Z"
        }
      )
    ]
  }
), fv = /* @__PURE__ */ t.forwardRef(vv), mv = fv, pv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.081 2.136 9.044 5.665l1.044 1.807c-.193.447-.52.957-1.065 1.498-.588.583-1.139.916-1.612 1.102L5.652 9.056l-3.528 2.037.669 2.495.221.096.2-.459-.2.46h.004l.004.002.013.006.04.016a4.6 4.6 0 0 0 .643.179 6.2 6.2 0 0 0 1.777.085c1.49-.136 3.473-.814 5.57-2.893 2.1-2.08 2.779-4.064 2.91-5.561a6.2 6.2 0 0 0-.095-1.786 5 5 0 0 0-.184-.647l-.016-.041-.006-.013-.002-.004v-.002s-.001-.002-.459.2l.458-.202-.096-.22zm1.746 1.504q.036.119.073.296c.073.35.134.864.079 1.496-.11 1.253-.681 3.019-2.618 4.938-1.938 1.921-3.706 2.493-4.957 2.607-.63.058-1.14 0-1.488-.07a4 4 0 0 1-.29-.07l-.337-1.261 2.363-1.365 1.652.954.211-.069c.677-.218 1.434-.645 2.212-1.416.73-.724 1.155-1.435 1.385-2.081l.078-.218-.991-1.716L11.563 3.3l1.264.339Z",
        clipRule: "evenodd"
      }
    )
  }
), gv = /* @__PURE__ */ t.forwardRef(pv), uv = gv, xv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.854 2.647 8 .793 6.146 2.647l.708.707.646-.647v7.141L5 9.178V7.916a1.5 1.5 0 1 0-1 0v2.03l3.5.939v.179a2 2 0 1 0 1 0v-1.68l3.5-.937V7h1V4h-3v3h1v.678l-2.5.67v-5.64l.646.646zM12 5v1h-1V5zM4 6.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M7 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), Rv = /* @__PURE__ */ t.forwardRef(xv), jv = Rv, Mv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4H6V3h4zm2.384 1 .937 3.498-.937 3.497h-3.5L8.615 11H7.384l-.267.995h-3.5l-.938-3.498L3.616 5zm-8 1-.67 2.497.67 2.498H6.35L6.616 10h2.768l.266.995h1.966l.67-2.497L11.616 6zm-3-.13.965.26-.635 2.367.636 2.374-.966.258L.68 8.497l.704-2.626Zm12.902 2.628-.635-2.369.966-.258.704 2.627-.705 2.631-.966-.258z",
        clipRule: "evenodd"
      }
    )
  }
), Hv = /* @__PURE__ */ t.forwardRef(Mv), Cv = Hv, yv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 1h6v3a5 5 0 0 1 1.9 3h.6v2h-.6a5 5 0 0 1-1.9 3v3H5v-3a5 5 0 0 1-2-4c0-1.636.786-3.088 2-4zm1 2.416A5 5 0 0 1 8 3c.711 0 1.388.148 2 .416V2H6zm0 9.168V14h4v-1.416A5 5 0 0 1 8 13a5 5 0 0 1-2-.416M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m.408 3.592-.572-2.137-.966.259.722 2.694 2.694.722.259-.966z",
        clipRule: "evenodd"
      }
    )
  }
), bv = /* @__PURE__ */ t.forwardRef(yv), Vv = bv, Lv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707L11 11.707V12H5v-1h.831l.268-1H4.5a3.5 3.5 0 0 1-1.743-6.536l-1.11-1.11zM3.5 4.208A2.5 2.5 0 0 0 4.5 9h3.793L5.987 6.695a1.5 1.5 0 1 1-1.682-1.683zm6.623 6.623.046.169h.123l-.169-.168ZM7.134 10l-.268 1h2.268l-.268-1zM4.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 6.5a3.5 3.5 0 0 1-2.361 3.31l-.83-.829A2.5 2.5 0 0 0 11.5 4H6.828l-1-1H11.5A3.5 3.5 0 0 1 15 6.5"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 7h-1V6h1z" })
    ]
  }
), zv = /* @__PURE__ */ t.forwardRef(Lv), Sv = zv, kv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5.5A3.5 3.5 0 0 1 4.5 2h7a3.5 3.5 0 0 1 3.194 4.934l-.912-.41A2.5 2.5 0 0 0 11.5 3h-7a2.5 2.5 0 0 0 0 5h2.902L6.6 11H5v-1h.831L6.1 9H4.5A3.5 3.5 0 0 1 1 5.5M4.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M3 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m8 3.55a2.5 2.5 0 0 0-1.371.792l-.91-.525-.5.866.91.525a2.5 2.5 0 0 0 0 1.584l-.91.525.5.866.91-.525a2.5 2.5 0 0 0 1.37.792V15h1v-1.05a2.5 2.5 0 0 0 1.372-.792l.91.525.5-.866-.91-.525a2.5 2.5 0 0 0 0-1.584l.91-.525-.5-.866-.91.525A2.5 2.5 0 0 0 12 9.05V8h-1zm.5.95a1.5 1.5 0 1 0-.002 2.999A1.5 1.5 0 0 0 11.5 10m.5-4h-1V5h1z",
        clipRule: "evenodd"
      }
    )
  }
), Fv = /* @__PURE__ */ t.forwardRef(kv), $v = Fv, Bv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6.5A3.5 3.5 0 0 1 4.5 3h7a3.5 3.5 0 1 1 0 7H9.902l.268 1H11v1H5v-1h.831l.268-1H4.5A3.5 3.5 0 0 1 1 6.5M7.134 10l-.268 1h2.268l-.268-1zM4.5 4a2.5 2.5 0 0 0 0 5h7a2.5 2.5 0 0 0 0-5zm0 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M3 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m9 .5h-1V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), Av = /* @__PURE__ */ t.forwardRef(Bv), Ev = Av, _v = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.188 4v1.812c0 .153.032.308.08.456a1.5 1.5 0 0 0-.455-.08A1.81 1.81 0 0 0 4 8v1.812h1.813c.152 0 .307-.032.455-.08-.048.148-.08.303-.08.456 0 1 .811 1.812 1.812 1.812h1.813v-1.813c0-.152-.033-.307-.081-.455.148.048.303.08.456.08A1.813 1.813 0 0 0 12 8V6.187h-1.813c-.152 0-.307.033-.455.081.048-.148.08-.303.08-.456A1.81 1.81 0 0 0 8 4zM8.25 6.886a10 10 0 0 1-.25.332 10 10 0 0 1-.25-.332 5.4 5.4 0 0 1-.413-.655c-.115-.224-.15-.362-.15-.419V5H8c.449 0 .813.364.813.812 0 .057-.035.195-.15.42a5.4 5.4 0 0 1-.413.654m-1.364.864q.18.129.332.25a10 10 0 0 1-.332.25 5.4 5.4 0 0 1-.655.413c-.224.115-.362.15-.418.15H5V8c0-.449.364-.813.813-.813.056 0 .194.034.418.15.209.107.437.256.655.413M8.25 9.114A10 10 0 0 0 8 8.782a10 10 0 0 0-.25.332 5.4 5.4 0 0 0-.413.655c-.115.224-.15.362-.15.418 0 .45.364.813.813.813h.813v-.813c0-.056-.035-.194-.15-.418a5.4 5.4 0 0 0-.413-.655m.864-.864A10 10 0 0 1 8.782 8a10 10 0 0 1 .332-.25c.218-.157.446-.306.655-.413.224-.115.362-.15.418-.15H11V8a.813.813 0 0 1-.813.812c-.056 0-.194-.034-.418-.15a5.4 5.4 0 0 1-.655-.412",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m8.001 1.072-6 3.464v6.928l6 3.464 6-3.464V4.536zm0 12.701-5-2.886V5.113l5-2.887 5 2.887v5.774z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ov = /* @__PURE__ */ t.forwardRef(_v), Dv = Ov, Pv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 11v1H7v-1zm2 1H9v-1h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.707.708L13.293 14H2V9h5.5v-.793l-1.85-1.85-.248.144a3 3 0 0 1-.288-.68L4.01 4.717A4 4 0 0 0 4.535 7l-.865.5a5 5 0 0 1-.535-3.659L1.646 2.355l.708-.708ZM9.293 10H3v3h9.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14 11.172-1-1V10h-.172l-1-1H14zM9 5c0 .32-.15.605-.384.788L7.212 4.384A1 1 0 0 1 9 5m3 0a4 4 0 0 0-.535-2l.866-.5c.426.735.669 1.59.669 2.5a5 5 0 0 1-.67 2.5l-.865-.5A4 4 0 0 0 12 5m-2 0a2 2 0 0 0-.267-1l.865-.5c.256.441.402.954.402 1.5s-.146 1.059-.402 1.5L9.733 6A2 2 0 0 0 10 5"
        }
      )
    ]
  }
), Tv = /* @__PURE__ */ t.forwardRef(Pv), qv = Tv, Iv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.535 3A4 4 0 0 0 4 5c0 .73.195 1.412.535 2l-.866.5A5 5 0 0 1 3 5c0-.91.244-1.765.67-2.5zM12 5a4 4 0 0 0-.535-2l.866-.5c.425.735.669 1.59.669 2.5a5 5 0 0 1-.67 2.5l-.865-.5A4 4 0 0 0 12 5M6.267 4C6.097 4.294 6 4.635 6 5s.097.706.267 1l-.865.5A3 3 0 0 1 5 5c0-.546.146-1.059.402-1.5zM10 5a2 2 0 0 0-.267-1l.865-.5c.256.441.402.954.402 1.5a3 3 0 0 1-.402 1.5L9.733 6A2 2 0 0 0 10 5M7 5a1 1 0 1 1 1.5.866V9H14v5H2V9h5.5V5.866A1 1 0 0 1 7 5m-4 5v3h10v-3zm5 1v1H7v-1zm2 1H9v-1h1zm2 0h-1v-1h1z",
        clipRule: "evenodd"
      }
    )
  }
), Zv = /* @__PURE__ */ t.forwardRef(Iv), Wv = Zv, Gv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708L12 12.707V14H4V4.707L1.646 2.354zM5 5.707V13h6v-1.293L8.293 9H6V8h1.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "m12 9.172-1-1V3H5.828l-1-1H12z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 7h-.172l-1-1H10zm0-2H9V4h1z" })
    ]
  }
), Nv = /* @__PURE__ */ t.forwardRef(Gv), Uv = Nv, Yv = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.708L13.293 14H10v-1h2.293L11 11.707V12H6.902l.268 1H9v1H3v-1h1.831l.268-1H1V5h3.293L1.646 2.354zM5.293 6H2v5h8v-.293zM6 12.5l-.134.5h.268z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "m15 12.172-1-1V3H8v1H7V2h8z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 9h-1.172L10 7.172V6H8.828l-1-1H11v1h2v1h-2v1h2zm-1-5h1v1h-1z"
        }
      )
    ]
  }
), Qv = /* @__PURE__ */ t.forwardRef(Yv), Kv = Qv, Xv = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2h8v12h-5v-1h4V3H8v1H7zm5 2h1v1h-1zM1 5h10v1h2v1h-2v1h2v1h-2v3H6.902l.268 1H9v1H3v-1h1.831l.268-1H1zm5 7.5-.134.5h.268zM10 6H2v5h8z",
        clipRule: "evenodd"
      }
    )
  }
), Jv = /* @__PURE__ */ t.forwardRef(Xv), e8 = Jv, l8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2h8v12H4zm1 1v10h6V3zm5 2H9V4h1zm0 2H6V6h4zm0 2H6V8h4z",
        clipRule: "evenodd"
      }
    )
  }
), o8 = /* @__PURE__ */ t.forwardRef(l8), n8 = o8, i8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.25 1.543 2.207 2.207L7 11.207v.043c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 4.792 9zM4.76 10h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055.9-.127 1.57-.774 1.57-1.755v-.01zm1.724.31.809-.81-.793-.793-.81.81zM7.207 8 8 8.793l5.043-5.043-.793-.793z",
        clipRule: "evenodd"
      }
    )
  }
), r8 = /* @__PURE__ */ t.forwardRef(i8), t8 = r8, a8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.664 4.957.693-2.586.966.258-.843 3.144 3.02 3.02v.689l-1.741.466-3.259 3.26L1.793 8.5 6.5 3.793zm-.299 1.115L6.5 5.207 3.207 8.5 6.5 11.793l2.741-2.741.87-.233-1.93-1.93-.198.74-.966-.258zm5.489 4.074-.354.354-.354-.354.354-.353zm-.354 1.135-.084.121c-.233.35-.416.748-.416 1.098a.5.5 0 1 0 1 0c0-.35-.183-.748-.416-1.098l-.084-.12Zm0-.781-.354-.354v.001l-.002.002-.003.003-.011.012-.038.04a5 5 0 0 0-.508.644c-.267.4-.584 1.002-.584 1.652a1.5 1.5 0 1 0 3 0c0-.65-.317-1.252-.584-1.652a5.3 5.3 0 0 0-.545-.684l-.012-.012-.003-.003-.002-.002z",
        clipRule: "evenodd"
      }
    )
  }
), s8 = /* @__PURE__ */ t.forwardRef(a8), d8 = s8, c8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.191 2h3.618l1 2H14v5h-1V5h-2.809l-1-2H6.809l-1 2H3v7h1v1H2V4h3.191zM8 6a2 2 0 0 0-1.834 2.8l-.916.4a3 3 0 1 1 5.5 0l-.916-.4A2 2 0 0 0 8 6m-4 5v-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4v-1h2v-1H5v-1h1v-1zm4 0a1 1 0 0 1 1-1h2v1.01h-1V11H9v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm1 2v1h1v-1zm3-2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm2 0h-1v3h1z",
        clipRule: "evenodd"
      }
    )
  }
), h8 = /* @__PURE__ */ t.forwardRef(c8), w8 = h8, v8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4a3 3 0 0 0-3-3V0a4 4 0 0 1 4 4zm-2 0a1 1 0 0 0-1-1V2a2 2 0 0 1 2 2zM6.191 3h3.618l1 2H14v9H2V5h3.191zm.618 1-1 2H3v7h10V6h-2.809l-1-2zM8 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
), f8 = /* @__PURE__ */ t.forwardRef(v8), m8 = f8, p8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.191 2h3.618l1 2H14v5h-1V5h-2.809l-1-2H6.809l-1 2H3v7h8v1H2V4h3.191zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7 3a1 1 0 0 1 1-1h2v1.01h-1V11h-1v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v-1.01h1V14h1v-1h-1a1 1 0 0 1-1-1z",
        clipRule: "evenodd"
      }
    )
  }
), g8 = /* @__PURE__ */ t.forwardRef(p8), u8 = g8, x8 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.773 4.455a1.318 1.318 0 1 0 0 2.636 1.318 1.318 0 0 0 0-2.636m-.319 1.318a.318.318 0 1 1 .637 0 .318.318 0 0 1-.637 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2H2v10h10zM3 7.211V3h8v5.54L8.65 7.183 5.8 8.828zm5.65 1.126L11 9.694V11H3V8.366l2.8 1.617z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 4v9H4v1h10V4z" })
    ]
  }
), R8 = /* @__PURE__ */ t.forwardRef(x8), j8 = R8, M8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4V2h1v9h9v1h-2v2h-1v-2H4V5H2V4zm7 1H6V4h6v6h-1z",
        clipRule: "evenodd"
      }
    )
  }
), H8 = /* @__PURE__ */ t.forwardRef(M8), C8 = H8, y8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 8a6 6 0 0 1 6-6V1a7 7 0 0 0 0 14v-1a6 6 0 0 1-6-6m8-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      }
    )
  }
), b8 = /* @__PURE__ */ t.forwardRef(y8), V8 = b8, L8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2H6v1H2v8h2v1h1.652l-.635 2.37.966.26.704-2.63h2.625l.705 2.63.966-.26-.636-2.37H12v-1h2V3h-4V2H8.5V1h-1zM3 4v6h10V4z",
        clipRule: "evenodd"
      }
    )
  }
), z8 = /* @__PURE__ */ t.forwardRef(L8), S8 = z8, k8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2.293 14.207 6.5l-6.5 6.5H5.293l-3-3zM3.707 10l2 2h1.586l2.5-2.5L7 6.707zm4-4L10.5 8.793 12.793 6.5 10 3.707zM14 13h-4v-1h4z",
        clipRule: "evenodd"
      }
    )
  }
), F8 = /* @__PURE__ */ t.forwardRef(k8), $8 = F8, B8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.146 3.854a.914.914 0 0 0-1.293 0L9.707 5 11 6.293l1.146-1.147a.914.914 0 0 0 0-1.292M10.043 6.75l-.793-.793-4.84 4.84-.792 1.585 1.586-.793zm-1.5-1.5-4.954 4.954-1.197 2.395 1.01 1.01 2.394-1.198 4.954-4.954.896.897.707-.708L11.707 7l1.146-1.146a1.914 1.914 0 1 0-2.707-2.708L9 4.293l-.646-.647-.708.708z",
        clipRule: "evenodd"
      }
    )
  }
), A8 = /* @__PURE__ */ t.forwardRef(B8), E8 = A8, _8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zM5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M9 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-1 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-4 3v-3H1v4h4v-1zm13-3v4h-4v-1h3v-3z",
        clipRule: "evenodd"
      }
    )
  }
), O8 = /* @__PURE__ */ t.forwardRef(_8), D8 = O8, P8 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m8.5 3.793 1.146-1.147.708.708L8 5.707 5.646 3.354l.708-.708L7.5 3.793V1h1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3zm9 6.694-2.35-1.357-2.85 1.646L4 10.366V13h8z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0m1.319-.318a.318.318 0 1 0 0 .636.318.318 0 0 0 0-.636",
          clipRule: "evenodd"
        }
      )
    ]
  }
), T8 = /* @__PURE__ */ t.forwardRef(P8), q8 = T8, I8 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.11 3.682 3.683 7.111l.707.707 3.429-3.429-.707-.707Zm2.514.487L4.169 9.624l.707.707 5.455-5.455zm1.5 1.5-5.455 5.455.707.707 5.455-5.455zm-2.235 6.649 3.429-3.429-.707-.707-3.43 3.429z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Z8 = /* @__PURE__ */ t.forwardRef(I8), W8 = Z8, G8 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m1.854 5.854 4-4-.708-.708-4 4zm0-3 1-1-.708-.708-1 1zm6.292-1.708L6.521 2.772l.707.707 1.626-1.625zm3 0L9.35 2.944l.707.707 1.798-1.797-.707-.708Zm3 0-2.964 2.965.707.707 2.965-2.964zm-1.09 5.504 1.798-1.796-.707-.708-1.798 1.798zM2.774 6.519 1.146 8.146l.708.708L3.48 7.226zm11.372.627L12.52 8.774l.707.707 1.628-1.627-.707-.708ZM2.944 9.35l-1.798 1.796.708.707 1.797-1.797-.707-.707Zm7.91 5.504 4-4-.707-.708-4 4zM4.11 11.182l-2.964 2.964.708.707 2.964-2.964-.707-.707Zm.744 3.672 1.797-1.798-.707-.707-1.798 1.797zm3.92-2.334-1.628 1.626.708.707 1.627-1.627zm5.08 2.334 1-1-.707-.708-1 1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), N8 = /* @__PURE__ */ t.forwardRef(G8), U8 = N8, Y8 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 14h-1V2h1zM2 3.293 6.707 8 2 12.707zm12 0v9.414L9.293 8zM3 5.707v4.586L5.293 8zM10.707 8 13 10.293V5.707z",
        clipRule: "evenodd"
      }
    )
  }
), Q8 = /* @__PURE__ */ t.forwardRef(Y8), K8 = Q8, X8 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 2H2v7h7zM3 8V3h5v5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.646 10.854 11.793 12H2v1h9.793l-1.147 1.146.707.707 2.354-2.353-2.354-2.354zM10 3h1V2h-1zm2 0h1v1h1V2h-2zm1 2v1h1V5zm0 2v1h-1v1h2V7zm-2 1h-1v1h1z"
        }
      )
    ]
  }
), J8 = /* @__PURE__ */ t.forwardRef(X8), ef = J8, lf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3C4.607 3 2 5.35 2 8c0 .948.146 1.75.545 2.473.398.723 1.074 1.415 2.212 2.098.933.56 1.658.547 1.957.38a.35.35 0 0 0 .194-.305c.011-.171-.052-.46-.324-.869-.388-.581-.456-1.201-.262-1.733.19-.518.613-.91 1.125-1.074.88-.281 1.75-.106 2.83.614.835.557 1.79.646 2.508.366C13.474 9.68 14 9.049 14 8c0-1.644-.66-2.874-1.713-3.703C11.22 3.457 9.712 3 8 3M1 8c0-3.35 3.213-6 7-6 1.877 0 3.62.499 4.905 1.511C14.206 4.534 15 6.054 15 8c0 1.451-.77 2.457-1.851 2.88-1.055.413-2.35.253-3.426-.464-.92-.613-1.473-.653-1.972-.493a.77.77 0 0 0-.49.464c-.074.205-.073.494.155.836.341.511.521 1.019.49 1.488a1.34 1.34 0 0 1-.705 1.114c-.76.423-1.897.24-2.958-.396-1.245-.747-2.069-1.555-2.575-2.474S1 9.052 1 8m6-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M3 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), of = /* @__PURE__ */ t.forwardRef(lf), nf = of, rf = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#image-scale-relative-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "M4 7.5H3v-1h1z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.708-1.854-1.854H1V3h1.293L.646 1.354zM3.293 4H2v8.5h9.793L10 10.707v.793H9v-1h.793L6 6.707V7.5H5v-1h.793z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M15 3v9.172l-1-1V4H6.828l-1-1z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "image-scale-relative-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), tf = /* @__PURE__ */ t.forwardRef(rf), af = tf, sf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v10.5H1zm1 1v8.5h12V4zm2 3.5H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm1 0v-1h1v1zm0 2v-1h1v1zm0 2v-1h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), df = /* @__PURE__ */ t.forwardRef(sf), cf = df, hf = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 2H2v4h1V3h10v10h-3v1h4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.294 5 8.646 6.645l.707.708 1.65-1.648V7h1V4H9v1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 8H2v6h6zm-5 5V9h4v4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), wf = /* @__PURE__ */ t.forwardRef(hf), vf = wf, ff = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.024 3.095a5 5 0 0 0-1.802.748l-.555-.832a6 6 0 0 1 2.162-.897l.195.98Zm3.755.747a5 5 0 0 0-1.803-.746l.195-.98a6 6 0 0 1 2.163.894zm-6.937 1.38a5 5 0 0 0-.746 1.802l-.98-.195a6 6 0 0 1 .894-2.163l.832.555Zm9.063 1.802a5 5 0 0 0-.748-1.802l.832-.555c.451.675.748 1.41.897 2.162l-.98.195Zm-.747 3.755c.367-.55.619-1.164.746-1.804l.98.195a6 6 0 0 1-.894 2.164zM3.095 8.976c.124.625.37 1.237.748 1.802l-.832.555a6 6 0 0 1-.897-2.162zm5.88 3.93a5 5 0 0 0 1.803-.749l.555.832a6 6 0 0 1-2.162.897l-.195-.98Zm-3.754-.748c.55.368 1.164.619 1.804.746l-.195.98a6 6 0 0 1-2.164-.894z",
        clipRule: "evenodd"
      }
    )
  }
), mf = /* @__PURE__ */ t.forwardRef(ff), pf = mf, gf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 2H2v2h1V3h1zm5.5 0h-3v1h3zM2 6.5v3h1v-3zM3 12H2v2h2v-1H3zm3.5 2h3v-1h-3zm7.707-12H12v.793l-.354.353.708.708zm-3.561 2.146-1.5 1.5.708.708 1.5-1.5zM8.854 7.354l-.707-.708L6.793 8l1.354 1.354.707-.708L8.207 8zm.293 3 1.5 1.5.707-.708-1.5-1.5zm2.499 2.5.354.353V14h2.207l-1.853-1.854z"
      }
    )
  }
), uf = /* @__PURE__ */ t.forwardRef(gf), xf = uf, Rf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM12 2h2v2h-1V3h-1zM2 9.5v-3h1v3zm12-3v3h-1v-3zM2 12h1v1h1v1H2zm12 0v2h-2v-1h1v-1zm-4.5 2h-3v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), jf = /* @__PURE__ */ t.forwardRef(Rf), Mf = jf, Hf = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.362 7 4.5 1.992 1.638 7zM5.638 6H3.362L4.5 4.008z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.293 3 9.646 5.646l.708.708L13 3.707V5h1V2h-3v1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M3 11.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14 9H9v5h5zm-1 4h-3v-3h3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Cf = /* @__PURE__ */ t.forwardRef(Hf), yf = Cf, bf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 4V2h1v2zM4.818 5.525 3.404 4.111l.707-.707 1.414 1.414zm6.364 0-.707-.707 1.414-1.414.707.707zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1 .5H2v-1h2zm10 0h-2v-1h2zm-9.89 4.096-.706-.707 1.414-1.414.707.707zm7.78 0-1.415-1.414.707-.707 1.414 1.414zM8.5 12v2h-1v-2z",
        clipRule: "evenodd"
      }
    )
  }
), Vf = /* @__PURE__ */ t.forwardRef(bf), Lf = Vf, zf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 4V3h1v1zM4.818 5.525l-.707-.707.707-.707.707.707zm5.657-.707.707-.707.707.707-.707.707zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1 .5H3v-1h1zm9 0h-1v-1h1zm-8.89 2.682.708-.707.707.707-.707.707zm7.072.707-.707-.707.707-.707.707.707zM8.5 12v1h-1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Sf = /* @__PURE__ */ t.forwardRef(zf), kf = Sf, Ff = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.707-3.909-3.908a3 3 0 0 1-4.184-4.184L1.647 2.355l.708-.708Zm3.923 5.338a2 2 0 0 0 2.74 2.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 8q0 .084-.005.167L7.833 5.005A3 3 0 0 1 11 8M7.5 4V2h1v2zm3.682 1.525-.707-.707 1.414-1.414.707.707zM4 8.5H2v-1h2zm10 0h-2v-1h2zm-9.89 4.096-.706-.707 1.414-1.414.707.707zM8.5 12v2h-1v-2z"
        }
      )
    ]
  }
), $f = /* @__PURE__ */ t.forwardRef(Ff), Bf = $f, Af = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 1H8a7 7 0 1 1 0 14h-.5zm1 1.02v11.96a6 6 0 0 0 0-11.96m-2.553.34a6 6 0 0 0-1.804 1.044L3.5 2.638c.62-.52 1.33-.935 2.105-1.217zM2.803 5a6 6 0 0 0-.713 1.957l-.985-.172c.144-.82.43-1.59.832-2.286zM2.09 9.043c.123.702.368 1.362.713 1.957l-.866.5a7 7 0 0 1-.832-2.285zm2.053 3.553a6 6 0 0 0 1.804 1.044l-.342.94A7 7 0 0 1 3.5 13.361z",
        clipRule: "evenodd"
      }
    )
  }
), Ef = /* @__PURE__ */ t.forwardRef(Af), _f = Ef, Of = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2h2.384l1.072 4H13a2 2 0 1 1 0 4h-2.544l-1.072 4H7v-4H4.384l-.268 1H1.179l.804-3-.804-3h2.937l.268 1H7zm1 4h1.42l-.804-3H8zM2.884 8.5 2.482 10h.866l.268-1H13a1 1 0 1 0 0-2H3.616l-.268-1h-.866l.402 1.5H5v1zM8 10v3h.616l.804-3z",
        clipRule: "evenodd"
      }
    )
  }
), Df = /* @__PURE__ */ t.forwardRef(Of), Pf = Df, Tf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.652 2h4.696l.536 2H14v9H2V4h3.116zm.5 2h3.696L9.58 3H6.42zM3 5v7h10V5z",
        clipRule: "evenodd"
      }
    )
  }
), qf = /* @__PURE__ */ t.forwardRef(Tf), If = qf, Zf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.799 11H13.2c.242-.503.387-1.138.442-1.844a10.3 10.3 0 0 0-.132-2.509c-.14-.812-.358-1.53-.599-2.032a2.2 2.2 0 0 0-.334-.531.6.6 0 0 0-.078-.071.5.5 0 0 0-.078.07 2.2 2.2 0 0 0-.335.532c-.24.501-.458 1.22-.598 2.032-.14.81-.197 1.69-.133 2.509.056.706.201 1.34.443 1.844Zm-1.082 0H8.732a2 2 0 0 0-.837-2.789 3.001 3.001 0 0 0-5.26-1.057A2.5 2.5 0 0 0 3.5 12h10.283l.146-.243c.43-.716.64-1.613.711-2.522.073-.916.007-1.88-.144-2.757-.15-.875-.39-1.688-.682-2.296a3.1 3.1 0 0 0-.508-.783C13.12 3.199 12.848 3 12.5 3s-.62.2-.807.399a3.1 3.1 0 0 0-.507.783c-.292.608-.532 1.421-.682 2.296a11.3 11.3 0 0 0-.144 2.757c.048.61.159 1.216.357 1.765M7 11a1 1 0 0 0 .31-1.951l-.288-.094-.051-.297a2 2 0 0 0-3.617-.795l-.101.146-.17.05A1.5 1.5 0 0 0 3.5 11z",
        clipRule: "evenodd"
      }
    )
  }
), Wf = /* @__PURE__ */ t.forwardRef(Zf), Gf = Wf, Nf = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 7v1h1V7zm0 2v1h1V9zm0 2v1h1v-1zm2-4v1h1V7zm0 2v1h1V9zm0 2v1h1v-1zM3 5V4h1v1zm0 2V6h1v1zm0 2V8h1v1zm2-4V4h1v1zm0 2V6h1v1zm0 2V8h1v1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 2h7v3h6v9H1zm7 11V6h5v7zM7 3v10H6v-2H3v2H2V3zM4 13h1v-1H4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Uf = /* @__PURE__ */ t.forwardRef(Nf), Yf = Uf, Qf = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.646 3.354-1-1 .708-.708 1 1zm4.755-1.462 1.099.549v1.118l-1.099.55L9.293 3zM6.646 3.146l1-1 .708.708-1 1zm2.5 1.708-1-1 .708-.708 1 1zm-2.5.5-1-1 .708-.708 1 1zm1.708 1-.708-.708 1-1 .708.708zM4.4 4.892l1.1.548v1.118l-1.099.55L3.293 6zm5.953 1.462-.708-.708 1-1 .708.708zm2.614-1.426L14 5.96v1.597l-1.987.497-1.085-1.086.51-1.53zm-.74 1.3-.156.47.248.248.68-.17v-.402l-.302-.302-.47.157Zm-4.374.418-.708.708-1-1 .708-.708zm-6.208 1 1-1 .708.708-1 1zm3 0 1-1 .708.708-1 1zm4.708 0-.708.708-1-1 .708-.708zM4.146 9.354l-1-1 .708-.708 1 1zm2.255-1.462L7.5 8.44v1.118l-1.099.55L5.293 9zm4.953.754-.707.708-1-1 .707-.708zm-9.708 1 1-1 .708.708-1 1zm7.208.707-.708-.707 1-1 .708.708zm2.793-.707 1-1 .707.708-1 1zm-8 1 1-1 .707.707-1 1-.708-.707Zm6.754-.754 1.099.549v1.118l-1.099.55L9.293 11zm-2.755 1.962-1-1 .708-.708 1 1zm-1.678-.926L7 11.959v1.598l-1.987.497-1.085-1.086.51-1.53zm-.74 1.3-.156.47.248.248.68-.17v-.402l-.302-.302-.47.157Zm4.626-.082-.708.707-1-1 .708-.707zm-.5 1.5-.708.707-1-1 .708-.707z",
        clipRule: "evenodd"
      }
    )
  }
), Kf = /* @__PURE__ */ t.forwardRef(Qf), Xf = Kf, Jf = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m4 7.707-.646.647-.708-.707L4.5 5.793l1.854 1.854-.708.707L5 7.707V10H4zm6.354-.061.646.647V6h1v2.293l.646-.647.708.707-1.854 1.854-1.854-1.854z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 1H1v14h14zM2 14V2h5.5v12zm6.5 0H14V2H8.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), em = /* @__PURE__ */ t.forwardRef(Jf), lm = em, om = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M5.5 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.207 4.5 7 5.293V7H6V5.707L5.793 5.5h-.586L5 5.707V9H4V5.293l.793-.793z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 4h-4.207l-7 7H1v4h4.207l7-7H15zM4.207 12l7-7H14v2h-2.207l-7 7H2v-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), nm = /* @__PURE__ */ t.forwardRef(om), im = nm, rm = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 10V9h1v1zm0 1v1h1v-1zm2-1V9h1v1zm0 1v1h1v-1zm6 1H9v-1h2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 2h-3v5H8V5H5.92l-.536 2H5V5H2.92l-.536 2H1v7h14V7h-2zm-1 1h-1v1h1zm0 2h-1v2h1zM3.152 8H2v5h5V9h6v4h1V8H7V6h-.313l-.535 2H4V6h-.313zM12 10v3H8v-3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tm = /* @__PURE__ */ t.forwardRef(rm), am = tm, sm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h1v1h5.384l.535 2H14v7H9.152l-.536-2H4v4H3zm1 7h5.384l.535 2H13V6H9.152l-.536-2H4z",
        clipRule: "evenodd"
      }
    )
  }
), dm = /* @__PURE__ */ t.forwardRef(sm), cm = dm, hm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 4a2 2 0 1 1 4 0c0 .183-.043.396-.096.598l-.058.204q.076-.08.148-.151a2.5 2.5 0 0 1 .47-.383 2 2 0 1 1 2 3.464c-.159.092-.365.16-.567.216L11.691 8q.107.025.206.052c.202.055.408.124.567.216a2 2 0 0 1-2 3.464 2.5 2.5 0 0 1-.47-.383l-.148-.152q.031.105.058.205c.053.202.096.415.096.598a2 2 0 1 1-4 0c0-.183.044-.396.097-.598l.057-.204q-.075.08-.148.151a2.5 2.5 0 0 1-.47.383 2 2 0 0 1-2-3.464l.238.412-.238-.412c.159-.092.365-.16.567-.216L4.309 8l-.206-.052a2.5 2.5 0 0 1-.567-.216 2 2 0 1 1 2-3.464c.159.091.322.236.47.383a4 4 0 0 1 .148.152l-.057-.205A2.5 2.5 0 0 1 6 4m.455 2.73c-.237-.31-.485-.62-.716-.892a8 8 0 0 0-.436-.477 1.6 1.6 0 0 0-.267-.227 1 1 0 1 0-1 1.732c.043.025.147.067.33.117.174.048.39.094.632.14.35.064.743.122 1.13.173.077-.207.189-.398.327-.566M8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6.127 8.704q.119.312.328.566c-.237.31-.485.62-.716.892-.16.187-.308.35-.436.477a1.6 1.6 0 0 1-.267.227 1 1 0 0 1-1-1.732 1.6 1.6 0 0 1 .33-.117 8 8 0 0 1 .632-.14c.35-.064.743-.122 1.13-.173Zm1.546 1.27a2 2 0 0 0 .654 0c.15.36.295.73.414 1.065a7 7 0 0 1 .195.617c.049.184.064.295.064.344a1 1 0 1 1-2 0c0-.05.016-.16.064-.344.046-.175.113-.384.195-.617.119-.335.265-.705.414-1.066Zm1.872-.704c.238.31.485.62.716.892.16.187.308.35.437.477.135.134.223.202.266.227l-.25.433.25-.433a1 1 0 1 0 1-1.732 1.6 1.6 0 0 0-.33-.117 8 8 0 0 0-.632-.14c-.35-.064-.743-.123-1.13-.173a2 2 0 0 1-.327.566m.328-1.974c.386-.05.78-.109 1.13-.174.242-.045.457-.092.63-.14a1.6 1.6 0 0 0 .33-.116 1 1 0 0 0-1-1.732 1.6 1.6 0 0 0-.265.227c-.129.127-.277.29-.437.477-.231.271-.478.583-.716.892q.21.254.328.566m-1.546-1.27a2 2 0 0 0-.654 0c-.149-.36-.295-.73-.414-1.065a8 8 0 0 1-.195-.617A1.6 1.6 0 0 1 7 4a1 1 0 0 1 2 0c0 .05-.015.16-.064.344a8 8 0 0 1-.195.617c-.119.335-.265.705-.414 1.066Z",
        clipRule: "evenodd"
      }
    )
  }
), wm = /* @__PURE__ */ t.forwardRef(hm), vm = wm, fm = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a3.5 3.5 0 0 0-3.5 3.5v.036l.005.428-.422.07A2.5 2.5 0 0 0 2 8.5H1a3.5 3.5 0 0 1 2.514-3.36 4.5 4.5 0 0 1 8.625-1.408A4.25 4.25 0 0 1 15 7.75h-1a3.25 3.25 0 0 0-2.373-3.13l-.247-.07-.088-.242A3.5 3.5 0 0 0 8 2m-.996 10.561a3.5 3.5 0 0 0-2.252-.302l-3.654.731-.196-.98 3.654-.731a4.5 4.5 0 0 1 2.895.387l1.545.773a3.5 3.5 0 0 0 2.252.302l3.654-.731.196.98-3.654.731a4.5 4.5 0 0 1-2.895-.388z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.752 10.26a3.5 3.5 0 0 1 2.252.301l1.545.772a4.5 4.5 0 0 0 2.895.388l3.654-.73-.196-.981-3.654.73a3.5 3.5 0 0 1-2.252-.301l-1.545-.772a4.5 4.5 0 0 0-2.895-.388l-3.654.73.196.981z"
        }
      )
    ]
  }
), mm = /* @__PURE__ */ t.forwardRef(fm), pm = mm, gm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.646 8.647 10 9l.354.353.002-.002.002-.002.002-.002.001-.001-.014.016q-.024.029-.08.116a3.3 3.3 0 0 0-.297.63c-.204.56-.42 1.477-.463 2.892h1.026c.13-.978.619-1.783 1.08-2.348a6.6 6.6 0 0 1 1.067-1.037l.021-.016.007-.005.002-.001c.001-.001.001-.001.29.407l.289.408-.002.001-.012.009a3 3 0 0 0-.257.21 5.6 5.6 0 0 0-.63.655c-.374.459-.722 1.045-.843 1.717H14v1H2v-1h2.384c-.142-.318-.403-.629-.717-.91a5.5 5.5 0 0 0-.89-.642l-.013-.007-.002-.001L3 11l.238-.44.003.002.006.003.02.012a4 4 0 0 1 .32.196c.202.133.473.327.746.572.425.38.932.95 1.106 1.655h1.016c-.121-.672-.47-1.258-.843-1.717a5.6 5.6 0 0 0-.887-.865l-.012-.009H4.71L5 10l.289-.408h.001l.002.002.007.005.021.016.074.056a6.6 6.6 0 0 1 .994.981c.46.565.95 1.37 1.079 2.348h1.04c.042-1.52.276-2.554.523-3.233.137-.376.277-.643.391-.823a2 2 0 0 1 .213-.285l.007-.007.003-.003zM4.71 10.408",
        clipRule: "evenodd"
      }
    )
  }
), um = /* @__PURE__ */ t.forwardRef(gm), xm = um, Rm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.646 2.646 1-1 .708.708-1 1zM11.191 2h1.618l.8 1.599L12 5.207 10.392 3.6 11.19 2Zm.618 1-.2.401.391.392.392-.392L12.19 3zm-6.174.928L7 5.293V7.39l-2.653.664-1.419-1.419.677-2.03zm-1.24 1.467-.323.97.581.581L6 6.61v-.903l-.635-.635zm4.251-.249 1-1 .708.708-1 1zm0 3.208-1-1 .708-.708 1 1zM10.793 8h2.097l.664 2.653-1.419 1.419-2.03-.677-.677-2.03zm.414 1-.635.635.323.97.97.323.581-.581L12.11 9zm-9.56.646 1-1 .707.708-1 1-.708-.708ZM5.9 8.892l1.6.798v1.618l-1.599.8L4.293 10.5zm.198 1.216-.392.392.392.392.401-.201v-.382zm2.547 4.245-1-1 .708-.707 1 1z",
        clipRule: "evenodd"
      }
    )
  }
), jm = /* @__PURE__ */ t.forwardRef(Rm), Mm = jm, Hm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.357 5.936a1.5 1.5 0 0 1 2.232.124L14.54 11H1.293l3.146-3.146a1.5 1.5 0 0 1 2.122 0L8.707 10h3.753L9.808 6.685a.5.5 0 0 0-.744-.041l-1.21 1.21-.707-.708zM7.293 10l-1.44-1.44a.5.5 0 0 0-.706 0L3.707 10z",
        clipRule: "evenodd"
      }
    )
  }
), Cm = /* @__PURE__ */ t.forwardRef(Hm), ym = Cm, bm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m11.582 10.875 2.772 2.771-.707.708-2.638-2.638q-.183.25-.367.482a19 19 0 0 1-1.59 1.76c-.337.331-.69.64-1.052.944a19 19 0 0 1-1.053-.943 19 19 0 0 1-1.589-1.761C4.217 10.756 3 8.742 3 6.648c0-.8.247-1.58.677-2.264l-2.03-2.03.707-.708 8.501 8.502C11.516 9.052 12 7.84 12 6.648 12 4.828 10.235 3 8 3c-.637 0-1.237.149-1.768.404l-.74-.74A5.1 5.1 0 0 1 8 2c2.736 0 5 2.227 5 4.647 0 .985-.27 1.953-.673 2.851a11 11 0 0 1-.745 1.377M10.293 11 4.409 5.116A3.2 3.2 0 0 0 4 6.647c0 1.742 1.033 3.53 2.142 4.93A18 18 0 0 0 8 13.581a18 18 0 0 0 1.858-2.004q.221-.28.435-.577",
        clipRule: "evenodd"
      }
    )
  }
), Vm = /* @__PURE__ */ t.forwardRef(bm), Lm = Vm, zm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3C5.765 3 4 4.83 4 6.647c0 1.742 1.033 3.53 2.142 4.93A18 18 0 0 0 8 13.581a18 18 0 0 0 1.858-2.004C10.967 10.177 12 8.389 12 6.647 12 4.83 10.235 3 8 3m0 11.25-.321.383h-.001l-.004-.004-.01-.01-.042-.034-.15-.132a19 19 0 0 1-2.115-2.255C4.217 10.756 3 8.742 3 6.648 3 4.227 5.264 2 8 2s5 2.227 5 4.647c0 2.095-1.217 4.11-2.358 5.55a19 19 0 0 1-2.264 2.388l-.041.035-.011.01-.004.002c0 .001-.001.001-.322-.382m0 0 .321.383-.321.269-.321-.269zM8 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Sm = /* @__PURE__ */ t.forwardRef(zm), km = Sm, Fm = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#maps-map-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.708-2.227-2.227-2.39.896L6 13.015 1.5 14.14V3.11l.722-.18L.646 1.353l.708-.708Zm1.693 3.108L2.5 3.89v8.97l3-.75V6.207zM6.5 7.207v4.903l3 .75v-2.653zm4 4v1.571l1.143-.428z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "m14.5 11.646-1-1.017V3.222l-3 1.125v3.23l-1-1.017V4.347L6.053 3.054 6 3l-.849-.803.879-.22L10 3.466l4.5-1.687z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "maps-map-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), $m = /* @__PURE__ */ t.forwardRef(Fm), Bm = $m, Am = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5 1.778v10.569l-4.47 1.676L6 13.015 1.5 14.14V3.11l4.53-1.133L10 3.466zm-5 2.568-3-1.125v8.889l3 .75zm1 8.432 3-1.125v-8.43l-3 1.124v8.432Zm-5-.668V3.14l-3 .75v8.97z",
        clipRule: "evenodd"
      }
    )
  }
), Em = /* @__PURE__ */ t.forwardRef(Am), _m = Em, Om = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.456 14.842 14H1.158zm-1.675 5.16 1.111.74.89-.889 1.385.214L8 3.544zm3.988 1.17-1.639-.253-1.11 1.11-1.72-1.146L2.842 13h10.316z",
        clipRule: "evenodd"
      }
    )
  }
), Dm = /* @__PURE__ */ t.forwardRef(Om), Pm = Dm, Tm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.382.447.894c.13.258.312.539.519.856q.178.271.37.58c.166.269.327.552.449.83.118.274.215.58.215.887a2 2 0 1 1-4 0c0-.307.097-.613.216-.886.12-.279.283-.562.448-.83q.193-.31.37-.58c.207-.318.39-.599.519-.857zm-.867 3.56C7.037 6.16 7 6.32 7 6.428a1 1 0 1 0 2 0c0-.108-.037-.268-.133-.488a6 6 0 0 0-.382-.704 25 25 0 0 0-.311-.487L8 4.482l-.173.268c-.11.169-.218.334-.312.487-.156.254-.29.49-.382.704ZM7.5 14c0-.365-.077-.626-.19-.817a1.2 1.2 0 0 0-.486-.454c-.443-.24-1.084-.322-1.803-.292-.706.03-1.422.163-1.969.292a13 13 0 0 0-.835.227l-.046.014-.01.004h-.003L2 12.5l-.158-.474.002-.001.004-.001.015-.005.055-.018.2-.06c.17-.05.414-.117.705-.185a12 12 0 0 1 2.156-.318c.514-.022 1.063.004 1.572.129a5 5 0 0 0-.834-.717 6.5 6.5 0 0 0-1.806-.856l-.027-.008-.005-.001L4 9.5l.122-.485h.002l.003.001.012.004a3 3 0 0 1 .182.053 7.5 7.5 0 0 1 1.962.953c.633.434 1.285 1.047 1.717 1.877.432-.83 1.085-1.443 1.717-1.878A7.5 7.5 0 0 1 11.86 9.02l.012-.004h.004c.001 0 .002-.001.123.484l.122.485-.006.001-.026.008a6 6 0 0 0-.53.182 6.5 6.5 0 0 0-1.277.674c-.292.2-.579.438-.834.717.51-.125 1.058-.15 1.572-.13a12 12 0 0 1 2.156.319 14 14 0 0 1 .905.245l.055.018.015.005.004.001h.001L14 12.5l-.158.474h-.002l-.011-.004-.046-.014a13 13 0 0 0-.835-.227 11 11 0 0 0-1.969-.292c-.72-.03-1.36.052-1.803.292a1.2 1.2 0 0 0-.487.454c-.111.191-.189.452-.189.817z",
        clipRule: "evenodd"
      }
    )
  }
), qm = /* @__PURE__ */ t.forwardRef(Tm), Im = qm, Zm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.348 6.541C1.858 6.214 1.5 5.694 1.5 5h1c0 .306.143.536.402.709C3.177 5.892 3.574 6 4 6s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 5.892 7.574 6 8 6s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 6.858 12.574 7 12 7s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 6.858 8.574 7 8 7s-1.177-.142-1.652-.459A2 2 0 0 1 6 6.251q-.158.165-.348.29C5.177 6.858 4.574 7 4 7s-1.177-.142-1.652-.459m0 4C1.858 10.214 1.5 9.694 1.5 9h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 10.858 8.574 11 8 11s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C5.177 10.858 4.574 11 4 11s-1.177-.142-1.652-.459",
        clipRule: "evenodd"
      }
    )
  }
), Wm = /* @__PURE__ */ t.forwardRef(Zm), Gm = Wm, Nm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m10.6 1.94 2.885 2.308.535 8.551-2.296 1.148-.447-.894 1.703-.852-.465-7.449L10.4 3.06l-2.481.828-.934 3.733-.97-.242 1.067-4.267zM4.462 7.96 7.77 9.063l2.23 2.23v2.475l-1.874 1.25-4.855-.54-1.806-1.806.584-3.505zm.076 1.08-1.587.793-.415 2.495 1.194 1.194 4.144.46L9 13.233v-1.525l-1.77-1.77-2.692-.897Z",
        clipRule: "evenodd"
      }
    )
  }
), Um = /* @__PURE__ */ t.forwardRef(Nm), Ym = Um, Qm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2v7h.5a.5.5 0 0 0 .5-.5V6h1v2.5a1.5 1.5 0 0 1-1.5 1.5H12v1.092A49 49 0 0 1 15 11v1a47.2 47.2 0 0 0-9.647.99 37 37 0 0 0-2.728.677 22 22 0 0 0-.897.283l-.045.015-.01.004h-.002s0 .001 0 0l-.525-.823L6.5 7.793l3.467 3.467q.505-.052 1.033-.096V8h-.5A1.5 1.5 0 0 1 9 6.5V4h1v2.5a.5.5 0 0 0 .5.5h.5V2zm-3.299 9.408L6.5 9.208l-3.25 3.249c.533-.14 1.169-.293 1.897-.446a46 46 0 0 1 3.554-.603",
        clipRule: "evenodd"
      }
    )
  }
), Km = /* @__PURE__ */ t.forwardRef(Qm), Xm = Km, Jm = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.348 4.541C1.858 4.214 1.5 3.694 1.5 3h1c0 .306.143.536.402.709C3.177 3.892 3.574 4 4 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 3.892 7.574 4 8 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 4.858 12.574 5 12 5s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 4.858 8.574 5 8 5s-1.177-.142-1.652-.459A2 2 0 0 1 6 4.251q-.158.165-.348.29C5.177 4.858 4.574 5 4 5s-1.177-.142-1.652-.459m0 4C1.858 8.214 1.5 7.694 1.5 7h1c0 .306.143.536.402.709C3.177 7.892 3.574 8 4 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 7.892 7.574 8 8 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 8.858 12.574 9 12 9s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 8.858 8.574 9 8 9s-1.177-.142-1.652-.459A2 2 0 0 1 6 8.251q-.158.165-.348.29C5.177 8.858 4.574 9 4 9s-1.177-.142-1.652-.459m0 4c-.49-.327-.848-.847-.848-1.541h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.164-.348.29C9.177 12.858 8.574 13 8 13s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.164-.348.29C5.177 12.858 4.574 13 4 13s-1.177-.142-1.652-.459",
        clipRule: "evenodd"
      }
    )
  }
), ep = /* @__PURE__ */ t.forwardRef(Jm), lp = ep, op = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4V2H7v2H3v5h4v5h1V9h3.707l2.5-2.5-2.5-2.5zM4 8V5h7.293l1.5 1.5-1.5 1.5z",
        clipRule: "evenodd"
      }
    )
  }
), np = /* @__PURE__ */ t.forwardRef(op), ip = np, rp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.19 2.487c-.369.056-.608.284-.675.61l-.2.98-.664-.749c-.22-.249-.541-.326-.89-.19-.358.14-.777.53-1.03 1.278l-.948-.32c.325-.96.92-1.618 1.615-1.89.476-.185.983-.18 1.422.024a1.8 1.8 0 0 1 1.22-.73c.738-.113 1.582.16 2.343.829l-.66.75c-.594-.521-1.152-.649-1.532-.59Zm4.99 2.743a1.8 1.8 0 0 0-1.22-.732c-.738-.112-1.582.161-2.342.83l.66.75c.594-.521 1.151-.649 1.532-.59.37.055.609.283.675.609l.2.98.664-.749c.221-.249.542-.326.89-.19.359.14.778.53 1.031 1.278l.947-.32c-.324-.96-.918-1.618-1.614-1.89a1.8 1.8 0 0 0-1.422.024ZM8 10a2 2 0 0 0-1.733 3h3.466A2 2 0 0 0 8 10m2.83 3a3 3 0 1 0-5.658 0H1.999v1h12v-1z",
        clipRule: "evenodd"
      }
    )
  }
), tp = /* @__PURE__ */ t.forwardRef(rp), ap = tp, sp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 3.793V2h1v1.793l.647-.647.707.708L8.5 5.207v1.927l1.669-.963.495-1.85.966.26-.236.882 1.552-.896.5.866-1.552.896.883.237-.26.966-1.848-.495L9 8l1.669.963 1.849-.495.259.966-.883.237 1.552.896-.5.866-1.552-.896.236.883-.966.258-.495-1.849L8.5 8.866v1.927l1.354 1.353-.707.708-.647-.647V14h-1v-1.793l-.646.647-.707-.708L7.5 10.793V8.866l-1.669.963-.495 1.85-.966-.26.237-.882-1.553.896-.5-.866 1.553-.896-.883-.237.258-.966 1.85.495L7 8l-1.669-.963-1.849.495-.258-.966.883-.237-1.553-.896.5-.866 1.553.896-.237-.883.966-.258.495 1.849 1.67.963V5.207L6.146 3.854l.707-.708.646.647Z",
        clipRule: "evenodd"
      }
    )
  }
), dp = /* @__PURE__ */ t.forwardRef(sp), cp = dp, hp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2h3v1h-2v3H9v3H6v3H3v2H2v-3h3V8h3V5h3z",
        clipRule: "evenodd"
      }
    )
  }
), wp = /* @__PURE__ */ t.forwardRef(hp), vp = wp, fp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.348 1h9.304l-.804 3H11v8h.848l.804 3H3.348l.804-3H5V4h-.848zM6 4v8h1.5V4zm2.5 0v8H10V4zM4.652 2l.268 1h6.16l.268-1zm.268 11-.268 1h6.696l-.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), mp = /* @__PURE__ */ t.forwardRef(fp), pp = mp, gp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.03 2.17 4.5 2l.47-.17.002.004.005.014.017.05a28 28 0 0 1 .296.908c.19.618.444 1.504.697 2.58.477 2.03.957 4.745 1.009 7.614h1.007a47.5 47.5 0 0 1 .502-6.386 38 38 0 0 1 .349-2.003 24 24 0 0 1 .148-.681l.01-.037.002-.01v-.004L9.5 4l.485.121v.002l-.002.007-.008.033-.03.13q-.041.177-.111.518a37 37 0 0 0-.34 1.95A46.5 46.5 0 0 0 9.004 13h1.002c.05-2.869.53-5.585 1.008-7.615.253-1.075.506-1.96.697-2.579a29 29 0 0 1 .296-.908l.017-.05.005-.014.002-.004.47.17.47.17-.001.004-.004.01-.016.045-.061.179c-.053.158-.13.392-.223.692-.184.6-.431 1.465-.678 2.515-.467 1.983-.931 4.618-.982 7.385H14v1H2v-1h1.992c-.066-2.035-.517-4.147-.974-5.805a35 35 0 0 0-.9-2.795l-.062-.162-.015-.04-.004-.01-.001-.002L2.5 4l.464-.186.002.005.005.012.018.045.065.172a36 36 0 0 1 .928 2.882c.469 1.7.944 3.91 1.01 6.07h1.003c-.05-2.767-.515-5.402-.982-7.385A39 39 0 0 0 4.335 3.1a27 27 0 0 0-.284-.871l-.016-.045-.004-.01V2.17Z",
        clipRule: "evenodd"
      }
    )
  }
), up = /* @__PURE__ */ t.forwardRef(gp), xp = up, Rp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 2H5V1h6v1H9.5v2.5H12V14h-1.5v1h-1v-1h-3v1h-1v-1H4V4.5h2.5zm1 0v2.5h1V2zM5 5.5V13h6V5.5zm4 2H7v-1h2zM5.812 9h4.375l-.803 3H6.616zm1.303 1 .268 1h1.233l.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), jp = /* @__PURE__ */ t.forwardRef(Rp), Mp = jp, Hp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2h6v2h3v9H2V4h3zm1 2h4V3H6zM3 5v2h3V6h4v1h3V5zm10 3h-3v1H6V8H3v4h10zM7 7v1h2V7z",
        clipRule: "evenodd"
      }
    )
  }
), Cp = /* @__PURE__ */ t.forwardRef(Hp), yp = Cp, bp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 2a1.5 1.5 0 0 0-1.341.827l-.188.374-.401-.119a2 2 0 0 0-2.266 2.979l.18.286-.199.273A1.5 1.5 0 0 0 5.538 9l.211-.006.15.148a3 3 0 0 0 4.941-1.176l.059-.17.152-.094A2 2 0 0 0 10.4 4.04l-.41-.083.01-.42V3.5A1.5 1.5 0 0 0 8.5 2m-2.027.037a2.5 2.5 0 0 1 4.505 1.126 3 3 0 0 1 .75 5.29A4 4 0 0 1 8.5 10.969V13H13v1H3v-1h4.5v-2.031a4 4 0 0 1-2.15-.973A2.5 2.5 0 0 1 3.3 6.31a3 3 0 0 1 3.172-4.273Z",
        clipRule: "evenodd"
      }
    )
  }
), Vp = /* @__PURE__ */ t.forwardRef(bp), Lp = Vp, zp = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.37 7.696 6.506 1 2.639 7.696h1.495l-3 5.196H6V15h1v-2.108h4.866l-3-5.196zm-6-1L6.506 3 8.64 6.696H7.134l3 5.196H2.866l3-5.196H4.371Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 15v-1h1v1zm4.37-7.304L10.505 1 8.938 3.714l.866.5.7-1.214 2.135 3.696h-1.505l3 5.196h-1.402v1h3.134l-3-5.196h1.505Z"
        }
      )
    ]
  }
), Sp = /* @__PURE__ */ t.forwardRef(zp), kp = Sp, Fp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.382.447.894c.317.633.779 1.344 1.278 2.11.27.416.551.848.826 1.293.38.616.737 1.246 1.001 1.853.262.602.448 1.219.448 1.801a4 4 0 1 1-8 0c0-.582.186-1.2.448-1.801.264-.607.622-1.237 1.001-1.853.275-.445.556-.877.826-1.293.499-.766.961-1.477 1.278-2.11zM5.365 8.931C5.126 9.479 5 9.949 5 10.333a3 3 0 1 0 6 0c0-.384-.127-.854-.365-1.402-.236-.543-.565-1.126-.936-1.727a61 61 0 0 0-.767-1.2A51 51 0 0 1 8 4.53c-.281.471-.606.972-.932 1.474a61 61 0 0 0-.767 1.2c-.37.601-.7 1.184-.936 1.727",
        clipRule: "evenodd"
      }
    )
  }
), $p = /* @__PURE__ */ t.forwardRef(Fp), Bp = $p, Ap = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2.354 1.646 12 12-.707.708-1.773-1.772a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19A5 5 0 0 0 3.416 6h1.747l.02-.11zM6.293 7h-.25a11.5 11.5 0 0 0 0 2h2.25zm3 3 .436.436a7 7 0 0 1-.416 1.246C8.875 12.644 8.373 13 8 13c-.374 0-.875-.356-1.313-1.318A7.4 7.4 0 0 1 6.18 10h3.114Zm1.25 1.25.621.621a5 5 0 0 1-1.202.73q.143-.243.261-.505a7 7 0 0 0 .32-.846M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm2.938 5.6a6 6 0 0 1-.26-.504A8.6 8.6 0 0 1 5.162 10H3.416a5.02 5.02 0 0 0 2.622 2.6M14 8c0 .926-.21 1.804-.585 2.587L11.828 9H12.9a5 5 0 0 0 0-2h-1.94A13 13 0 0 1 11 8.17L9.97 7.14 9.956 7h-.129l-1-1h.993a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3c-.33 0-.762.28-1.16 1.011L5.413 2.585A6 6 0 0 1 14 8m-3.163-2a8.6 8.6 0 0 0-.614-2.096 5 5 0 0 0-.26-.504 5.02 5.02 0 0 1 2.62 2.6h-1.747Z",
        clipRule: "evenodd"
      }
    )
  }
), Ep = /* @__PURE__ */ t.forwardRef(Ap), _p = Ep, Op = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm.316-1h1.747a8.6 8.6 0 0 1 .614-2.096 6 6 0 0 1 .26-.504A5.02 5.02 0 0 0 3.417 6ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m0 1c-.374 0-.875.356-1.313 1.318A7.4 7.4 0 0 0 6.18 6h3.64a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3m2.837 3a8.6 8.6 0 0 0-.614-2.096 6 6 0 0 0-.26-.504 5.02 5.02 0 0 1 2.62 2.6h-1.747Zm-.88 1H6.043a11.5 11.5 0 0 0 0 2h3.914a11.5 11.5 0 0 0 0-2m1.003 2a12.5 12.5 0 0 0 0-2h1.94a5 5 0 0 1 0 2zm-1.139 1H6.18c.12.642.295 1.213.508 1.682C7.125 12.644 7.627 13 8 13s.875-.356 1.313-1.318c.213-.47.388-1.04.508-1.682m.141 2.6q.143-.242.26-.504c.272-.597.482-1.31.615-2.096h1.747a5.02 5.02 0 0 1-2.622 2.6m-3.924 0a6 6 0 0 1-.261-.504A8.6 8.6 0 0 1 5.163 10H3.416a5.02 5.02 0 0 0 2.622 2.6",
        clipRule: "evenodd"
      }
    )
  }
), Dp = /* @__PURE__ */ t.forwardRef(Op), Pp = Dp, Tp = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#misc-bandaid_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.5.793 15.207 4.5 4.5 15.207.793 11.5zM8.707 5 11 7.293 13.793 4.5 11.5 2.207zm1.586 3L9.5 7.207 8.707 8l.793.793zm-1.5 1.5L8 8.707l-.793.793.793.793zm-1.5 1.5L5 8.707 2.207 11.5 4.5 13.793zM5.707 8l.793.793L7.293 8 6.5 7.207zm1.5-1.5L8 7.293l.793-.793L8 5.707z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "misc-bandaid_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), qp = /* @__PURE__ */ t.forwardRef(Tp), Ip = qp, Zp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 2h5.119v1H10v2.928l3 5.196V14H3v-2.876l3-5.196V3h-.5zM7 3v3.196L6.536 7h2.928L9 6.196V3zm3.042 5H5.959L4 11.392V13h8v-1.608zM8 11v-1h1v1zm-2 1v-1h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), Wp = /* @__PURE__ */ t.forwardRef(Zp), Gp = Wp, Np = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v8h1v3H1v-3h1zm1 8h5V8h4v2h1V3H3zm8 0V9H9v1zm-9 1v1h12v-1zm6-6H4V4h4zM7 7H4V6h3z",
        clipRule: "evenodd"
      }
    )
  }
), Up = /* @__PURE__ */ t.forwardRef(Np), Yp = Up, Qp = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3.5A1.5 1.5 0 0 1 3.5 2H14v12H3.5A1.5 1.5 0 0 1 2 12.5zm1 7.585V3.5a.5.5 0 0 1 .5-.5H13v8H3.5q-.264.001-.5.085M13 12H3.5a.5.5 0 0 0 0 1H13zm-1.5-7H4V4h7.5zm0 2H4V6h7.5zM8 9H4V8h4z",
        clipRule: "evenodd"
      }
    )
  }
), Kp = /* @__PURE__ */ t.forwardRef(Qp), Xp = Kp, Jp = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 9.5h-1.67l-1-1H14zM11 7v1.172l-1-1V6a1.997 1.997 0 0 0-2-2c-.34 0-.659.084-.938.233L5.758 2.93l-.349-1.3.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m11.293 12 2.354 2.354.707-.708-12-12-.708.708L5.013 5.72A3 3 0 0 0 5 6H3.384l-.548-2.044-.966.259L2.616 7H5v1.5H2v1h3V11H2.616l-.746 2.785.966.26L3.383 12h1.788a3 3 0 0 0 5.658 0zM7.5 8.207 6 6.707V11a2 2 0 0 0 4 0v-.293l-1.5-1.5V11.5h-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), eg = /* @__PURE__ */ t.forwardRef(Jp), lg = eg, og = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.985 3.778-.576-2.149.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7H11v1.5h3v1h-3V11h2.383l.747 2.785-.966.26L12.616 12H10.83a3 3 0 0 1-5.658 0H3.383l-.547 2.044-.966-.259L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.26L3.383 6H5c0-.882.38-1.674.985-2.222M8 4a1.997 1.997 0 0 0-2 2v5a2 2 0 0 0 4 0V6a1.997 1.997 0 0 0-2-2m.5 7.5h-1v-5h1z",
        clipRule: "evenodd"
      }
    )
  }
), ng = /* @__PURE__ */ t.forwardRef(og), ig = ng, rg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.11 3h9.78l.625 2.5h.845l.834 2.5H14v1.562L13.39 12h-.58l-.5 1h-1.62l-.5-1H5.81l-.5 1H3.691l-.5-1H2.61L2 9.562V8H.806l.834-2.5h.845zM3 8v1.438L3.39 11h9.22L13 9.438V8zm9.86-1-.75-3H8.5v.5H9v1H7v-1h.5V4H3.89l-.75 3H8.5c0-.495.301-.883.662-1.123.364-.243.839-.377 1.338-.377s.974.134 1.338.377c.361.24.662.628.662 1.123zm-3.143-.291C9.535 6.83 9.5 6.943 9.5 7h2c0-.057-.034-.17-.217-.291A1.44 1.44 0 0 0 10.5 6.5c-.33 0-.605.09-.783.209M6 10H4V9h2zm6 0h-2V9h2z",
        clipRule: "evenodd"
      }
    )
  }
), tg = /* @__PURE__ */ t.forwardRef(rg), ag = tg, sg = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#misc-checkmark-badge_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "m7 10.707 4.854-4.853-.707-.708L7 9.293 4.854 7.146l-.708.708z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M9.603 2.017 8 .257l-1.603 1.76-2.268-.722L3.62 3.62l-2.325.509.722 2.268L.257 8l1.76 1.603-.722 2.268 2.325.509.509 2.325 2.268-.722L8 15.743l1.603-1.76 2.268.722.509-2.325 2.325-.509-.722-2.268L15.743 8l-1.76-1.603.722-2.268-2.325-.509-.509-2.325zM6.704 3.164 8 1.742l1.296 1.422 1.833-.583.41 1.88 1.88.41-.584 1.833L14.258 8l-1.422 1.296.583 1.833-1.88.41-.41 1.88-1.833-.584L8 14.258l-1.296-1.422-1.833.583-.41-1.88-1.88-.41.583-1.833L1.742 8l1.422-1.296-.583-1.833 1.88-.41.41-1.88z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "misc-checkmark-badge_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), dg = /* @__PURE__ */ t.forwardRef(sg), cg = dg, hg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6z",
        clipRule: "evenodd"
      }
    )
  }
), wg = /* @__PURE__ */ t.forwardRef(hg), vg = wg, fg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 0 12v-1a5 5 0 0 0 5-5",
        clipRule: "evenodd"
      }
    )
  }
), mg = /* @__PURE__ */ t.forwardRef(fg), pg = mg, gg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1-6 6h1a5 5 0 0 0 10 0",
        clipRule: "evenodd"
      }
    )
  }
), ug = /* @__PURE__ */ t.forwardRef(gg), xg = ug, Rg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 5V2h1v3zM5.525 6.232 3.404 4.111l.707-.707 2.121 2.121zm7.071-2.121-2.121 2.121-.707-.707 2.121-2.121zM5 8.5H2v-1h3zm9 0h-3v-1h3zm-7.768 1.975-2.121 2.121-.707-.707 2.121-2.121zm5.657 2.121L9.812 10.52l.707-.707 2.077 2.077zM7.5 14v-3h1v3z",
        clipRule: "evenodd"
      }
    )
  }
), jg = /* @__PURE__ */ t.forwardRef(Rg), Mg = jg, Hg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.026 12.342 3-9 .948.316-3 9zm-1.38-7.696.708.708L2.707 8l2.647 2.646-.707.708L1.293 8l3.354-3.354ZM13.294 8l-2.646-2.646.707-.708L14.707 8l-3.353 3.354-.707-.708L13.293 8Z",
        clipRule: "evenodd"
      }
    )
  }
), Cg = /* @__PURE__ */ t.forwardRef(Hg), yg = Cg, bg = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m11.902 4.829-.732-.732L6.695 6.68l-2.593 4.491.732.732L9.31 9.32l2.593-4.49ZM7.166 7.864l-1.332 2.307 2.299-1.327zm1.672.271L10.17 5.83l-2.3 1.326.967.98Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Vg = /* @__PURE__ */ t.forwardRef(bg), Lg = Vg, zg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4H2v6h1.085a1.5 1.5 0 1 0 2.83 0h4.17a1.5 1.5 0 1 0 2.83 0H14V8.434L13.08 5H10zM9 9V5H3v4zm-4.5 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m6.5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M13 9h-3V6h2.313L13 8.566z",
        clipRule: "evenodd"
      }
    )
  }
), Sg = /* @__PURE__ */ t.forwardRef(zg), kg = Sg, Fg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.32 3.828A3.44 3.44 0 0 1 13.954 7H15v1h-1.373q-.182.361-.455.68l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.4 3.4 0 0 1 2.373 8H1V7h1.046A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302zM3.563 8l.012.014L8 12.45l4.425-4.435.012-.015H12V7h.935a2.44 2.44 0 0 0-3.951-2.424L8 5.542l-.984-.966A2.44 2.44 0 0 0 3.065 7h1.728l1.966-1.966.902 3.368L8.756 7H11v1H9.244l-2.03 2.598-.973-3.632L5.207 8z",
        clipRule: "evenodd"
      }
    )
  }
), $g = /* @__PURE__ */ t.forwardRef(Fg), Bg = $g, Ag = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.21 4.025a.727.727 0 0 0-.89.514L7.66 7h.84v1H7.393l-.997 3.72A1.727 1.727 0 0 1 3 11.271h1a.728.728 0 0 0 1.43.188L6.357 8H5.5V7h1.125l.73-2.72a1.727 1.727 0 0 1 3.395.447h-1a.73.73 0 0 0-.54-.702M10.294 11 8.646 9.354l.708-.708L11 10.293l1.646-1.647.708.708L11.707 11l1.647 1.646-.708.708L11 11.707l-1.646 1.647-.708-.708L10.293 11Z",
        clipRule: "evenodd"
      }
    )
  }
), Eg = /* @__PURE__ */ t.forwardRef(Ag), _g = Eg, Og = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.268 4A2 2 0 0 1 6 1c.513 0 1.165.157 1.681.727A2.5 2.5 0 0 1 8 2.169a2.5 2.5 0 0 1 .319-.442C8.835 1.157 9.487 1 10 1a2 2 0 0 1 1.732 3H14.5v3H14v7H2V7h-.5V4zM5 3a1 1 0 0 1 1-1c.315 0 .663.093.94.398.24.265.476.744.542 1.602H6a1 1 0 0 1-1-1m1 2H2.5v1H6zm0 2H3v6h10V7h-3v3.934L8 9.601l-2 1.333zm4-1h3.5V5H10zm0-2a1 1 0 1 0 0-2c-.315 0-.663.093-.94.398-.24.265-.476.744-.542 1.602zM7 5h2v4.066l-1-.667-1 .667z",
        clipRule: "evenodd"
      }
    )
  }
), Dg = /* @__PURE__ */ t.forwardRef(Og), Pg = Dg, Tg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5 6.175 8 2.423 1.5 6.175 4 7.62V10c0 .894.508 1.656 1.234 2.175.728.52 1.707.825 2.766.825s2.038-.306 2.765-.825C11.492 11.655 12 10.894 12 10V7.619l1-.578V12h1V6.464zM5 10V8.196l3 1.732 3-1.732V10c0 .487-.275.975-.816 1.36S8.874 12 8 12s-1.645-.254-2.184-.64C5.276 10.976 5 10.488 5 10M3.5 6.175 8 3.577l4.5 2.598L8 8.774z",
        clipRule: "evenodd"
      }
    )
  }
), qg = /* @__PURE__ */ t.forwardRef(Tg), Ig = qg, Zg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.5 4H6v1.05a2.5 2.5 0 0 0 0 4.9V12H2.5v1H7V9.95A2.5 2.5 0 0 0 8.95 8h4.343l-1.647 1.646.708.708L15.207 7.5l-2.853-2.854-.708.708L13.293 7H8.95A2.5 2.5 0 0 0 7 5.05V3H2.5zM5 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Wg = /* @__PURE__ */ t.forwardRef(Zg), Gg = Wg, Ng = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 4H2.5V3H7v2.05a2.5 2.5 0 0 1 0 4.9V13H2.5v-1H6V9.95a2.5 2.5 0 0 1 0-4.9zm.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m11.793 7.5-1.646-1.646.707-.708L12.5 6.793l1.646-1.647.707.708L13.207 7.5l1.647 1.646-.707.708L12.5 8.207l-1.646 1.647-.708-.708z"
        }
      )
    ]
  }
), Ug = /* @__PURE__ */ t.forwardRef(Ng), Yg = Ug, Qg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v2.05a2.5 2.5 0 0 1 0 4.9V13H3V9h.5a1.5 1.5 0 1 0 0-3H3zm9 6.95a2.5 2.5 0 0 1 0-4.9V4H4v1.05a2.5 2.5 0 0 1 0 4.9V12h8zM12.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), Kg = /* @__PURE__ */ t.forwardRef(Qg), Xg = Kg, Jg = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3h4v3h3v4h-3v3H6v-3H3V6h3zm1 1v3H4v2h3v3h2V9h3V7H9V4z",
        clipRule: "evenodd"
      }
    )
  }
), e9 = /* @__PURE__ */ t.forwardRef(Jg), l9 = e9, o9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.141 2.95C4.44 3.544 4 4.404 4 5.5c0 1.038.627 1.914 1.368 2.718q.245.264.486.51l.056.058c.175.18.347.36.498.531.149.17.29.35.396.533q.041.07.078.15h.068c-.075-.363-.225-.702-.412-1.127q-.06-.132-.122-.277C6.09 7.84 5.75 6.916 5.75 5.5c0-1.36.191-2.442.547-3.204l.004-.01c-.44.161-.831.385-1.16.664M8 1c-1.34 0-2.586.409-3.505 1.186C3.568 2.971 3 4.111 3 5.5c0 1.447.873 2.572 1.632 3.396.173.187.345.365.504.528l.056.058c.177.182.332.344.463.494q.197.224.283.374c.06.103.062.148.062.15v.5h4v-.5c0-.002.002-.047.062-.15q.085-.149.283-.374c.131-.15.287-.312.463-.494l.056-.057c.159-.164.331-.342.504-.53C12.127 8.073 13 6.948 13 5.5c0-1.39-.568-2.53-1.495-3.314C10.586 1.41 9.341 1 8 1m0 1c-.229 0-.528.144-.797.719-.27.576-.453 1.494-.453 2.781 0 1.23.286 2.013.584 2.698l.114.258c.21.47.43.964.515 1.544h.074c.085-.58.306-1.074.515-1.544l.114-.258c.298-.685.584-1.468.584-2.698 0-1.287-.184-2.205-.453-2.781C8.528 2.144 8.229 2 8 2m1.05 8c.075-.363.225-.702.412-1.127q.06-.132.122-.277c.327-.756.666-1.68.666-3.096 0-1.36-.191-2.442-.547-3.204l-.004-.01c.44.161.831.385 1.16.664C11.56 3.544 12 4.404 12 5.5c0 1.038-.627 1.914-1.368 2.718a27 27 0 0 1-.542.568c-.175.18-.347.36-.498.531-.149.17-.29.35-.396.533a2 2 0 0 0-.078.15zM5.5 13v-1h5v1H10v2H6v-2zM7 13v1h2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), n9 = /* @__PURE__ */ t.forwardRef(o9), i9 = n9, r9 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.947 4.276 12.31 5H15v2.5h-1V6H9v1.5H8V5h3.19l-.137-.276z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m13.416 7.277-.001.002-.003.005-.01.014-.037.053a11 11 0 0 1-.61.786c-.234.273-.53.59-.862.863H15v1h-3.5v.5A1.5 1.5 0 0 1 10 12h-.5v-1h.5a.5.5 0 0 0 .5-.5V10H8V9h2.5v-.31l.276-.137c.24-.12.494-.32.737-.553H9.5V7h2.586a.5.5 0 0 0 .353-.147l.207-.207z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.451 4.5h-.866L1.533 9.82l.933.36.642-1.664h1.826l.644 1.665.933-.362zm.096 3.016H3.494l.525-1.362z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t9 = /* @__PURE__ */ t.forwardRef(r9), a9 = t9, s9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.295 5H5.71l2.293 2.293L10.295 5h3.414l1.293 1.293v3.414L13.71 11h-3.414L8.002 8.707 5.71 11H2.295L1.002 9.707V6.293zm5 3-2-2H2.71l-.707.707v2.586L2.71 10h2.586zM8.71 8l2 2h2.586l.707-.707V6.707L13.295 6H10.71z",
        clipRule: "evenodd"
      }
    )
  }
), d9 = /* @__PURE__ */ t.forwardRef(s9), c9 = d9, h9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 5a3 3 0 1 1 1.262 2.445L6.707 9l1.647 1.646-.708.708L6 9.707l-.793.793 1.647 1.646-.708.708L4.5 11.207l-1.146 1.147-.708-.708 4.909-4.908A3 3 0 0 1 7 5m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
        clipRule: "evenodd"
      }
    )
  }
), w9 = /* @__PURE__ */ t.forwardRef(h9), v9 = w9, f9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2h3v1h2v1.053l1.786-.479 2.07 7.728-2.898.776L10.464 6.5H10V4H9v2.5H8V3H7v3.5H6V5H5v1.5H4V4h2zm5.113 3.058 1.552 5.796.966-.26L12.078 4.8l-.965.259Zm-5.88 2.255 1.016.272h.502l1.017-.272 1.979.53 1.274 4.052-.442 1.647-1.171.479-1.075-.288-.34-1.268-1.493-.4-1.493.4-.34 1.268-1.075.288-1.171-.479-.442-1.647 1.275-4.052zm0 1.035-1.19.319-1.022 3.25.237.887.4.164.193-.052.34-1.267 2.31-.62 2.309.62.34 1.267.192.052.4-.164.237-.887-1.022-3.25-1.19-.32-.884.238h-.766l-.885-.237Z",
        clipRule: "evenodd"
      }
    )
  }
), m9 = /* @__PURE__ */ t.forwardRef(f9), p9 = m9, g9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3h3v1h2v1.053l1.785-.479 2.071 7.728-2.898.776L10 9.502V13H3V5h2zm1 9h1V4H6zm2 0h1V5H8zm-3 0V6H4v6zm5.112-5.942 1.553 5.796.966-.26L11.078 5.8l-.966.259Z",
        clipRule: "evenodd"
      }
    )
  }
), u9 = /* @__PURE__ */ t.forwardRef(g9), x9 = u9, R9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.945 3.44 1.009 1.748a3 3 0 0 1 2.092 0l1.009-1.748A5 5 0 0 0 8 3a5 5 0 0 0-2.055.44m4.975.501L9.912 5.688q.219.18.4.4l1.747-1.009a5 5 0 0 0-1.139-1.138m1.64 2.004-1.748 1.008a3 3 0 0 1 0 2.093l1.748 1.01A5 5 0 0 0 13 8c0-.733-.158-1.429-.44-2.055m-.501 4.976-1.747-1.009q-.181.219-.4.4l1.009 1.747c.438-.316.822-.7 1.138-1.138m-2.004 1.639-1.009-1.748a3 3 0 0 1-2.093 0L5.944 12.56A5 5 0 0 0 8 13a5 5 0 0 0 2.055-.44m-4.976-.502 1.009-1.746a3 3 0 0 1-.4-.4L3.941 10.92c.316.438.7.823 1.138 1.139ZM3.44 10.056l1.748-1.009a3 3 0 0 1 0-2.092L3.44 5.944A5 5 0 0 0 3 8c0 .733.157 1.428.44 2.055Zm.501-4.976 1.747 1.009q.181-.22.4-.4L5.079 3.941c-.437.316-.822.7-1.138 1.138ZM5 2.803A6 6 0 0 1 8 2c1.092 0 2.117.292 3 .803A6 6 0 0 1 13.198 5c.509.882.802 1.908.802 3a6 6 0 0 1-.803 3A6 6 0 0 1 11 13.198 6 6 0 0 1 8 14a6 6 0 0 1-3.001-.803A6 6 0 0 1 2.803 11 6 6 0 0 1 2 8c0-1.092.292-2.118.803-3A6 6 0 0 1 5 2.802ZM8 6a1.99 1.99 0 0 0-1.733 1A2 2 0 0 0 6 8a1.99 1.99 0 0 0 1 1.732c.294.17.635.268 1 .268a1.99 1.99 0 0 0 1.733-1c.17-.294.267-.635.267-1s-.097-.706-.267-1A2 2 0 0 0 9 6.267 2 2 0 0 0 8 6",
        clipRule: "evenodd"
      }
    )
  }
), j9 = /* @__PURE__ */ t.forwardRef(R9), M9 = j9, H9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a4 4 0 0 0-4 4c0 1.038.627 1.914 1.368 2.718q.133.145.265.282h1.715l-.903-3.37.966-.26L8 8.569l.589-2.197.966.258L8.652 10h1.715q.133-.137.265-.282C11.373 8.914 12 8.038 12 7a4 4 0 0 0-4-4m1.44 8H8.383l-.268 1H9c0-.248.092-.47.196-.65q.105-.179.243-.35ZM9 13H7v.293l.707.707h.586L9 13.293zm-2-1h.884l-.268-1H6.561c.09.114.174.231.243.35.104.18.196.402.196.65M3 7a5 5 0 0 1 10 0c0 1.447-.873 2.572-1.632 3.396-.173.187-.345.365-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v1.707L8.707 15H7.293L6 13.707V12c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.057a28 28 0 0 1-.504-.53C3.873 9.573 3 8.448 3 7",
        clipRule: "evenodd"
      }
    )
  }
), C9 = /* @__PURE__ */ t.forwardRef(H9), y9 = C9, b9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8.354a6 6 0 0 1 12 0v6h-4v-6a2 2 0 1 0-4 0v6H2zm6-5a5 5 0 0 0-5 5v3h2v-3a3 3 0 0 1 6 0v3h2v-3a5 5 0 0 0-5-5m5 9h-2v1h2zm-8 0H3v1h2z",
        clipRule: "evenodd"
      }
    )
  }
), V9 = /* @__PURE__ */ t.forwardRef(b9), L9 = V9, z9 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4M3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.662 6h2.676l2.4 6H13v3h-1v-4h1.261l-1.6-4H10.34l-1.6 4H10v4H9v-3H7.261l2.4-6ZM7 11V6H1v5h1v4h1v-5H2V7h4v3H5v5h1v-4z"
        }
      )
    ]
  }
), S9 = /* @__PURE__ */ t.forwardRef(z9), k9 = S9, F9 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11V6H5v5h1v4h1v-5H6V7h4v3H9v5h1v-4z" })
    ]
  }
), $9 = /* @__PURE__ */ t.forwardRef(F9), B9 = $9, A9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4.23v-2.5h1v2.5h2.5v1H5v2.5H4v-2.5H1.5v-1zm10.354-1.647-12 12-.708-.707 12-12zm.146 9.646h-6v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), E9 = /* @__PURE__ */ t.forwardRef(A9), _9 = E9, O9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5.585V2.761L7.404 5H6V4H3v1H2v4h1v4h3V9h1.404L13 11.239V8.415a1.5 1.5 0 0 0 0-2.83M6 8V6h1.596L12 4.239V9.76L7.596 8zM4 5h1v7H4V8H3V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), D9 = /* @__PURE__ */ t.forwardRef(O9), P9 = D9, T9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 1h2v1h1v7h-1.117l-.267 1H9.384l-.268-1H8V5.915q-.183.065-.383.08L6.007 12h7.877l.803 3H1.313l.803-3h.857l2.143-8h.97A1.5 1.5 0 0 1 8 3.085V2h1zm0 2v5h2V3zM6.085 5h-.201l-1.876 7h.965L6.65 5.737A1.5 1.5 0 0 1 6.085 5M8 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M2.884 13l-.268 1h10.768l-.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), q9 = /* @__PURE__ */ t.forwardRef(T9), I9 = q9, Z9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 6v-3H1v4h4v-1zm13-3v4h-4v-1h3v-3z",
        clipRule: "evenodd"
      }
    )
  }
), W9 = /* @__PURE__ */ t.forwardRef(Z9), G9 = W9, N9 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m5.146 5.854.768.767A2.5 2.5 0 0 0 5.5 8c0 .51.153.984.414 1.379l-.768.768.708.707.767-.768a2.5 2.5 0 0 0 2.758 0l.768.768.707-.707-.768-.768A2.5 2.5 0 0 0 10.5 8c0-.51-.153-.983-.414-1.379l.768-.767-.707-.708-.768.768A2.5 2.5 0 0 0 8 5.5c-.51 0-.983.153-1.379.414l-.767-.768zM6.94 6.939A1.5 1.5 0 0 1 8 6.5c.414 0 .789.167 1.06.44.273.271.44.646.44 1.06s-.167.789-.44 1.06c-.271.273-.646.44-1.06.44s-.789-.167-1.06-.44A1.5 1.5 0 0 1 6.5 8c0-.414.167-.789.44-1.06Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), U9 = /* @__PURE__ */ t.forwardRef(N9), Y9 = U9, Q9 = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 4H1v8h14zM2 6V5h1v1zm0 3V7h2V5h8v2h2v2h-2v2H4V9zm11-3V5h1v1zm0 4h1v1h-1zM3 10v1H2v-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), K9 = /* @__PURE__ */ t.forwardRef(Q9), X9 = K9, J9 = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.05 4.5c.09.07.248.153.487.233C4.017 4.893 4.71 5 5.5 5s1.484-.107 1.963-.267A1.7 1.7 0 0 0 7.95 4.5a1.7 1.7 0 0 0-.487-.233C6.983 4.107 6.29 4 5.5 4s-1.484.107-1.963.267a1.7 1.7 0 0 0-.487.233M8 5.6a4 4 0 0 1-.22.081C7.172 5.884 6.366 6 5.5 6c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 6.893 4.71 7 5.5 7s1.484-.107 1.963-.267c.243-.081.403-.166.492-.236A.4.4 0 0 0 8 6.457zm0 2a4 4 0 0 1-.22.081C7.172 7.884 6.366 8 5.5 8c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 8.893 4.71 9 5.5 9c.806 0 1.507-.112 1.982-.274q.22-.37.518-.675zm1-.263a3.5 3.5 0 1 1-1.741 4.486A8.3 8.3 0 0 1 5.5 12c-.867 0-1.673-.116-2.28-.319-.3-.1-.58-.23-.794-.399C2.217 11.117 2 10.857 2 10.5v-6c0-.357.217-.617.426-.782.215-.169.494-.3.795-.4C3.827 3.117 4.633 3 5.5 3s1.673.116 2.28.319c.3.1.58.23.794.399.209.165.426.425.426.782zM3 9.601v.855q.013.015.045.04c.09.07.25.156.492.237.48.16 1.173.267 1.963.267.57 0 1.091-.056 1.518-.148a3.5 3.5 0 0 1 .04-.988A8.6 8.6 0 0 1 5.5 10c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08M10.5 8c-.64 0-1.224.24-1.667.636a2.49 2.49 0 0 0-.761 2.463A2.501 2.501 0 1 0 10.5 8",
        clipRule: "evenodd"
      }
    )
  }
), eu = /* @__PURE__ */ t.forwardRef(J9), lu = eu, ou = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-2.482-2.482a5 5 0 0 1-7.33-1.104L3.28 9.93l1.004.063a4 4 0 0 0 3.435-1.568L1.646 2.354zM8.43 9.137a5 5 0 0 1-3.14 1.806 4 4 0 0 0 5.164.218z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 3.67a5 5 0 0 1 2.155 6.157l-.79-.791a4 4 0 0 0-2.672-4.855c.306.783.413 1.638.3 2.483l-.968-.968a4 4 0 0 0-.658-1.912l-.556-.838 1.004.063a5 5 0 0 1 2.185.66Z"
        }
      )
    ]
  }
), nu = /* @__PURE__ */ t.forwardRef(ou), iu = nu, ru = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.311 2.946 1.004.063a5 5 0 1 1-4.48 7.76L3.28 9.93l1.004.063a4 4 0 0 0 3.584-6.209l-.556-.838Zm1.882 1.235A4.99 4.99 0 0 1 8.866 8.5a4.99 4.99 0 0 1-3.576 2.443A4 4 0 1 0 9.194 4.18Z",
        clipRule: "evenodd"
      }
    )
  }
), tu = /* @__PURE__ */ t.forwardRef(ru), au = tu, su = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 4V1h1v3zM3 4V2h1v2zm5 0V2h1v2zM2 5h9v1h3.393l-1.607 6H11v.566L10.616 14H2.384L2 12.566zm9 6h1.018l1.072-4H11zm-1-5H3v6.434l.152.566h6.696l.152-.566z",
        clipRule: "evenodd"
      }
    )
  }
), du = /* @__PURE__ */ t.forwardRef(su), cu = du, hu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M2 3a2 2 0 0 1 4-.015l4.242 1.06A1.999 1.999 0 0 1 14 5a2 2 0 0 1-3.016 1.723L9.707 8l1.277 1.277a2 2 0 1 1-.742 2.678L6 13.015a2 2 0 1 1-.984-1.738l1.718-1.718-1.096-.41a2 2 0 1 1 0-2.296l1.096-.412-1.718-1.718A2 2 0 0 1 2 3m3.723 1.016 2.04 2.04 2.248-.844a2 2 0 0 1-.01-.197l-4.243-1.06-.035.06Zm4.291 2.263-1.475.553.461.46zM8.293 8l-.783-.782-1.521.57a2 2 0 0 1 0 .424l1.521.57zm-.53 1.945-2.04 2.04.035.06L10 10.985q0-.1.011-.197l-2.249-.843Zm2.251-.224L8.54 9.168l.46-.46zM12 4a1 1 0 1 0 0 2.001A1 1 0 0 0 12 4M4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8 3a.995.995 0 0 0-.937.649 1 1 0 0 0-.033.594A1 1 0 1 0 12 10m-8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
        clipRule: "evenodd"
      }
    )
  }
), wu = /* @__PURE__ */ t.forwardRef(hu), vu = wu, fu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12h-1.185l-.753-.646-1.312.716-1.375-.75L8 14.07l-1.375-.75-1.365.744-1.411-.706-.642.642H2zm1 1v9.793l.651-.651 1.589.794 1.385-.755L8 12.93l1.375-.75 1.375.75 1.438-.785.812.695V3zm1 1h4v3H4zm1 1v1h2V5zm7 0H9V4h3zm0 2H9V6h3zM4 9V8h8v1zm8 1v1H4v-1z",
        clipRule: "evenodd"
      }
    )
  }
), mu = /* @__PURE__ */ t.forwardRef(fu), pu = mu, gu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3h-3v3H6V3zm4 0v2h2V3zM4.646 7.568 8.51 8.603l-1.035 3.864L3.61 11.43l1.035-3.863Zm.708 1.224-.518 1.932 1.932.518.517-1.932zM11.5 10H9V9h2.5zm-.5 1v1H9v-1z",
        clipRule: "evenodd"
      }
    )
  }
), uu = /* @__PURE__ */ t.forwardRef(gu), xu = uu, Ru = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v10H1zm1 1v1h12V4zm12 2H2v.5h12zm0 1.5H2V12h12zM9 10H3V9h6zm4 0h-2V9h2z",
        clipRule: "evenodd"
      }
    )
  }
), ju = /* @__PURE__ */ t.forwardRef(Ru), Mu = ju, Hu = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.5 2H3v13.366l11.578-6.684-.251-.433A12.5 12.5 0 0 0 3.5 2M4 8.915a1.5 1.5 0 1 0 0-2.83V5.013a9.5 9.5 0 0 1 7.467 4.31L7.99 11.33a1.5 1.5 0 1 0-2.382 1.376L4 13.634zM4 7.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m0-3.488c3.5.164 6.55 2.041 8.334 4.81l.867-.5A11.5 11.5 0 0 0 4 3.01v1ZM6.5 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Cu = /* @__PURE__ */ t.forwardRef(Hu), yu = Cu, bu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.5 1.293 1.5 1.5 1.5-1.5 4.488 4.488.484 8.219H15v1H1v-1h.529l.483-8.22L6.5 1.294ZM2.53 14h3.187L7 11.862V7.5H5.99l-.49.85v2.15h-1V8.082l2.7-4.675-.7-.7L2.988 6.22zm4.353 0h2.234L8 12.139zm3.4 0h3.187l-.458-7.78L9.5 2.706l-.7.7 2.7 4.675V10.5h-1V8.35l-.49-.85H9v4.362zM6.568 6.5 8 4.02 9.432 6.5z",
        clipRule: "evenodd"
      }
    )
  }
), Vu = /* @__PURE__ */ t.forwardRef(bu), Lu = Vu, zu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 2h14v2h-1v7h-3.92l.903 3.37-.966.26L9.58 13H6.42l-.437 1.63-.966-.26L5.92 11H2V4H1zm2 8V4h10v6zm3.955 1-.268 1h2.625l-.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), Su = /* @__PURE__ */ t.forwardRef(zu), ku = Su, Fu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.552 1.263 2.436 9.09 2.588-7L11.554 7H15v1h-4.214l-.362-1.352-2.589 7-2.387-8.91L4.36 8H1V7h2.64z",
        clipRule: "evenodd"
      }
    )
  }
), $u = /* @__PURE__ */ t.forwardRef(Fu), Bu = $u, Au = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a1 1 0 0 0-1 1v1H5v2H4a1 1 0 0 0 0 2h1v3h1a2 2 0 1 1 4 0h2v-2a2 2 0 1 1 0-4V5H9V4a1 1 0 0 0-1-1M6 4a2 2 0 1 1 4 0h3v3h-1a1 1 0 1 0 0 2h1v4H9v-1a1 1 0 1 0-2 0v1H4v-3a2 2 0 1 1 0-4V4z",
        clipRule: "evenodd"
      }
    )
  }
), Eu = /* @__PURE__ */ t.forwardRef(Au), _u = Eu, Ou = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m9 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M1 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M1 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), Du = /* @__PURE__ */ t.forwardRef(Ou), Pu = Du, Tu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.694 2.008a6 6 0 1 0 5.344 9.253l.838.544A7 7 0 1 1 7.644 1.009zm1.635-.9.483.129a7.003 7.003 0 0 1 4.951 8.575l-.13.483-7.245-1.941zm.702 1.244L8.612 7.646l5.294 1.419a6 6 0 0 0-3.875-6.713M6.98 5.177a3.001 3.001 0 1 0 2.953 5.116l.645.764a4 4 0 1 1-3.937-6.82z",
        clipRule: "evenodd"
      }
    )
  }
), qu = /* @__PURE__ */ t.forwardRef(Tu), Iu = qu, Zu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.443 2.57 6.7 4.75a3.5 3.5 0 0 1 2.599 0l1.257-2.18A6 6 0 0 0 8 2c-.915 0-1.782.205-2.557.57m-.944-.633A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.5.937l.433.25-2.25 3.898-.433-.25A2.5 2.5 0 0 0 8 5.5c-.456 0-.883.122-1.25.334l-.433.25-2.25-3.897zM8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M1 7.5h4.5V8a2.5 2.5 0 0 0 1.25 2.166l.433.25-2.25 3.897-.434-.25A7 7 0 0 1 1 8zm1.02 1a6 6 0 0 0 2.557 4.429l1.258-2.179a3.5 3.5 0 0 1-1.3-2.25zm9.444 0c-.13.91-.61 1.707-1.299 2.25l1.258 2.179A6 6 0 0 0 13.979 8.5zM15 7.5V8a7 7 0 0 1-3.5 6.063l-.432.25-2.25-3.897.432-.25A2.5 2.5 0 0 0 10.5 8v-.5z",
        clipRule: "evenodd"
      }
    )
  }
), Wu = /* @__PURE__ */ t.forwardRef(Zu), Gu = Wu, Nu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m9.335 4.628 2.037 2.037c.589-.946.878-1.947.72-2.756-.81-.159-1.811.13-2.757.719m1.441 2.855L8.517 5.224a7 7 0 0 0-.42.387L4.206 9.5l.793.793.647-.647.707.708-.647.646.793.793 3.89-3.89a7 7 0 0 0 .386-.42ZM8 11.707l3.096-3.096c.267-.267.52-.558.75-.867.946-1.268 1.61-2.955 1.128-4.402l-.079-.237-.237-.08c-1.446-.481-3.134.183-4.402 1.13a8 8 0 0 0-.867.749L4.293 8h-2l-1.5 1.5L2.5 11.207l1-1 .793.793-1.146 1.146.707.708L5 11.707l.793.793-1 1L6.5 15.207l1.5-1.5zm-1 1-.793.793.293.293.5-.5zM3.293 9h-.586l-.5.5.293.293z",
        clipRule: "evenodd"
      }
    )
  }
), Uu = /* @__PURE__ */ t.forwardRef(Nu), Yu = Uu, Qu = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-3.582-.357 6 3.464 1.96-1.96.708.707-2.504 2.503-3-1.732-1.768 1.768 3 1.732-3.46 3.46-.708-.706 2.54-2.54-2.104-1.214-5.228 5.229-.708-.708 7.54-7.539-2.104-1.214-1.96 1.96-.707-.707z",
        clipRule: "evenodd"
      }
    )
  }
), Ku = /* @__PURE__ */ t.forwardRef(Qu), Xu = Ku, Ju = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 4V3h1v1H15v1h-2v2h2.152l-.804 3h-3.696l-.804-3H12V5H8.5v7H10v1H6v-1h1.5V5H4v2h2.152l-.804 3H1.652L.848 7H3V5H1V4zM2.152 8l.268 1h2.16l.268-1zm9 0 .268 1h2.16l.268-1z",
        clipRule: "evenodd"
      }
    )
  }
), ex = /* @__PURE__ */ t.forwardRef(Ju), lx = ex, ox = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2H10v2H8.5v.26l2.5 2V9h3v5H2V9h3V6.26l2.5-2zM8 5.14l-2 1.6V13h1v-2h2v2h1V6.74zM11 13h2v-3h-2zm-6 0v-3H3v3zm3-5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), nx = /* @__PURE__ */ t.forwardRef(ox), ix = nx, rx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.5 2.207.853-.853-.707-.708L7.5 1.793v1.66L2.868 4.694 1.982 8H3.25l1.363 5.088L8 15.043l3.386-1.955L12.75 8h1.268l-.886-3.306L8.5 3.453zM8 4.354 3.685 5.511 3.285 7h9.43l-.4-1.49L8 4.355ZM11.714 8H4.285l1.187 4.43L8 13.888l2.527-1.46z",
        clipRule: "evenodd"
      }
    )
  }
), tx = /* @__PURE__ */ t.forwardRef(rx), ax = tx, sx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6zm2 0a3 3 0 0 0 3 3v1a4 4 0 0 1-4-4zm2 0a1 1 0 0 0 1 1v1a2 2 0 0 1-2-2zM4.94 4.111a3.5 3.5 0 0 0-.636 4.079 3.57 3.57 0 0 0 1.527 1.515c.237.121.484.214.733.277A3.5 3.5 0 0 0 9.89 9.06l.707.707a4.5 4.5 0 0 1-4.26 1.188l.815 3.04H1.848l1.48-5.525a4.5 4.5 0 0 1 .904-5.067zm-.874 5.474-.914 3.411h2.696l-.672-2.51a4.6 4.6 0 0 1-1.11-.901",
        clipRule: "evenodd"
      }
    )
  }
), dx = /* @__PURE__ */ t.forwardRef(sx), cx = dx, hx = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.707.708-2.033-2.033a6.58 6.58 0 0 1-3.493 2.164l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188 16 16 0 0 1-.027-1.016c.003-.3.015-.468.032-.754l.695-.186-2.07-2.07zm2.18 3.595-.544.145c-.002.226.003.547.025.937.045.798.167 1.87.468 2.984.596 2.208 1.86 4.455 4.517 5.176a5.6 5.6 0 0 0 2.904-1.872z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.483 8.568c-.138.51-.313 1.034-.534 1.552l-.768-.768q.195-.519.336-1.045c.301-1.113.423-2.186.468-2.984.023-.39.027-.711.025-.937L8 3.044l-1.678.45-.817-.817L8 2.009l5.978 1.601c.015.252.03.502.032.754.002.245-.002.594-.026 1.016a16 16 0 0 1-.501 3.188"
        }
      )
    ]
  }
), wx = /* @__PURE__ */ t.forwardRef(hx), vx = wx, fx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.009 5.978 1.601.021.36-.5.03.5-.03v.01l.002.02.003.078q.004.102.006.286c.002.245-.002.594-.027 1.016a16 16 0 0 1-.5 3.188c-.645 2.384-2.102 5.102-5.362 5.917l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188A16 16 0 0 1 1.998 4L2 3.98v-.008L2.5 4 2 3.97l.022-.36zM2.99 4.386c-.002.226.002.547.025.937.045.798.167 1.87.468 2.984.596 2.208 1.86 4.455 4.517 5.176 2.657-.72 3.92-2.968 4.517-5.176.301-1.113.423-2.186.468-2.984.022-.39.026-.711.025-.937L8 3.044z",
        clipRule: "evenodd"
      }
    )
  }
), mx = /* @__PURE__ */ t.forwardRef(fx), px = mx, gx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2.02V1h1v1.02a5.97 5.97 0 0 1 3.374 1.398l.722-.721.707.707-.722.722A5.97 5.97 0 0 1 13.98 7.5H15v1h-1.02a5.97 5.97 0 0 1-1.399 3.374l.722.722-.707.707-.722-.722A5.97 5.97 0 0 1 8.5 13.98V15h-1v-1.02a5.97 5.97 0 0 1-3.374-1.397l-.722.721-.707-.707.721-.722A5.97 5.97 0 0 1 2.021 8.5H1v-1h1.02a5.97 5.97 0 0 1 1.398-3.374l-.721-.722.707-.707.722.721A5.97 5.97 0 0 1 7.5 2.021Zm0 1.005a4.98 4.98 0 0 0-2.664 1.104l2.148 2.148a2 2 0 0 1 .516-.214zm1 3.038q.276.072.516.214l2.148-2.148A4.98 4.98 0 0 0 8.5 3.025zm3.371-1.227L9.723 6.984q.142.24.214.516h3.038a4.98 4.98 0 0 0-1.104-2.664M12.976 8.5H9.937q-.072.276-.214.516l2.148 2.148A4.98 4.98 0 0 0 12.976 8.5m-1.81 3.371-2.15-2.148a2 2 0 0 1-.515.214v3.038a5 5 0 0 0 2.664-1.104ZM7.5 12.976V9.937a2 2 0 0 1-.516-.214l-2.148 2.148A4.98 4.98 0 0 0 7.5 12.976m-3.371-1.81 2.148-2.15a2 2 0 0 1-.214-.515H3.025a4.98 4.98 0 0 0 1.104 2.664ZM3.025 7.5h3.038q.072-.277.214-.516L4.129 4.836A4.98 4.98 0 0 0 3.025 7.5M8 7a1 1 0 0 0-.707.293A1 1 0 0 0 7 8c0 .276.111.526.293.707.181.182.43.293.707.293a1 1 0 0 0 .707-.293A1 1 0 0 0 9 8a1 1 0 0 0-.293-.707A1 1 0 0 0 8 7",
        clipRule: "evenodd"
      }
    )
  }
), ux = /* @__PURE__ */ t.forwardRef(gx), xx = ux, Rx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2m3 2a3 3 0 0 0-6 0H3v10h10V4zM4 5v8h8V5zm2 1a2 2 0 1 0 4 0h1a3 3 0 0 1-6 0z",
        clipRule: "evenodd"
      }
    )
  }
), jx = /* @__PURE__ */ t.forwardRef(Rx), Mx = jx, Hx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m4.796 7 1.149-4.289.966.26L5.83 7h4.338l-1.08-4.03.966-.259L11.205 7h2.947l-1.608 6H3.456L1.848 7zM3.152 8l1.071 4h7.554l1.071-4z",
        clipRule: "evenodd"
      }
    )
  }
), Cx = /* @__PURE__ */ t.forwardRef(Hx), yx = Cx, bx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.877 3H1V2h2.643l1.343 5h6.058l1.078-4.126.967.252L11.816 8H5.255l.268 1H11v1H4.757zM5.5 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Vx = /* @__PURE__ */ t.forwardRef(bx), Lx = Vx, zx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.877 3H1V2h2.643l.269 1h9.21l-1.306 5H5.255l.268 1H11v1H4.757zm2.11 4h6.057l.784-3H4.18l.805 3Zm.513 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Sx = /* @__PURE__ */ t.forwardRef(zx), kx = Sx, Fx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 5.5V4.366l-.982.567-.5-.866L9.5 3.5l-.982-.567.5-.866.982.567V1.5h1v1.134l.982-.567.5.866-.982.567.982.567-.5.866L11 4.366V5.5zm1 10v-3.134l-2.714 1.567-.5-.866L10.5 11.5 7.786 9.933l.5-.866L11 10.634V7.5h1v3.134l2.714-1.567.5.866L12.5 11.5l2.714 1.567-.5.866L12 12.366V15.5zm-7.5-8L1.652 6.433l.5-.866L4 6.634V4.5h1v2.134l1.848-1.067.5.866L5.5 7.5l1.848 1.067-.5.866L5 8.366V10.5H4V8.366L2.152 9.433l-.5-.866z"
      }
    )
  }
), $x = /* @__PURE__ */ t.forwardRef(Fx), Bx = $x, Ax = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm.414 1-5.5 5.5L7.5 12.793l5.5-5.5V4.707L11.293 3zM10.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.146 3.646-.707.708-2-2 .707-.708zm-1.707 1.708-2-2 .707-.708 2 2z",
        clipRule: "evenodd"
      }
    )
  }
), Ex = /* @__PURE__ */ t.forwardRef(Ax), _x = Ex, Ox = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm.414 1-5.5 5.5L7.5 12.793l5.5-5.5V4.707L11.293 3zM10.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), Dx = /* @__PURE__ */ t.forwardRef(Ox), Px = Dx, Tx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m13.016 1.828 1.357 5.064-2.332.625-.183-.683L9.74 7.4l1.74 6.492-.967.26-.634-2.369a4.5 4.5 0 0 1-2.765-.001l-.635 2.37-.966-.26L7.062 8.12l-2.034.545-.183-.683-1.767.473.074.273-.966.259-.777-2.898.966-.259.079.293L4.22 5.65l-.183-.683 6.83-1.83-.183-.683 2.332-.625ZM11.909 3.16l.839 3.132.4-.107-.84-3.132zm-.783.942L5.262 5.673l.473 1.766 5.864-1.571zM4.479 6.615l-1.766.473.107.4 1.766-.473zM8.177 7.82l-.803 2.995a3.5 3.5 0 0 0 2.247.002L8.775 7.66z",
        clipRule: "evenodd"
      }
    )
  }
), qx = /* @__PURE__ */ t.forwardRef(Tx), Ix = qx, Zx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 1h4v8.764a3 3 0 1 1-4 0zm3 8.17V8H8V7h1V6H8V5h1V4H8V3h1V2H7v8.25l-.2.15A2 2 0 1 0 8 10V9c.35 0 .687.06 1 .17",
        clipRule: "evenodd"
      }
    )
  }
), Wx = /* @__PURE__ */ t.forwardRef(Zx), Gx = Wx, Nx = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.641 7.169 8 5.87l-.641 1.3-1.433.208 1.037 1.011-.245 1.428L8 9.142l1.282.674-.245-1.428 1.037-1.01z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 3H1v4h1a1 1 0 0 1 0 2H1v4h14V9h-1a1 1 0 1 1 0-2h1zM2 6V4h12v2a2 2 0 1 0 0 4v2H2v-2a2 2 0 1 0 0-4",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ux = /* @__PURE__ */ t.forwardRef(Nx), Yx = Ux, Qx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.614 3h2.768l2.411 9h2.205v1h-12v-1h2.205zm-1.376 9h5.52L8.614 4H7.382l-.938 3.5H8v1H6.176l-.268 1H9v1H5.64z",
        clipRule: "evenodd"
      }
    )
  }
), Kx = /* @__PURE__ */ t.forwardRef(Qx), Xx = Kx, Jx = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4h1v3.5h6V4h1v8h-1V8.5H5V12H4zM2 7.5V5h1v6H2V8.5H1v-1zM13 5h1v2.5h1v1h-1V11h-1z",
        clipRule: "evenodd"
      }
    )
  }
), eR = /* @__PURE__ */ t.forwardRef(Jx), lR = eR, oR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m1.732 2a2 2 0 1 0-3.465 0H3.993l-2.144 8h12.304l-2.144-8zM4.76 6l-1.607 6h9.696l-1.607-6zM6 10V7h1v3zm3 0V7h1v3z",
        clipRule: "evenodd"
      }
    )
  }
), nR = /* @__PURE__ */ t.forwardRef(oR), iR = nR, rR = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.188 7.254a3.501 3.501 0 1 0 4.045 5.433l.78.626a4.5 4.5 0 1 1-5.2-6.985z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 7V6H7v5h3.711l1.3 2.25.865-.5L11.29 10H8V8h2V7z"
        }
      )
    ]
  }
), tR = /* @__PURE__ */ t.forwardRef(rR), aR = tR, sR = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.339 6H6.662l-2.4 6H6v3h1v-4H5.739l1.6-4h1.323l1.6 4H9v4h1v-3h1.739z"
        }
      )
    ]
  }
), dR = /* @__PURE__ */ t.forwardRef(sR), cR = dR, hR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m5.707 11 5.647-5.646-.707-.708L5 10.293V6H4v6h6v-1z"
      }
    )
  }
), wR = /* @__PURE__ */ t.forwardRef(hR), vR = wR, fR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.5 9.793V2h-1v7.793L4.354 6.646l-.708.708L8 11.707l4.354-4.353-.707-.708zM3 13h10v-1H3z"
      }
    )
  }
), mR = /* @__PURE__ */ t.forwardRef(fR), pR = mR, gR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 10.293 5.354 4.646l-.708.708L10.293 11H6v1h6V6h-1z"
      }
    )
  }
), uR = /* @__PURE__ */ t.forwardRef(gR), xR = uR, RR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.5 10.793V3h-1v7.793L4.354 7.646l-.708.708L8 12.707l4.354-4.353-.707-.708z"
      }
    )
  }
), jR = /* @__PURE__ */ t.forwardRef(RR), MR = jR, HR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3v10h1V3zm3.207 5.5H14v-1H6.207l3.147-3.146-.707-.708L4.293 8l4.354 4.354.707-.708z"
      }
    )
  }
), CR = /* @__PURE__ */ t.forwardRef(HR), yR = CR, bR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m3.207 8.5 2.147 2.146-.707.708L1.293 8l3.354-3.354.707.708L3.207 7.5h9.586l-2.146-2.146.707-.708L14.707 8l-3.353 3.354-.707-.707L12.793 8.5z",
        clipRule: "evenodd"
      }
    )
  }
), VR = /* @__PURE__ */ t.forwardRef(bR), LR = VR, zR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m8.354 4.354-.707-.708L3.293 8l4.354 4.354.707-.707L5.207 8.5H13v-1H5.207z"
      }
    )
  }
), SR = /* @__PURE__ */ t.forwardRef(zR), kR = SR, FR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 3v10h1V3zM9.793 7.5H2v1h7.793l-3.147 3.146.708.707L11.707 8 7.354 3.646l-.708.708z"
      }
    )
  }
), $R = /* @__PURE__ */ t.forwardRef(FR), BR = $R, AR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.793 8.5H3v-1h7.793L7.646 4.354l.708-.708L12.707 8l-4.353 4.354-.708-.707z"
      }
    )
  }
), ER = /* @__PURE__ */ t.forwardRef(AR), _R = ER, OR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.293 3.354 3.353-.707.708L8.5 3.207v9.586l2.146-2.147.708.707L8 14.707l-3.354-3.354.708-.707L7.5 12.793V3.207L5.354 5.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), DR = /* @__PURE__ */ t.forwardRef(OR), PR = DR, TR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 4H4v6h1V5.707l5.646 5.647.708-.707L5.707 5H10z"
      }
    )
  }
), qR = /* @__PURE__ */ t.forwardRef(TR), IR = qR, ZR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4h10V3H3zm4.5 2.207V14h1V6.207l3.146 3.147.708-.708L8 4.293 3.646 8.646l.708.708z"
      }
    )
  }
), WR = /* @__PURE__ */ t.forwardRef(ZR), GR = WR, NR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 10V4H6v1h4.293l-5.647 5.646.708.708L11 5.707V10z"
      }
    )
  }
), UR = /* @__PURE__ */ t.forwardRef(NR), YR = UR, QR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.354 7.646 8 3.293 3.646 7.646l.708.708L7.5 5.207V13h1V5.207l3.146 3.147z"
      }
    )
  }
), KR = /* @__PURE__ */ t.forwardRef(QR), XR = KR, JR = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 7.293 4.354 3.646l-.708.708L8 8.707l4.354-4.353-.707-.708zm0 4L4.354 7.646l-.708.708L8 12.707l4.354-4.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), ej = /* @__PURE__ */ t.forwardRef(JR), lj = ej, oj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.647 3.646.707.708L4.707 8l3.647 3.646-.707.707L3.293 8zm4 0 .707.708L8.707 8l3.647 3.646-.707.707L7.292 8l4.353-4.354Z",
        clipRule: "evenodd"
      }
    )
  }
), nj = /* @__PURE__ */ t.forwardRef(oj), ij = nj, rj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.354 3.646 8.707 8l-4.353 4.354-.708-.707L7.293 8 3.646 4.354zm4 0L12.707 8l-4.353 4.354-.708-.707L11.293 8 7.646 4.354z",
        clipRule: "evenodd"
      }
    )
  }
), tj = /* @__PURE__ */ t.forwardRef(rj), aj = tj, sj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 3.293 4.354 4.353-.707.708L8 4.707 4.354 8.354l-.708-.708zm0 4 4.354 4.353-.707.708L8 8.707l-3.646 3.647-.708-.707L8 7.292Z",
        clipRule: "evenodd"
      }
    )
  }
), dj = /* @__PURE__ */ t.forwardRef(sj), cj = dj, hj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.036 3.964H8.293v-1h4.743v4.743h-1zM2.965 8.293h1v3.743h3.742v1H2.965z",
        clipRule: "evenodd"
      }
    )
  }
), wj = /* @__PURE__ */ t.forwardRef(hj), vj = wj, fj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 9.293 4.354 5.646l-.708.708L8 10.707l4.354-4.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), mj = /* @__PURE__ */ t.forwardRef(fj), pj = mj, gj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.647 4.646.707.708L3.707 8l2.647 2.646-.707.708L2.293 8zM12.293 8 9.647 5.354l.707-.708L13.707 8l-3.353 3.354-.707-.707z",
        clipRule: "evenodd"
      }
    )
  }
), uj = /* @__PURE__ */ t.forwardRef(gj), xj = uj, Rj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.707 8 3.647 3.646-.708.708L5.293 8l4.353-4.354.707.708L6.708 8Z",
        clipRule: "evenodd"
      }
    )
  }
), jj = /* @__PURE__ */ t.forwardRef(Rj), Mj = jj, Hj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.293 8 5.646 4.354l.708-.708L10.707 8l-4.353 4.354-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Cj = /* @__PURE__ */ t.forwardRef(Hj), yj = Cj, bj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.293 3.354 3.353-.707.708L8 3.707 5.354 6.354l-.708-.708zm0 10L5.354 9.646l-.708.708L8 13.707l3.354-3.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Vj = /* @__PURE__ */ t.forwardRef(bj), Lj = Vj, zj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.964 2.964h4.743v1H3.964v3.743h-1zm9.072 9.072V8.293h1v4.743H8.293v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Sj = /* @__PURE__ */ t.forwardRef(zj), kj = Sj, Fj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 6.707-3.646 3.647-.708-.708L8 5.293l4.354 4.353-.707.708z",
        clipRule: "evenodd"
      }
    )
  }
), $j = /* @__PURE__ */ t.forwardRef(Fj), Bj = $j, Aj = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#shapes-diamond-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx("path", { d: "m13.268 10.44-.707-.708L14.293 8 8 1.707 6.268 3.44l-.707-.707L8 .292 15.706 8l-2.44 2.44Z" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M3.793 4.5.646 1.354l.708-.708 14 14-.708.708-3.146-3.147-3.5 3.5L.293 8zm.707.707L1.707 8 8 14.293l2.793-2.793z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-diamond-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Ej = /* @__PURE__ */ t.forwardRef(Aj), _j = Ej, Oj = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#shapes-diamond_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 .293 15.707 8 8 15.707.293 8zM1.707 8 8 14.293 14.293 8 8 1.707z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-diamond_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Dj = /* @__PURE__ */ t.forwardRef(Oj), Pj = Dj, Tj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m4.707 5 1.647-1.646-.707-.708L2.793 5.5l2.854 2.854.707-.708L4.707 6h7.311l-1.607 6H3v1h8.177l2.144-8z"
      }
    )
  }
), qj = /* @__PURE__ */ t.forwardRef(Tj), Ij = qj, Zj = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.707-1.773-1.771a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19a5 5 0 0 0 7.036 7.036L4.128 4.835Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 8c0 .926-.21 1.804-.585 2.587l-.76-.76a5 5 0 0 0-6.483-6.483l-.759-.76A6 6 0 0 1 14 8"
        }
      )
    ]
  }
), Wj = /* @__PURE__ */ t.forwardRef(Zj), Gj = Wj, Nj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
        clipRule: "evenodd"
      }
    )
  }
), Uj = /* @__PURE__ */ t.forwardRef(Nj), Yj = Uj, Qj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m3 10.887 5 2.886 5-2.886V5.113L8 2.227 3 5.113zM2 4.536l6-3.464 6 3.464v6.928l-6 3.464-6-3.464z",
        clipRule: "evenodd"
      }
    )
  }
), Kj = /* @__PURE__ */ t.forwardRef(Qj), Xj = Kj, Jj = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.515 2h4.97L14 5.515v4.97L10.485 14h-4.97L2 10.485v-4.97zm.414 1L3 5.929v4.142L5.929 13h4.142L13 10.071V5.93L10.071 3z",
        clipRule: "evenodd"
      }
    )
  }
), eM = /* @__PURE__ */ t.forwardRef(Jj), lM = eM, oM = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#shapes-shape-square-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.707L13.293 14H2V2.707L.646 1.354zM3 3.707V13h9.293z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M14 2v9.172l-1-1V3H5.828l-1-1z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-shape-square-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), nM = /* @__PURE__ */ t.forwardRef(oM), iM = nM, rM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3z",
        clipRule: "evenodd"
      }
    )
  }
), tM = /* @__PURE__ */ t.forwardRef(rM), aM = tM, sM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.24 7.366 12.758H.634zM2.366 12.998h11.268L8 3.24z",
        clipRule: "evenodd"
      }
    )
  }
), dM = /* @__PURE__ */ t.forwardRef(sM), cM = dM, hM = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m4.456 8-1.608 6h4.329v-1H4.15l1.072-4H9V8zM11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
        }
      )
    ]
  }
), wM = /* @__PURE__ */ t.forwardRef(hM), vM = wM, fM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M11.16 8.5H4.84l-1.34 5h3.464m1.536-2 2 2L15 9m-4.5-5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      }
    )
  }
), mM = /* @__PURE__ */ t.forwardRef(fM), pM = mM, gM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M7 8.5H4.84l-1.34 5h3m4-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM9 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
      }
    )
  }
), uM = /* @__PURE__ */ t.forwardRef(gM), xM = uM, RM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        stroke: "currentColor",
        d: "M7.177 13.5H3.5l1.34-5h6.32m-2.66 3h6m-4-7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      }
    )
  }
), jM = /* @__PURE__ */ t.forwardRef(RM), MM = jM, HM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .258 1.19 1.305 1.681-.536.378 1.725 1.724.377-.535 1.682L13.743 6l-1.305 1.189.535 1.682-.973.213v5.655l-4-1.6-4 1.6V9.084l-.973-.213.536-1.682L2.258 6l1.305-1.189-.536-1.682 1.725-.377.377-1.725 1.682.536zM5 10.384v2.877l3-1.2 3 1.2v-2.877l-.129.589-1.682-.536L8 11.742l-1.189-1.305-1.682.536zm3-8.642-.881.968-1.248-.397-.28 1.279-1.278.28.397 1.246L3.743 6l.967.882-.397 1.247 1.279.28.28 1.278 1.247-.397.881.968.882-.968 1.247.397.28-1.279 1.278-.28-.397-1.246.968-.882-.968-.882.397-1.247-1.278-.28-.28-1.278-1.247.397zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), CM = /* @__PURE__ */ t.forwardRef(HM), yM = CM, bM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.934 2h8.132l-.25 2h2.336l-1.34 5h-1.62l-.25 2h-1.79l.535 2H11v1H5v-1h1.312l.536-2h-1.79l-.25-2h-1.62l-1.34-5h2.336zm.375 3H3.15l.804 3h.729l-.375-3Zm3.574 6-.535 2h1.304l-.536-2zm3.05-8H5.067l.875 7h4.118l.875-7Zm.383 5h.729l.803-3h-1.157zM9.5 5h-3V4h3z",
        clipRule: "evenodd"
      }
    )
  }
), VM = /* @__PURE__ */ t.forwardRef(bM), LM = VM, zM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.1 3.374A5.002 5.002 0 0 0 8 13 5 5 0 0 0 8 3a1 1 0 1 0 .26 1.966l.257.966A2.002 2.002 0 0 1 6.1 3.374M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M5 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 4a4 4 0 0 1-2.83-1.172l.707-.707A3 3 0 0 0 8 10a3 3 0 0 0 2.121-.879l.707.707A4 4 0 0 1 8 11",
        clipRule: "evenodd"
      }
    )
  }
), SM = /* @__PURE__ */ t.forwardRef(zM), kM = SM, FM = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#social-bookmark-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.708L13 13.707v1.643l-5-2.778-5 2.778V3.707L.646 1.354zM4 4.707v8.943l4-2.222 4 2.222v-.943z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "m13 10.172-1-1V2H4.828l-1-1H13z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "social-bookmark-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), $M = /* @__PURE__ */ t.forwardRef(FM), BM = $M, AM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 1h10v14.35l-5-2.778-5 2.778zm1 1v11.65l4-2.222 4 2.222V2z",
        clipRule: "evenodd"
      }
    )
  }
), EM = /* @__PURE__ */ t.forwardRef(AM), _M = EM, OM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3zm8 3H5V5h6zm0 3H5V8h6z",
        clipRule: "evenodd"
      }
    )
  }
), DM = /* @__PURE__ */ t.forwardRef(OM), PM = DM, TM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2h11v8h-1.582l-.66 2.467L10.29 10H4zm1 1v6h5.704l1.535 1.536L12.651 9H14V3zM1 6h2v1H2v5h1.35l.41 1.536L5.297 12H8v-1h1v2H5.71l-2.467 2.467L2.582 13H1z",
        clipRule: "evenodd"
      }
    )
  }
), qM = /* @__PURE__ */ t.forwardRef(TM), IM = qM, ZM = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v5.5h-1V3H3v8h2.35l.41 1.536.89-.89.707.708-2.114 2.113L4.582 12H2z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z" })
    ]
  }
), WM = /* @__PURE__ */ t.forwardRef(ZM), GM = WM, NM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3z",
        clipRule: "evenodd"
      }
    )
  }
), UM = /* @__PURE__ */ t.forwardRef(NM), YM = UM, QM = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.61 7h2.78l.5 2H13v2.5h1V11h1v2h-1v-.5h-1V15H3v-2.5H2v.5H1v-2h1v.5h1V9h3.11zm.53 2h1.72l-.25-1H7.39zM4 10v4h8v-4zm7 2.5H5v-1h6z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 1h8v5h-1.293L11.23 8.48 10.61 6H7zm1 1v3h3.39l.381 1.523L13.293 5H14V2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), KM = /* @__PURE__ */ t.forwardRef(QM), XM = KM, JM = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 5a4 4 0 0 1-2.83-1.172l.707-.707A3 3 0 0 0 8 10a3 3 0 0 0 2.121-.879l.707.707A4 4 0 0 1 8 11",
        clipRule: "evenodd"
      }
    )
  }
), eH = /* @__PURE__ */ t.forwardRef(JM), lH = eH, oH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m2 3v1H5V9z",
        clipRule: "evenodd"
      }
    )
  }
), nH = /* @__PURE__ */ t.forwardRef(oH), iH = nH, rH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 4c-.829 0-1.578.335-2.122.879l-.707-.707A4 4 0 0 1 8 9c1.104 0 2.105.448 2.828 1.172l-.707.707A3 3 0 0 0 8 10",
        clipRule: "evenodd"
      }
    )
  }
), tH = /* @__PURE__ */ t.forwardRef(rH), aH = tH, sH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M3.959 8h8.082l-.082.57a4 4 0 0 1-7.919 0zM5.17 9a3.002 3.002 0 0 0 5.66 0z",
        clipRule: "evenodd"
      }
    )
  }
), dH = /* @__PURE__ */ t.forwardRef(sH), cH = dH, hH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.095-1.276-1.931.518-.26-.966 1.933-.518zm3.742.518-1.932-.518.259-.966 1.931.518zM8 9a2 2 0 0 0-2 2H5a3 3 0 0 1 6 0h-1a2 2 0 0 0-2-2",
        clipRule: "evenodd"
      }
    )
  }
), wH = /* @__PURE__ */ t.forwardRef(hH), vH = wH, fH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#social-founders-tier-1_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.001 5.113v6.062h-1v-6.64l6-3.464 5.75 3.32-.5.866-5.25-3.031zM5.5 6.557 8 5.113l2.25 1.3-.5.865L8 6.268l-1.5.866v2.02h-1zm8.251 2.164-8 4.619-.5-.866 8-4.619zm-6 5.196 5.5-3.175.5.866-5.5 3.175z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "social-founders-tier-1_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), mH = /* @__PURE__ */ t.forwardRef(fH), pH = mH, gH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#social-founders-tier-2_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.001 5.113v5.196l9.5-5.485-4.5-2.598zm5-4.042 6.5 3.753-12.5 7.217V4.535zm5.75 7.65-8 4.619-.5-.866 8-4.619zm-6 5.196 5.5-3.175.5.866-5.5 3.175z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "social-founders-tier-2_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), uH = /* @__PURE__ */ t.forwardRef(gH), xH = uH, RH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m3.001 10.887 1.817 1.049 8.183-4.725V5.113l-5-2.887-5 2.887zm-1-6.351 6-3.464 6 3.464v3.253L4.819 13.09l-2.817-1.626V4.536Zm5.75 9.382 5.5-3.176.5.866-5.5 3.176z",
        clipRule: "evenodd"
      }
    )
  }
), jH = /* @__PURE__ */ t.forwardRef(RH), MH = jH, HH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.001 1.072 6 3.464v6.928l-6 3.464-6-3.464V4.536zm-5 4.041v5.774l5 2.886 5-2.886V5.113l-5-2.887zm4.999 0 2.5 1.444v2.886L8 10.887 5.5 9.443V6.557zM6.5 7.134v1.732l1.5.866 1.5-.866V7.134L8 6.268z",
        clipRule: "evenodd"
      }
    )
  }
), CH = /* @__PURE__ */ t.forwardRef(HH), yH = CH, bH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-3.07-3.07L8 13.865 2.84 8.694l-.012-.014a3.44 3.44 0 0 1 .33-4.814L1.647 2.354zm1.513 2.928a2.44 2.44 0 0 0-.292 3.44L8 12.45l1.87-1.874z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m12.342 9.514-.707-.708.79-.791a2.44 2.44 0 0 0-3.441-3.439l-.797.783-2.334-2.334a3.43 3.43 0 0 1 1.827.803l.012.01.308.303.308-.302.013-.011a3.44 3.44 0 0 1 4.851 4.852l-.012.014z"
        }
      )
    ]
  }
), VH = /* @__PURE__ */ t.forwardRef(bH), LH = VH, zH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.32 3.828a3.44 3.44 0 0 1 4.852 4.852l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302zm.664.748L8 5.542l-.984-.966a2.44 2.44 0 0 0-3.44 3.439L8 12.45l4.425-4.435a2.44 2.44 0 0 0-3.441-3.439",
        clipRule: "evenodd"
      }
    )
  }
), SH = /* @__PURE__ */ t.forwardRef(zH), kH = SH, FH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.92 9h4.16l1.072 4H4.849zm.768 1-.536 2h3.697l-.536-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 0v1h6V0h1v1h2v14H2V1h2V0zm6 2v1h1V2h1v12H3V2h1v1h1V2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $H = /* @__PURE__ */ t.forwardRef(FH), BH = $H, AH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 2h14v12H1zm1 1v10h12V3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-.5h-1v-1h1zM13 8h-3V7h3zM4.14 9h3.72l1 3H3.14zm.72 1-.333 1h2.946l-.333-1zM13 10h-3V9h3zm0 2h-3v-1h3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), EH = /* @__PURE__ */ t.forwardRef(AH), _H = EH, OH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.116v2.056l-1-1v-.288l-.393-.106-.615-.614L9.542 2H6.458l-.13 1.5-.924-.924.05-.576h-.626L4.5 1.672V1h7v1h-.954l.422 4.84z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m9.293 10 4.354 4.354.707-.708-12-12-.708.708 3.475 3.474-.089 1.012L4 7.116V10h3.5v5h1v-5zm-3.25-3.249-.075.873-.968.26V9h3.293z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), DH = /* @__PURE__ */ t.forwardRef(OH), PH = DH, TH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.454 2H4.5V1h7v1h-.954l.422 4.84L12 7.116V10H8.5v5h-1v-5H4V7.116l1.032-.276zm1.004 0-.49 5.624-.968.26V9h6V7.884l-.968-.26L9.542 2z",
        clipRule: "evenodd"
      }
    )
  }
), qH = /* @__PURE__ */ t.forwardRef(TH), IH = qH, ZH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m6.844-1.495a2.5 2.5 0 0 1 .473 4.975l-.126-.992a1.5 1.5 0 0 0-.285-2.985zM2.456 8h7.088l1.607 6H.848zm.767 1-1.072 4h7.697L8.776 9zm9.021 1h-1.316V9h2.084l1.34 5H12v-1h1.048z",
        clipRule: "evenodd"
      }
    )
  }
), WH = /* @__PURE__ */ t.forwardRef(ZH), GH = WH, NH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.582 11.875 1.772 1.771-.707.708-12-12 .707-.708 2.661 2.662a3 3 0 1 1 2.676 2.676L8.707 8h2.837zM9.707 9h1.07l.39 1.46zM8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.223 9h.949l-1-1h-.716l-1.608 6h8.324l-1-1h-6.02z"
        }
      )
    ]
  }
), UH = /* @__PURE__ */ t.forwardRef(NH), YH = UH, QH = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4h7.088l1.607 6H2.848zm.767 1-1.072 4h7.697l-1.072-4z",
        clipRule: "evenodd"
      }
    )
  }
), KH = /* @__PURE__ */ t.forwardRef(QH), XH = KH, JH = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 6h-1v1.44l.7.56-.7.56V10h1v-.96l.5-.4.5.4V10h1V8.56L6.8 8l.7-.56V6h-1v.96l-.5.4-.5-.4z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1H9V6zm-1 2h1V7h-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m14.001 4.536-6-3.464-6 3.464v6.928l6 3.464 6-3.464zm-11 6.35V5.114l5-2.887 5 2.887v5.774l-5 2.886-5-2.886Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), eC = /* @__PURE__ */ t.forwardRef(JH), lC = eC, oC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.5 3H14v8h-3.211l-1.895 3.281a1.437 1.437 0 0 1-2.633-1.09L6.848 11H2.482L1.72 8.152 3.1 3h5.6l1.801.482zm1 7H13V4h-1.5zm-1-5.482v5.275l-.4.4-2.072 3.588a.437.437 0 0 1-.8-.331L8.151 10H3.25l-.495-1.848L3.867 4h4.701z",
        clipRule: "evenodd"
      }
    )
  }
), nC = /* @__PURE__ */ t.forwardRef(oC), iC = nC, rC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.35 2c-.156 0-.3.083-.378.219L5.9 5.807l-.4.4v5.275L7.432 12h4.701l1.113-4.152L12.75 6H7.848l.925-3.45A.437.437 0 0 0 8.35 2M4.5 12V6H3v6zm.711-7 1.895-3.281a1.437 1.437 0 0 1 2.633 1.09L9.152 5h4.366l.763 2.848L12.9 13H7.3l-1.8-.482V13H2V5z",
        clipRule: "evenodd"
      }
    )
  }
), tC = /* @__PURE__ */ t.forwardRef(rC), aC = tC, sC = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 2H2v5h5zM3 6V3h3v3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 14h-1v-2H9v-1h2V9h1v2h2v1h-2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 9h5v5H2zm1 1v3h3v-3zm11-8H9v5h5zm-4 4V3h3v3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dC = /* @__PURE__ */ t.forwardRef(sC), cC = dC, hC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2H2v5h5zM3 6V3h3v3zm4 3H2v5h5zm-4 4v-3h3v3zm6-4h5v5H9zm1 1v3h3v-3zm4-8H9v5h5zm-4 4V3h3v3z",
        clipRule: "evenodd"
      }
    )
  }
), wC = /* @__PURE__ */ t.forwardRef(hC), vC = wC, fC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h3v3H2zm1 1v1h1V3zm3.5-1h3v3h-3zm1 1v1h1V3zM11 2h3v3h-3zm1 1v1h1V3zM2 6.5h3v3H2zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zM2 11h3v3H2zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), mC = /* @__PURE__ */ t.forwardRef(fC), pC = mC, gC = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 4v8H2V4zm-1 7V5H3v6z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 2h8v1H4zm8 11H4v1h8z" })
    ]
  }
), uC = /* @__PURE__ */ t.forwardRef(gC), xC = uC, RC = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2H4v12h8zM5 13V3h6v10z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 4v8H2V4zm10 8V4h1v8z" })
    ]
  }
), jC = /* @__PURE__ */ t.forwardRef(RC), MC = jC, HC = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.354 2.646 8 .293 5.646 2.646l.708.708L7.5 2.207V7h1V2.207l1.146 1.147z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 4H2v8h5.1l-.269 1H5v1h6v-1H9.17l-.268-1H14V4h-3v1h2v6H3V5h2zm2.866 9L8 12.5l.134.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), CC = /* @__PURE__ */ t.forwardRef(HC), yC = CC, bC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 3V2h1v12H7v-1H2V3zm0 1H3v5.293l4-4zm0 2.707-4 4V12h4zM13 4H9V3h5v10H9v-1h4v-1.306l-2.35-1.357-1.4.809-.5-.866 1.9-1.097L13 9.539zM9.318 6.318A.32.32 0 0 0 9 6V5a1.318 1.318 0 1 1 0 2.636v-1a.32.32 0 0 0 .318-.318",
        clipRule: "evenodd"
      }
    )
  }
), VC = /* @__PURE__ */ t.forwardRef(bC), LC = VC, zC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3zm4.5 4.5v-3h1v3zm0 2v-1h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), SC = /* @__PURE__ */ t.forwardRef(zC), kC = SC, FC = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.295 8 6 10.291V8.997H5v3h3.001v-1H6.712L9 8.707 9.003 10h1V7H7v1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.707 2H3v12h10V5.293zM4 13V3h5v3h3v7zm7.293-8L10 3.707V5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $C = /* @__PURE__ */ t.forwardRef(FC), BC = $C, AC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5V2h1v4H2V5zm5-3h1v3h3v1h-4zm-8 8h4v4H5v-3H2zm8 0h4v1h-3v3h-1z",
        clipRule: "evenodd"
      }
    )
  }
), EC = /* @__PURE__ */ t.forwardRef(AC), _C = EC, OC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2v1H3v3H2V2zm7 1h-3V2h4v4h-1zM3 13v-3H2v4h4v-1zm10 0v-3h1v4h-4v-1z",
        clipRule: "evenodd"
      }
    )
  }
), DC = /* @__PURE__ */ t.forwardRef(OC), PC = DC, TC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2h8v8H4zm1 1v6h6V3zm-4 9h2v2H1zm3 0h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zm3 0h2v2h-2z",
        clipRule: "evenodd"
      }
    )
  }
), qC = /* @__PURE__ */ t.forwardRef(TC), IC = qC, ZC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), WC = /* @__PURE__ */ t.forwardRef(ZC), GC = WC, NC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), UC = /* @__PURE__ */ t.forwardRef(NC), YC = UC, QC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), KC = /* @__PURE__ */ t.forwardRef(QC), XC = KC, JC = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), ey = /* @__PURE__ */ t.forwardRef(JC), ly = ey, oy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), ny = /* @__PURE__ */ t.forwardRef(oy), iy = ny, ry = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h10v12H3zm1 1v10h2V3zm3 0v10h2V3zm3 0v10h2V3z",
        clipRule: "evenodd"
      }
    )
  }
), ty = /* @__PURE__ */ t.forwardRef(ry), ay = ty, sy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h3V3zm4 0v4.5h6V3zm6 5.5H7V13h6z",
        clipRule: "evenodd"
      }
    )
  }
), dy = /* @__PURE__ */ t.forwardRef(sy), cy = dy, hy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v3.5h2.5V4zm3.5 0v3.5h3V4zm4 0v3.5H13V4zM13 8.5h-2.5V12H13zM9.5 12V8.5h-3V12zm-4 0V8.5H3V12z",
        clipRule: "evenodd"
      }
    )
  }
), wy = /* @__PURE__ */ t.forwardRef(hy), vy = wy, fy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h3v3H2zm1 1v1h1V3zm11 1H6V3h8zM2 6h3v3H2zm1 1v1h1V7zm11 1H6V7h8zM2 10h3v3H2zm1 1v1h1v-1zm11 1H6v-1h8z",
        clipRule: "evenodd"
      }
    )
  }
), my = /* @__PURE__ */ t.forwardRef(fy), py = my, gy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v2h10V4zm10 3H3v2h10zm0 3H3v2h10z",
        clipRule: "evenodd"
      }
    )
  }
), uy = /* @__PURE__ */ t.forwardRef(gy), xy = uy, Ry = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h10v10H2zm1 1v5.293L8.293 4zm6.707 0-2.5 2.5L11 10.293V4zM11 11.707l-4.5-4.5-3.5 3.5V12h8zM13 12V4h1v8z",
        clipRule: "evenodd"
      }
    )
  }
), jy = /* @__PURE__ */ t.forwardRef(Ry), My = jy, Hy = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 2H9v1h3.293L6.646 8.646l.708.708L13 3.707V7h1z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7 3H2v11h11V9h-1v4H3V4h4z" })
    ]
  }
), Cy = /* @__PURE__ */ t.forwardRef(Hy), yy = Cy, by = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v3h12zM3 4V3h10v1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 8h12V7H2zm0 3h12v-1H2zm12 3H2v-1h12z" })
    ]
  }
), Vy = /* @__PURE__ */ t.forwardRef(by), Ly = Vy, zy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h5v6H3zm1 1v4h3V3zM2 9h6v5H2zm1 1v3h4v-3zm6-6h5v8H9zm1 1v6h3V5z",
        clipRule: "evenodd"
      }
    )
  }
), Sy = /* @__PURE__ */ t.forwardRef(zy), ky = Sy, Fy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3h10v10H4zm1 1v4.211l2.8 1.617 2.85-1.645L13 9.54V4zm8 6.694-2.35-1.357-2.85 1.646L5 9.366V12h8zM2 12V4h1v8zm5.773-5.545a.318.318 0 1 0 0 .636.318.318 0 0 0 0-.636m-1.318.318a1.318 1.318 0 1 1 2.636 0 1.318 1.318 0 0 1-2.636 0",
        clipRule: "evenodd"
      }
    )
  }
), $y = /* @__PURE__ */ t.forwardRef(Fy), By = $y, Ay = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 3H6v10h8zm-7 9V4h6v8z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5 4v8H4V4zM3 5v6H2V5z" })
    ]
  }
), Ey = /* @__PURE__ */ t.forwardRef(Ay), _y = Ey, Oy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10zm-6.141 4.842 1.333-4 .949.316-1.333 4zM5.646 7.146l.708.708L5.207 9l1.147 1.146-.708.708L3.793 9zM10.793 9 9.646 7.854l.708-.708L12.207 9l-1.853 1.854-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Dy = /* @__PURE__ */ t.forwardRef(Oy), Py = Dy, Ty = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1h6v6H1zm1 1v1h4V2zm4 2H2v2h4zm3-3h6v6H9zm1 1v1h4V2zm4 2h-4v2h4zM1 9h6v6H1zm1 1v1h4v-1zm4 2H2v2h4zm3-3h6v6H9zm1 1v1h4v-1zm4 2h-4v2h4z",
        clipRule: "evenodd"
      }
    )
  }
), qy = /* @__PURE__ */ t.forwardRef(Ty), Iy = qy, Zy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h10v8H2zm1 1v1h8V4zm8 2H3v4h8zm2 6V5h1v8H3v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Wy = /* @__PURE__ */ t.forwardRef(Zy), Gy = Wy, Ny = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10zM5.293 9 4.146 7.854l.708-.708L6.707 9l-1.853 1.854-.708-.708zM10 11H7v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), Uy = /* @__PURE__ */ t.forwardRef(Ny), Yy = Uy, Qy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10z",
        clipRule: "evenodd"
      }
    )
  }
), Ky = /* @__PURE__ */ t.forwardRef(Qy), Xy = Ky, Jy = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h10v8H2zm1 1v2h8V4zm8 3H6v3h5zm-6 3V7H3v3zm8 2V5h1v8H3v-1z",
        clipRule: "evenodd"
      }
    )
  }
), eb = /* @__PURE__ */ t.forwardRef(Jy), lb = eb, ob = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v10H2zm1 1v3h10V4zm10 4H7v4h6zm-7 4V8H3v4z",
        clipRule: "evenodd"
      }
    )
  }
), nb = /* @__PURE__ */ t.forwardRef(ob), ib = nb, rb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.293 2.354 2.353-.707.708L8.5 4.207v4.504l3.901 2.252-.42-1.566.966-.258.862 3.215-3.215.861-.26-.966 1.567-.42-3.9-2.252-3.902 2.252 1.566.42-.259.966-3.215-.861.862-3.215.966.258-.42 1.566L7.5 8.712V4.207L6.354 5.354l-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), tb = /* @__PURE__ */ t.forwardRef(rb), ab = tb, sb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 0 0-1 1H6a2 2 0 1 1 3.49 1.333l-.018.021-.623.558L14 7.886V9h-3v6.239l-3-1.2-3 1.2V9H2V7.887l5.706-3.294 1.056-.945A1 1 0 0 0 8 2m4.197 6L8 5.577 3.805 8z",
        clipRule: "evenodd"
      }
    )
  }
), db = /* @__PURE__ */ t.forwardRef(sb), cb = db, hb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.501 4.247 5.5-3.175 5.5 3.175-5.5 3.176zm-.5.866v6.351l5.5 3.175V8.29zm6.5 9.527 5.5-3.176v-6.35l-5.5 3.175v6.35Z"
      }
    )
  }
), wb = /* @__PURE__ */ t.forwardRef(hb), vb = wb, fb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.875 10.3 3.6l-.6.8-1.2-.9v8.915l2.674-2.298.652.758L8 14.164l-3.826-3.29.652-.758 2.674 2.3V3.5l-1.2.9-.6-.8z",
        clipRule: "evenodd"
      }
    )
  }
), mb = /* @__PURE__ */ t.forwardRef(fb), pb = mb, gb = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 2a5.97 5.97 0 0 0-3 .803l-.5-.866A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.501.937l-.5.866A5.97 5.97 0 0 0 8 2m0 2a4 4 0 0 0-2 .535l-.5-.866A5 5 0 0 1 8 3c.91 0 1.765.244 2.5.67l-.5.865A4 4 0 0 0 8 4M2.803 5A5.97 5.97 0 0 0 2 8a5.97 5.97 0 0 0 .803 3l-.866.5A6.97 6.97 0 0 1 1 8c0-1.274.341-2.47.937-3.501zM14 8a5.97 5.97 0 0 0-.803-3l.866-.501A6.97 6.97 0 0 1 15 8a6.97 6.97 0 0 1-.937 3.501l-.866-.5A5.97 5.97 0 0 0 14 8M4.535 6A4 4 0 0 0 4 8c0 .73.195 1.412.535 2l-.866.5A5 5 0 0 1 3 8c0-.91.244-1.765.67-2.5zM12 8a4 4 0 0 0-.535-2l.866-.5c.425.735.669 1.59.669 2.5a5 5 0 0 1-.67 2.5l-.865-.5A4 4 0 0 0 12 8m-6 3.465A4 4 0 0 0 8 12a4 4 0 0 0 2-.535l.5.866A5 5 0 0 1 8 13a5 5 0 0 1-2.5-.67zm-1 1.732A5.97 5.97 0 0 0 8 14a5.97 5.97 0 0 0 3-.803l.501.866A6.97 6.97 0 0 1 8 15a6.97 6.97 0 0 1-3.501-.937z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ub = /* @__PURE__ */ t.forwardRef(gb), xb = ub, Rb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .423 5.5 3.175-2.815 1.625 1.315.76v1.481l3-1.732v6.35l-5.5 3.176v-3.214L8 12.91l-1.5-.866v3.214L1 12.083v-6.35l3 1.731V5.982l1.315-.759L2.5 3.598zM6.315 5.8l-.815.47L8 7.715l2.5-1.443-.815-.47L8 6.773zM11 7.137 8.5 8.58v2.887l1-.578V8.908l1.5-.866v-.904Zm-3.5 4.33V8.58L5 7.137v.904l1.5.866v1.982z",
        clipRule: "evenodd"
      }
    )
  }
), jb = /* @__PURE__ */ t.forwardRef(Rb), Mb = jb, Hb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.173 9.938 3.29l-.5.866L8 3.327l-1.438.83-.5-.866zM4 6.214v1.083H3V5.059l1.938-1.118.5.866-.938.541.938.541-.5.866zm7.5-.866-.938-.541.5-.866L13 5.059v2.238h-1V6.214l-.938.541-.5-.866.938-.54ZM8 7.368l1.438-.83.5.867-1.438.83v1.66h-1v-1.66l-1.438-.83.5-.866zm-4 2.887v-1.66H3v2.238l1.938 1.118.5-.866zm8 0v-1.66h1v2.238l-1.938 1.118-.5-.866zm-4.5 2.021-.938-.541-.5.866L8 13.72l1.938-1.12-.5-.866-.938.541v-1.082h-1z",
        clipRule: "evenodd"
      }
    )
  }
), Cb = /* @__PURE__ */ t.forwardRef(Hb), yb = Cb, bb = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.224 7.053 8 7.44l.776-.388.448.894L8 8.56l-1.224-.612.448-.894Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h12v12H2zm6 2a3 3 0 0 0-3 3c0 .895.54 1.575.966 2.037q.118.129.228.24h3.612q.11-.111.229-.24C10.46 8.575 11 7.895 11 7a3 3 0 0 0-3-3m-1.333 6.818v-.54h2.666v.54l-.848.849h-.97z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Vb = /* @__PURE__ */ t.forwardRef(bb), Lb = Vb, zb = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zM2.5 5.793l1.854 1.853-.707.708L3 7.707V8a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6v-.293l-.646.647-.707-.708z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 4.375a2.5 2.5 0 0 0-2.5 2.5c0 .757.457 1.326.799 1.697q.121.13.229.24l.025.026c.079.082.143.149.196.21a1 1 0 0 1 .084.106v1.484l.738.737h.858l.738-.737V9.154a1 1 0 0 1 .084-.107q.079-.088.196-.209l.025-.025c.07-.073.15-.155.23-.24.341-.372.798-.94.798-1.698a2.5 2.5 0 0 0-2.5-2.5"
        }
      )
    ]
  }
), Sb = /* @__PURE__ */ t.forwardRef(zb), kb = Sb, Fb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m0 9a3 3 0 0 0 3-3h1a4 4 0 0 1-4 4zm-2.286.283.503-.86 1 .482-.36.93a4 4 0 0 1-1.143-.552m.7-4.368c-.587.586-1.378.744-1.769.353-.39-.39-.232-1.182.354-1.767.586-.586 1.377-.744 1.768-.354.39.39.232 1.182-.354 1.768Z",
        clipRule: "evenodd"
      }
    )
  }
), $b = /* @__PURE__ */ t.forwardRef(Fb), Bb = $b, Ab = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#3d-move-global_svg__a)", children: /* @__PURE__ */ l.jsx("path", { d: "m8 .918 2.354 2.353-.708.708L8.5 2.832V4.5h-1V2.832L6.354 3.98l-.708-.708zM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m2.354 7.229L8 15.082l-2.354-2.354.708-.707L7.5 13.168V11.5h1v1.668l1.146-1.147zM15.082 8l-2.354-2.354-.707.708L13.168 7.5H11.5v1h1.668L12.02 9.646l.707.708zM3.271 5.646.918 8l2.353 2.354.708-.708L2.832 8.5H4.5v-1H2.832L3.98 6.354l-.708-.708Z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "3d-move-global_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Eb = /* @__PURE__ */ t.forwardRef(Ab), _b = Eb, Ob = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2.173 8.938 3.29l-.5.866L7 3.327l-1.438.83-.5-.866zM3 6.214v1.083H2V5.059l1.938-1.118.5.866-.938.541.938.541-.5.866zm2.563.325L7.5 7.657v2.238h-1v-1.66l-1.438-.83zM3 10.256v-1.66H2v2.237l1.938 1.118.5-.866zm8 0v-1.66h1v2.237l-1.938 1.118-.5-.866zm-4.5 2.02-.938-.541-.5.866L7 13.72l1.938-1.12-.5-.866-.938.541v-1.082h-1zM11 2h4v4h-1V3.707l-3.646 3.647-.708-.708L13.293 3H11z",
        clipRule: "evenodd"
      }
    )
  }
), Db = /* @__PURE__ */ t.forwardRef(Ob), Pb = Db, Tb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.08 12.502c.55-1.1.92-2.69.92-4.502 0-.98-.108-1.897-.295-2.705A12 12 0 0 0 8 5c-.579 0-1.135.038-1.66.107a11.6 11.6 0 0 0-.32 2.166l.626-.627.708.708L5.5 9.207 3.646 7.354l.708-.708.663.664c.034-.706.121-1.38.253-2.01a8 8 0 0 0-1.773.62C2.337 6.5 2 7.116 2 7.5s.337 1 1.497 1.58C4.598 9.63 6.19 10 8 10q.146 0 .29-.003l-.644-.643.708-.708 1.853 1.854-1.853 1.854-.708-.708.65-.65A7 7 0 0 1 8 11c-3.866 0-7-1.567-7-3.5 0-1.503 1.894-2.784 4.554-3.28C6.176 2.283 7.264 1 8.5 1c1.29 0 2.418 1.397 3.025 3.475C13.603 5.082 15 6.21 15 7.5c0 .988-.82 1.881-2.137 2.518q.081-.589.115-1.205C13.758 8.317 14 7.825 14 7.5c0-.384-.337-1-1.498-1.58a7 7 0 0 0-.71-.305C11.927 6.359 12 7.162 12 8c0 3.866-1.567 7-3.5 7-1.233 0-2.317-1.275-2.94-3.203q.541.093 1.111.144.117.298.249.561C7.5 13.663 8.116 14 8.5 14s1-.337 1.58-1.498m.305-8.294a7 7 0 0 0-.305-.71C9.5 2.336 8.884 2 8.5 2s-1 .337-1.58 1.497a7 7 0 0 0-.25.566 14 14 0 0 1 3.715.145",
        clipRule: "evenodd"
      }
    )
  }
), qb = /* @__PURE__ */ t.forwardRef(Tb), Ib = qb, Zb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 3a5 5 0 0 1 5 5v.293l-.646-.647-.707.708 1.853 1.853 1.854-1.853-.707-.708-.647.647V8a6 6 0 0 0-6-6zM4.354 7.646 2.5 5.793.647 7.646l.707.708L2 7.707V8a6 6 0 0 0 6 6v-1a5 5 0 0 1-5-5v-.293l.647.647zM5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      }
    )
  }
), Wb = /* @__PURE__ */ t.forwardRef(Zb), Gb = Wb, Nb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7 1.226 5.5 3.176-5 2.887v5.773L2 9.887V4.113zm0 5.197 3.5-2.021L7 2.382l-3.5 2.02L7 6.422ZM3 5.268v4.041l3.5 2.021V7.289zm12 .268v6.35l-5.5 3.176v-6.35z",
        clipRule: "evenodd"
      }
    )
  }
), Ub = /* @__PURE__ */ t.forwardRef(Nb), Yb = Ub, Qb = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1a5.5 5.5 0 0 0-3.783 9.492 5 5 0 0 0-.81.331 2.2 2.2 0 0 0-.614.459A1.08 1.08 0 0 0 2.5 12v1c0 .45.302.777.604.992.315.223.738.404 1.217.548.963.289 2.264.46 3.679.46s2.716-.171 3.68-.46c.478-.144.901-.325 1.216-.548.302-.215.604-.543.604-.992v-1a1.08 1.08 0 0 0-.293-.718 2.2 2.2 0 0 0-.613-.459 5 5 0 0 0-.811-.33A5.5 5.5 0 0 0 8 1M3.876 11.706c.314-.167.778-.324 1.365-.447C6.053 11.73 6.995 12 8 12s1.947-.27 2.759-.74c.587.122 1.051.279 1.365.446.173.092.278.176.334.24a.2.2 0 0 1 .042.06v.987c-.004.012-.032.076-.182.183-.191.135-.5.278-.926.406C10.545 13.836 9.346 14 8 14s-2.545-.164-3.392-.418c-.426-.128-.735-.27-.926-.406-.15-.107-.178-.17-.182-.183v-.988a.2.2 0 0 1 .042-.06c.056-.063.16-.147.334-.239m-.377.303v-.002zm3.414-6.27c-.586.586-1.377.745-1.768.354-.39-.39-.232-1.182.354-1.768.586-.585 1.377-.744 1.768-.353.39.39.232 1.182-.354 1.768ZM11 6.326a3 3 0 0 1-3 3v1a4 4 0 0 0 4-4zm-3.43 2.97a3 3 0 0 1-.855-.259l-.43.904c.356.168.74.287 1.144.344l.142-.99Z",
        clipRule: "evenodd"
      }
    )
  }
), Kb = /* @__PURE__ */ t.forwardRef(Qb), Xb = Kb, Jb = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a6 6 0 0 1 11.995-.246 4.5 4.5 0 0 0-6.24 6.24A6 6 0 0 1 2 8.001Zm2.645-.732c.39.39 1.182.233 1.768-.353s.744-1.377.354-1.768c-.39-.39-1.182-.232-1.768.354-.586.585-.744 1.377-.354 1.767",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 9.05a2.5 2.5 0 0 0-1.371.792l-.91-.525-.5.866.91.525a2.5 2.5 0 0 0 0 1.584l-.91.525.5.866.91-.525A2.5 2.5 0 0 0 11 13.95V15h1v-1.05a2.5 2.5 0 0 0 1.371-.792l.91.525.5-.866-.91-.525a2.5 2.5 0 0 0 0-1.584l.91-.525-.5-.866-.91.525a2.5 2.5 0 0 0-1.37-.792V8h-1v1.05Zm.5.95a1.5 1.5 0 1 0-.001 3 1.5 1.5 0 0 0 .001-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
), eV = /* @__PURE__ */ t.forwardRef(Jb), lV = eV, oV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2.84 2.854 3 3 .708-.708-3-3zm-3.389-.708-3 3 .707.708 3-3zM8.499 10V5h-1v5zm-2.606-.13-1.34 5 .966.26 1.34-5zm3.247.26 1.339 5 .966-.26-1.34-5z"
      }
    )
  }
), nV = /* @__PURE__ */ t.forwardRef(oV), iV = nV, rV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4.5h2V5h1.91l.804 3h.403l.803-3h1.58v1h-.812l-.804 3h-.902l.518 1.934V11c0 .424-.332.685-.56.82-.262.154-.607.276-.99.372-.774.194-1.817.308-2.95.308s-2.176-.114-2.95-.308c-.383-.096-.729-.218-.99-.372-.229-.135-.56-.396-.56-.82v-.066L3.75 10H1.848L2.92 6h1.902l.268-1H7zM3.688 7l-.536 2h.866l.536-2z",
        clipRule: "evenodd"
      }
    )
  }
), tV = /* @__PURE__ */ t.forwardRef(rV), aV = tV, sV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m3.152 4.675H4.848L6.811 13H9.19z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.069 10.23C2.667 10.624 1 11.492 1 12.5 1 13.88 4.134 15 8 15s7-1.12 7-2.5c0-1.007-1.667-1.875-4.069-2.27l-.26.97c.742.117 1.4.28 1.942.474.571.204.962.423 1.192.617a.8.8 0 0 1 .189.209.8.8 0 0 1-.19.21c-.229.193-.62.412-1.19.616C11.48 13.731 9.848 14 8 14c-1.85 0-3.48-.27-4.613-.674-.571-.204-.962-.423-1.192-.617a.8.8 0 0 1-.189-.209.8.8 0 0 1 .19-.21c.229-.193.62-.412 1.19-.616a11 11 0 0 1 1.943-.474z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dV = /* @__PURE__ */ t.forwardRef(sV), cV = dV, hV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2H2v12h12zM3 3.293V3h.293zm0 1.414v1.586L6.293 3H4.707zM7.707 3 3 7.707v1.586L9.293 3zm3 0L3 10.707v1.586L12.293 3zM13 3.707 3.707 13h1.586L13 5.293zm0 3L6.707 13h1.586L13 8.293zm0 3L9.707 13h1.586L13 11.293zm0 3-.293.293H13z",
        clipRule: "evenodd"
      }
    )
  }
), wV = /* @__PURE__ */ t.forwardRef(hV), vV = wV, fV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708-4.631-4.63a2 2 0 0 1-2.74-2.74L4.84 5.547a4.002 4.002 0 0 0 1.844 6.232 1.5 1.5 0 1 1-.158 1 5.002 5.002 0 0 1-2.397-7.943L1.646 2.354zM8 4c-.358 0-.706.047-1.036.136l-.791-.792a5 5 0 0 1 6.784 3.992l.69-.69.707.708L12 9.707V8a4 4 0 0 0-4-4"
      }
    )
  }
), mV = /* @__PURE__ */ t.forwardRef(fV), pV = mV, gV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 8a4 4 0 1 1 8 0v1.707l2.354-2.353-.707-.708-.69.69a5.001 5.001 0 1 0-6.431 5.443 1.5 1.5 0 1 0 .159-1A4 4 0 0 1 4 8"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4" })
    ]
  }
), uV = /* @__PURE__ */ t.forwardRef(gV), xV = uV, RV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 13.062 3.502L13.197 11a6 6 0 1 0-10.394 0l-.865.5A6.97 6.97 0 0 1 1 8m3 0a4 4 0 1 1 7.464 2.002l-.866-.501a3 3 0 1 0-5.197 0l-.865.5A4 4 0 0 1 4 8m3 0a1 1 0 1 1 1.706.708l1.517 5.663-.966.258-.302-1.129H7.043l-.303 1.13-.966-.26 1.518-5.664A1 1 0 0 1 7 8m.999 1.932L7.311 12.5h1.376z",
        clipRule: "evenodd"
      }
    )
  }
), jV = /* @__PURE__ */ t.forwardRef(RV), MV = jV, HV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v3.758a4.48 4.48 0 0 0-3.155-.71 3.001 3.001 0 1 0-3.798 3.797A4.54 4.54 0 0 0 7.257 13H2V4h3.191z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 6a2 2 0 0 1 1.875 1.302 4.51 4.51 0 0 0-2.573 2.573A2 2 0 0 1 8 6m3 8.5V12H8.5v-1H11V8.5h1V11h2.5v1H12v2.5z"
        }
      )
    ]
  }
), CV = /* @__PURE__ */ t.forwardRef(HV), yV = CV, bV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.293 13 1.354 1.354.707-.708-12-12-.708.708L3.293 4H2v9zm-2.555-2.555-.722-.722a2 2 0 0 1-2.74-2.74l-.721-.721a3 3 0 0 0 4.184 4.184Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 4v7.172l-3.005-3.005a3 3 0 0 0-3.162-3.162L5.737 2.908 6.19 2h3.618l1 2z"
        }
      )
    ]
  }
), VV = /* @__PURE__ */ t.forwardRef(bV), LV = VV, zV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.191 2h3.618l1 2H14v9H2V4h3.191zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
          clipRule: "evenodd"
        }
      )
    ]
  }
), SV = /* @__PURE__ */ t.forwardRef(zV), kV = SV, FV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3H2v11h12zM5.788 4h1.964l-.536 2H5.252zm3 0-.536 2h1.964l.536-2zM13 4v2h-1.748l.536-2zM4.216 6H3V4h1.752z",
        clipRule: "evenodd"
      }
    )
  }
), $V = /* @__PURE__ */ t.forwardRef(FV), BV = $V, AV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.134 3.5H1v9h1.134l.116-.067C3.215 11.877 5.407 11 8 11s4.785.877 5.75 1.433l.116.067H15v-9h-1.134l-.116.067C12.785 4.123 10.593 5 8 5s-4.785-.877-5.75-1.433z"
      }
    )
  }
), EV = /* @__PURE__ */ t.forwardRef(AV), _V = EV, OV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13.623 9 8 2.753 2.377 9zM2.5 11v1h11v-1z" })
  }
), DV = /* @__PURE__ */ t.forwardRef(OV), PV = DV, TV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4H6V3h4zm0 2H6V5h4zm0 2H6V7h4zm5 0h-4V7h4zM5 10H1V9h4zm5 0H6V9h4zm5 0h-4V9h4zM5 12H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4zM5 14H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4z",
        clipRule: "evenodd"
      }
    )
  }
), qV = /* @__PURE__ */ t.forwardRef(TV), IV = qV, ZV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 5h2V1h1v4h2v3H5v2H4V8H2zm9-4v2H9v3h2v4h1V6h2V3h-2V1zM4.5 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      }
    )
  }
), WV = /* @__PURE__ */ t.forwardRef(ZV), GV = WV, NV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15.492 8 8 3.63v3.49L2 3.63v8.74l6-3.5v3.5z"
      }
    )
  }
), UV = /* @__PURE__ */ t.forwardRef(NV), YV = UV, QV = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 7.12V3.63L.508 8 8 12.37v-3.5l6 3.5V3.63z"
      }
    )
  }
), KV = /* @__PURE__ */ t.forwardRef(QV), XV = KV, JV = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 1h12v6h-1V6h-1v1h-1V2H5v5h4v1H5v5h2v1H2zm2 12v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm0-2h1V2H3zm9-1v1h1V2zm1 2h-1v1h1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z" })
    ]
  }
), eL = /* @__PURE__ */ t.forwardRef(JV), lL = eL, oL = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3H2v9h10zm-1 8v-1h-1v1zm-2 0V8H5v3zm-5 0v-1H3v1zM3 9h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm2-1v3h4V4zm5 0v1h1V4zm1 2h-1v1h1zm0 2h-1v1h1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 5h1v9H4v-1h9z" })
    ]
  }
), nL = /* @__PURE__ */ t.forwardRef(oL), iL = nL, rL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 1H2v13h12zM3 3V2h1v1zm0 5v1h1V8zm0 5v-1h1v1zm1-2H3v-1h1zM3 7h1V6H3zm2 1v5h6V8zm6-1H5V2h6zm1 5v1h1v-1zm0-1h1v-1h-1zm0-2h1V8h-1zm1-2h-1V6h1zM3 5h1V4H3zm9-1v1h1V4zm0-2v1h1V2z",
        clipRule: "evenodd"
      }
    )
  }
), tL = /* @__PURE__ */ t.forwardRef(rL), aL = tL, sL = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 8a5 5 0 1 0-5 5v1a6 6 0 1 1 5.898-7.105l1.248-1.249.708.708L12 9.207z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 5h1.01v1.125H5v3.75h.01V11H4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6.125C6 5.422 6.649 5 7.25 5h1.5C9.351 5 10 5.422 10 6.125v3.75C10 10.578 9.351 11 8.75 11h-1.5C6.649 11 6 10.578 6 9.875zm1.04-.058C7 6.1 7 6.123 7 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067C9 9.9 9 9.877 9 9.875v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 8.75 6h-1.5a.33.33 0 0 0-.21.067",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dL = /* @__PURE__ */ t.forwardRef(sL), cL = dL, hL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM7 5h1a1.5 1.5 0 0 1 0 3v1H7zm1 2a.5.5 0 1 0 0-1zM4 5h2.5v1H5v.5h1v1H5V9H4zm7.114 1.098c-.09.049-.114.13-.114.152 0 .095.024.143.3.35l.029.021c.234.175.671.5.671 1.129a1.2 1.2 0 0 1-.636 1.03c-.433.236-.987.218-1.588-.083l.448-.894c.399.2.595.136.662.1.09-.05.114-.131.114-.153 0-.095-.024-.143-.3-.35l-.029-.021c-.234-.175-.671-.5-.671-1.129a1.2 1.2 0 0 1 .636-1.03c.433-.236.987-.218 1.588.083l-.448.894c-.399-.2-.595-.136-.662-.1Z",
        clipRule: "evenodd"
      }
    )
  }
), wL = /* @__PURE__ */ t.forwardRef(hL), vL = wL, fL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0 2h16v11H0zm3 8V5h1v2h2V5h1v5H6V8H4v2zm7.5-4a1.5 1.5 0 1 0 .647 2.854l-.5-.5.707-.708.5.5A1.5 1.5 0 0 0 10.5 6m2.086 2.879a2.5 2.5 0 1 0-.707.707l.767.768.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), mL = /* @__PURE__ */ t.forwardRef(fL), pL = mL, gL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM12 6h-1V5h1zM7.51 9H4.5V8h3.01zM10 9H9V8h1zm2 0h-1V8h1z",
        clipRule: "evenodd"
      }
    )
  }
), uL = /* @__PURE__ */ t.forwardRef(gL), xL = uL, RL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.708.708-9.285-9.286A3.001 3.001 0 0 0 5 11h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.708L7.293 12H5a4 4 0 0 1-1.44-7.733L1.646 2.354zM15 8a3.99 3.99 0 0 1-1.259 2.913l-.707-.708A3 3 0 0 0 11 5H7.828l-1-1H11a4 4 0 0 1 4 4"
      }
    )
  }
), jL = /* @__PURE__ */ t.forwardRef(RL), ML = jL, HL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8v-1a3 3 0 1 0 0-6H5a3 3 0 0 0 0 6h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.708L7.293 12H5a4 4 0 0 1-4-4",
        clipRule: "evenodd"
      }
    )
  }
), CL = /* @__PURE__ */ t.forwardRef(HL), yL = CL, bL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 8c0 .645-.122 1.261-.344 1.827l-.792-.79Q12 8.537 12 8zm-2 0q0 .084-.005.167l-5.62-5.62A3 3 0 0 1 11 4zm-.547 3.16A4 4 0 0 1 4 8H3a5 5 0 0 0 3.45 4.755L5.848 15h4.303l-.599-2.245a5 5 0 0 0 1.612-.884l2.482 2.482.707-.707-12-12-.707.708L5 5.707V8a3 3 0 0 0 4.738 2.445z"
      }
    )
  }
), VL = /* @__PURE__ */ t.forwardRef(bL), LL = VL, zL = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 12a4 4 0 0 1-4-4H3a5 5 0 0 0 3.45 4.755L5.848 15h4.303l-.599-2.245A5 5 0 0 0 13 8h-1a4 4 0 0 1-4 4"
        }
      )
    ]
  }
), SL = /* @__PURE__ */ t.forwardRef(zL), kL = SL, FL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 3.5v4.213L4 3.629v8.741l7-4.083V12.5h1v-9z"
      }
    )
  }
), $L = /* @__PURE__ */ t.forwardRef(FL), BL = $L, AL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 3H5v7H4a2 2 0 1 0 2 2V6h6v4h-1a2 2 0 1 0 2 2z",
        clipRule: "evenodd"
      }
    )
  }
), EL = /* @__PURE__ */ t.forwardRef(AL), _L = EL, OL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 12V4h1v8zm5 0V4h1v8z",
        clipRule: "evenodd"
      }
    )
  }
), DL = /* @__PURE__ */ t.forwardRef(OL), PL = DL, TL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v10H1zm11.5 2.5h-5v3h5z",
        clipRule: "evenodd"
      }
    )
  }
), qL = /* @__PURE__ */ t.forwardRef(TL), IL = qL, ZL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12.492 8 5 3.63v8.74z" })
  }
), WL = /* @__PURE__ */ t.forwardRef(ZL), GL = WL, NL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 3.5v9h1V8.287l7 4.083V3.63L5 7.712V3.5z" })
  }
), UL = /* @__PURE__ */ t.forwardRef(NL), YL = UL, QL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
        clipRule: "evenodd"
      }
    )
  }
), KL = /* @__PURE__ */ t.forwardRef(QL), XL = KL, JL = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.707-2.483-2.482c-.7.573-1.559.96-2.5 1.085l.69.69-.708.707L6.293 12H8c.924 0 1.775-.314 2.453-.84L9.016 9.723a2 2 0 0 1-2.74-2.74L4.84 5.548a3.997 3.997 0 0 0 1.044 5.848l-.53.848a4.997 4.997 0 0 1-1.225-7.407L1.646 2.354zM13 8c0 .874-.224 1.696-.619 2.41l-.658-.945a4 4 0 0 0-1.607-4.86l.53-.848A5 5 0 0 1 13 8M8 4c-.358 0-.706.047-1.036.136l-.791-.791a5 5 0 0 1 1.164-.301l-.69-.69.707-.708L9.707 4z"
      }
    )
  }
), ez = /* @__PURE__ */ t.forwardRef(JL), lz = ez, oz = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 8c0 1.432.751 2.688 1.884 3.395l-.53.848a5.001 5.001 0 0 1 1.983-9.2l-.69-.69.707-.707L9.707 4H8a4 4 0 0 0-4 4"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.116 4.605A4 4 0 0 1 8 12H6.293l2.353 2.354.708-.707-.69-.69a5.001 5.001 0 0 0 1.982-9.2z"
        }
      )
    ]
  }
), nz = /* @__PURE__ */ t.forwardRef(oz), iz = nz, rz = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 8a5 5 0 1 1 5 5v1a6 6 0 1 0-5.898-7.105L1.854 5.646l-.708.708L4 9.207z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 5h1.01v1.125H7v3.75h.01V11H6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6.125C8 5.422 8.649 5 9.25 5h1.5c.601 0 1.25.422 1.25 1.125v3.75c0 .703-.649 1.125-1.25 1.125h-1.5C8.649 11 8 10.578 8 9.875zm1.04-.058C9 6.1 9 6.123 9 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067c.04-.033.04-.056.04-.058v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 10.75 6h-1.5a.33.33 0 0 0-.21.067",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tz = /* @__PURE__ */ t.forwardRef(rz), az = tz, sz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 13V3h1v10zm-2-2V5h1v6zm4 0V5h1v6zm4 0V5h1v6zm-2-1V6h1v4zM2 9V7h1v2z",
        clipRule: "evenodd"
      }
    )
  }
), dz = /* @__PURE__ */ t.forwardRef(sz), cz = dz, hz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 13.587V2.413L3.815 6H2v4h1.815zM13 4v8h1V4zm-2 1v6h1V5zM9 6v4h1V6z"
      }
    )
  }
), wz = /* @__PURE__ */ t.forwardRef(hz), vz = wz, fz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 13.587V2.413L5.815 6H4v4h1.815zM11 6v4h1V6z"
      }
    )
  }
), mz = /* @__PURE__ */ t.forwardRef(fz), pz = mz, gz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 13.587V2.413L4.815 6H3v4h1.815zM12 5v6h1V5zm-2 1v4h1V6z"
      }
    )
  }
), uz = /* @__PURE__ */ t.forwardRef(gz), xz = uz, Rz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 13.587V2.413L3.815 6H2v4h1.815zm1.146-6.733L10.793 8.5l-1.647 1.646.708.707L11.5 9.207l1.646 1.646.708-.707L12.207 8.5l1.647-1.646-.708-.708L11.5 7.793 9.854 6.146z"
      }
    )
  }
), jz = /* @__PURE__ */ t.forwardRef(Rz), Mz = jz, Hz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.708.708L10 10.707v2.88L5.815 10H4V6h1.293L1.646 2.354zM10 2.413v4.759L7.438 4.609z"
      }
    )
  }
), Cz = /* @__PURE__ */ t.forwardRef(Hz), yz = Cz, bz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 13.587V2.413L6.815 6H5v4h1.815z" })
  }
), Vz = /* @__PURE__ */ t.forwardRef(bz), Lz = Vz, zz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 3.5v9h1v-9zM13.492 8 6 3.63v8.74z" })
  }
), Sz = /* @__PURE__ */ t.forwardRef(zz), kz = Sz, Fz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 12.5h1v-9h-1zM2.508 8 10 12.37V3.63z" })
  }
), $z = /* @__PURE__ */ t.forwardRef(Fz), Bz = $z, Az = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 4H4v8h8z" })
  }
), Ez = /* @__PURE__ */ t.forwardRef(Az), _z = Ez, Oz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.708.708L11.293 12H1V4h2.293L1.646 2.354zM15 11.809l-.725-.363L6.828 4H12v1.691l3-1.5z"
      }
    )
  }
), Dz = /* @__PURE__ */ t.forwardRef(Oz), Pz = Dz, Tz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 4H1v8h11v-1.691l3 1.5V4.191l-3 1.5z" })
  }
), qz = /* @__PURE__ */ t.forwardRef(Tz), Iz = qz, Zz = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 1H1v9h1V2h12v8h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 3.254 9.992 5 7 6.745zm1 1.75L8.008 5 8 4.995v.01Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.11 2h2.78l.75 3H5.86zm4.311 2h2.72l-.75-3h-2.72zm-5.092-3h-2.72l-.75 3h2.72z"
        }
      )
    ]
  }
), Wz = /* @__PURE__ */ t.forwardRef(Zz), Gz = Wz, Nz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5 4V8.5H12v-1H8.5V4h-1v3.5H4v1h3.5V12z",
        clipRule: "evenodd"
      }
    )
  }
), Uz = /* @__PURE__ */ t.forwardRef(Nz), Yz = Uz, Qz = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 7.5V2h1v5.5H14v1H8.5V14h-1V8.5H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Kz = /* @__PURE__ */ t.forwardRef(Qz), Xz = Kz, Jz = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m5.354 2.354-2 2-.708-.708 2-2zm6-.708 2 2-.707.708-2-2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 8a5 5 0 1 1 8.504 3.567l.483 1.804-.966.258-.372-1.388A5 5 0 0 1 8 13a5 5 0 0 1-2.646-.757l-.371 1.386-.966-.258.482-1.8A4.99 4.99 0 0 1 3 8m4.706-3.028.702 2.62 2.62.702-.259.966-3.177-.852-.852-3.177z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), eS = /* @__PURE__ */ t.forwardRef(Jz), lS = eS, oS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 10.171V7c0-2.08-1.27-3.862-3.075-4.616L9.54 1H6.461l-.386 1.384a5 5 0 0 0-.577.286L13 10.172ZM12.293 13l1.354 1.354.707-.708-12-12-.708.708 2.069 2.068A5 5 0 0 0 3 7v3.382L1.691 13H6a2 2 0 1 0 4 0z"
      }
    )
  }
), nS = /* @__PURE__ */ t.forwardRef(oS), iS = nS, rS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.54 1H6.46l-.385 1.384A5 5 0 0 0 3 7v3.382L1.691 13h4.31a2 2 0 1 0 4 0h4.308L13 10.382V7c0-2.08-1.27-3.862-3.075-4.616z",
        clipRule: "evenodd"
      }
    )
  }
), tS = /* @__PURE__ */ t.forwardRef(rS), aS = tS, sS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2v1H2v11h12V3h-3V2h-1v1H6V2zM3 4h2v1h1V4h4v1h1V4h2v2H3zm5 3.87-.641 1.3-1.433.207 1.037 1.011-.245 1.428L8 11.142l1.282.674-.245-1.428 1.037-1.01-1.433-.209z",
        clipRule: "evenodd"
      }
    )
  }
), dS = /* @__PURE__ */ t.forwardRef(sS), cS = dS, hS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3V2h1v1h4V2h1v1h3v11H2V3zm0 1H3v2h10V4h-2v1h-1V4H6v1H5z",
        clipRule: "evenodd"
      }
    )
  }
), wS = /* @__PURE__ */ t.forwardRef(hS), vS = wS, fS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.418 4.126a6 6 0 0 0 8.456 8.456zm.708-.708 8.455 8.456a6 6 0 0 0-8.456-8.456ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
        clipRule: "evenodd"
      }
    )
  }
), mS = /* @__PURE__ */ t.forwardRef(fS), pS = mS, gS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6 2.707 4.854-4.853-.707-.708L7 9.293 4.854 7.146l-.708.708z",
        clipRule: "evenodd"
      }
    )
  }
), uS = /* @__PURE__ */ t.forwardRef(gS), xS = uS, RS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6.646-.354 2.5-2.5.708.708-2.5 2.5zM8.5 9.793l4.146-4.147.708.708L8.5 11.207 5.646 8.354l.708-.708zM3.354 7.646 6.207 10.5l-.707.707-2.854-2.853z",
        clipRule: "evenodd"
      }
    )
  }
), jS = /* @__PURE__ */ t.forwardRef(RS), MS = jS, HS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.354 4.354 6 12.707 1.646 8.354l.708-.708L6 11.293l7.646-7.647z",
        clipRule: "evenodd"
      }
    )
  }
), CS = /* @__PURE__ */ t.forwardRef(HS), yS = CS, bS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.348 2h5.304l-.268 1H13v11H3V3h2.616zm4 1H6.652l.268 1h2.16zM11 8H5V7h6zm0 3H5v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), VS = /* @__PURE__ */ t.forwardRef(bS), LS = VS, zS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6.5-4v4.384l4.235 1.134.26-.965L8.5 7.616V4z",
        clipRule: "evenodd"
      }
    )
  }
), SS = /* @__PURE__ */ t.forwardRef(zS), kS = SS, FS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m3.646-2.646L7.293 8l-2.647 2.646.708.708L8 8.707l2.646 2.647.708-.708L8.707 8l2.647-2.646-.707-.708L8 7.293 5.354 4.646z",
        clipRule: "evenodd"
      }
    )
  }
), $S = /* @__PURE__ */ t.forwardRef(FS), BS = $S, AS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.293 8 2.646 3.354l.708-.708L8 7.293l4.646-4.647.708.708L8.707 8l4.647 4.646-.707.708L8 8.707l-4.646 4.647-.708-.707z",
        clipRule: "evenodd"
      }
    )
  }
), ES = /* @__PURE__ */ t.forwardRef(AS), _S = ES, OS = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.707.708-2.756-2.756-.116-.055c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.106-1.957L1.646 2.354zm3.923 5.338a2 2 0 0 0 2.74 2.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.415 10.587a6 6 0 0 0 .272-.67l.12-.359-1.351-.926a4.5 4.5 0 0 0 0-1.264l1.352-.926-.12-.359a6 6 0 0 0-1.186-2.05l-.25-.283-1.477.707a4.5 4.5 0 0 0-1.095-.633l-.125-1.633-.372-.074a6 6 0 0 0-2.366 0l-.372.074-.102 1.324z"
        }
      )
    ]
  }
), DS = /* @__PURE__ */ t.forwardRef(OS), PS = DS, TS = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.817 2.117a6 6 0 0 1 2.366 0l.372.074.125 1.633c.396.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926a4.5 4.5 0 0 1 0 1.264l1.352.926-.12.359a6 6 0 0 1-1.186 2.05l-.25.283-1.477-.707c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.186-2.05l.25-.283 1.477.707c.33-.259.699-.473 1.095-.633l.125-1.633zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
        clipRule: "evenodd"
      }
    )
  }
), qS = /* @__PURE__ */ t.forwardRef(TS), IS = qS, ZS = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.707 2H3v10h8V4.293zM8 2.707V5h2.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 14V5h-1v8H6v1z" })
    ]
  }
), WS = /* @__PURE__ */ t.forwardRef(ZS), GS = WS, NS = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 2H2v10h10z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 4v9H4v1h10V4z" })
    ]
  }
), US = /* @__PURE__ */ t.forwardRef(NS), YS = US, QS = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 2h8v12H6v-2h1v1h6V3H7v1H6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.207 8 8.354 5.146l-.708.708L9.293 7.5H1v1h8.293l-1.647 1.646.708.708z"
        }
      )
    ]
  }
), KS = /* @__PURE__ */ t.forwardRef(QS), XS = KS, JS = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#common-error_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 .5 15.5 8 8 15.5.5 8zm-.5 5V9h1V5.5zm0 4.5v1h1v-1z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "common-error_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), ek = /* @__PURE__ */ t.forwardRef(JS), lk = ek, ok = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h8v2H9V3H3v10h6v-1h1v2H2zm11.293 5.5-1.647-1.646.708-.708L15.207 8l-2.853 2.854-.708-.708L13.293 8.5H5v-1z",
        clipRule: "evenodd"
      }
    )
  }
), nk = /* @__PURE__ */ t.forwardRef(ok), ik = nk, rk = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708-2.907-2.908C9.894 11.78 8.965 12 8 12c-1.69 0-3.267-.674-4.48-1.455-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3q.365-.235.773-.453L1.646 2.354zm3.923 5.338a2 2 0 0 0 2.74 2.74l-.758-.758a1 1 0 0 1-1.225-1.225z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14.935 8.246c-.286.506-.988 1.25-1.925 1.935L6.918 4.09Q7.449 4.002 8 4c1.69 0 3.267.674 4.48 1.455 1.2.773 2.117 1.701 2.455 2.299l.14.246z"
        }
      )
    ]
  }
), tk = /* @__PURE__ */ t.forwardRef(rk), ak = tk, sk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.52 5.455C4.734 4.674 6.31 4 8 4s3.267.674 4.48 1.455c1.2.773 2.117 1.701 2.455 2.299l.14.246-.14.246c-.338.598-1.256 1.526-2.456 2.3C11.267 11.325 9.69 12 8 12s-3.267-.674-4.48-1.455c-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3ZM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), dk = /* @__PURE__ */ t.forwardRef(sk), ck = dk, hk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 6H3V5h10zm-2 3H5V8h6zm-2 3H7v-1h2z",
        clipRule: "evenodd"
      }
    )
  }
), wk = /* @__PURE__ */ t.forwardRef(hk), vk = wk, fk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6-2a1 1 0 0 1 2 0c0 .284-.069.473-.16.62-.096.155-.232.285-.41.433l-.093.077c-.15.122-.338.274-.482.443-.2.232-.355.53-.355.927V10h1V8.5c0-.104.032-.18.114-.276.08-.094.179-.175.32-.29l.136-.112c.197-.164.436-.378.62-.676.191-.307.31-.68.31-1.146a2 2 0 1 0-4 0zm.5 5v1h1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), mk = /* @__PURE__ */ t.forwardRef(fk), pk = mk, gk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4m.5 1v2.616l2.528.678-.259.966L7.5 8.384V5z",
        clipRule: "evenodd"
      }
    )
  }
), uk = /* @__PURE__ */ t.forwardRef(gk), xk = uk, Rk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 10.172V7.707l1.146 1.147.708-.708L8 1.293l-1.94 1.94L13 10.171Zm0 3.535.646.646.708-.707-12-12-.708.708L4.293 5 1.146 8.146l.708.708L3 7.707V14h4v-4h2v4h4z"
      }
    )
  }
), jk = /* @__PURE__ */ t.forwardRef(Rk), Mk = jk, Hk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14.854 8.146 8 1.293 1.146 8.146l.708.708L3 7.707V14h4v-4h2v4h4V7.707l1.146 1.147z"
      }
    )
  }
), Ck = /* @__PURE__ */ t.forwardRef(Hk), yk = Ck, bk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5-3V4h-1v1zm0 7V6h-1v6z",
        clipRule: "evenodd"
      }
    )
  }
), Vk = /* @__PURE__ */ t.forwardRef(bk), Lk = Vk, zk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 2.5V5h-1V2.5zM5.854 3.646l1.5 1.5-.708.708-1.5-1.5zm5 .708-1.5 1.5-.708-.708 1.5-1.5zM5.268 5.438l.507 1.892 1.088-.31.274.96-1.103.316.528 1.972-4.83 1.294-1.294-4.83zm-.455 2.167-1.45.414.274.962 1.435-.41.265.99-2.897.776-.777-2.898 2.898-.776zm5.92-2.167 4.829 1.294-1.294 4.83-4.83-1.294.529-1.972-1.104-.315.274-.962 1.088.311zm.195 3.133 1.435.41.274-.962-1.45-.414.252-.942 2.898.776-.776 2.898-2.898-.776z",
        clipRule: "evenodd"
      }
    )
  }
), Sk = /* @__PURE__ */ t.forwardRef(zk), kk = Sk, Fk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6h5v2h2V6h5v5H9V9H7v2H2zm4 2H4.5v1H6v1H3V7h3zm4 1v1h3V7h-3v1h1.5v1z",
        clipRule: "evenodd"
      }
    )
  }
), $k = /* @__PURE__ */ t.forwardRef(Fk), Bk = $k, Ak = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a3 3 0 0 0-3 3v2H4v7h8V7h-1V5a3 3 0 0 0-3-3M6 5v2h4V5a2 2 0 1 0-4 0",
        clipRule: "evenodd"
      }
    )
  }
), Ek = /* @__PURE__ */ t.forwardRef(Ak), _k = Ek, Ok = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 2a3 3 0 0 0-3 3v2H2v7h8V7H9V5a2 2 0 0 1 3.95-.447V7h1V4.45l-.01-.05A3 3 0 0 0 11 2"
      }
    )
  }
), Dk = /* @__PURE__ */ t.forwardRef(Ok), Pk = Dk, Tk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M9 7H4V6h5z",
        clipRule: "evenodd"
      }
    )
  }
), qk = /* @__PURE__ */ t.forwardRef(Tk), Ik = qk, Zk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M6 6V4h1v2h2v1H7v2H6V7H4V6z",
        clipRule: "evenodd"
      }
    )
  }
), Wk = /* @__PURE__ */ t.forwardRef(Zk), Gk = Wk, Nk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.338-.707.707-4.338-4.338A4.5 4.5 0 0 1 2 6.5",
        clipRule: "evenodd"
      }
    )
  }
), Uk = /* @__PURE__ */ t.forwardRef(Nk), Yk = Uk, Qk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4H3V3h10zm0 4H3V7h10zm0 4H3v-1h10z",
        clipRule: "evenodd"
      }
    )
  }
), Kk = /* @__PURE__ */ t.forwardRef(Qk), Xk = Kk, Jk = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      }
    )
  }
), eF = /* @__PURE__ */ t.forwardRef(Jk), lF = eF, oF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      }
    )
  }
), nF = /* @__PURE__ */ t.forwardRef(oF), iF = nF, rF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M.747 1.623 15.242 8 .747 14.377 2.322 8.5H8v-1H2.322z"
      }
    )
  }
), tF = /* @__PURE__ */ t.forwardRef(rF), aF = tF, sF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.646 5.354c-1.59-1.59-3.935-1.718-5.47-.182a4 4 0 0 0 0 5.656l-.708.708a5 5 0 0 1 0-7.072c1.98-1.98 4.961-1.742 6.886.182l1.645 1.646L13 4h1l-.002 3.998L10 8V7l2.292-.001z",
        clipRule: "evenodd"
      }
    )
  }
), dF = /* @__PURE__ */ t.forwardRef(sF), cF = dF, hF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a5 5 0 0 1 10 0v1.293l1.646-1.647.708.708-2.854 2.853-2.854-2.853.708-.708L12 9.293V8a4 4 0 1 0-2.964 3.865l.258.966A5.005 5.005 0 0 1 3 8",
        clipRule: "evenodd"
      }
    )
  }
), wF = /* @__PURE__ */ t.forwardRef(hF), vF = wF, fF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4",
        clipRule: "evenodd"
      }
    )
  }
), mF = /* @__PURE__ */ t.forwardRef(fF), pF = mF, gF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.354.646 11.207 3.5 8.354 6.354l-.708-.708L9.293 4H8a4 4 0 1 0 4 4h1a5 5 0 1 1-5-5h1.293L7.646 1.354z",
        clipRule: "evenodd"
      }
    )
  }
), uF = /* @__PURE__ */ t.forwardRef(gF), xF = uF, RF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.5 1a2.5 2.5 0 0 0-2.343 3.375l-2.53 1.58.53.849 2.53-1.582A2.5 2.5 0 1 0 11.5 1m-8 5a2.5 2.5 0 1 0 1.967 4.043l2.231 1.115.447-.894-2.23-1.116A2.504 2.504 0 0 0 3.5 6M9 12.5a2.5 2.5 0 0 1 2-2.45V7.5h1v2.55a2.5 2.5 0 1 1-3 2.45"
      }
    )
  }
), jF = /* @__PURE__ */ t.forwardRef(RF), MF = jF, HF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 6H3V5h10zM9 9H3V8h6zm-3 3H3v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), CF = /* @__PURE__ */ t.forwardRef(HF), yF = CF, bF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.186 5.8 8 1.37 5.814 5.8l-4.888.71 3.537 3.448-.835 4.869L8 12.528l4.372 2.299-.835-4.869 3.537-3.448z"
      }
    )
  }
), VF = /* @__PURE__ */ t.forwardRef(bF), LF = VF, zF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m11-.5H4v1h8z",
        clipRule: "evenodd"
      }
    )
  }
), SF = /* @__PURE__ */ t.forwardRef(zF), kF = SF, FF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 7.5h9v1h-9z",
        clipRule: "evenodd"
      }
    )
  }
), $F = /* @__PURE__ */ t.forwardRef(FF), BF = $F, AF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.294 4.005 8.06 5.233l.707.707 2.443-2.435L8.354.646l-.708.707 1.65 1.652H8.005c-.645 0-1.261.122-1.827.344l.791.79q.497-.132 1.036-.134h1.29Zm3.709 3.99c0 .648-.123 1.266-.346 1.833l-.79-.79a4 4 0 0 0 .001-2.079l.966-.258c.11.414.17.848.17 1.294Zm-1.84 3.875a4.98 4.98 0 0 1-3.16 1.126H6.708l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.641h1.292c.923 0 1.772-.312 2.449-.836L4.844 5.55a4 4 0 0 0-.705 3.49l-.966.258a5 5 0 0 1 .96-4.46L1.646 2.355l.707-.708 12 12-.707.708-2.483-2.483Z"
      }
    )
  }
), EF = /* @__PURE__ */ t.forwardRef(AF), _F = EF, OF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8.354.646 2.857 2.86-2.858 2.848-.706-.708 1.647-1.641h-1.29A4 4 0 0 0 4.139 9.04l-.966.258a5.006 5.006 0 0 1 4.83-6.294h1.294l-1.65-1.652.707-.707Zm4.48 6.055a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.641h1.292a4 4 0 0 0 3.865-5.036z",
        clipRule: "evenodd"
      }
    )
  }
), DF = /* @__PURE__ */ t.forwardRef(OF), PF = DF, TF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 3H6V2h4v1H9v1.1A5.002 5.002 0 0 1 8 14a5 5 0 0 1-1-9.9zm0 6c0-.276.112-.526.293-.707L6.74 6.231l.966-.259.553 2.062A1 1 0 1 1 7 9",
        clipRule: "evenodd"
      }
    )
  }
), qF = /* @__PURE__ */ t.forwardRef(TF), IF = qF, ZF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 1H6v2H3v1h10V3h-3zm2 4H4v10h8z" })
  }
), WF = /* @__PURE__ */ t.forwardRef(ZF), GF = WF, NF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.646 4.646c1.925-1.924 4.906-2.161 6.886-.182a5 5 0 0 1 0 7.072l-.707-.708a4 4 0 0 0 0-5.656c-1.536-1.536-3.881-1.409-5.471.182L3.708 6.998 6 7v1l-3.998-.002L2 4h1l.001 2.292z",
        clipRule: "evenodd"
      }
    )
  }
), UF = /* @__PURE__ */ t.forwardRef(NF), YF = UF, QF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .984 7.357 13.014H.643zM7.5 6.5V10h1V6.5zm0 4.5v1h1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), KF = /* @__PURE__ */ t.forwardRef(QF), XF = KF, JF = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.708.708-1.566-1.566a4.3 4.3 0 0 1-1.33.212H4.5a3.5 3.5 0 0 1-.986-6.86c.043-.54.18-1.052.397-1.522L1.646 2.354zM15 8.75c0 .962-.32 1.85-.86 2.563l-8.588-8.59a4.5 4.5 0 0 1 6.587 2.009A4.25 4.25 0 0 1 15 8.75"
      }
    )
  }
), e$ = /* @__PURE__ */ t.forwardRef(JF), l$ = e$, o$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2a4.5 4.5 0 0 0-4.486 4.14A3.501 3.501 0 0 0 4.5 13h6.25a4.25 4.25 0 0 0 1.39-8.268A4.5 4.5 0 0 0 8 2"
      }
    )
  }
), n$ = /* @__PURE__ */ t.forwardRef(o$), i$ = n$, r$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 2h-1v5h1zM5 14V9H4v5zm6.5-5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
      }
    )
  }
), t$ = /* @__PURE__ */ t.forwardRef(r$), a$ = t$, s$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 2v7.793l3.146-3.147.707.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2zM3.384 13l-.571-2.13-.966.26.77 2.87h10.767l.769-2.87-.966-.26-.57 2.13H3.383Z",
        clipRule: "evenodd"
      }
    )
  }
), d$ = /* @__PURE__ */ t.forwardRef(s$), c$ = d$, h$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m1.354.646 13 13-.708.708L12.293 13H2V5.774l6 3.819.541-.345-1.365-1.365L2 4.589V3h.293L.646 1.354zM14 5.774v5.398l-3.298-3.299zm0-1.184L9.977 7.148 5.828 3H14z"
      }
    )
  }
), w$ = /* @__PURE__ */ t.forwardRef(h$), v$ = w$, f$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h12v1.59L8 8.406 2 4.59z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 5.774V13h12V5.774L8 9.593z" })
    ]
  }
), m$ = /* @__PURE__ */ t.forwardRef(f$), p$ = m$, g$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#communication-firewall-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-2H6V8h1.293l-1-1H2V5h2.293l-1-1H2V2.707L.646 1.354zM9.293 10H8.5v2H10v1h2.293z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M14 10h-1.172l-2-2H14zm0-3H9.828L8.5 5.672V5H14zm0-3H6.828L6 3.172V2h4v1h1V2h3zM2 8v2h3V8z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "communication-firewall-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), u$ = /* @__PURE__ */ t.forwardRef(g$), x$ = u$, R$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 2H2v2h12V2h-3v1h-1V2H6v1H5zM2 7V5h5.5v2zm0 3V8h3v2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 10H6V8h4v2H8.5v2H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 10h-3V8h3zm0-5v2H8.5V5z" })
    ]
  }
), j$ = /* @__PURE__ */ t.forwardRef(R$), M$ = j$, H$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.353 2.646 13.207 5.5l-2.854 2.854-.707-.708L11.293 6H3.982l1.707 6.37-.966.26L2.678 5h8.615L9.646 3.354z",
        clipRule: "evenodd"
      }
    )
  }
), C$ = /* @__PURE__ */ t.forwardRef(H$), y$ = C$, b$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "g",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipPath: "url(#communication-isp-off_svg__a)",
          clipRule: "evenodd",
          children: /* @__PURE__ */ l.jsx("path", { d: "m1.354.646 14 14-.708.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-1.025a5 5 0 0 1-4.12-6.889L.645 1.354l.708-.708ZM4.293 5h-.167a4 4 0 0 0 0 2h1.91a8 8 0 0 1-.017-.274zm3 3h-.13L8 10l.008-.002a.2.2 0 0 0 .033-.016.6.6 0 0 0 .15-.145 2.4 2.4 0 0 0 .324-.615zm2.62 2.62a5 5 0 0 1-1.413.355V12H10v1h2.293zM6.466 9.34q.071.218.158.417A4 4 0 0 1 4.535 8H6.15c.079.495.185.948.316 1.34M13 6c0 1.17-.402 2.245-1.075 3.097l-.713-.713q.137-.184.253-.384h-.637l-1.83-1.83A13 13 0 0 0 8.962 5H7.828L6.256 3.428q.09-.414.209-.768.072-.218.158-.417a4 4 0 0 0-1.007.545l-.713-.714A5 5 0 0 1 13 6M8.008 2.002 8 2l-.008.002a.2.2 0 0 0-.033.016.6.6 0 0 0-.15.145c-.13.165-.27.435-.395.813-.099.296-.184.64-.25 1.024h1.673a7 7 0 0 0-.25-1.024c-.127-.378-.266-.648-.396-.813a.6.6 0 0 0-.15-.145.2.2 0 0 0-.033-.016M10 6q0-.514-.036-1h1.91a4 4 0 0 1 0 2h-1.91Q10 6.513 10 6m-.623-3.757A4 4 0 0 1 11.465 4H9.85a8.4 8.4 0 0 0-.316-1.34 5 5 0 0 0-.158-.417Z" })
        }
      ),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "communication-isp-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), V$ = /* @__PURE__ */ t.forwardRef(b$), L$ = V$, z$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1a5 5 0 0 0-.5 9.975V12H6v1H2v1h4v1h4v-1h4v-1h-4v-1H8.5v-1.025A5 5 0 0 0 8 1M4.126 5a4 4 0 0 0 0 2h1.91a14 14 0 0 1 0-2zm2.023 3H4.535a4 4 0 0 0 2.088 1.757 5 5 0 0 1-.158-.417A8.4 8.4 0 0 1 6.149 8M8 10l.008-.002a.2.2 0 0 0 .033-.016.6.6 0 0 0 .15-.145c.13-.165.27-.435.395-.813.099-.296.184-.64.25-1.024H7.164c.067.383.152.728.25 1.024.127.378.266.648.396.813a.6.6 0 0 0 .15.145q.026.015.033.016zm-.961-3H8.96a13 13 0 0 0 0-2H7.04a13 13 0 0 0 0 2ZM4.535 4H6.15c.079-.495.185-.948.316-1.34q.071-.218.158-.417A4 4 0 0 0 4.535 4M8 2l.008.002a.2.2 0 0 1 .033.016.6.6 0 0 1 .15.145c.13.165.27.435.395.813.099.296.184.64.25 1.024H7.164c.067-.383.152-.728.25-1.024.127-.378.266-.648.396-.813a.6.6 0 0 1 .15-.145.2.2 0 0 1 .033-.016zm1.964 3a14 14 0 0 1 0 2h1.91a4 4 0 0 0 0-2zm1.5-1a4 4 0 0 0-2.087-1.757q.086.2.158.417c.13.392.237.845.316 1.34h1.614Zm0 4H9.852a8.4 8.4 0 0 1-.316 1.34q-.072.218-.158.417A4 4 0 0 0 11.465 8Z",
        clipRule: "evenodd"
      }
    )
  }
), S$ = /* @__PURE__ */ t.forwardRef(z$), k$ = S$, F$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708-4.63-4.63a2 2 0 0 1-2.74-2.74l-4.63-4.63zm.594 3.424-.714-.715A5.98 5.98 0 0 0 1 8c0 1.657.672 3.157 1.757 4.243l.707-.707A4.98 4.98 0 0 1 2 8c0-1.095.351-2.107.948-2.93"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m4.393 6.514-.726-.726A4 4 0 0 0 3 8a4 4 0 0 0 1.172 2.828l.707-.707A3 3 0 0 1 4 8c0-.54.143-1.048.393-1.486M15 8a5.97 5.97 0 0 1-.942 3.23l-.728-.728c.426-.736.67-1.59.67-2.502 0-1.38-.56-2.63-1.464-3.536l.707-.707A5.98 5.98 0 0 1 15 8"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0 .633-.147 1.231-.409 1.763l-.762-.762C11.94 8.688 12 8.35 12 8c0-.829-.335-1.578-.879-2.121l.707-.707A4 4 0 0 1 13 8"
        }
      )
    ]
  }
), $$ = /* @__PURE__ */ t.forwardRef(F$), B$ = $$, A$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2.757 3.757A5.98 5.98 0 0 0 1 8c0 1.657.672 3.157 1.757 4.243l.707-.707A4.98 4.98 0 0 1 2 8c0-1.38.56-2.63 1.464-3.536zM15 8a5.98 5.98 0 0 0-1.757-4.243l-.707.707A4.98 4.98 0 0 1 14 8c0 1.38-.56 2.63-1.464 3.536l.707.707A5.98 5.98 0 0 0 15 8"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.172 5.172A4 4 0 0 0 3 8a4 4 0 0 0 1.172 2.828l.707-.707A3 3 0 0 1 4 8c0-.829.335-1.578.879-2.121zM13 8a4 4 0 0 0-1.172-2.828l-.707.707c.544.543.879 1.292.879 2.12 0 .83-.335 1.579-.879 2.122l.707.707A4 4 0 0 0 13 8M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    ]
  }
), E$ = /* @__PURE__ */ t.forwardRef(A$), _$ = E$, O$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m4.707 6 1.647 1.646-.708.708L2.793 5.5l2.853-2.854.708.708L4.707 5h8.614l-2.044 7.63-.966-.26L12.018 6h-7.31Z",
        clipRule: "evenodd"
      }
    )
  }
), D$ = /* @__PURE__ */ t.forwardRef(O$), P$ = D$, T$ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.71 4.005 8.354.646l-.708.707 1.65 1.652H8.005a5 5 0 0 0-4.831 6.294l.966-.258a4 4 0 0 1 3.865-5.036h3.707Z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10.6 10 8.002 5.5 5.404 10z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.003 7.995c0-.446-.058-.88-.169-1.294l-.966.258a4.005 4.005 0 0 1-3.865 5.037H4.3l3.347 3.357.708-.706-1.646-1.652h1.295a5 5 0 0 0 5-5Z"
        }
      )
    ]
  }
), q$ = /* @__PURE__ */ t.forwardRef(T$), I$ = q$, Z$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.146 1.15.708.707-2.147 2.147H12v1H4.707L6.854 7.15l-.708.707-3.353-3.353zm5.147 9.854L9.146 8.857l.708-.707 3.353 3.354-3.353 3.353-.708-.707 2.147-2.146H4v-1z",
        clipRule: "evenodd"
      }
    )
  }
), W$ = /* @__PURE__ */ t.forwardRef(
  Z$
), G$ = W$, N$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m1.146 9.857.708-.707L4 11.296V4.004h1v7.292L7.146 9.15l.708.707L4.5 13.211zM11 4.711 8.854 6.857l-.708-.707L11.5 2.796l3.354 3.354-.707.707L12 4.711v7.293h-1V4.71Z",
        clipRule: "evenodd"
      }
    )
  }
), U$ = /* @__PURE__ */ t.forwardRef(N$), Y$ = U$, Q$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m3.384 3-.571 2.13-.966-.26.77-2.87h10.767l.769 2.87-.966.26-.57-2.13H3.383ZM8 4.293l4.354 4.353-.708.708L8.5 6.207V14h-1V6.207L4.354 9.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), K$ = /* @__PURE__ */ t.forwardRef(Q$), X$ = K$, J$ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.707-3.672-3.671a2 2 0 1 1-1.657-1.657L6.486 7.193a6 6 0 0 0-2.729 1.564L3.05 8.05a7 7 0 0 1 2.635-1.658L4.154 4.861a9 9 0 0 0-2.518 1.775L.93 5.929a10 10 0 0 1 2.479-1.814L1.646 2.354zm9.889 7.111a6 6 0 0 0-1.969-1.311l-1.39-1.39A6.97 6.97 0 0 1 12.95 8.05zM8 4q-.562 0-1.104.067l-.872-.872Q6.984 3.002 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4"
      }
    )
  }
), eB = /* @__PURE__ */ t.forwardRef(J$), lB = eB, oB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M1.636 6.636A8.97 8.97 0 0 1 8 4a8.97 8.97 0 0 1 6.364 2.636l.707-.707A9.97 9.97 0 0 0 8 3 9.97 9.97 0 0 0 .929 5.929z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3.757 8.757A5.98 5.98 0 0 1 8 7a5.98 5.98 0 0 1 4.243 1.757l.707-.707A6.98 6.98 0 0 0 8 6a6.98 6.98 0 0 0-4.95 2.05zM8 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    ]
  }
), nB = /* @__PURE__ */ t.forwardRef(oB), iB = nB, rB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15 7.5 1.75 1.75 7.5 15l2.129-3.725 3.048 3.048 1.646-1.646-3.048-3.048z"
      }
    )
  }
), tB = /* @__PURE__ */ t.forwardRef(rB), aB = tB, sB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2.02V1h1v1.02a6 6 0 0 1 5.48 5.48H15v1h-1.02a6 6 0 0 1-5.48 5.48V15h-1v-1.02A6 6 0 0 1 2.02 8.5H1v-1h1.02A6 6 0 0 1 7.5 2.02m0 1.005A5 5 0 0 0 3.025 7.5H4v1h-.975A5 5 0 0 0 7.5 12.975V12h1v.975A5 5 0 0 0 12.975 8.5H12v-1h.975A5 5 0 0 0 8.5 3.025V4h-1zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), dB = /* @__PURE__ */ t.forwardRef(sB), cB = dB, hB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.5 5c-.267 0-.518.07-.736.192a1.5 1.5 0 0 0-2.528 0A1.5 1.5 0 0 0 5 6.5v.55A2.5 2.5 0 0 0 3 9.5v1.038c0 .664.264 1.299.732 1.768L6.427 15H10.5a3.5 3.5 0 0 0 3.5-3.5V7a1.5 1.5 0 0 0-2.236-1.308A1.5 1.5 0 0 0 10.5 5"
      }
    )
  }
), wB = /* @__PURE__ */ t.forwardRef(hB), vB = wB, fB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.5 1A1.5 1.5 0 0 0 7 2.5v.085A1.5 1.5 0 0 0 5 4v4.499a20 20 0 0 0-.524-.263c-.595-.276-1.375-.41-1.988.203-.6.6-.561 1.473-.026 2.095.197.228 1.149 1.305 2.046 2.32l1.214 1.37.687.776H10.5a3.5 3.5 0 0 0 3.5-3.5V5a1.5 1.5 0 0 0-2-1.415V3.5a1.5 1.5 0 0 0-2.052-1.395A1.5 1.5 0 0 0 8.5 1"
      }
    )
  }
), mB = /* @__PURE__ */ t.forwardRef(fB), pB = mB, gB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1H5v1h1.293L2 6.293V5H1v3h3V7H2.707L7 2.707V4h1zm0 4.5a1.5 1.5 0 0 1 3 0v1.616l2.147.576A2.5 2.5 0 0 1 15 10.106V12.5a2.5 2.5 0 0 1-2.5 2.5H8.523l-.15-.168a882 882 0 0 1-2.911-3.299c-.535-.62-.575-1.494.025-2.094.614-.613 1.394-.48 1.988-.203.083.038.27.132.525.263z"
      }
    )
  }
), uB = /* @__PURE__ */ t.forwardRef(gB), xB = uB, RB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 3.5v1.085a1.5 1.5 0 0 1 1.764.607 1.5 1.5 0 0 1 2 .5A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.537V9.5a2.5 2.5 0 0 1 2-2.45V3.5a1.5 1.5 0 1 1 3 0"
      }
    )
  }
), jB = /* @__PURE__ */ t.forwardRef(RB), MB = jB, HB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 1H3v2h10z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm5.537-3L9.325 8h-2.65L4.943 5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 15v-2h10v2z" })
    ]
  }
), CB = /* @__PURE__ */ t.forwardRef(HB), yB = CB, bB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 1H3v2h10z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm-.577-3h6.114l-.866 1.5H5.809zm6.114 6H4.943l.866-1.5h4.382z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 15v-2h10v2z" })
    ]
  }
), VB = /* @__PURE__ */ t.forwardRef(bB), LB = VB, zB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 1H3v2h10z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm3.805 0 1.732 3H4.943l1.732-3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 15v-2h10v2z" })
    ]
  }
), SB = /* @__PURE__ */ t.forwardRef(zB), kB = SB, FB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 1H3v2h10z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm3.805 0 1.732 3H4.943l1.732-3-1.732-3h6.114z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 15v-2h10v2z" })
    ]
  }
), $B = /* @__PURE__ */ t.forwardRef(FB), BB = $B, AB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3h10v10H3zm3 3h4v4H6zm1 1v2h2V7z",
        clipRule: "evenodd"
      }
    )
  }
), EB = /* @__PURE__ */ t.forwardRef(AB), _B = EB, OB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 3h10v3h-3v4h3v3H3zm4 4H6V6h1zm0 3H6V9h1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 7h-2v2h2z" })
    ]
  }
), DB = /* @__PURE__ */ t.forwardRef(OB), PB = DB, TB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 13V3h3v3h4V3h3v10zm4-4v1H6V9zm3 0v1H9V9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7 3v2h2V3z" })
    ]
  }
), qB = /* @__PURE__ */ t.forwardRef(TB), IB = qB, ZB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 7h4v6H3V3h6zm4-2V3h-2v2zm-4 5V9h1v1zM7 7H6V6h1zm-1 3V9h1v1z",
        clipRule: "evenodd"
      }
    )
  }
), WB = /* @__PURE__ */ t.forwardRef(ZB), GB = WB, NB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7V3h6v10H3V7zM5 3H3v2h2zm5 4H9V6h1zM7 9v1H6V9zm3 1H9V9h1z",
        clipRule: "evenodd"
      }
    )
  }
), UB = /* @__PURE__ */ t.forwardRef(NB), YB = UB, QB = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 3v10h-3v-3H6v3H3V3zM9 7V6h1v1zM6 7V6h1v1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M9 13v-2H7v2z" })
    ]
  }
), KB = /* @__PURE__ */ t.forwardRef(QB), XB = KB, JB = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 9v4H3V3h10v6zm2 4h2v-2h-2zM6 9h1v1H6zm3-2V6h1v1zM6 6h1v1H6z",
        clipRule: "evenodd"
      }
    )
  }
), eA = /* @__PURE__ */ t.forwardRef(JB), lA = eA, oA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 9H3V3h10v10H7zm-4 2v2h2v-2zm4-5v1H6V6zm2 3h1v1H9zm1-3v1H9V6z",
        clipRule: "evenodd"
      }
    )
  }
), nA = /* @__PURE__ */ t.forwardRef(oA), iA = nA, rA = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 13H3v-3h3V6H3V3h10zM9 9h1v1H9zm0-3h1v1H9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 9h2V7H3z" })
    ]
  }
), tA = /* @__PURE__ */ t.forwardRef(rA), aA = tA, sA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 2h7.414L14 4.293v4.414l-1.985 1.985-2.366-.634-.942.942H5.793L5 10.207V8.793l.741-.741L9 7.179v-.972L8.793 6H6.207l-.353.354-.708-.708L5.793 5h3.414l.793.793v3.323l1.717.46L13 8.293V4.707L11.293 3H4.707L3 4.707v6.586L4.707 13h6.586l.853-.854.708.708L11.707 14H4.293L2 11.707V4.293zM9 9.293v-1.08l-2.741.735-.259.26v.585l.207.207h2.086z",
        clipRule: "evenodd"
      }
    )
  }
), dA = /* @__PURE__ */ t.forwardRef(sA), cA = dA, hA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.81 3H14v10H3.81L.922 8l2.886-5Zm2.836 3.354L8.293 8 6.646 9.646l.708.708L9 8.707l1.646 1.647.708-.708L9.707 8l1.647-1.646-.707-.708L9 7.293 7.354 5.646z",
        clipRule: "evenodd"
      }
    )
  }
), wA = /* @__PURE__ */ t.forwardRef(hA), vA = wA, fA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3h3.5a2.5 2.5 0 0 1 1.76 4.276A3 3 0 0 1 8 13H4zm1 5v4h3a2 2 0 1 0 0-4zm0-1h2.5a1.5 1.5 0 1 0 0-3H5z",
        clipRule: "evenodd"
      }
    )
  }
), mA = /* @__PURE__ */ t.forwardRef(fA), pA = mA, gA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 2h4v4H4.5v4H6v.268l5.5-3.175V6H10V2h4v4h-1.5v1.67L6 11.423V14H2v-4h1.5V6H2z"
      }
    )
  }
), uA = /* @__PURE__ */ t.forwardRef(gA), xA = uA, RA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 10h3v4H2zm4-4h3v8H6zm4-4h3v12h-3z" })
  }
), jA = /* @__PURE__ */ t.forwardRef(RA), MA = jA, HA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 2H2v5h2v2.05A2.5 2.5 0 1 0 6.95 12h2.343L12 14.707l3.207-3.207L12 8.293 9.293 11H6.95A2.5 2.5 0 0 0 5 9.05V7h2z"
      }
    )
  }
), CA = /* @__PURE__ */ t.forwardRef(HA), yA = CA, bA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 1H6v4h1.5v2.5h-5V11H1v4h4v-4H3.5V8.5h4V11H6v4h4v-4H8.5V8.5h4V11H11v4h4v-4h-1.5V7.5h-5V5H10z"
      }
    )
  }
), VA = /* @__PURE__ */ t.forwardRef(bA), LA = VA, zA = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 2h3v3H7V3.707L3.354 7.354l-.708-.708L6.293 3H5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 10h3v4H2zm4-2h3v6H6zm4-2h3v8h-3z" })
    ]
  }
), SA = /* @__PURE__ */ t.forwardRef(zA), kA = SA, FA = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2q-.24 0-.473.018l-.6.047 1.481 5.527 5.527 1.48.047-.6A6 6 0 0 0 8 2"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m7.592 8.408-1.63-6.085-.544.26a6 6 0 1 0 8 7.998l.259-.542z"
        }
      )
    ]
  }
), $A = /* @__PURE__ */ t.forwardRef(FA), BA = $A, AA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14 2H2v3h1.5v8H8v1h3v-3H8v1H4.5V9H8v1h3V7H8v1H4.5V5H14z"
      }
    )
  }
), EA = /* @__PURE__ */ t.forwardRef(AA), _A = EA, OA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.854 4.854 9.5 10.207l-3-3-4.646 4.647-.708-.707L6.5 5.792l3 3 4.646-4.647.708.708Z",
        clipRule: "evenodd"
      }
    )
  }
), DA = /* @__PURE__ */ t.forwardRef(OA), PA = DA, TA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 7h4V6h-2.293l2.646-2.646-.707-.708L10 5.293V3H9zM7 9H3v1h2.293l-2.647 2.646.708.708L6 10.707V13h1z"
      }
    )
  }
), qA = /* @__PURE__ */ t.forwardRef(TA), IA = qA, ZA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8.5 2h-1v3H5v6h2.5v3h1v-3H11V5H8.5z" })
  }
), WA = /* @__PURE__ */ t.forwardRef(ZA), GA = WA, NA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.354 5.646 9.207 4.5H11.5V10H10v4h4v-4h-1.5V3.5H9.207l1.146-1.146-.707-.708L7.293 4l2.353 2.354zM6 2H2v4h1.5v6.5h3.293l-1.147 1.146.708.708L8.707 12 6.354 9.646l-.708.708L6.793 11.5H4.5V6H6z"
      }
    )
  }
), UA = /* @__PURE__ */ t.forwardRef(NA), YA = UA, QA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 2h5v5H5v4h4V9h5v5H9v-2H4V7H2z" })
  }
), KA = /* @__PURE__ */ t.forwardRef(QA), XA = KA, JA = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 3H9v1h2.293L8.647 6.646l.707.708L12 4.707V7h1zM3 13h4v-1H4.707l2.647-2.646-.708-.708L4 11.293V9H3z"
      }
    )
  }
), eE = /* @__PURE__ */ t.forwardRef(JA), lE = eE, oE = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.348 2h5.304l-.268 1H13v11H3v-2h1v1h8V4h-1.884l-.268 1H6.152l-.268-1H4v3H3V3h2.616z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.293 9 5.646 7.354l.708-.708L9.208 9.5l-2.854 2.854-.708-.708L7.293 10H2V9z"
        }
      )
    ]
  }
), nE = /* @__PURE__ */ t.forwardRef(oE), iE = nE, rE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm1 1v10h10V3zm9.002 1v3h-1V5.706l-5.291 5.29 1.292.001v1H4.002v-3h1v1.294L10.295 5H9V4z",
        clipRule: "evenodd"
      }
    )
  }
), tE = /* @__PURE__ */ t.forwardRef(rE), aE = tE, sE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 2H2v4h2.018l.804 3H7.5v1H6v4h4v-4H8.5V9h2.678l.804-3H14V2h-4v4h.947l-.536 2H5.589l-.535-2H6z"
      }
    )
  }
), dE = /* @__PURE__ */ t.forwardRef(sE), cE = dE, hE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.736 5.53.006.005-.707.707c-.528-.528-1.482-1.482-2.388-2.215-.456-.37-.874-.661-1.202-.818a1.4 1.4 0 0 0-.27-.102q.007.03.02.071.088.285.443.794c.472.67 1.202 1.482 1.966 2.322l.104.115c.716.79 1.45 1.598 1.95 2.28.26.354.483.71.6 1.035.11.306.185.768-.161 1.114-.317.317-.738.304-1.054.226-.322-.08-.671-.257-1.014-.468-.693-.424-1.503-1.077-2.273-1.715l-.475-.395c-.608-.506-1.175-.98-1.65-1.326a7 7 0 0 0-.377-.26 4 4 0 0 0 .096.179c.272.48.696 1.075 1.143 1.701l.012.017c.433.606.887 1.242 1.188 1.773.15.266.28.539.344.79.058.224.102.607-.183.893-.245.244-.567.275-.811.254a2.8 2.8 0 0 1-.77-.21c-.513-.208-1.106-.549-1.656-.883-.215-.13-.422-.26-.619-.382l-.355-.22.192.257.01.014c.258.343.534.711.723 1.018.094.153.185.32.237.481.026.08.052.188.048.306a.63.63 0 0 1-.182.426.72.72 0 0 1-.56.201 1.3 1.3 0 0 1-.414-.104 5.5 5.5 0 0 1-.677-.364L4 13.034q-.207-.126-.367-.214.03.135.083.29a6 6 0 0 0 .276.674l.005.01v.002l-.446.223-.448.224v-.002l-.003-.004-.007-.014a4 4 0 0 1-.105-.229 7 7 0 0 1-.221-.568 3.2 3.2 0 0 1-.162-.704c-.018-.203-.02-.565.239-.824a.72.72 0 0 1 .56-.202c.154.009.3.057.414.104.167.069.347.17.514.267l-.297-.399-.011-.014c-.257-.343-.533-.711-.722-1.018a2.4 2.4 0 0 1-.238-.481.9.9 0 0 1-.048-.306.63.63 0 0 1 .181-.426.63.63 0 0 1 .501-.17c.115.009.225.043.312.076.18.068.39.179.606.301.272.156.598.358.936.568.194.12.391.243.585.36.55.335 1.081.637 1.511.812q.238.095.385.124a3 3 0 0 0-.211-.433c-.271-.48-.695-1.074-1.143-1.7l-.012-.018C6.234 8.737 5.78 8.101 5.48 7.57c-.15-.265-.282-.538-.345-.789-.057-.225-.102-.608.183-.893a.73.73 0 0 1 .57-.203c.162.01.317.064.449.122.266.117.571.316.884.544.503.368 1.105.87 1.715 1.378l.458.381c.777.644 1.535 1.25 2.158 1.633.314.193.559.306.732.349l.047.01-.014-.04q-.099-.281-.466-.783c-.467-.639-1.17-1.412-1.904-2.221l-.084-.092c-.75-.827-1.528-1.689-2.043-2.42-.254-.362-.471-.729-.579-1.068-.104-.332-.143-.784.199-1.126a.93.93 0 0 1 .75-.254c.235.02.471.104.688.208.436.209.926.56 1.398.943.95.768 1.936 1.755 2.46 2.28Z",
        clipRule: "evenodd"
      }
    )
  }
), wE = /* @__PURE__ */ t.forwardRef(hE), vE = wE, fE = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.353 1.646 12 12-.707.708L11 11.707V14h-1v-3H6v3H5v-3H2v-1h3V6H2V5h2.293L1.646 2.354zM6 6.707V10h3.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 6v2.172l-1-1V6H8.828l-1-1H10V2h1v3h3v1z" })
    ]
  }
), mE = /* @__PURE__ */ t.forwardRef(fE), pE = mE, gE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5V2h1v3h4V2h1v3h3v1h-3v4h3v1h-3v3h-1v-3H6v3H5v-3H2v-1h3V6H2V5zm1 1v4h4V6z",
        clipRule: "evenodd"
      }
    )
  }
), uE = /* @__PURE__ */ t.forwardRef(gE), xE = uE, RE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 4V2h1v2H13v3H8.5v1H11v3H8.5v3h-1v-3H5V8h2.5V7H3V4z"
      }
    )
  }
), jE = /* @__PURE__ */ t.forwardRef(RE), ME = jE, HE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 2v12h1V2zm2 2h9v3H5zm0 4h6v3H5z" })
  }
), CE = /* @__PURE__ */ t.forwardRef(HE), yE = CE, bE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 2v12h1V2zm-1 2H2v3h9zm0 4H5v3h6z" })
  }
), VE = /* @__PURE__ */ t.forwardRef(bE), LE = VE, zE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3h1v4h4V3h1v9h-1V8H6v4H5z",
        clipRule: "evenodd"
      }
    )
  }
), SE = /* @__PURE__ */ t.forwardRef(zE), kE = SE, FE = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v12h12zM3 8.211V3h10v6.959L10.017 8.24l-3.483 2.007z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $E = /* @__PURE__ */ t.forwardRef(FE), BE = $E, AE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.55 4H7.2V3h4v1H9.585l-2.143 8H8.79v1h-4v-1h1.616z",
        clipRule: "evenodd"
      }
    )
  }
), EE = /* @__PURE__ */ t.forwardRef(AE), _E = EE, OE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.354 3.646-.708.708L13.293 6H7a3 3 0 1 0 2.898 2.224l-.966.258A2.003 2.003 0 0 1 7 11a2 2 0 1 1 0-4h6.293l-1.647 1.646.708.708L15.207 6.5zM1 7h3V6H1z",
        clipRule: "evenodd"
      }
    )
  }
), DE = /* @__PURE__ */ t.forwardRef(OE), PE = DE, TE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13.707 8 8 2.293 2.293 8 8 13.707z" })
  }
), qE = /* @__PURE__ */ t.forwardRef(TE), IE = qE, ZE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m14.762 10.926-.624.384-.727-.727.827-.509zm0-3-2.481 1.527-.727-.727 2.684-1.652zm-5.397 2.147-1.13-1.131L8 9.079 1.008 5l2.075-1.21-1.437-1.436.708-.708 12 12-.708.708-1.697-1.697L8 15.087l-6.762-4.161.524-.852L8 13.913l3.223-1.983-1.13-1.13L8 12.087 1.238 7.926l.524-.852L8 10.913zM14.992 5l-4.524 2.64-5.152-5.153L8 .921z"
      }
    )
  }
), WE = /* @__PURE__ */ t.forwardRef(ZE), GE = WE, NE = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14.992 5 8 .921 1.008 5 8 9.079z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m1.238 7.926.524-.852L8 10.913l6.238-3.839.524.852L8 12.087z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m1.238 10.926.524-.852L8 13.913l6.238-3.839.524.852L8 15.087z"
        }
      )
    ]
  }
), UE = /* @__PURE__ */ t.forwardRef(NE), YE = UE, QE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 2a2 2 0 0 0-1.723 3.016l-5.261 5.26a2 2 0 1 0 .707.707l5.26-5.26A2 2 0 1 0 12 2"
      }
    )
  }
), KE = /* @__PURE__ */ t.forwardRef(QE), XE = KE, JE = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M9 5h5V4H9zM4.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M9 12h5v-1H9z"
      }
    )
  }
), e_ = /* @__PURE__ */ t.forwardRef(JE), l_ = e_, o_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5H9V4h5zm0 7H9v-1h5zM7.354 2.354 3.5 6.207 1.646 4.354l.708-.708L3.5 4.793l3.146-3.147zm0 7L3.5 13.207l-1.854-1.854.708-.707L3.5 11.793l3.146-3.147z",
        clipRule: "evenodd"
      }
    )
  }
), n_ = /* @__PURE__ */ t.forwardRef(o_), i_ = n_, r_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h1.01v1H4v3h.01v1H3zm11 3H7V4h7zM2 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3v1h1v-.01h1V14H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1H3v.01H2zm12 3H7v-1h7z",
        clipRule: "evenodd"
      }
    )
  }
), t_ = /* @__PURE__ */ t.forwardRef(r_), a_ = t_, s_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 7.098 4.289 5H2v6h1V6h.711L5.5 9.098 7.289 6H8v5h1V5H6.711zM13 9.293V5h-1v4.293l-1.646-1.647-.708.708 2.854 2.853 2.854-2.853-.707-.708z"
      }
    )
  }
), d_ = /* @__PURE__ */ t.forwardRef(s_), c_ = d_, h_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 14h4v-4H4.5V6H6v-.268l5.5 3.175V10H10v4h4v-4h-1.5V8.33L6 4.577V2H2v4h1.5v4H2z"
      }
    )
  }
), w_ = /* @__PURE__ */ t.forwardRef(h_), v_ = w_, f_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V7.5h4.293l-1.147-1.146.707-.708L14.707 8l-2.354 2.354-.707-.708L12.793 8.5H8.5v4.293l1.146-1.147.707.707L8 14.707l-2.354-2.354.708-.707L7.5 12.793V8.5H3.207l1.147 1.146-.708.707L1.293 8l2.353-2.354.708.708L3.207 7.5H7.5V3.207L6.354 4.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), m_ = /* @__PURE__ */ t.forwardRef(f_), p_ = m_, g_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 1.5h1v5h-1zm1 7a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1h2v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1h-2v-1zm3-2h2v1h-1v1h1v1h-2v1h2a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2z"
      }
    )
  }
), u_ = /* @__PURE__ */ t.forwardRef(g_), x_ = u_, R_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.725 8.732a2.5 2.5 0 0 0 3.535 3.536l4.89-4.89.707.708-4.89 4.889a3.5 3.5 0 0 1-4.95-4.95l5.658-5.657a2.5 2.5 0 1 1 3.535 3.536L6.553 11.56a1.5 1.5 0 0 1-2.121-2.122L9.32 4.55l.707.707-4.889 4.89a.5.5 0 0 0 .707.707l5.657-5.657a1.5 1.5 0 1 0-2.121-2.122z",
        clipRule: "evenodd"
      }
    )
  }
), j_ = /* @__PURE__ */ t.forwardRef(R_), M_ = j_, H_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4h2V3H5.5a2.5 2.5 0 0 0 0 5H6v5h1V4h2v9h1zM6 4v3h-.5a1.5 1.5 0 1 1 0-3z",
        clipRule: "evenodd"
      }
    )
  }
), C_ = /* @__PURE__ */ t.forwardRef(H_), y_ = C_, b_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.5 1.793 14.207 4.5l-2 2L9.5 3.793zM8.793 4.5 2 11.293V14h2.707L11.5 7.207z"
      }
    )
  }
), V_ = /* @__PURE__ */ t.forwardRef(b_), L_ = V_, z_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.646 2.354 11.293 4 9.646 5.646l.708.708L12 4.707l1.646 1.647.708-.708L12.707 4l1.647-1.646-.707-.708L12 3.293l-1.646-1.647zM2 2h4v4H4.5v4H6v4H2v-4h1.5V6H2zm9.5 8H10v4h4v-4h-1.5V7h-1z"
      }
    )
  }
), S_ = /* @__PURE__ */ t.forwardRef(z_), k_ = S_, F_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 2H2v4h1.5v4H2v4h4v-4H4.5V6H6zm8 8h-4v4h4zm-1-4h-2v2h2zm0-3h-2v2h2z"
      }
    )
  }
), $_ = /* @__PURE__ */ t.forwardRef(F_), B_ = $_, A_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m9.207 4.5 1.147 1.146-.707.708L7.293 4l2.354-2.354.707.708L9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5zM6 2H2v4h1.5v4H2v4h4v-4H4.5V6H6z"
      }
    )
  }
), E_ = /* @__PURE__ */ t.forwardRef(A_), __ = E_, O_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.646 5.646 7.793 4.5H6.5A2.5 2.5 0 0 0 4 7H3a3.5 3.5 0 0 1 3.5-3.5h1.293L6.646 2.354l.708-.708L9.707 4 7.354 6.354zM5 7h6v6H5z"
      }
    )
  }
), D_ = /* @__PURE__ */ t.forwardRef(O_), P_ = D_, T_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.354 5.646 8.207 4.5H9.5A2.5 2.5 0 0 1 12 7h1a3.5 3.5 0 0 0-3.5-3.5H8.207l1.147-1.146-.708-.708L6.293 4l2.353 2.354zM5 7h6v6H5z"
      }
    )
  }
), q_ = /* @__PURE__ */ t.forwardRef(T_), I_ = q_, Z_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.613 5.833C2.474 6.359 2 6.984 2 7.5s.474 1.142 1.613 1.667C4.71 9.674 6.261 10 8 10h.293l-.647-.646.708-.708 1.853 1.854-1.853 1.854-.708-.708.647-.646H8c-1.85 0-3.55-.345-4.806-.925C1.981 9.515 1 8.641 1 7.5s.981-2.015 2.194-2.575C4.45 4.345 6.15 4 8 4s3.55.345 4.806.925C14.019 5.485 15 6.359 15 7.5c0 .663-.34 1.24-.84 1.704-.499.462-1.19.842-1.99 1.131l-.34-.94c.721-.26 1.28-.582 1.651-.925.37-.342.519-.672.519-.97 0-.516-.474-1.141-1.613-1.667C11.29 5.326 9.739 5 8 5c-1.74 0-3.29.326-4.387.833",
        clipRule: "evenodd"
      }
    )
  }
), W_ = /* @__PURE__ */ t.forwardRef(Z_), G_ = W_, N_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 1.293 14.707 5l-1.5 1.5-1.353-1.354-.707.708L12.5 7.207 11.707 8 9.354 5.646l-.707.708L11 8.707l-.793.793-1.353-1.354-.707.708L9.5 10.207 8.707 11 6.354 8.646l-.707.708L8 11.707l-.793.793-1.353-1.354-.707.708L6.5 13.207l-1.5 1.5L1.293 11z"
      }
    )
  }
), U_ = /* @__PURE__ */ t.forwardRef(N_), Y_ = U_, Q_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 1v2.793l1.146-1.147.708.708L8 5.707 5.646 3.354l.708-.708L7.5 3.793V1zM14 6.5v1H2v-1zm-12 3v-1h12v1zm6 .793 2.354 2.353-.708.708L8.5 12.207V15h-1v-2.793l-1.146 1.147-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), K_ = /* @__PURE__ */ t.forwardRef(Q_), X_ = K_, J_ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3H2V2h12zM4 8a4 4 0 1 1 4 4v-1a3 3 0 1 0-3-3v.293l.646-.647.708.708L4.5 10.207 2.646 8.354l.708-.708.646.647zm10 5v1H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), eO = /* @__PURE__ */ t.forwardRef(J_), lO = eO, oO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3H2V2h12zm-6 .293 2.354 2.353-.708.708L8.5 5.207v5.586l1.146-1.147.708.708L8 12.707l-2.354-2.353.708-.708L7.5 10.793V5.207L6.354 6.354l-.708-.708zM14 13v1H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), nO = /* @__PURE__ */ t.forwardRef(oO), iO = nO, rO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 4.45 1.564l2.354 1.359 4.946-2.856.5.866L9.804 8l4.446 2.567-.5.866-4.946-2.856-2.354 1.36a2.5 2.5 0 1 1-.834-.673L7.804 8 5.617 6.737A2.5 2.5 0 0 1 2 4.5M4.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), tO = /* @__PURE__ */ t.forwardRef(rO), aO = tO, sO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2a6 6 0 0 0-5.98 5.5L.755 7.497l-.002 1h14.495v-1l-1.268.001A6 6 0 0 0 8 2m-5.62 8.053a6 6 0 0 0 1.044 1.804l.766-.643a5 5 0 0 1-.87-1.503zm10.236 1.804c.446-.53.802-1.14 1.044-1.804l-.94-.342a5 5 0 0 1-.87 1.503zm-7.596 1.34c.595.345 1.256.59 1.959.713l.172-.985a5 5 0 0 1-1.63-.594l-.502.866Zm4.041.713a6 6 0 0 0 1.96-.713l-.501-.866a5 5 0 0 1-1.631.594z"
      }
    )
  }
), dO = /* @__PURE__ */ t.forwardRef(sO), cO = dO, hO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.889 3.072a5 5 0 0 1 1.63.594l.501-.866a6 6 0 0 0-1.959-.713zm-3.369.594a5 5 0 0 1 1.63-.594l-.172-.985A6 6 0 0 0 5.02 2.8zm6.33 1.117c.372.443.668.95.87 1.503l.94-.342a6 6 0 0 0-1.044-1.804zM3.32 6.286c.201-.553.497-1.06.87-1.503l-.766-.643A6 6 0 0 0 2.38 5.944zM13.5 7.497h-11l-1.748.002.001 1 1.267-.001a6 6 0 0 0 11.959 0l1.267.001.001-1z"
      }
    )
  }
), wO = /* @__PURE__ */ t.forwardRef(hO), vO = wO, fO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m5.642 14.87.325-1.204A6 6 0 0 1 9.062 2.115L9.393.87l.967.258L6.608 15.13zm4.468-2.318c-.523.245-1.09.4-1.676.45L8.52 14a6 6 0 0 0 2.013-.541zm2.42-2.418a5 5 0 0 1-.995 1.422l.706.708a6 6 0 0 0 1.196-1.708zm.299-3.408c.148.554.203 1.138.15 1.73l.997.088a6 6 0 0 0-.182-2.077l-.966.26Zm-1.962-2.803c.482.338.895.755 1.227 1.23l.82-.574a6 6 0 0 0-1.474-1.475l-.573.82Z"
      }
    )
  }
), mO = /* @__PURE__ */ t.forwardRef(fO), pO = mO, gO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12.353 5.146-1.5-1.5L13 1.5 14.5 3zm-2.207-.793L8.853 5.646l1.5 1.5 1.293-1.293zM10 8.207 7.792 6H7.75a2 2 0 0 0-1.46.613c-.33.328-.578.752-.787 1.112l-.016.027c-.39.671-.675 1.117-1.145 1.274l-.547.182.258.516c.335.67.956 1.026 1.59 1.193.631.167 1.327.163 1.927.078C8.896 10.808 10 9.794 10 8.25zm-6.776-.439q-.343.226-.63.489l.677.737a4 4 0 0 1 .505-.392zm10.181.489a5 5 0 0 0-.63-.49l-.55.835q.281.187.504.392zM1.65 9.63a2.62 2.62 0 0 0 .105 1.999l.907-.422a1.62 1.62 0 0 1-.068-1.247zm12.85.87q-.002-.452-.15-.87l-.944.33a1.62 1.62 0 0 1-.068 1.247l.907.422A2.7 2.7 0 0 0 14.5 10.5M3.198 13.215a7.1 7.1 0 0 0 1.847.857l.295-.956a6.1 6.1 0 0 1-1.586-.732zm7.757.857a7.1 7.1 0 0 0 1.847-.857l-.556-.832a6.1 6.1 0 0 1-1.586.733zm-3.949.382a11 11 0 0 0 1.988 0l-.092-.995a10 10 0 0 1-1.804 0z"
      }
    )
  }
), uO = /* @__PURE__ */ t.forwardRef(gO), xO = uO, RO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.207 5.5 8.5 3.793l-6.5 6.5V12h1.707zM6 12h8v-1H6z"
      }
    )
  }
), jO = /* @__PURE__ */ t.forwardRef(RO), MO = jO, HO = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 0 0-5 5v1h1V8a4 4 0 1 1 8 0v.293l-.646-.647-.708.708 1.854 1.853 1.854-1.853-.708-.708-.646.647V8a5 5 0 0 0-5-5"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" })
    ]
  }
), CO = /* @__PURE__ */ t.forwardRef(HO), yO = CO, bO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2H5v2H2v1h3v2h3V5h6V4H8zm3 6H8v2H2v1h6v2h3v-2h3v-1h-3z"
      }
    )
  }
), VO = /* @__PURE__ */ t.forwardRef(bO), LO = VO, zO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 12H3v1h10zM9 9H3v1h6zM6 6H3v1h3zm6-3.707 2.854 2.854-.708.707L12.5 4.207V9h-1V4.207L9.854 5.854l-.708-.707z",
        clipRule: "evenodd"
      }
    )
  }
), SO = /* @__PURE__ */ t.forwardRef(zO), kO = SO, FO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4h10V3H3zm0 3h6V6H3zm0 3h3V9H3zm11.854.854L12 13.707l-2.854-2.854.708-.707 1.646 1.647V7h1v4.793l1.646-1.647z"
      }
    )
  }
), $O = /* @__PURE__ */ t.forwardRef(FO), BO = $O, AO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2H2v8.414L5.586 14H14zm-1 7.959L10.017 8.24 7.75 9.546l.5.866 1.767-1.018L13 11.113zM6 13v-3H3zM5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), EO = /* @__PURE__ */ t.forwardRef(AO), _O = EO, OO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H5.586L2 10.414zm4 8v3l-3-3zm2-6.63 1.26 2.551 2.815.41-2.038 1.985.481 2.804-2.25-1.183.465-.885.457.24-.227-1.325.963-.938-1.331-.194L8 5.63l-.595 1.205-1.33.194.274.267-.698.716-1.725-1.681 2.815-.41z",
        clipRule: "evenodd"
      }
    )
  }
), DO = /* @__PURE__ */ t.forwardRef(OO), PO = DO, TO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2H2v8.414L5.586 14H14zM8 6H6V5h5v1H9v5H8zm-2 7v-3H3z",
        clipRule: "evenodd"
      }
    )
  }
), qO = /* @__PURE__ */ t.forwardRef(TO), IO = qO, ZO = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 2H2v8.414L5.586 14H14zM6 13v-3H3zm0-6.5a2.5 2.5 0 1 1 4.586 1.379l1.768 1.768-.707.707-1.768-1.768A2.5 2.5 0 0 1 6 6.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
), WO = /* @__PURE__ */ t.forwardRef(ZO), GO = WO, NO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H6.293L2 9.707zm4 10.293L3.707 10H6z",
        clipRule: "evenodd"
      }
    )
  }
), UO = /* @__PURE__ */ t.forwardRef(NO), YO = UO, QO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4c-1.299 0-2 .846-2 1.5 0 .596.21.917.514 1.15.348.265.836.43 1.45.623l.072.023c.198.063.408.129.62.204H14v1h-3.671c.324.357.564.817.664 1.418.152.911-.16 1.702-.746 2.251C9.673 12.71 8.858 13 8 13c-1.683 0-3-1.035-3-2.5h1c0 .744.683 1.5 2 1.5.642 0 1.2-.219 1.563-.56.351-.33.538-.79.444-1.358-.1-.598-.386-.952-.777-1.213a3.7 3.7 0 0 0-.752-.369H2v-1h3.983l-.076-.056C5.353 7.021 5 6.404 5 5.5 5 4.154 6.299 3 8 3c1.683 0 3 1.035 3 2.5h-1C10 4.756 9.317 4 8 4",
        clipRule: "evenodd"
      }
    )
  }
), KO = /* @__PURE__ */ t.forwardRef(QO), XO = KO, JO = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 4h12V3H2zm12 1H2v3h12zm0 4H2v4h12z" })
  }
), eD = /* @__PURE__ */ t.forwardRef(JO), lD = eD, oD = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15.5 2 14 .5l-3 3L12.5 5z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 3H1v10h14V6h-1v6H2V4h6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.49 6.75C6.94 5.97 7.51 5 8.75 5l-.01-.01c.218 0 .436.044.647.123l.903-.903 1.5 1.5-.912.912c.072.202.112.41.112.618 0 1.44-.98 2.55-2.43 2.75-.28.04-.56.06-.82.06-1.28 0-2.26-.47-2.69-1.33l-.26-.52.55-.18c.507-.159.816-.693 1.144-1.26z"
        }
      )
    ]
  }
), nD = /* @__PURE__ */ t.forwardRef(oD), iD = nD, rD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3h2.725l-2.432 9.073-.293.079zM4 4.137l-2.373.636 2.07 7.728L4 12.42zm4.976-1.943 5.797 1.554-2.588 9.66-5.797-1.554z"
      }
    )
  }
), tD = /* @__PURE__ */ t.forwardRef(rD), aD = tD, sD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm-2 3H4V6h8zm1 3H3V9h10zm-2 3H5v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), dD = /* @__PURE__ */ t.forwardRef(sD), cD = dD, hD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm0 3H2V6h12zm0 3H2V9h12zm-6 3H2v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), wD = /* @__PURE__ */ t.forwardRef(hD), vD = wD, fD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm-4 3H2V6h8zm2 3H2V9h10zm-4 3H2v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), mD = /* @__PURE__ */ t.forwardRef(fD), pD = mD, gD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 4H2V3h12zm0 3H6V6h8zm0 3H4V9h10zm0 3H8v-1h6z",
        clipRule: "evenodd"
      }
    )
  }
), uD = /* @__PURE__ */ t.forwardRef(gD), xD = uD, RD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2zm5.5 4H5V5h6v1H8.5v5h-1z",
        clipRule: "evenodd"
      }
    )
  }
), jD = /* @__PURE__ */ t.forwardRef(RD), MD = jD, HD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 4H4V3h8v1H8.5v9h-1z",
        clipRule: "evenodd"
      }
    )
  }
), CD = /* @__PURE__ */ t.forwardRef(HD), yD = CD, bD = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1H6v2H3v1h10V3h-3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.89 5H4v10h3.257a5.5 5.5 0 0 1 4.632-8.986V5Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.793 11.5 8.646 9.354l.708-.708 2.146 2.147 2.146-2.147.707.708-2.146 2.146 2.146 2.146-.707.708-2.146-2.147-2.146 2.146-.708-.707z"
        }
      )
    ]
  }
), VD = /* @__PURE__ */ t.forwardRef(bD), LD = VD, zD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.76 11.87 5.383 3H3.616L1.24 11.87l.966.26.877-3.273h2.836l.876 3.272zM5.65 7.858h-2.3L4.384 4h.232zM13.207 6H9.793l-.647.646.708.708.353-.354h2.586l.207.207v.972l-3.259.873-.741.74v1.415l.793.793h2.914l.534-.534.178.663.966-.258L14 10.434V6.793zM10.26 9.948 13 9.214v1.079l-.707.707h-2.086L10 10.793v-.586z",
        clipRule: "evenodd"
      }
    )
  }
), SD = /* @__PURE__ */ t.forwardRef(zD), kD = SD, FD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.5 3v6.5a2.5 2.5 0 0 0 5 0V3h1v6.5a3.5 3.5 0 1 1-7 0V3zM14 14v1H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), $D = /* @__PURE__ */ t.forwardRef(FD), BD = $D, AD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 13H2v-1h12zM4 2v9h3V2zm4 3v6h3V5z" })
  }
), ED = /* @__PURE__ */ t.forwardRef(AD), _D = ED, OD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 8.5V13h3V8.5h1V11h3V8.5h3v-1h-3V5H8v2.5H7V3H4v4.5H2v1z"
      }
    )
  }
), DD = /* @__PURE__ */ t.forwardRef(OD), PD = DD, TD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 4h12V3H2zm2 1v9h3V5zm4 0v6h3V5z" })
  }
), qD = /* @__PURE__ */ t.forwardRef(TD), ID = qD, ZD = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m8.093.815.518 1.933.966-.259L9.059.557zm5.443.942L12.12 3.172l.707.707 1.415-1.415zM4.557 5.06l1.932.517.259-.966-1.933-.518zm10.886 1.88-1.932-.517-.259.966 1.932.518zm-3.536 4.244-.518-1.932-.966.259.518 1.932zm-3.261-2.33L3.5 14 2 12.5l5.146-5.146zm.708-.708L11.5 6 10 4.5 7.854 6.646z"
      }
    )
  }
), WD = /* @__PURE__ */ t.forwardRef(ZD), GD = WD, ND = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a4 4 0 0 0-3.838 5.13L.793 12.5 3.5 15.207l5.37-5.37a4 4 0 0 0 4.746-2.123l.1-.214H10L9.25 6 10 4.5h3.717l-.102-.215A4 4 0 0 0 10 2"
      }
    )
  }
), UD = /* @__PURE__ */ t.forwardRef(ND), YD = UD, QD = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 3H2v2h12z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 6H3v7h10zM6 7h4v1H6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), KD = /* @__PURE__ */ t.forwardRef(QD), XD = KD, JD = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 4.72C2 6 4.865 7 8 7c3.136 0 6-1 6-2.28 0-.72-.973-1.52-1.904-1.943C11.022 2.289 9.573 2 8 2s-3.022.289-4.096.777C2.973 3.2 2 4 2 4.72m10.627 5.97c.51-.211.984-.475 1.373-.797V11c0 1.007-.875 1.755-1.904 2.223C11.022 13.71 9.573 14 8 14s-3.022-.289-4.096-.777C2.875 12.755 2 12.007 2 11V9.893c.39.322.863.585 1.373.798 1.235.514 2.871.809 4.627.809s3.393-.295 4.627-.81"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 8c1.756 0 3.393-.295 4.627-.81.51-.212.984-.475 1.373-.797v2.5c-.389.322-.863.585-1.373.798-1.234.514-2.871.809-4.627.809s-3.392-.295-4.627-.81c-.51-.212-.984-.475-1.373-.797v-2.5c.39.322.863.585 1.373.798C4.608 7.705 6.244 8 8 8"
        }
      )
    ]
  }
), eP = /* @__PURE__ */ t.forwardRef(JD), lP = eP, oP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 2h6.707L13 5.293v1.963A4.5 4.5 0 0 0 7.758 14H3zm6 1v3h3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10.5 14.207 4.854-4.853-.707-.708-4.147 4.147-1.646-1.646-.708.707z"
        }
      )
    ]
  }
), nP = /* @__PURE__ */ t.forwardRef(oP), iP = nP, rP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.707 2H3v12h4.758A4.5 4.5 0 0 1 13 7.256V5.293zM9 6V3l3 3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z" })
    ]
  }
), tP = /* @__PURE__ */ t.forwardRef(rP), aP = tP, sP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 2h7.134L13 4.751V14H3zm6.25 3.6V2.849L12.116 5.6zm-1.75.9a2 2 0 1 0 1.016 3.723l1.63 1.63.707-.707-1.63-1.63A2 2 0 0 0 7.5 6.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dP = /* @__PURE__ */ t.forwardRef(sP), cP = dP, hP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 2h6.707L13 5.293V14H3zm6 1v3h3z",
        clipRule: "evenodd"
      }
    )
  }
), wP = /* @__PURE__ */ t.forwardRef(hP), vP = wP, fP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V9h-1V3.207L6.354 4.354l-.708-.708zM3 5h2v1H4v6h8V6h-1V5h2v8H3z",
        clipRule: "evenodd"
      }
    )
  }
), mP = /* @__PURE__ */ t.forwardRef(fP), pP = mP, gP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.977 2H2v12h12V4.312zM5 3h5v3H5zm6 6H5v4h6z",
        clipRule: "evenodd"
      }
    )
  }
), uP = /* @__PURE__ */ t.forwardRef(gP), xP = uP, RP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 5H7.42l-.536-2H2v10h12z" })
  }
), jP = /* @__PURE__ */ t.forwardRef(RP), MP = jP, HP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6.42 5H13v2H3.161l-2.16 5.398L1 3h4.884z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M1.837 13h11l2.002-5h-11z" })
    ]
  }
), CP = /* @__PURE__ */ t.forwardRef(HP), yP = CP, bP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 8.793V3h1v5.793l1.146-1.147.708.708L8 10.707 5.646 8.354l.708-.708zM3 5h2v1H4v6h8V6h-1V5h2v8H3z",
        clipRule: "evenodd"
      }
    )
  }
), VP = /* @__PURE__ */ t.forwardRef(bP), LP = VP, zP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5 3.25a.25.25 0 1 1 .5 0 .25.25 0 0 1-.5 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.5 1H3v4.5h4.5zM5.25 2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 5.5H8.5V1H13zM3 10V6.5h10V10a5 5 0 0 1-10 0"
        }
      )
    ]
  }
), SP = /* @__PURE__ */ t.forwardRef(zP), kP = SP, FP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708L10.293 11H2V5h2.293L1.646 2.354zM13 9v1.172L7.828 5H13v2h1v2z"
      }
    )
  }
), $P = /* @__PURE__ */ t.forwardRef(FP), BP = $P, AP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1z",
        clipRule: "evenodd"
      }
    )
  }
), EP = /* @__PURE__ */ t.forwardRef(AP), _P = EP, OP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1zM4 7h1v2H4zm3 0H6v2h1zm1 0h1v2H8zm3 0h-1v2h1z",
        clipRule: "evenodd"
      }
    )
  }
), DP = /* @__PURE__ */ t.forwardRef(OP), PP = DP, TP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1zM4 7h1v2H4z",
        clipRule: "evenodd"
      }
    )
  }
), qP = /* @__PURE__ */ t.forwardRef(TP), IP = qP, ZP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1zM4 7h1v2H4zm3 0H6v2h1z",
        clipRule: "evenodd"
      }
    )
  }
), WP = /* @__PURE__ */ t.forwardRef(ZP), GP = WP, NP = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5H2v6h11V9h1V7h-1zM4 7h1v2H4zm3 0H6v2h1zm1 0h1v2H8z",
        clipRule: "evenodd"
      }
    )
  }
), UP = /* @__PURE__ */ t.forwardRef(NP), YP = UP, QP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 6v2.133L8.001 6.979 6 8.134V6z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 9.288v1.345L8.001 9.479 6 10.634V9.289l2.001-1.156z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zM10 12.619v-.831l-1.999-1.155L6 11.79v.83l-1-.578V5h2V4h2v1h2v7.042z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), KP = /* @__PURE__ */ t.forwardRef(QP), XP = KP, JP = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 7V2.07L5.15 9H7v4.93L10.85 7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.229 5H2v6h4v-1H3.45l2.78-5Zm3.542 6H13V9h1V7h-1V5h-3v1h2.55z"
        }
      )
    ]
  }
), eT = /* @__PURE__ */ t.forwardRef(JP), lT = eT, oT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m11.207 5-1.69 1.69-.706-.708L9.793 5 8 3.207v1.965l-1-1V.793z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.5 11.707 2.646 2.647.708-.707-12-12-.708.707L6.793 8l-3.146 3.146.707.708L7 9.207v6zM8 9.207 9.793 11 8 12.793z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), nT = /* @__PURE__ */ t.forwardRef(oT), iT = nT, rT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 .793 11.207 5l-3 3 3 3L7 15.207v-6l-2.646 2.647-.708-.707L6.793 8 3.646 4.854l.708-.707L7 6.793zm1 8.414L9.793 11 8 12.793zm0-2.414V3.207L9.793 5z",
        clipRule: "evenodd"
      }
    )
  }
), tT = /* @__PURE__ */ t.forwardRef(rT), aT = tT, sT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 2h9v12h-9zm8 1v2h-7V3zm-5 4h-1v1h1zm-1 2h1v1h-1zm1 2h-1v1h1zm1-4h1v1h-1zm1 2h-1v1h1zm-1 2h1v1h-1zm3-4h-1v1h1zm-1 2h1v1h-1zm1 2h-1v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), dT = /* @__PURE__ */ t.forwardRef(sT), cT = dT, hT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7 9V7h2v2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 3H3v2.5H2v1h1v1H2v1h1v1H2v1h1V13h2.5v1h1v-1h1v1h1v-1h1v1h1v-1H13v-2.5h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1V3h-2.5V2h-1v1h-1V2h-1v1h-1V2h-1zM6 6v4h4V6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), wT = /* @__PURE__ */ t.forwardRef(hT), vT = wT, fT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 2H1v8h1V3h11z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 4h12v8H9.902l.268 1H12v1H6v-1h1.831l.268-1H3zm6 8.5-.133.5h.267z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), mT = /* @__PURE__ */ t.forwardRef(fT), pT = mT, gT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.707.708L10.293 11H8.902l.268 1H11v1H5v-1h1.831l.268-1H2V3h.293L.646 1.354zM7.867 12 8 11.5l.134.5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 11h-.172l-8-8H14z" })
    ]
  }
), uT = /* @__PURE__ */ t.forwardRef(gT), xT = uT, RT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3H2v8h5.1l-.269 1H5v1h6v-1H9.17l-.268-1H14zm-6.133 9L8 11.5l.134.5z",
        clipRule: "evenodd"
      }
    )
  }
), jT = /* @__PURE__ */ t.forwardRef(RT), MT = jT, HT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.707-1.223-1.222c-.38.234-.831.369-1.308.369h-3.5c-1.132 0-2.115-.861-2.115-2 0-.515.232-1.028.592-1.387a1.74 1.74 0 0 1 .86-.477c.027-.517.275-.984.622-1.336l.01-.01-.707-.706-.014.014q-.181.183-.34.402H1V4h2.293L1.646 2.354zM3 6h1v1H3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10.5 7.5-.168.004L6.828 4H15v5h-1.517a3.4 3.4 0 0 0-.59-.627c-.629-.517-1.499-.873-2.393-.873"
        }
      )
    ]
  }
), CT = /* @__PURE__ */ t.forwardRef(HT), yT = CT, bT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 8.5a2.75 2.75 0 0 0-1.926.8c-.347.352-.595.819-.623 1.336a1.74 1.74 0 0 0-.859.477c-.36.359-.592.872-.592 1.387 0 1.139.983 2 2.115 2h3.5c1.282 0 2.385-.973 2.385-2.25 0-.543-.236-1.086-.593-1.474a1.83 1.83 0 0 0-.945-.561c-.093-.435-.384-.807-.703-1.069C11.79 8.761 11.14 8.5 10.5 8.5"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 4H1v5h6.524q.157-.219.339-.402A3.75 3.75 0 0 1 10.5 7.5c.894 0 1.764.356 2.394.874.195.16.405.371.589.626H15zM3 6h1v1H3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), VT = /* @__PURE__ */ t.forwardRef(bT), LT = VT, zT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5V9H1V4h2.293L1.646 2.354zM8.5 9.207V12H10v1h2.293zM4 6H3v1h1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 9h-3.172l-5-5H15z" })
    ]
  }
), ST = /* @__PURE__ */ t.forwardRef(zT), kT = ST, FT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4h14v5H8.5v3H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5V9H1zm3 2H3v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), $T = /* @__PURE__ */ t.forwardRef(FT), BT = $T, AT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.708L9.293 10H1V5h3.293L1.646 2.354zM6.293 7H6v1h1.293zM3 7h1v1H3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 10h-2.172l-2-2H13V7H9.828l-2-2H15z" })
    ]
  }
), ET = /* @__PURE__ */ t.forwardRef(AT), _T = ET, OT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5h14v5H1zm2 2h1v1H3zm10 0H6v1h7z",
        clipRule: "evenodd"
      }
    )
  }
), DT = /* @__PURE__ */ t.forwardRef(OT), PT = DT, TT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708L11 11.707v1.507l-3 .804-3-.804V5.707L1.646 2.354zM11 5v3.172L7.828 5H9V3H7v1.172l-1-1V2h4v3z"
      }
    )
  }
), qT = /* @__PURE__ */ t.forwardRef(TT), IT = qT, ZT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2H6v3H5v8.214l3 .804 3-.804V5h-1zM9 5V3H7v2z",
        clipRule: "evenodd"
      }
    )
  }
), WT = /* @__PURE__ */ t.forwardRef(ZT), GT = WT, NT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5.5 10V7h1V6h3v1h1v3h-1V8h-1v2h-1V8h-1v2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h12v12H2zm8.5 3h-5v1h-1v5h7V6h-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), UT = /* @__PURE__ */ t.forwardRef(NT), YT = UT, QT = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 9V5h1v4zm2 2V3h1v8z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3.647 3v1.853c0 .285.125.608.278.905a6 6 0 0 0 .22.387 6 6 0 0 0-.387-.22c-.297-.153-.62-.278-.905-.278C1.83 5.647 1 6.477 1 7.5v1.853h1.853c.285 0 .608-.125.905-.278a6 6 0 0 0 .387-.22 6 6 0 0 0-.22.387c-.153.297-.278.62-.278.905C3.647 11.17 4.477 12 5.5 12h1.853v-1.853c0-.285-.125-.608-.278-.905a6 6 0 0 0-.22-.387q.193.12.387.22c.297.153.62.278.905.278C9.17 9.353 10 8.523 10 7.5V5.647H8.147c-.285 0-.608.125-.905.278a6 6 0 0 0-.387.22 6 6 0 0 0 .22-.387c.153-.297.278-.62.278-.905C7.353 3.83 6.523 3 5.5 3z"
        }
      )
    ]
  }
), KT = /* @__PURE__ */ t.forwardRef(QT), XT = KT, JT = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.647 3H6.5c1.023 0 1.853.83 1.853 1.853 0 .285-.125.608-.278.905a6 6 0 0 1-.22.387 6 6 0 0 1 .387-.22c.297-.153.62-.278.905-.278H11V7.5c0 1.023-.83 1.853-1.853 1.853-.285 0-.608-.125-.905-.278a6 6 0 0 1-.387-.22q.12.194.22.387c.153.297.278.62.278.905V12H6.5a1.853 1.853 0 0 1-1.853-1.853c0-.285.125-.608.278-.905a6 6 0 0 1 .22-.387 6 6 0 0 1-.387.22c-.297.153-.62.278-.905.278H2V7.5c0-1.023.83-1.853 1.853-1.853.285 0 .608.125.905.278a6 6 0 0 1 .387.22 6 6 0 0 1-.22-.387c-.153-.297-.278-.62-.278-.905zM12 5v4h1V5z"
      }
    )
  }
), eq = /* @__PURE__ */ t.forwardRef(JT), lq = eq, oq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 2.25H5.25V4.5c0 .44.181.892.425 1.306.192.326.43.643.677.933C5.768 6.47 5.105 6.25 4.5 6.25A2.25 2.25 0 0 0 2.25 8.5v2.25H4.5c.44 0 .892-.181 1.306-.425.326-.192.643-.43.933-.677-.268.584-.489 1.247-.489 1.852a2.25 2.25 0 0 0 2.25 2.25h2.25V11.5c0-.44-.181-.892-.425-1.306a7 7 0 0 0-.677-.933c.584.268 1.247.489 1.852.489a2.25 2.25 0 0 0 2.25-2.25V5.25H11.5c-.44 0-.892.181-1.306.425-.326.192-.643.43-.933.677.268-.584.489-1.247.489-1.852A2.25 2.25 0 0 0 7.5 2.25"
      }
    )
  }
), nq = /* @__PURE__ */ t.forwardRef(oq), iq = nq, rq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707-1.064-1.064-.013.005-1.441-.386-.393-1.466-.677-.677L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162.218-.058-1.677-1.676zM5.293 6H5v1H4v1h1v1h1V8h1v-.293L6.293 7H6v-.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.833 10.25-.37 1.384-2.991-2.991a1.5 1.5 0 1 0-2.114-2.114L6.192 3.364l1.373.368h.869L10 3.312l2.894.776z"
        }
      )
    ]
  }
), tq = /* @__PURE__ */ t.forwardRef(rq), aq = tq, sq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m5.998 2.313 1.566.419h.869l1.565-.42 2.894.776 1.937 6.16-.241.9L10.84 7.96A1.5 1.5 0 1 0 9 6.5v2.98l-1.002-.268-2.59.694-.537 2-1.44.386-1.626-.664-.638-2.38 1.938-6.16 2.893-.776ZM5 6V5h1v1h1v1H6v1H5V7H4V6z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m4.421 5.5-4.92-2.87v5.74z"
        }
      )
    ]
  }
), dq = /* @__PURE__ */ t.forwardRef(sq), cq = dq, hq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6 3.313 1.566.42h.869L10 3.312l2.894.775 1.938 6.162-.638 2.38-1.626.664-1.441-.386-.536-2L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162L6 3.312ZM5 6v1H4v1h1v1h1V8h1V7H6V6zm5.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
), wq = /* @__PURE__ */ t.forwardRef(hq), vq = wq, fq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M0 3h1v7h1V9h1v1h5V9h5V3H2V2H0zm8.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 11V5.5h-1V10H9v1H5v1h5v-1z" })
    ]
  }
), mq = /* @__PURE__ */ t.forwardRef(fq), pq = mq, gq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L10.293 11H9v1H4v-1H3v1H2V5H1V4h2v1h1.293L1.646 2.354zM14 11h-.172l-1.857-1.857a1.5 1.5 0 1 0-2.114-2.114L7.828 5H14z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 8a.5.5 0 0 1-.243.429l-.686-.686A.5.5 0 0 1 11.5 8"
        }
      )
    ]
  }
), uq = /* @__PURE__ */ t.forwardRef(gq), xq = uq, Rq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 5H1V4h2v1h11v6H9v1H4v-1H3v1H2zm9 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
), jq = /* @__PURE__ */ t.forwardRef(Rq), Mq = jq, Hq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "g",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipPath: "url(#hardware-gpu-off_svg__a)",
          clipRule: "evenodd",
          children: /* @__PURE__ */ l.jsx("path", { d: "m.854.146 15 15-.707.707-1.354-1.353H9.5V14h-3v.5h-5v-5H2v-3h-.5V2.207L.146.854zM4 4.707V6h1.293zm3 3V9h1.293zm3 3V12h1.293zM4 7v2h2V7zm0 3v2h2v-2zm3 0v2h2v-2zm7.5-.5v2.172l-2.5-2.5V7H9.828L9 6.172V4H6.828l-2.5-2.5H6.5V2h3v-.5h5v5H14v3zM10 4v2h2V4z" })
        }
      ),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "hardware-gpu-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Cq = /* @__PURE__ */ t.forwardRef(Hq), yq = Cq, bq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.5 6.5H2v3h-.5v5h5V14h3v.5h5v-5H14v-3h.5v-5h-5V2h-3v-.5h-5zM4 4v2h2V4zm3 0v2h2V4zm3 0v2h2V4zM4 7v2h2V7zm3 0v2h2V7zm3 0v2h2V7zm-6 3v2h2v-2zm3 0v2h2v-2zm3 0v2h2v-2z",
        clipRule: "evenodd"
      }
    )
  }
), Vq = /* @__PURE__ */ t.forwardRef(bq), Lq = Vq, zq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.066 7H1.64L.973 9l.667 2H4V7h-.924c.171-1.086.624-1.978 1.285-2.64C5.214 3.508 6.455 3 8 3s2.786.507 3.64 1.36c.66.662 1.113 1.554 1.284 2.64H12v4h1v2H9v-.5H7v2h2V14h5v-3h.36l.667-2-.667-2h-.425c-.18-1.339-.728-2.486-1.589-3.346C11.278 2.586 9.77 2 8 2s-3.278.586-4.346 1.654c-.86.86-1.408 2.007-1.588 3.346"
      }
    )
  }
), Sq = /* @__PURE__ */ t.forwardRef(zq), kq = Sq, Fq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 3h14v9H1zm3 3H3V5h1zm1.5 0h-1V5h1zM6 6h1V5H6zm2.5 0h-1V5h1zM9 6h1V5H9zm2.5 0h-1V5h1zm.5 0h1V5h-1zM4 8H3V7h1zm.5 0h1V7h-1zM7 8H6V7h1zm.5 0h1V7h-1zM10 8H9V7h1zm.5 0h1V7h-1zM13 8h-1V7h1zM3 10h1V9H3zm8 0H5V9h6zm1 0h1V9h-1z",
        clipRule: "evenodd"
      }
    )
  }
), $q = /* @__PURE__ */ t.forwardRef(Fq), Bq = $q, Aq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 3H3v7h10zM2 12h12v-1H2z" })
  }
), Eq = /* @__PURE__ */ t.forwardRef(Aq), _q = Eq, Oq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.151 2H6.116l-2.144 8H7v5.383L12.362 6H9.079z"
      }
    )
  }
), Dq = /* @__PURE__ */ t.forwardRef(Oq), Pq = Dq, Tq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m1.354.646 13 13-.707.707L10.293 11h-.391l.268 1H11v1H5v-1h.831l.268-1H2V9h6.293l-1-1H2V3h.293L.646 1.354zM7.134 11l-.268 1h2.268l-.268-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 11h-.172l-2-2H14zm0-3h-3.172l-5-5H14z" })
    ]
  }
), qq = /* @__PURE__ */ t.forwardRef(Tq), Iq = qq, Zq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h12v5H2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 9v2h4.1l-.269 1H5v1h6v-1h-.83l-.268-1H14V9zm5.134 2-.268 1h2.268l-.268-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Wq = /* @__PURE__ */ t.forwardRef(Zq), Gq = Wq, Nq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.5c-.581 0-1.145.076-1.682.22A6.51 6.51 0 0 0 2.37 4.75 6.5 6.5 0 1 0 8 1.5M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M3.236 5.25l2.599 1.5a2.5 2.5 0 0 1 1.518-1.165l-.777-2.899a5.51 5.51 0 0 0-3.34 2.563Z",
        clipRule: "evenodd"
      }
    )
  }
), Uq = /* @__PURE__ */ t.forwardRef(Nq), Yq = Uq, Qq = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 1.86 5.562 3h4.876L15 1.86v12.28L10.438 13H5.562L1 14.14zM6 12h4v-2H6zm0-3h4V7H6zm0-3h4V4H6zM5 3.89l-3-.75v2.42l3 .375zm0 3.051-3-.375v2.868l3-.375zm0 3.125-3 .375v2.419l3-.75zm6-6.176v2.044l3-.375V3.14zm3 2.676-3 .375V9.06l3 .375zm0 3.875-3-.375v2.044l3 .75z",
        clipRule: "evenodd"
      }
    )
  }
), Kq = /* @__PURE__ */ t.forwardRef(Qq), Xq = Kq, Jq = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 3.25a.25.25 0 1 0-.5 0 .25.25 0 0 0 .5 0"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.5 1H13v4.5H8.5zm2.25 1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 5.5h4.5V1H3zM13 10V6.5H3V10a5 5 0 0 0 10 0"
        }
      )
    ]
  }
), eI = /* @__PURE__ */ t.forwardRef(Jq), lI = eI, oI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 1H3v4.5h4.5zm1 4.5V1H13v4.5zM3 6.5V10a5 5 0 0 0 10 0V6.5z"
      }
    )
  }
), nI = /* @__PURE__ */ t.forwardRef(oI), iI = nI, rI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.667 1H3v4.5h2.667zM3 10V6.5h10V10a5 5 0 0 1-10 0m3.667-9h2.666v4.5H6.667zM13 1h-2.667v4.5H13z"
      }
    )
  }
), tI = /* @__PURE__ */ t.forwardRef(rI), aI = tI, sI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 1h4.5v2.585A1.5 1.5 0 0 0 6.5 5v.5H3zm3.5 5.5H3V10a5 5 0 0 0 10 0V6.5H9.5V7a1.5 1.5 0 1 1-3 0zm3-1H13V1H8.5v2.585A1.5 1.5 0 0 1 9.5 5z"
      }
    )
  }
), dI = /* @__PURE__ */ t.forwardRef(
  sI
), cI = dI, hI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h4.5v2.585A1.5 1.5 0 0 0 6.5 5v.5H3zm3.5 5.5H3V10a5 5 0 0 0 10 0V6.5H9.5V7a1.5 1.5 0 1 1-3 0zm3-1H13V1H8.5v2.585A1.5 1.5 0 0 1 9.5 5z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7.5 5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0z" })
    ]
  }
), wI = /* @__PURE__ */ t.forwardRef(hI), vI = wI, fI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 3H1v4h14zM3.5 4.5h-1v1h1zM15 8H1v4h14zM3.5 9.5h-1v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), mI = /* @__PURE__ */ t.forwardRef(fI), pI = mI, gI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m4.854 5.354-.707-.708L.793 8l3.354 3.354.707-.707L2.207 8zm6.292 0L13.793 8l-2.646 2.646.707.708L15.207 8l-3.353-3.354z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    ]
  }
), uI = /* @__PURE__ */ t.forwardRef(gI), xI = uI, RI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2H6v3h4zM6 7h4V6H6zm4.13 3.517L8.5 10.08V7.964h-1v2.116l-1.63.437.26.966L8 10.982l1.87.501zM5 9H1v3h4zm10 0h-4v3h4zM1 14h4v-1H1zm10 0h4v-1h-4z"
      }
    )
  }
), jI = /* @__PURE__ */ t.forwardRef(RI), MI = jI, HI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a2 2 0 0 0-.5 3.937v1.626a2 2 0 0 0-1.211.902l-1.29-.387L5 7a2 2 0 1 0-.289 1.035l1.29.387a2 2 0 0 0 .508 1.411l-.85 1.278a2 2 0 1 0 .832.555l.85-1.277a2 2 0 0 0 1.317 0l.852 1.277a2 2 0 1 0 .832-.555L9.49 9.834A2 2 0 0 0 10 8.422l1.29-.387a2 2 0 1 0-.287-.958l-1.29.388a2 2 0 0 0-1.212-.902V4.937A2 2 0 0 0 8 1"
      }
    )
  }
), CI = /* @__PURE__ */ t.forwardRef(HI), yI = CI, bI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.607 1h6.594L9.525 4.114zM12 5.69V1.625l-1.63 3.026zM4 1.806v9.36L6.154 9.32l.423.269L9.04 5.013zm8 5.074v6.16l-4.578-2.913 2.475-4.595z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.5 15v-1.23l3.742-3.208L12 14.226V15zm7.283-1H3.768l2.563-2.197z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), VI = /* @__PURE__ */ t.forwardRef(bI), LI = VI, zI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1.774 12H9.12l1.348-2.103-5.478-2.95zm8.536 0h4.064l-3.026-1.63zm4.69-.799V4.607l-3.114 4.918L15 11.2ZM14.194 4H1.626l9.36 5.04zM1 4.799v6.555l3.107-4.882z"
      }
    )
  }
), SI = /* @__PURE__ */ t.forwardRef(zI), kI = SI, FI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 9.213 5.068l.536.844a7 7 0 1 0-7.498 0l.536-.844A6 6 0 0 1 2 8"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 6.5a1.5 1.5 0 1 0 1.237 2.349l2.981.799.26-.966-2.982-.799A1.5 1.5 0 0 0 8 6.5"
        }
      )
    ]
  }
), $I = /* @__PURE__ */ t.forwardRef(FI), BI = $I, AI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2M6.504 7.883a1.5 1.5 0 1 1 .26.966l-2.982.799-.26-.966z",
        clipRule: "evenodd"
      }
    )
  }
), EI = /* @__PURE__ */ t.forwardRef(AI), _I = EI, OI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 9.213 5.068l.536.844a7 7 0 1 0-7.498 0l.536-.844A6 6 0 0 1 2 8"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 6.5q.14 0 .273.025L9.817 3.85l.866.5-1.544 2.674A1.5 1.5 0 1 1 8 6.5"
        }
      )
    ]
  }
), DI = /* @__PURE__ */ t.forwardRef(OI), PI = DI, TI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 2h10v7H8V5H4zm11 9H8v-1h7z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 6h2v1h1V6h2v5H2zm0 6v2h5v-2z" })
    ]
  }
), qI = /* @__PURE__ */ t.forwardRef(TI), II = qI, ZI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m11.099 2.392.901.9 1.646-1.646.708.708L12.707 4l.901.901-1.197 2.395-.704.704.647.646-.707.708-5-5 .707-.708.646.647.704-.704zM7.146 6.146 5.5 7.793 4.354 6.646l-.708.707.647.647-.704.704-1.197 2.395.9.9-1.646 1.647.708.707L4 12.707l.901.901 2.395-1.197.704-.704.646.646.708-.707L8.207 10.5l1.647-1.647-.708-.707L7.5 9.793 6.207 8.5l1.647-1.647z"
      }
    )
  }
), WI = /* @__PURE__ */ t.forwardRef(ZI), GI = WI, NI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 3v2h1V3zm3 0v2h1V3z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1H4v7H3v3.678l3 .804V15h4v-2.518l3-.804V8h-1zM5 8h6V2H5zm2 6v-1.25l1 .268 1-.268V14z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), UI = /* @__PURE__ */ t.forwardRef(NI), YI = UI, QI = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 1v3H3v1h1v2.365L4.706 10H7.5v1.5A1.5 1.5 0 0 1 6 13H3v1h3a2.5 2.5 0 0 0 2.5-2.5V10h2.794L12 7.365V5h1V4h-3V1H9v3H7V1z"
      }
    )
  }
), KI = /* @__PURE__ */ t.forwardRef(QI), XI = KI, JI = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7.5 1v7h1V1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 3.669a5 5 0 1 1-5 0L5 2.803a6 6 0 1 0 6.002 0z"
        }
      )
    ]
  }
), eZ = /* @__PURE__ */ t.forwardRef(JI), lZ = eZ, oZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 5h1.5V3h1v2h1V3h1v2h1V3h1v2h1V3h1v2h1V3h1v2H14v6h-1.5v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2H2z"
      }
    )
  }
), nZ = /* @__PURE__ */ t.forwardRef(oZ), iZ = nZ, rZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.25 2.236A5.5 5.5 0 0 1 8 1.5c1.003 0 1.941.268 2.75.736l.5-.866A6.5 6.5 0 0 0 8 .5a6.5 6.5 0 0 0-3.251.87zm1 1.732A3.5 3.5 0 0 1 8 3.5c.638 0 1.236.17 1.75.468l.5-.865A4.5 4.5 0 0 0 8 2.5a4.5 4.5 0 0 0-2.25.603zM7.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 5H5v10h6zM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-1.25 4h1v1h-1zm2.5 0h-1v1h1zM6.75 12h1v1h-1zm2.5 0h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tZ = /* @__PURE__ */ t.forwardRef(rZ), aZ = tZ, sZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.982 4.743A2 2 0 0 1 8 5a2 2 0 0 1-1.016-.277L5.586 6.121a2.49 2.49 0 0 1 .302 2.12L9.646 12h4.238l.804 3H1.313l.804-3h3.287L3.402 9.998a2.5 2.5 0 1 1 1.477-4.584l1.398-1.398a2 2 0 1 1 3.426.033l1.793 1.748.297-.297h1.914l1.646 1.646-.707.708L13.293 6.5h-1.086l-.707.707v1.086l1.354 1.353-.708.707L10.5 8.707V6.793l.289-.289zM9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3.535 9H3.5a1.5 1.5 0 1 1 .035 0",
        clipRule: "evenodd"
      }
    )
  }
), dZ = /* @__PURE__ */ t.forwardRef(sZ), cZ = dZ, hZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.793 2H13v3h-.5v1h.5v8H3V3.793zM6 4.5H5V7h1zM7 4h1v3H7zm3 0H9v3h1z",
        clipRule: "evenodd"
      }
    )
  }
), wZ = /* @__PURE__ */ t.forwardRef(hZ), vZ = wZ, fZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2.5v6.672L4.357 1.529A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5M9 2H7v1h2zM4 4.707V11h6.293l1 1H4v1.5A1.5 1.5 0 0 0 5.5 15h5a1.5 1.5 0 0 0 1.5-1.5v-.793l1.646 1.647.708-.708-12-12-.708.708zM8.5 13h-1v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), mZ = /* @__PURE__ */ t.forwardRef(fZ), pZ = mZ, gZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2.5A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5V11H4zM9 2H7v1h2zM4 12h8v1.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5zm4.5 1h-1v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), uZ = /* @__PURE__ */ t.forwardRef(gZ), xZ = uZ, RZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 2.5v7.672L3.937 1.109C4.111 1.039 4.301 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m11.293 12-1-1H3V3.707L1.646 2.354l.708-.708 13 13-.707.708-1.66-1.66A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V12zM8.5 13h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), jZ = /* @__PURE__ */ t.forwardRef(RZ), MZ = jZ, HZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 1A1.5 1.5 0 0 0 3 2.5V11h10V2.5A1.5 1.5 0 0 0 11.5 1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 13.5V12h10v1.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5m5.5-.5h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), CZ = /* @__PURE__ */ t.forwardRef(HZ), yZ = CZ, bZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708-3.112-3.112c-1.924 1.774-3.715 2.36-5.063 2.482-.86.079-1.687-.004-2.47-.319l-.587-2.19 3.237-1.87 1.739 1.004a5.2 5.2 0 0 0 1.41-.84L1.646 2.354zm9.848 7.727-1.86-1.86.025-.057-1.034-1.791 1.869-3.237 2.19.587c.317.778.409 1.63.334 2.482-.094 1.07-.48 2.416-1.524 3.877Z"
      }
    )
  }
), VZ = /* @__PURE__ */ t.forwardRef(bZ), LZ = VZ, zZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13.726 5.497c.074-.853-.017-1.704-.334-2.482l-2.19-.587-1.87 3.237 1.035 1.791c-.276.64-.672 1.2-1.168 1.692a5.3 5.3 0 0 1-1.808 1.2L5.652 9.346l-3.237 1.87.587 2.19c.783.315 1.61.398 2.47.32 1.43-.131 3.36-.782 5.417-2.822 2.059-2.04 2.71-3.97 2.837-5.406Z"
      }
    )
  }
), SZ = /* @__PURE__ */ t.forwardRef(zZ), kZ = SZ, FZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.854 2.647 8 .793 6.146 2.647l.708.707.646-.647v7.141L5 9.178V7.916a1.5 1.5 0 1 0-1 0v2.03l3.5.939v.18a2 2 0 1 0 1 0v-1.68l3.5-.938V7h1V4h-3v3h1v.678l-2.5.67v-5.64l.646.646z"
      }
    )
  }
), $Z = /* @__PURE__ */ t.forwardRef(FZ), BZ = $Z, AZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 4h4V3H6zm7.32 4.498L12.385 5H3.616L2.68 8.497l.937 3.498h3.501L7.384 11h1.232l.267.995h3.5zM2.349 6.13l-.966-.26L.68 8.498l.705 2.632.966-.258-.636-2.374zm11.302 0 .635 2.368-.636 2.373.966.258.705-2.631-.704-2.627-.966.258Z"
      }
    )
  }
), EZ = /* @__PURE__ */ t.forwardRef(AZ), _Z = EZ, OZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 1H5v1.803A6 6 0 0 1 8 2c1.093 0 2.117.292 3 .803z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 12a5 5 0 0 0 1.9-3h.6V7h-.6a5 5 0 1 0-1.9 5M7.836 5.455l.572 2.137 2.137.572-.259.966-2.694-.722-.722-2.694z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 13.197c.883.51 1.907.803 3 .803a6 6 0 0 0 3-.803V15H5z"
        }
      )
    ]
  }
), DZ = /* @__PURE__ */ t.forwardRef(OZ), PZ = DZ, TZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 12 12-.708.707L11 11.707V12H5v-1h.831l.268-1H4.5a3.5 3.5 0 0 1-1.743-6.536l-1.11-1.11zm1.951 3.366a1.5 1.5 0 1 0 1.682 1.683zM6.866 11l.268-1h1.732l.268 1zM15 6.5a3.5 3.5 0 0 1-2.361 3.31L5.829 3H11.5A3.5 3.5 0 0 1 15 6.5M12 6h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), qZ = /* @__PURE__ */ t.forwardRef(TZ), IZ = qZ, ZZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.5 3a3.5 3.5 0 1 0 0 7h1.6l-.269 1H5v1h1.599l.535-2h.282a5 5 0 0 1 7.327-2.181A3.5 3.5 0 0 0 11.5 3zM3 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M11 5v1h1V5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.629 9.842a2.5 2.5 0 0 1 1.37-.792V8h1v1.05a2.5 2.5 0 0 1 1.372.792l.91-.525.5.866-.91.525a2.5 2.5 0 0 1 0 1.584l.91.525-.5.866-.91-.525A2.5 2.5 0 0 1 12 13.95V15h-1v-1.05a2.5 2.5 0 0 1-1.371-.792l-.91.525-.5-.866.91-.525a2.5 2.5 0 0 1 0-1.584l-.91-.525.5-.866zm.571.908a1.5 1.5 0 1 1 2.598 1.498A1.5 1.5 0 0 1 10.2 10.75",
          clipRule: "evenodd"
        }
      )
    ]
  }
), WZ = /* @__PURE__ */ t.forwardRef(ZZ), GZ = WZ, NZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.5 3a3.5 3.5 0 1 0 0 7h1.6l-.269 1H5v1h6v-1h-.83l-.268-1H11.5a3.5 3.5 0 1 0 0-7zm2.366 8 .268-1h1.732l.268 1zM3 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m9-.5h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), UZ = /* @__PURE__ */ t.forwardRef(NZ), YZ = UZ, QZ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zm4.352 1.111V4H8c.91 0 1.647.737 1.647 1.647 0 .254-.11.54-.247.804a5 5 0 0 1-.196.345c.115-.07.23-.138.345-.196.264-.136.55-.247.804-.247H12V8c0 .91-.737 1.647-1.647 1.647-.254 0-.54-.11-.804-.247a5 5 0 0 1-.345-.196c.07.115.138.23.196.345.136.264.247.55.247.804V12H8c-.91 0-1.647-.737-1.647-1.647 0-.254.11-.54.247-.804a5 5 0 0 1 .196-.345 5 5 0 0 1-.345.196c-.264.136-.55.247-.804.247H4V8c0-.91.737-1.647 1.647-1.647.254 0 .54.11.804.247q.173.088.345.196A5 5 0 0 1 6.6 6.45c-.136-.264-.247-.55-.247-.804Z",
        clipRule: "evenodd"
      }
    )
  }
), KZ = /* @__PURE__ */ t.forwardRef(QZ), XZ = KZ, JZ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.707.708L13.293 14H2V9h5.5v-.793l-1.85-1.85-.248.144a3 3 0 0 1-.288-.68L4.01 4.717A4 4 0 0 0 4.535 7l-.865.501a5 5 0 0 1-.535-3.659L1.646 2.354zM8 12v-1H7v1zm1-1h1v1H9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 9v2.172L11.829 9zM9 5c0 .32-.15.605-.384.788L7.212 4.384A1 1 0 0 1 9 5m3 0a4 4 0 0 0-.535-2l.866-.5c.426.735.669 1.59.669 2.5a5 5 0 0 1-.67 2.501l-.865-.5A4 4 0 0 0 12 5m-2 0a2 2 0 0 0-.267-1l.865-.5c.256.441.402.955.402 1.5a3 3 0 0 1-.402 1.5L9.733 6A2 2 0 0 0 10 5"
        }
      )
    ]
  }
), eW = /* @__PURE__ */ t.forwardRef(JZ), lW = eW, oW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 5c0-.73.195-1.412.535-2l-.866-.5A5 5 0 0 0 3 5c0 .91.244 1.765.67 2.5l.865-.5A4 4 0 0 1 4 5m7.465-2c.34.588.535 1.27.535 2a4 4 0 0 1-.535 2l.866.5A5 5 0 0 0 13 5a5 5 0 0 0-.67-2.5zM6.267 4C6.097 4.294 6 4.635 6 5s.097.706.267 1l-.865.5A3 3 0 0 1 5 5c0-.546.146-1.059.402-1.5zm3.466 0c.17.294.267.635.267 1s-.097.706-.267 1l.865.5A3 3 0 0 0 11 5a3 3 0 0 0-.402-1.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 5a1 1 0 1 1 1.5.866V9H14v5H2V9h5.5V5.866A1 1 0 0 1 7 5m1 7v-1H7v1zm1-1h1v1H9zm3 0h-1v1h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), nW = /* @__PURE__ */ t.forwardRef(oW), iW = nW, rW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2.354 1.646 12 12-.707.708L12 12.707V14H4V4.707L1.646 2.354zM7.293 8H6v1h2.293zM12 2v7.172L9.828 7H10V6H8.828l-4-4zm-2 2H9v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), tW = /* @__PURE__ */ t.forwardRef(rW), aW = tW, sW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.354 1.646 13 13-.708.708L13.293 14H10v-1h2v-.293l-1-1V12H6.902l.268 1H9v1H3v-1h1.831l.268-1H1V5h3.293L1.646 2.354zM6 12.5l-.134.5h.268zM15 2v10.172l-3-3V9h2V8h-2V7h2V6h-2V4H7V2zm-2 2h1v1h-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 5v3.172L7.828 5z" })
    ]
  }
), dW = /* @__PURE__ */ t.forwardRef(sW), cW = dW, hW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 2h8v12h-5v-1h2V9h2V8h-2V7h2V6h-2V4H7zm6 2h1v1h-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 5h10v7H6.902l.268 1H9v1H3v-1h1.831l.268-1H1zm5 7.5-.134.5h.268z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), wW = /* @__PURE__ */ t.forwardRef(hW), vW = wW, fW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2h8v12H4zm6 4H6v1h4zM6 8h4v1H6zm4-4H9v1h1z",
        clipRule: "evenodd"
      }
    )
  }
), mW = /* @__PURE__ */ t.forwardRef(fW), pW = mW, gW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 11.207 4.792 9H4.75a2 2 0 0 0-1.46.613c-.33.328-.578.752-.787 1.112l-.016.027c-.39.671-.675 1.117-1.145 1.274l-.547.182.258.516c.335.67.956 1.026 1.59 1.193.631.167 1.327.163 1.927.078C5.896 13.808 7 12.794 7 11.25zm.146-3.854L5.853 8.646l1.5 1.5 1.293-1.293zm.707-.707 1.5 1.5L13.75 3.75l-1.5-1.5z"
      }
    )
  }
), uW = /* @__PURE__ */ t.forwardRef(gW), xW = uW, RW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.847 4.14 5.792 8.078l.966.259L8.357 2.37l.966.258-.843 3.144 3.02 3.02v.689l-1.741.466-3.259 3.26L1.793 8.5 6.5 3.793z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.584 10.848c-.267.4-.584 1.002-.584 1.652a1.5 1.5 0 0 0 3 0c0-.65-.317-1.252-.584-1.652a6.3 6.3 0 0 0-.916-1.055c-.34.322-.656.665-.916 1.055",
          clipRule: "evenodd"
        }
      )
    ]
  }
), jW = /* @__PURE__ */ t.forwardRef(RW), MW = jW, HW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v5h-3.17a3 3 0 1 0-5.66 0H3v3h1v1H2V4h3.191z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 8c0 .364-.097.706-.268 1H6.268A2 2 0 1 1 10 8m-6 2v1h2v1H5v1h1v1H4v1h2a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 10a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9v-1h1v.01h1V10zm0 4v-1h1v1zm4-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm0 1h1v3h-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), CW = /* @__PURE__ */ t.forwardRef(HW), yW = CW, bW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 4a3 3 0 0 0-3-3V0a4 4 0 0 1 4 4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 4a1 1 0 0 0-1-1V2a2 2 0 0 1 2 2zM6 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.191 3h3.618l1 2H14v9H2V5h3.191zM8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
          clipRule: "evenodd"
        }
      )
    ]
  }
), VW = /* @__PURE__ */ t.forwardRef(bW), LW = VW, zW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.191 2h3.618l1 2H14v5h-3v4H2V4h3.191zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v1h-1v-.01h-1V15h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-1h1v.01h1V10z"
        }
      )
    ]
  }
), SW = /* @__PURE__ */ t.forwardRef(zW), kW = SW, FW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.773 4.455a1.318 1.318 0 1 0 0 2.636 1.318 1.318 0 0 0 0-2.636"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2H2v10h10zM3 7.211V3h8v5.54L8.65 7.183 5.8 8.828z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 4v9H4v1h10V4z" })
    ]
  }
), $W = /* @__PURE__ */ t.forwardRef(FW), BW = $W, AW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4V2h1v9h9v1h-2v2h-1v-2H4V5H2V4zm7 1H6V4h6v6h-1z",
        clipRule: "evenodd"
      }
    )
  }
), EW = /* @__PURE__ */ t.forwardRef(AW), _W = EW, OW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1 8a7 7 0 0 1 7-7v14a7 7 0 0 1-7-7m9-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      }
    )
  }
), DW = /* @__PURE__ */ t.forwardRef(OW), PW = DW, TW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 5H4v4h8z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 2h1.5V1h1v1H10v1h4v8h-2v1h-1.653l.636 2.37-.966.26L9.312 12H6.687l-.704 2.63-.966-.26.635-2.37H4v-1H2V3h4zm-3 8V4h10v6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), qW = /* @__PURE__ */ t.forwardRef(TW), IW = qW, ZW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2.293 14.207 6.5l-3 3L7 5.293zM6.293 6l-4 4 3 3h2.414l2.793-2.793zM14 13h-4v-1h4z"
      }
    )
  }
), WW = /* @__PURE__ */ t.forwardRef(ZW), GW = WW, NW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.589 10.204 8.543 5.25l-.897-.896.708-.708.646.647 1.146-1.147a1.914 1.914 0 1 1 2.707 2.708L11.707 7l.646.646-.707.708-.896-.897-4.954 4.954-2.395 1.197-1.01-1.01zM9.25 5.957l.793.793-4.84 4.84-1.585.792.793-1.586z",
        clipRule: "evenodd"
      }
    )
  }
), UW = /* @__PURE__ */ t.forwardRef(NW), YW = UW, QW = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 1H1v4h1V2h3zm6 1h3v3h1V1h-4zM5 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-6 2v3h3v1H1v-4zm9 3v1h4v-4h-1v3z"
      }
    )
  }
), KW = /* @__PURE__ */ t.forwardRef(QW), XW = KW, JW = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.354 3.354 8 5.707 5.646 3.354l.708-.708L7.5 3.793V1h1v2.793l1.146-1.147z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0"
        }
      )
    ]
  }
), eG = /* @__PURE__ */ t.forwardRef(JW), lG = eG, oG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2q-.297 0-.588.028l.097.996a5 5 0 0 1 .982 0l.097-.996A6 6 0 0 0 8 2m2.83.708a6 6 0 0 0-1.088-.451l-.29.957q.475.145.905.375zm-4.572-.451q-.571.174-1.087.45l.472.882q.43-.231.905-.375zm6.38 1.936a6 6 0 0 0-.831-.831l-.635.773q.38.313.693.693zm-8.445-.831q-.456.376-.831.831l.773.635q.313-.38.693-.693zm9.55 2.896a6 6 0 0 0-.45-1.087l-.882.472q.231.43.375.905zM2.708 5.17a6 6 0 0 0-.451 1.088l.957.29q.145-.475.375-.905zM14 8q0-.297-.028-.588l-.996.097a5 5 0 0 1 0 .982l.995.097q.03-.291.029-.588M2.028 7.412a6 6 0 0 0 0 1.176l.996-.097a5 5 0 0 1 0-.982zm.229 2.33q.174.571.45 1.087l.882-.472a5 5 0 0 1-.375-.905zm11.035 1.088q.277-.517.451-1.088l-.957-.29a5 5 0 0 1-.375.905zm-9.93.977q.376.456.831.831l.635-.773a5 5 0 0 1-.693-.693zm8.445.831q.456-.376.831-.831l-.773-.635a5 5 0 0 1-.693.693zm-6.637.654a6 6 0 0 0 1.088.451l.29-.957a5 5 0 0 1-.905-.375l-.472.881Zm4.572.451q.571-.174 1.087-.45l-.472-.882q-.43.231-.905.375zM8 14q.297 0 .588-.028l-.097-.996a5 5 0 0 1-.982 0l-.097.995q.291.03.588.029m0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
      }
    )
  }
), nG = /* @__PURE__ */ t.forwardRef(oG), iG = nG, rG = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 4q-.265 0-.522.034l.13.991a3 3 0 0 1 .784 0l.13-.991A4 4 0 0 0 8 4m2.435.827a4 4 0 0 0-.904-.523l-.383.923q.367.153.678.393zm-3.966-.523a4 4 0 0 0-.904.523l.609.793q.311-.24.678-.393zM4.827 5.565a4 4 0 0 0-.523.904l.923.383q.153-.367.393-.678l-.793-.61Zm6.869.904a4 4 0 0 0-.523-.904l-.793.609q.24.311.393.678zM12 8q0-.265-.034-.522l-.991.13a3 3 0 0 1 0 .784l.991.13Q12.001 8.265 12 8m-7.966-.522a4 4 0 0 0 0 1.044l.991-.13a3 3 0 0 1 0-.784zm7.139 2.957q.32-.414.523-.904l-.923-.383a3 3 0 0 1-.393.678zm-6.869-.904q.204.491.523.904l.793-.609a3 3 0 0 1-.393-.678zm1.261 1.642q.414.32.904.523l.383-.923a3 3 0 0 1-.678-.393l-.61.793Zm3.966.523a4 4 0 0 0 .904-.523l-.609-.793a3 3 0 0 1-.678.393zM8 12q.265 0 .522-.034l-.13-.991a3 3 0 0 1-.784 0l-.13.991Q7.734 12 8 12"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 1h14v14H1zm12 7A5 5 0 1 1 3 8a5 5 0 0 1 10 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tG = /* @__PURE__ */ t.forwardRef(rG), aG = tG, sG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 14h1V2h-1zm-.793-6L2 3.293v9.414zm2.586 0L14 12.707V3.293z"
      }
    )
  }
), dG = /* @__PURE__ */ t.forwardRef(sG), cG = dG, hG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 2H2v7h7zm2.354 8.146-.708.707L11.793 12H2v1h9.793l-1.147 1.146.708.707 2.353-2.353zM10 3h1V2h-1zm2 0h1v1h1V2h-2zm1 2v1h1V5zm0 2v1h-1v1h2V7zm-2 1h-1v1h1z"
      }
    )
  }
), wG = /* @__PURE__ */ t.forwardRef(hG), vG = wG, fG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8c0-3.35 3.213-6 7-6 1.877 0 3.62.499 4.905 1.511C14.206 4.534 15 6.054 15 8c0 1.451-.77 2.457-1.851 2.88-1.055.413-2.35.253-3.426-.464-.92-.613-1.473-.653-1.972-.493a.77.77 0 0 0-.49.464c-.074.205-.073.494.155.836.341.511.521 1.019.49 1.488a1.34 1.34 0 0 1-.705 1.114c-.76.423-1.897.24-2.958-.396-1.245-.747-2.069-1.555-2.575-2.474S1 9.052 1 8m7-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
        clipRule: "evenodd"
      }
    )
  }
), mG = /* @__PURE__ */ t.forwardRef(fG), pG = mG, gG = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "currentColor", clipPath: "url(#image-scale-relative-off_svg__a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "m1.354.646 14 14-.707.708-1.854-1.854H10v-1H9v1H1v-6h1v-1H1V3h1.293L.646 1.354zM5.793 6.5H5v1h1v-.793zm4 4H9v1h1v-.793zM3 7.5h1v-1H3z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M15 3v9.172L5.828 3z" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "image-scale-relative-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), uG = /* @__PURE__ */ t.forwardRef(gG), xG = uG, RG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 3H1v3.5h1v1H1v6h8v-1h1v1h5zM3 7.5h1v-1H3zm2 0h1v-1H5zm3 0H7v-1h1zm1 1v1h1v-1zm0 3v-1h1v1zm0-4h1v-1H9z",
        clipRule: "evenodd"
      }
    )
  }
), jG = /* @__PURE__ */ t.forwardRef(RG), MG = jG, HG = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 8H2v6h6z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 2H2v4h1V3h10v10h-3v1h4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.294 5 8.646 6.645l.707.708 1.65-1.648V7h1V4H9v1z"
        }
      )
    ]
  }
), CG = /* @__PURE__ */ t.forwardRef(HG), yG = CG, bG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.024 3.095a5 5 0 0 0-1.802.748l-.555-.832a6 6 0 0 1 2.162-.897l.195.98Zm3.755.747a5 5 0 0 0-1.803-.746l.195-.98a6 6 0 0 1 2.163.894zm-6.937 1.38a5 5 0 0 0-.746 1.802l-.98-.195a6 6 0 0 1 .894-2.163l.832.555Zm9.063 1.802a5 5 0 0 0-.748-1.802l.832-.555c.451.675.748 1.41.897 2.162l-.98.195Zm-.747 3.755c.367-.55.619-1.164.746-1.804l.98.195a6 6 0 0 1-.894 2.164zM3.095 8.976c.124.625.37 1.237.748 1.802l-.832.555a6 6 0 0 1-.897-2.162zm5.88 3.93a5 5 0 0 0 1.803-.749l.555.832a6 6 0 0 1-2.162.897l-.195-.98Zm-3.754-.748c.55.368 1.164.619 1.804.746l-.195.98a6 6 0 0 1-2.164-.894z",
        clipRule: "evenodd"
      }
    )
  }
), VG = /* @__PURE__ */ t.forwardRef(bG), LG = VG, zG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM2 9.5v-3h1v3zM2 12h1v1h1v1H2zm7.5 2h-3v-1h3zM12 2h2.207l-1.853 1.854-.708-.708.354-.353zM9.146 5.646l1.5-1.5.708.708-1.5 1.5zm-1 1 .708.708L8.207 8l.647.646-.708.708L6.793 8zm2.5 5.208-1.5-1.5.708-.708 1.5 1.5zM12 13.207l-.354-.353.708-.708L14.207 14H12z",
        clipRule: "evenodd"
      }
    )
  }
), SG = /* @__PURE__ */ t.forwardRef(zG), kG = SG, FG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM12 2h2v2h-1V3h-1zM2 9.5v-3h1v3zm12-3v3h-1v-3zM2 12h1v1h1v1H2zm12 0v2h-2v-1h1v-1zm-4.5 2h-3v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), $G = /* @__PURE__ */ t.forwardRef(FG), BG = $G, AG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.362 7 4.5 1.992 1.638 7zM14 2h-3v1h1.293L9.646 5.646l.708.708L13 3.707V5h1zM4.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M14 9H9v5h5z"
      }
    )
  }
), EG = /* @__PURE__ */ t.forwardRef(AG), _G = EG, OG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 2v2h1V2zM3.404 4.11l1.414 1.415.707-.707-1.414-1.414-.707.707Zm7.071.708.707.707 1.414-1.414-.707-.707zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 8.5h2v-1H2zm10 0h2v-1h-2zm-8.596 3.39.707.706 1.414-1.414-.707-.707-1.414 1.414Zm7.071-.708 1.414 1.414.707-.707-1.414-1.414zM8.5 14v-2h-1v2z"
      }
    )
  }
), DG = /* @__PURE__ */ t.forwardRef(OG), PG = DG, TG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 3v1h1V3zM4.11 4.818l.708.707.707-.707-.707-.707-.707.707Zm7.072-.708-.707.708.707.707.707-.707zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 8.5h1v-1H3zm9 0h1v-1h-1zm-7.182 1.975-.707.707.707.707.707-.707zm5.657.707.707.707.707-.707-.707-.707zM8.5 13v-1h-1v1z"
      }
    )
  }
), qG = /* @__PURE__ */ t.forwardRef(TG), IG = qG, ZG = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-3.909-3.908a3 3 0 0 1-4.184-4.184L1.647 2.355l.708-.708ZM11 8q0 .084-.005.167L7.833 5.005A3 3 0 0 1 11 8M7.5 4V2h1v2zm2.975.818.707.707 1.414-1.414-.707-.707zM2 8.5h2v-1H2zm12 0h-2v-1h2zM3.404 11.89l.707.706 1.414-1.414-.707-.707-1.414 1.414Z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8.5 14v-2h-1v2z" })
    ]
  }
), WG = /* @__PURE__ */ t.forwardRef(ZG), GG = WG, NG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1h-.5v14H8A7 7 0 1 0 8 1M4.143 3.404A6 6 0 0 1 5.947 2.36l-.342-.94A7 7 0 0 0 3.5 2.639zM2.09 6.957A6 6 0 0 1 2.803 5l-.866-.5a7 7 0 0 0-.832 2.285zM2.803 11a6 6 0 0 1-.713-1.957l-.985.172c.144.82.43 1.59.832 2.286zm3.144 2.64a6 6 0 0 1-1.804-1.044l-.643.766c.62.52 1.33.935 2.105 1.217z"
      }
    )
  }
), UG = /* @__PURE__ */ t.forwardRef(NG), YG = UG, QG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 2v4H4.384l-.268-1H1.179l.804 3-.804 3h2.937l.268-1H7v4h2.384l1.072-4H13a2 2 0 1 0 0-4h-2.544L9.384 2z"
      }
    )
  }
), KG = /* @__PURE__ */ t.forwardRef(QG), XG = KG, JG = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.348 2H5.652l-.536 2H2v9h12V4h-3.116zm-.5 2L9.58 3H6.42l-.268 1z",
        clipRule: "evenodd"
      }
    )
  }
), eN = /* @__PURE__ */ t.forwardRef(JG), lN = eN, oN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.5 3c-.348 0-.62.2-.807.399a3.1 3.1 0 0 0-.507.783c-.292.608-.532 1.421-.682 2.296a11.3 11.3 0 0 0-.144 2.757c.048.61.159 1.216.357 1.765H8.732a2 2 0 0 0-.837-2.789 3.001 3.001 0 0 0-5.26-1.057A2.5 2.5 0 0 0 3.5 12h10.283l.146-.243c.43-.716.64-1.613.711-2.522a11.3 11.3 0 0 0-.144-2.757c-.15-.875-.39-1.688-.682-2.296a3.1 3.1 0 0 0-.508-.783C13.12 3.199 12.848 3 12.5 3"
      }
    )
  }
), nN = /* @__PURE__ */ t.forwardRef(oN), iN = nN, rN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 2h7v3h6v9H5.5v-2h-2v2H1zm3 2H3v1h1zm5 3h1v1H9zM6 4H5v1h1zm5 3h1v1h-1zM4 6H3v1h1zm5 3h1v1H9zM4 8H3v1h1zm1-2h1v1H5zm7 3h-1v1h1zM5 8h1v1H5zm7 3h-1v1h1zm-3 0h1v1H9z",
        clipRule: "evenodd"
      }
    )
  }
), tN = /* @__PURE__ */ t.forwardRef(rN), aN = tN, sN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m4.646 2.354 1 1 .708-.708-1-1zM11.5 3.559l-1.099.55L9.293 3 10.4 1.892l1.1.549zm-6 3-1.099.55L3.293 6 4.4 4.892l1.1.549zM14 5.96l-1.032-1.032-1.53.51-.51 1.53 1.085 1.086L14 7.557zm-7 6-1.032-1.032-1.53.51-.51 1.53 1.085 1.086L7 13.557zm.5-2.401V8.441l-1.099-.55L5.293 9 6.4 10.108zm4 2-1.099.55L9.293 11 10.4 9.892l1.1.549zM7.646 7.354l.708-.708 1 1-.708.708zm2 1 1 1 .708-.708-1-1zm-5.5 1-1-1 .708-.708 1 1zm1.5-5 1 1 .708-.708-1-1zm3.5.5-1-1 .708-.708 1 1zm-3 1.5 1 1 .708-.708-1-1zm1.5 7 .708-.707 1 1-.708.707zm-1-2.5 1 1 .708-.707-1-1zm1.5 1 .708-.707 1 1-.708.707zm-5.5-3.208-1 1 .708.707 1-1zm-1-1 1-1 .708.708-1 1zm6-5.5-1 1 .708.708 1-1zm0 3.5 1-1 .708.708-1 1zm3-1-1 1 .708.708 1-1zm-6 3 1-1 .708.708-1 1zm4.5 1-1 1 .708.707 1-1zm2.5 1 1-1 .708.708-1 1zm-6.292.708-.708-.708-1 1 .708.707z"
      }
    )
  }
), dN = /* @__PURE__ */ t.forwardRef(sN), cN = dN, hN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 15H15V1H8.5zm1.854-7.354.646.647V6h1v2.293l.646-.647.708.708-1.854 1.853-1.854-1.853zM7.5 1H1v14h6.5zM4 7.707l-.646.647-.708-.708L4.5 5.793l1.854 1.853-.708.708L5 7.707V10H4z",
        clipRule: "evenodd"
      }
    )
  }
), wN = /* @__PURE__ */ t.forwardRef(hN), vN = wN, fN = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m.707 3.5H4.793L4 5.293v4.086l3-3V5.293z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 4h-4.207l-7 7H1v4h4.207l7-7H15z" })
    ]
  }
), mN = /* @__PURE__ */ t.forwardRef(fN), pN = mN, gN = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 2h-3v5H8V5H5.92l-.536 2H5V5H2.92l-.536 2H1v7h7v-4h4v4h3V7h-2zM3 9h1v1H3zm3 0H5v1h1zm-3 2h1v1H3zm3 0H5v1h1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 11H9v1h2z" })
    ]
  }
), uN = /* @__PURE__ */ t.forwardRef(gN), xN = uN, RN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 2H3v12h1v-4h4.616l.536 2H14V5H9.92l-.536-2H4z"
      }
    )
  }
), jN = /* @__PURE__ */ t.forwardRef(RN), MN = jN, HN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 4a2 2 0 1 1 4 0c0 .183-.043.396-.096.598l-.058.204q.076-.08.148-.151a2.5 2.5 0 0 1 .47-.383 2 2 0 1 1 2 3.464c-.159.092-.365.16-.567.216L11.691 8q.107.025.206.052c.202.055.408.124.567.216a2 2 0 0 1-2 3.464 2.5 2.5 0 0 1-.47-.383l-.148-.152q.031.105.058.205c.053.202.096.415.096.598a2 2 0 1 1-4 0c0-.183.044-.396.097-.598l.057-.204q-.075.08-.148.151a2.5 2.5 0 0 1-.47.383 2 2 0 0 1-2-3.464c.159-.092.365-.16.567-.216L4.309 8l-.206-.052a2.5 2.5 0 0 1-.567-.216 2 2 0 1 1 2-3.464c.159.091.322.236.47.383a4 4 0 0 1 .148.152l-.057-.205A2.5 2.5 0 0 1 6 4m2 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
        clipRule: "evenodd"
      }
    )
  }
), CN = /* @__PURE__ */ t.forwardRef(HN), yN = CN, bN = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a4.5 4.5 0 0 0-4.486 4.14 3.5 3.5 0 0 0-2.441 2.646l-.154.74 3.833-.767a3.5 3.5 0 0 1 2.252.302l1.545.772a4.5 4.5 0 0 0 2.895.388L15 8.51v-.76a4.25 4.25 0 0 0-2.86-4.018A4.5 4.5 0 0 0 8 1m-.996 11.561a3.5 3.5 0 0 0-2.252-.302l-3.654.731-.196-.98 3.654-.731a4.5 4.5 0 0 1 2.895.387l1.545.773a3.5 3.5 0 0 0 2.252.302l3.654-.731.196.98-3.654.731a4.5 4.5 0 0 1-2.895-.388z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.752 10.26a3.5 3.5 0 0 1 2.252.301l1.545.772a4.5 4.5 0 0 0 2.895.388l3.654-.73-.196-.981-3.654.73a3.5 3.5 0 0 1-2.252-.301l-1.545-.772a4.5 4.5 0 0 0-2.895-.388l-3.654.73.196.981z"
        }
      )
    ]
  }
), VN = /* @__PURE__ */ t.forwardRef(bN), LN = VN, zN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.97 10.108c.113-.311.223-.513.296-.63l.094-.131-.714-.7s-.159.192-.225.297c-.114.18-.254.447-.39.823-.248.68-.482 1.713-.524 3.233h-1.04c-.13-.978-.619-1.783-1.08-2.348a6.6 6.6 0 0 0-.744-.774c-.114-.1-.23-.198-.354-.286l-.576.817a5.6 5.6 0 0 1 .9.874c.373.459.72 1.045.842 1.717H5.439c-.174-.706-.681-1.276-1.106-1.655a6.5 6.5 0 0 0-.746-.572c-.113-.074-.346-.211-.346-.211s-.421.8-.464.886a5.5 5.5 0 0 1 .89.642c.314.281.575.592.717.91H2v1h12v-1h-2.455c.121-.672.47-1.258.843-1.717.229-.28.458-.503.63-.654.087-.077.27-.22.27-.22l-.577-.817s-.24.186-.354.286a6.6 6.6 0 0 0-.745.774c-.46.565-.95 1.37-1.079 2.348H9.507c.042-1.415.26-2.332.463-2.892"
      }
    )
  }
), SN = /* @__PURE__ */ t.forwardRef(zN), kN = SN, FN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m7.646 1.646-1 1 .708.708 1-1zM11.191 2h1.618l.8 1.599L12 5.207 10.392 3.6 11.19 2ZM5.635 3.928 7 5.293V7.39l-2.653.664-1.419-1.419.677-2.03zM10.793 8 9.428 9.365l.677 2.03 2.03.677 1.419-1.419L12.89 8zm-4.892.892 1.6.799v1.618l-1.6.8L4.293 10.5zm2.745-.538-1-1 .708-.708 1 1zm-1 5 1 1 .708-.707-1-1zm-6-3.708 1-1 .708.708-1 1zm8-5.5-1 1 .708.708 1-1z"
      }
    )
  }
), $N = /* @__PURE__ */ t.forwardRef(FN), BN = $N, AN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.588 6.06a1.5 1.5 0 0 0-2.231-.124l-1.15 1.15.06.06L11.122 11h3.42l-3.953-4.94Zm-4.09 1.735q.032.028.063.059L9.707 11H1.293l3.146-3.146a1.5 1.5 0 0 1 2.06-.06Z"
      }
    )
  }
), EN = /* @__PURE__ */ t.forwardRef(AN), _N = EN, ON = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708-2.638-2.638q-.184.25-.367.482a19 19 0 0 1-1.59 1.76c-.338.333-.689.64-1.052.944-.117-.098-.209-.117-1.053-.943a19 19 0 0 1-1.589-1.761C4.217 10.756 3 8.742 3 6.648c0-.8.247-1.58.677-2.264l-2.03-2.03zM13 6.647c0 .985-.27 1.953-.673 2.851L5.493 2.664A5.1 5.1 0 0 1 8 2c2.736 0 5 2.227 5 4.647"
      }
    )
  }
), DN = /* @__PURE__ */ t.forwardRef(ON), PN = DN, TN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.358 12.198a19 19 0 0 0 1.59 1.76c.68.668.872.809.982.89l.07.054c.363-.304.714-.61 1.053-.943a19 19 0 0 0 1.589-1.761C11.783 10.756 13 8.742 13 6.648 13 4.227 10.736 2 8 2S3 4.227 3 6.647c0 2.095 1.217 4.11 2.358 5.55ZM8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
        clipRule: "evenodd"
      }
    )
  }
), qN = /* @__PURE__ */ t.forwardRef(TN), IN = qN, ZN = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#maps-map-off_svg__a)", children: /* @__PURE__ */ l.jsx("path", { d: "m1.354.646 14 14-.707.708-2.227-2.227-1.92.72v-2.64l-1-1v3.683l-3-.75V7.207l-1-1v6.933l-4 1V3.11l.722-.18L.646 1.353l.708-.708ZM14.5 1.779v9.893l-4-4V3.279zm-5 1.5v3.393l-3-3V2.154z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "maps-map-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), WN = /* @__PURE__ */ t.forwardRef(ZN), GN = WN, NN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m9.5 3.279-3-1.125V13.14l3 .75zm1 10.568 4-1.5V1.777l-4 1.5zM1.5 3.11l4-1v11.03l-4 1z"
      }
    )
  }
), UN = /* @__PURE__ */ t.forwardRef(NN), YN = UN, QN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.456 14.842 14H1.158zm.326 5.011 1.385.214L8 3.544 6.325 6.616l1.111.74z",
        clipRule: "evenodd"
      }
    )
  }
), KN = /* @__PURE__ */ t.forwardRef(QN), XN = KN, JN = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m8 2.382.447.894c.13.258.312.539.519.856q.178.271.37.58c.166.269.327.552.449.83.118.274.215.58.215.887a2 2 0 1 1-4 0c0-.307.097-.613.216-.886.12-.279.283-.562.448-.83q.193-.31.37-.58c.207-.318.39-.599.519-.857zm-.69 10.801c.113.191.19.452.19.817h1c0-.365.078-.626.19-.817q.166-.283.486-.454c.443-.24 1.084-.322 1.803-.292.707.03 1.423.163 1.969.292a13 13 0 0 1 .835.227l.046.014.01.004h.003L14 12.5c.158-.474.158-.475.157-.475l-.005-.001-.015-.005-.055-.018a14 14 0 0 0-.905-.246 12 12 0 0 0-2.156-.317c-.514-.022-1.063.004-1.572.129.255-.28.542-.516.834-.717a6.5 6.5 0 0 1 1.807-.856l.026-.008.006-.001L12 9.5l-.122-.485h-.002l-.003.001-.012.004a4 4 0 0 0-.182.053 7.5 7.5 0 0 0-1.962.953c-.632.434-1.285 1.047-1.717 1.877-.432-.83-1.084-1.443-1.717-1.878A7.5 7.5 0 0 0 4.14 9.02l-.012-.004h-.005L4 9.5l-.121.485.005.001.027.008.112.033a6.5 6.5 0 0 1 1.694.822c.292.202.58.439.834.718-.51-.125-1.058-.15-1.572-.13a12 12 0 0 0-2.156.319 14 14 0 0 0-.905.245l-.055.018-.015.005-.004.001h-.002L2 12.5l.155.463.003.011h.003l.01-.004.046-.014.18-.055c.158-.046.384-.108.655-.172a11 11 0 0 1 1.969-.292c.72-.03 1.36.052 1.803.292q.32.17.487.454Z"
      }
    )
  }
), eU = /* @__PURE__ */ t.forwardRef(JN), lU = eU, oU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1.5 5c0 .694.357 1.214.848 1.541C2.823 6.858 3.426 7 4 7s1.177-.142 1.652-.459q.19-.125.348-.29.158.165.348.29C6.823 6.858 7.426 7 8 7s1.177-.142 1.652-.459q.19-.125.348-.29.158.165.348.29C10.823 6.858 11.426 7 12 7s1.177-.142 1.652-.459c.49-.327.848-.847.848-1.541h-1c0 .306-.143.536-.402.709C12.823 5.892 12.426 6 12 6s-.823-.108-1.098-.291c-.26-.173-.402-.403-.402-.709h-1c0 .306-.143.536-.402.709C8.823 5.892 8.426 6 8 6s-.823-.108-1.098-.291C6.642 5.536 6.5 5.306 6.5 5h-1c0 .306-.143.536-.402.709C4.823 5.892 4.426 6 4 6s-.823-.108-1.098-.291C2.642 5.536 2.5 5.306 2.5 5zm0 4c0 .694.357 1.214.848 1.541C2.823 10.858 3.426 11 4 11s1.177-.142 1.652-.459q.19-.125.348-.29.158.165.348.29C6.823 10.858 7.426 11 8 11s1.177-.142 1.652-.459q.19-.125.348-.29.158.165.348.29c.475.317 1.078.459 1.652.459s1.177-.142 1.652-.459c.49-.327.848-.847.848-1.541h-1c0 .306-.143.536-.402.709-.275.183-.672.291-1.098.291s-.823-.108-1.098-.291c-.26-.173-.402-.403-.402-.709h-1c0 .306-.143.536-.402.709C8.823 9.892 8.426 10 8 10s-.823-.108-1.098-.291C6.642 9.536 6.5 9.306 6.5 9h-1c0 .306-.143.536-.402.709C4.823 9.892 4.426 10 4 10s-.823-.108-1.098-.291C2.642 9.536 2.5 9.306 2.5 9z"
      }
    )
  }
), nU = /* @__PURE__ */ t.forwardRef(oU), iU = nU, rU = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.485 4.248 10.6 1.94 7.087 3.11l-1.15 4.288 2.373.791 2.69 2.69v3.642l3.018-1.743z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.461 7.96 7.77 9.063l2.23 2.23v2.475l-1.874 1.249-4.856-.54-1.806-1.805.585-3.505L4.46 7.96Z"
        }
      )
    ]
  }
), tU = /* @__PURE__ */ t.forwardRef(rU), aU = tU, sU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 9V2h-1v5h-.5a.5.5 0 0 1-.5-.5V4H9v2.5A1.5 1.5 0 0 0 10.5 8h.5v3.164q-.528.045-1.033.096L6.5 7.793l-5.354 5.353.525.824.007-.003.025-.008.105-.037a31 31 0 0 1 2.052-.59 44.5 44.5 0 0 1 5.977-1.052A48 48 0 0 1 15 12v-1c-1.044 0-2.046.034-3 .092V10h.5A1.5 1.5 0 0 0 14 8.5V6h-1v2.5a.5.5 0 0 1-.5.5z"
      }
    )
  }
), dU = /* @__PURE__ */ t.forwardRef(sU), cU = dU, hU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.348 4.541C1.858 4.214 1.5 3.694 1.5 3h1c0 .306.143.536.402.709C3.177 3.892 3.574 4 4 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 3.892 7.574 4 8 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 4.858 12.574 5 12 5s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 4.858 8.574 5 8 5s-1.177-.142-1.652-.459A2 2 0 0 1 6 4.251q-.158.165-.348.29C5.177 4.858 4.574 5 4 5s-1.177-.142-1.652-.459m0 4C1.858 8.214 1.5 7.694 1.5 7h1c0 .306.143.536.402.709C3.177 7.892 3.574 8 4 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 7.892 7.574 8 8 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 8.858 12.574 9 12 9s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.165-.348.29C9.177 8.858 8.574 9 8 9s-1.177-.142-1.652-.459A2 2 0 0 1 6 8.251q-.158.165-.348.29C5.177 8.858 4.574 9 4 9s-1.177-.142-1.652-.459M1.5 11c0 .694.357 1.214.848 1.541C2.823 12.858 3.426 13 4 13s1.177-.142 1.652-.459q.19-.126.348-.29.158.164.348.29C6.823 12.858 7.426 13 8 13s1.177-.142 1.652-.459q.19-.126.348-.29.158.164.348.29c.475.317 1.078.459 1.652.459s1.177-.142 1.652-.459c.49-.327.848-.847.848-1.541h-1c0 .306-.143.536-.402.709-.275.183-.672.291-1.098.291s-.823-.108-1.098-.291c-.26-.173-.402-.403-.402-.709h-1c0 .306-.143.536-.402.709C8.823 11.892 8.426 12 8 12s-.823-.108-1.098-.291c-.26-.173-.402-.403-.402-.709h-1c0 .306-.143.536-.402.709C4.823 11.892 4.426 12 4 12s-.823-.108-1.098-.291c-.26-.173-.402-.403-.402-.709z"
      }
    )
  }
), wU = /* @__PURE__ */ t.forwardRef(hU), vU = wU, fU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 4V2H7v2H3v5h4v5h1V9h3.707l2.5-2.5-2.5-2.5z"
      }
    )
  }
), mU = /* @__PURE__ */ t.forwardRef(fU), pU = mU, gU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.82 2.23a1.8 1.8 0 0 0-1.422-.023c-.696.271-1.29.93-1.615 1.889l.948.32c.253-.748.672-1.138 1.03-1.278.349-.136.67-.059.89.19l.664.749.2-.98c.067-.326.306-.554.676-.61.38-.058.938.07 1.532.592l.66-.751c-.76-.669-1.605-.942-2.343-.83a1.8 1.8 0 0 0-1.22.732M5 12a3 3 0 1 1 5.83 1H14v1H2v-1h3.17c-.11-.313-.17-.65-.17-1m4.96-7.502a1.8 1.8 0 0 1 1.22.732c.44-.203.947-.21 1.423-.024.696.272 1.29.93 1.614 1.89l-.947.32c-.253-.748-.672-1.138-1.031-1.278-.348-.136-.669-.059-.89.19l-.663.749-.2-.98c-.067-.326-.306-.554-.676-.61-.38-.058-.938.07-1.532.592l-.66-.751c.76-.669 1.604-.942 2.343-.83Z"
      }
    )
  }
), uU = /* @__PURE__ */ t.forwardRef(gU), xU = uU, RU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 3.793V2h1v1.793l.646-.647.708.708L8.5 5.207v1.927l1.669-.963.495-1.85.966.26-.237.882 1.553-.896.5.866-1.553.896.883.237-.258.966-1.85-.495L9 8l1.669.963 1.849-.495.258.966-.883.237 1.553.896-.5.866-1.553-.896.237.883-.966.258-.495-1.849L8.5 8.866v1.927l1.354 1.353-.708.708-.646-.647V14h-1v-1.793l-.646.647-.708-.708L7.5 10.793V8.866l-1.669.963-.495 1.85-.966-.26.236-.882-1.552.896-.5-.866 1.552-.896-.883-.237.26-.966 1.848.495L7 8l-1.67-.963-1.849.495-.259-.966.883-.237-1.552-.896.5-.866 1.552.896-.236-.883.966-.258.495 1.849 1.669.963V5.207L6.146 3.854l.708-.708z"
      }
    )
  }
), jU = /* @__PURE__ */ t.forwardRef(RU), MU = jU, HU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2h3v1h-2v3H9v3H6v3H3v2H2v-3h3V8h3V5h3z",
        clipRule: "evenodd"
      }
    )
  }
), CU = /* @__PURE__ */ t.forwardRef(HU), yU = CU, bU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.848 4H11v8h.848l.804 3H3.348l.804-3H5V4h-.848l-.804-3h9.304zM8.625 4H9.75v8H8.625zm-1.25 0H6.25v8h1.125z",
        clipRule: "evenodd"
      }
    )
  }
), VU = /* @__PURE__ */ t.forwardRef(bU), LU = VU, zU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12.03 1.83.94.34q-.043.12-.082.238c-.053.158-.13.392-.223.692-.184.6-.431 1.465-.678 2.515-.467 1.983-.931 4.618-.982 7.385H14v1H2v-1h1.992c-.066-2.035-.517-4.147-.974-5.805a35 35 0 0 0-.9-2.795l-.082-.214.928-.371q.046.116.09.233a36 36 0 0 1 .928 2.882c.469 1.7.944 3.91 1.01 6.07h1.003c-.05-2.767-.515-5.402-.982-7.385A39 39 0 0 0 4.335 3.1a27 27 0 0 0-.305-.93l.94-.34q.046.128.09.258a40 40 0 0 1 .927 3.298c.477 2.03.957 4.745 1.008 7.614h1.008a47.5 47.5 0 0 1 .502-6.386 38 38 0 0 1 .349-2.003 24 24 0 0 1 .16-.732l.971.242a23 23 0 0 0-.151.69 37 37 0 0 0-.34 1.95A46.5 46.5 0 0 0 9.004 13h1.002c.05-2.869.53-5.585 1.008-7.615.253-1.075.506-1.96.697-2.579a29 29 0 0 1 .32-.977Z"
      }
    )
  }
), SU = /* @__PURE__ */ t.forwardRef(zU), kU = SU, FU = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "m7.383 11-.268-1h1.77l-.269 1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.5 2H5V1h6v1H9.5v2.5H12V14h-1.5v1h-1v-1h-3v1h-1v-1H4V4.5h2.5zm2 0v2.5h-1V2zM7 7.5h2v-1H7zM10.188 9H5.811l.804 3h2.768l.803-3Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $U = /* @__PURE__ */ t.forwardRef(FU), BU = $U, AU = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 2h6v2h3v3h-4V6H6v1H2V4h3zm5 1v1H6V3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 8v5h12V8h-4v1H6V8zm7 0H7V7h2z" })
    ]
  }
), EU = /* @__PURE__ */ t.forwardRef(AU), _U = EU, OU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.473 2.037a2.5 2.5 0 0 1 4.505 1.126 3 3 0 0 1 .75 5.29A4 4 0 0 1 8.5 10.969V13H13v1H3v-1h4.5v-2.031a4 4 0 0 1-2.15-.973A2.5 2.5 0 0 1 3.3 6.31a3 3 0 0 1 3.172-4.273Z"
      }
    )
  }
), DU = /* @__PURE__ */ t.forwardRef(OU), PU = DU, TU = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.505 1 2.639 7.696h1.495l-3 5.196H6V15h1v-2.108h4.866l-3-5.196h1.505zM10 15v-1.108h1V15z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.103 8.696 9.082 3.464 10.505 1l3.866 6.696h-1.505l3 5.196h-2.845l-2.423-4.196z"
        }
      )
    ]
  }
), qU = /* @__PURE__ */ t.forwardRef(TU), IU = qU, ZU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.447 3.276 8 2.382l-.447.894c-.317.633-.779 1.344-1.278 2.11-.27.416-.551.848-.826 1.293-.38.616-.737 1.246-1.001 1.853C4.186 9.134 4 9.751 4 10.333a4 4 0 1 0 8 0c0-.582-.186-1.2-.448-1.801-.264-.607-.622-1.237-1.001-1.853a63 63 0 0 0-.826-1.293c-.499-.766-.961-1.477-1.278-2.11"
      }
    )
  }
), WU = /* @__PURE__ */ t.forwardRef(ZU), GU = WU, NU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2.354 1.646 12 12-.707.708-1.773-1.772a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19A5 5 0 0 0 3.416 6h1.747l.02-.11zM6.293 7h-.25a11.5 11.5 0 0 0 0 2h2.25zm3 3 .436.436a7 7 0 0 1-.416 1.246C8.875 12.644 8.373 13 8 13c-.374 0-.875-.356-1.313-1.318A7.4 7.4 0 0 1 6.18 10h3.114Zm1.25 1.25.621.621a5 5 0 0 1-1.202.73q.143-.243.261-.505a7 7 0 0 0 .32-.846M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm2.938 5.6a6 6 0 0 1-.26-.504A8.6 8.6 0 0 1 5.162 10H3.416a5.02 5.02 0 0 0 2.622 2.6M14 8c0 .926-.21 1.804-.585 2.587L11.828 9H12.9a5 5 0 0 0 0-2h-1.94A13 13 0 0 1 11 8.17L9.97 7.14 9.956 7h-.129l-1-1h.993a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3c-.33 0-.762.28-1.16 1.011L5.413 2.585A6 6 0 0 1 14 8m-3.163-2a8.6 8.6 0 0 0-.614-2.096 5 5 0 0 0-.26-.504 5.02 5.02 0 0 1 2.62 2.6h-1.747Z",
        clipRule: "evenodd"
      }
    )
  }
), UU = /* @__PURE__ */ t.forwardRef(NU), YU = UU, QU = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm.316-1h1.747a8.6 8.6 0 0 1 .614-2.096 6 6 0 0 1 .26-.504A5.02 5.02 0 0 0 3.417 6ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m0 1c-.374 0-.875.356-1.313 1.318A7.4 7.4 0 0 0 6.18 6h3.64a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3m2.837 3a8.6 8.6 0 0 0-.614-2.096 6 6 0 0 0-.26-.504 5.02 5.02 0 0 1 2.62 2.6h-1.747Zm-.88 1H6.043a11.5 11.5 0 0 0 0 2h3.914a11.5 11.5 0 0 0 0-2m1.003 2a12.5 12.5 0 0 0 0-2h1.94a5 5 0 0 1 0 2zm-1.139 1H6.18c.12.642.295 1.213.508 1.682C7.125 12.644 7.627 13 8 13s.875-.356 1.313-1.318c.213-.47.388-1.04.508-1.682m.141 2.6q.143-.242.26-.504c.272-.597.482-1.31.615-2.096h1.747a5.02 5.02 0 0 1-2.622 2.6m-3.924 0a6 6 0 0 1-.261-.504A8.6 8.6 0 0 1 5.163 10H3.416a5.02 5.02 0 0 0 2.622 2.6",
        clipRule: "evenodd"
      }
    )
  }
), KU = /* @__PURE__ */ t.forwardRef(QU), XU = KU, JU = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#misc-bandaid_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.5.793 15.207 4.5 4.5 15.207.793 11.5zM10.293 8 9.5 7.207 8.707 8l.793.793zm-1.5 1.5L8 8.707l-.793.793.793.793zM5.707 8l.793.793L7.293 8 6.5 7.207zm1.5-1.5L8 7.293l.793-.793L8 5.707z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "misc-bandaid_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), eY = /* @__PURE__ */ t.forwardRef(JU), lY = eY, oY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.619 1H5.5v1H6v3.928l-3 5.196V14h10v-2.876l-3-5.196V2h.619zM9.464 7H6.536L7 6.196V2h2v4.196zM8 10v1h1v-1zm-2 1v1h1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), nY = /* @__PURE__ */ t.forwardRef(oY), iY = nY, rY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h12v8h-2V8H8v2H2zm6 2H4v1h4zM4 6h3v1H4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 13v-2H1v2z" })
    ]
  }
), tY = /* @__PURE__ */ t.forwardRef(rY), aY = tY, sY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 2A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14H14V2zM13 12H3.5a.5.5 0 0 0 0 1H13zM4 5h7.5V4H4zm0 2h7.5V6H4zm0 2h4V8H4z",
        clipRule: "evenodd"
      }
    )
  }
), dY = /* @__PURE__ */ t.forwardRef(sY), cY = dY, hY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 9.5h-1.67l-1-1H14zM11 7v1.172L5.758 2.929l-.349-1.3.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m11.293 12 2.354 2.354.707-.708-12-12-.708.708L5.013 5.72A3 3 0 0 0 5 6H3.384l-.548-2.044-.966.259L2.616 7H5v1.5H2v1h3V11H2.616l-.746 2.785.966.26L3.383 12h1.788a3 3 0 0 0 5.658 0zM8.5 9.207l-1-1V11.5h1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), wY = /* @__PURE__ */ t.forwardRef(hY), vY = wY, fY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.985 3.778-.576-2.149.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7H11v1.5h3v1h-3V11h2.383l.747 2.785-.966.26L12.616 12H10.83a3 3 0 0 1-5.658 0H3.383l-.547 2.044-.966-.259L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.26L3.383 6H5c0-.882.38-1.674.985-2.222M7.5 6.5v5h1v-5z",
        clipRule: "evenodd"
      }
    )
  }
), mY = /* @__PURE__ */ t.forwardRef(fY), pY = mY, gY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.89 3H3.11l-.625 2.5h-.846L.806 8H2v1.562L2.61 12h.58l.5 1h1.62l.5-1h4.382l.5 1h1.618l.5-1h.581L14 9.562V8h1.194l-.834-2.5h-.845zm-.03 4-.75-3H8.5v.5H9v1H7v-1h.5V4H3.89l-.75 3H8.5c0-.495.301-.883.662-1.123C9.526 5.634 10 5.5 10.5 5.5c.499 0 .974.134 1.338.377.36.24.662.628.662 1.123zM11.5 7c0-.057-.035-.17-.217-.291A1.44 1.44 0 0 0 10.5 6.5c-.33 0-.605.09-.783.209-.182.121-.217.234-.217.291zM6 10H4V9h2zm6 0h-2V9h2z",
        clipRule: "evenodd"
      }
    )
  }
), uY = /* @__PURE__ */ t.forwardRef(gY), xY = uY, RY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#misc-checkmark-badge_svg__a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m8 .258 1.603 1.76 2.268-.723.509 2.325 2.325.509-.722 2.268L15.743 8l-1.76 1.603.722 2.268-2.325.509-.509 2.325-2.268-.722L8 15.743l-1.603-1.76-2.268.722-.509-2.325-2.325-.509.722-2.268L.257 8l1.76-1.603-.722-2.268L3.62 3.62l.509-2.325 2.268.722zm-1 10.45 4.854-4.854-.707-.708L7 9.293 4.854 7.146l-.708.708z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "misc-checkmark-badge_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), jY = /* @__PURE__ */ t.forwardRef(RY), MY = jY, HY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6z",
        clipRule: "evenodd"
      }
    )
  }
), CY = /* @__PURE__ */ t.forwardRef(HY), yY = CY, bY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 0 12v-1a5 5 0 0 0 5-5",
        clipRule: "evenodd"
      }
    )
  }
), VY = /* @__PURE__ */ t.forwardRef(bY), LY = VY, zY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1-6 6h1a5 5 0 0 0 10 0",
        clipRule: "evenodd"
      }
    )
  }
), SY = /* @__PURE__ */ t.forwardRef(zY), kY = SY, FY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 5V2h1v3zM5.525 6.232 3.404 4.111l.707-.707 2.121 2.121zm7.071-2.121-2.121 2.121-.707-.707 2.121-2.121zM5 8.5H2v-1h3zm9 0h-3v-1h3zm-7.768 1.975-2.121 2.121-.707-.707 2.121-2.121zm5.657 2.121L9.812 10.52l.707-.707 2.077 2.077zM7.5 14v-3h1v3z",
        clipRule: "evenodd"
      }
    )
  }
), $Y = /* @__PURE__ */ t.forwardRef(FY), BY = $Y, AY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.026 12.342 3-9 .948.316-3 9zm-1.38-7.696.708.708L2.707 8l2.647 2.646-.707.708L1.293 8l3.354-3.354ZM13.294 8l-2.646-2.646.707-.708L14.707 8l-3.353 3.354-.707-.708L13.293 8Z",
        clipRule: "evenodd"
      }
    )
  }
), EY = /* @__PURE__ */ t.forwardRef(AY), _Y = EY, OY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m3.468 3.537 2.329-4.033L8.5 9.208l-4.033 2.33ZM9.206 8.5 7.5 6.793l4.036-2.33-2.33 4.036Z",
        clipRule: "evenodd"
      }
    )
  }
), DY = /* @__PURE__ */ t.forwardRef(OY), PY = DY, TY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 4h7v4h1V5h3.08L14 8.434V10h-1.085a1.5 1.5 0 1 1-2.83 0h-4.17a1.5 1.5 0 1 1-2.83 0H2z"
      }
    )
  }
), qY = /* @__PURE__ */ t.forwardRef(TY), IY = qY, ZY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.32 3.828A3.44 3.44 0 0 1 13.954 7H12v1h1.627a3.4 3.4 0 0 1-.455.68l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.4 3.4 0 0 1 2.373 8h2.834l1.034-1.034.973 3.632L9.244 8H11V7H8.756L7.661 8.402 6.76 5.034 4.793 7H2.046A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13.627 8a3.4 3.4 0 0 0 .327-1H15v1zM2.046 7c.056.345.165.682.327 1H1V7z"
        }
      )
    ]
  }
), WY = /* @__PURE__ */ t.forwardRef(ZY), GY = WY, NY = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.32 4.539a.727.727 0 0 1 1.43.188h1a1.728 1.728 0 0 0-3.396-.447L6.625 7H5.5v1h.857l-.927 3.46A.727.727 0 0 1 4 11.272H3a1.728 1.728 0 0 0 3.396.447L7.393 8H8.5V7h-.84zM10.293 11 8.646 9.354l.708-.708L11 10.293l1.646-1.647.707.708L11.707 11l1.647 1.646-.707.708L11 11.707l-1.646 1.647-.708-.707z"
      }
    )
  }
), UY = /* @__PURE__ */ t.forwardRef(NY), YY = UY, QY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.5 4v2h5V5h3v1h5V4h-2.768A2 2 0 0 0 10 1c-.513 0-1.165.157-1.681.727A2.5 2.5 0 0 0 8 2.169a2.5 2.5 0 0 0-.319-.442C7.165 1.157 6.513 1 6 1a2 2 0 0 0-1.732 3zM6 2a1 1 0 0 0 0 2h1.482c-.066-.858-.302-1.337-.542-1.602A1.23 1.23 0 0 0 6 2m5 1a1 1 0 0 1-1 1H8.518c.066-.858.302-1.337.542-1.602C9.337 2.093 9.685 2 10 2a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M6.5 7v3.5l1.5-1 1.5 1V7H14v7H2V7z" })
    ]
  }
), KY = /* @__PURE__ */ t.forwardRef(QY), XY = KY, JY = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14.646 5.746 8 2.423 1.354 5.746 8 8.889l5-2.365V12h1V6.051z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 10V8.103l4 1.892 4-1.892V10c0 .894-.508 1.656-1.235 2.175C10.038 12.695 9.06 13 8 13c-1.059 0-2.038-.306-2.765-.825C4.508 11.655 4 10.894 4 10"
        }
      )
    ]
  }
), eQ = /* @__PURE__ */ t.forwardRef(JY), lQ = eQ, oQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h5v2.05a2.5 2.5 0 1 0 0 4.9V13H2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 6a1.5 1.5 0 1 0 1.415 2h5.378l-1.647 1.646.708.708L15.207 7.5l-2.853-2.854-.708.708L13.293 7H7.915A1.5 1.5 0 0 0 6.5 6"
        }
      )
    ]
  }
), nQ = /* @__PURE__ */ t.forwardRef(oQ), iQ = nQ, rQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h5v2.05a2.5 2.5 0 1 0 0 4.9V13H2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m4.354 3.854L12.5 8.207l1.646 1.647.708-.708L13.207 7.5l1.646-1.646-.707-.708L12.5 6.793l-1.646-1.647-.707.708L11.793 7.5l-1.647 1.646z"
        }
      )
    ]
  }
), tQ = /* @__PURE__ */ t.forwardRef(rQ), aQ = tQ, sQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M13 3H3v3h.5a1.5 1.5 0 1 1 0 3H3v4h10V9.95a2.5 2.5 0 1 1 0-4.9z"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M11 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" })
    ]
  }
), dQ = /* @__PURE__ */ t.forwardRef(sQ), cQ = dQ, hQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 3H6v3H3v4h3v3h4v-3h3V6h-3z" })
  }
), wQ = /* @__PURE__ */ t.forwardRef(hQ), vQ = wQ, fQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 1c-1.34 0-2.586.409-3.505 1.186C3.568 2.971 3 4.111 3 5.5c0 1.447.873 2.572 1.632 3.396.173.187.345.365.504.528l.056.058c.177.182.332.344.463.494q.197.224.283.374c.06.103.062.148.062.15v.5h1v-.5c0-.58-.192-1.016-.462-1.627q-.06-.132-.122-.277C6.09 7.84 5.75 6.916 5.75 5.5c0-1.36.191-2.442.547-3.204C6.653 1.533 7.229 1 8 1m1 10v-.5c0-.58.192-1.016.462-1.627l.122-.277c.327-.756.666-1.68.666-3.096 0-1.36-.191-2.442-.547-3.204C9.347 1.533 8.771 1 8 1c1.34 0 2.586.409 3.505 1.186C12.432 2.971 13 4.111 13 5.5c0 1.447-.873 2.572-1.632 3.396a28 28 0 0 1-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v.5zm-3.5 2v-1h5v1H10v2H6v-2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.75 5.5c0-1.287.184-2.205.453-2.781C7.472 2.144 7.771 2 8 2s.528.144.797.719c.27.576.453 1.494.453 2.781 0 1.23-.286 2.013-.584 2.698l-.114.258C8.285 9.056 8 9.693 8 10.5c0-.807-.285-1.445-.552-2.044l-.114-.258C7.036 7.513 6.75 6.73 6.75 5.5"
        }
      )
    ]
  }
), mQ = /* @__PURE__ */ t.forwardRef(fQ), pQ = mQ, gQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.947 4.276 12.31 5H15v2.5h-1V6H9v1.5H8V5h3.19l-.137-.276z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m13.416 7.277-.001.002-.003.005-.01.014-.037.053a11 11 0 0 1-.61.786 7 7 0 0 1-.862.863H15v1h-3.5v.5A1.5 1.5 0 0 1 10 12h-.5v-1h.5a.5.5 0 0 0 .5-.5V10H8V9h2.5v-.309l.276-.138c.24-.12.494-.32.737-.553H9.5V7h2.586a.5.5 0 0 0 .353-.146l.207-.208z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.451 4.5h-.866L1.533 9.82l.933.36.642-1.664h1.826l.644 1.665.933-.362zm.096 3.016H3.494l.525-1.362z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), uQ = /* @__PURE__ */ t.forwardRef(gQ), xQ = uQ, RQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.295 5H5.71l2.293 2.293L10.295 5h3.414l1.293 1.293v3.414L13.71 11h-3.414L8.002 8.707 5.71 11H2.295L1.002 9.707V6.293zm5 3-2-2H2.71l-.707.707v2.586L2.71 10h2.586zM8.71 8l2 2h2.586l.707-.707V6.707L13.295 6H10.71z",
        clipRule: "evenodd"
      }
    )
  }
), jQ = /* @__PURE__ */ t.forwardRef(RQ), MQ = jQ, HQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 5a3 3 0 1 1 1.262 2.445L6.707 9l1.647 1.646-.708.708L6 9.707l-.793.793 1.647 1.646-.708.708L4.5 11.207l-1.146 1.147-.708-.708 4.909-4.908A3 3 0 0 1 7 5m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
        clipRule: "evenodd"
      }
    )
  }
), CQ = /* @__PURE__ */ t.forwardRef(HQ), yQ = CQ, bQ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 2h3v1h2v1.053l1.786-.479 2.07 7.728-2.898.776L10.464 6.5H10V4H9v2.5H8V3H7v3.5H6V5H5v1.5H4V4h2zm6.665 8.854-1.552-5.796.965-.259 1.553 5.796z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m5.232 7.313 1.017.272h.502l1.017-.272 1.979.53 1.274 4.052-.442 1.647-1.171.479-1.075-.288-.34-1.268-1.493-.4-1.493.4-.34 1.268-1.075.288-1.171-.479-.442-1.647 1.275-4.052z"
        }
      )
    ]
  }
), VQ = /* @__PURE__ */ t.forwardRef(bQ), LQ = VQ, zQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 3h-2v10h2zM5 5H3v8h2zm3-1h2v1.053l1.785-.479 2.12 7.911-1.932.518L10 5.639V13H8z"
      }
    )
  }
), SQ = /* @__PURE__ */ t.forwardRef(zQ), kQ = SQ, FQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m-4 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2.33-2.5a5 5 0 0 0-1.83-1.831L9.5 5.4c.455.264.835.643 1.099 1.099zM6.5 5.4a3 3 0 0 0-1.098 1.1l-1.733-1A5 5 0 0 1 5.5 3.67zm-2.83 5.1a5 5 0 0 0 1.83 1.83l1-1.733A3 3 0 0 1 5.402 9.5zm8.66 0a5 5 0 0 1-1.83 1.83l-1-1.733A3 3 0 0 0 10.598 9.5l1.733 1Z",
        clipRule: "evenodd"
      }
    )
  }
), $Q = /* @__PURE__ */ t.forwardRef(FQ), BQ = $Q, AQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a4 4 0 0 0-4 4c0 1.038.627 1.914 1.368 2.718q.133.145.265.282h1.715l-.903-3.37.966-.26L8 8.569l.589-2.197.966.258L8.652 10h1.715q.133-.137.265-.282C11.373 8.914 12 8.038 12 7a4 4 0 0 0-4-4m1.44 8H8.383l-.268 1H9c0-.248.092-.47.196-.65q.105-.179.243-.35ZM9 13H7v.293l.707.707h.586L9 13.293zm-2-1h.884l-.268-1H6.561c.09.114.174.231.243.35.104.18.196.402.196.65M3 7a5 5 0 0 1 10 0c0 1.447-.873 2.572-1.632 3.396-.173.187-.345.365-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v1.707L8.707 15H7.293L6 13.707V12c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.057a28 28 0 0 1-.504-.53C3.873 9.573 3 8.448 3 7",
        clipRule: "evenodd"
      }
    )
  }
), EQ = /* @__PURE__ */ t.forwardRef(AQ), _Q = EQ, OQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8.354a6 6 0 0 1 12 0v6h-4v-6a2 2 0 1 0-4 0v6H2zm1 5v-1h2v1zm8 0v-1h2v1z",
        clipRule: "evenodd"
      }
    )
  }
), DQ = /* @__PURE__ */ t.forwardRef(OQ), PQ = DQ, TQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m1.338 5H9.662l-2.4 6H9v3h1v-3h2v3h1v-3h1.739l-2.4-6ZM7 6H1v5h1v4h1v-4h2v4h1v-4h1z"
      }
    )
  }
), qQ = /* @__PURE__ */ t.forwardRef(TQ), IQ = qQ, ZQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4M6 15v-4H5V6h6v5h-1v4H9v-4H7v4z"
      }
    )
  }
), WQ = /* @__PURE__ */ t.forwardRef(ZQ), GQ = WQ, NQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4 1.73v2.5H1.5v1H4v2.5h1v-2.5h2.5v-1H5v-2.5zM2.354 14.583l12-12-.707-.707-12 12zM8.5 12.23h6v-1h-6z"
      }
    )
  }
), UQ = /* @__PURE__ */ t.forwardRef(NQ), YQ = UQ, QQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 8.415v2.824L7.404 9H6v4H3V9H2V5h1V4h3v1h1.404L13 2.761v2.824a1.5 1.5 0 0 1 0 2.83"
      }
    )
  }
), KQ = /* @__PURE__ */ t.forwardRef(QQ), XQ = KQ, JQ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 1h2v1h1v7h-1.117l-.267 1H9.384l-.268-1H8V5.915q-.183.065-.383.08L6.007 12h7.877l.803 3H1.313l.803-3h.857l2.143-8h.97A1.5 1.5 0 0 1 8 3.085V2h1zM7.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
        clipRule: "evenodd"
      }
    )
  }
), eK = /* @__PURE__ */ t.forwardRef(JQ), lK = eK, oK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zm1 9v4h-4v-1h3v-3zM2 14v-3H1v4h4v-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8" })
    ]
  }
), nK = /* @__PURE__ */ t.forwardRef(oK), iK = nK, rK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.94 6.94c.271-.273.646-.44 1.06-.44s.789.167 1.06.44c.273.271.44.646.44 1.06s-.167.789-.44 1.06c-.271.273-.646.44-1.06.44s-.789-.167-1.06-.44A1.5 1.5 0 0 1 6.5 8c0-.414.167-.789.44-1.06"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3.146-2.146.768.767A2.5 2.5 0 0 0 5.5 8c0 .51.153.984.414 1.379l-.768.768.708.707.767-.768a2.5 2.5 0 0 0 2.758 0l.768.768.707-.707-.768-.768A2.5 2.5 0 0 0 10.5 8c0-.51-.153-.983-.414-1.379l.768-.767-.707-.708-.768.768A2.5 2.5 0 0 0 8 5.5c-.51 0-.983.153-1.379.414l-.767-.768z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tK = /* @__PURE__ */ t.forwardRef(rK), aK = tK, sK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4h14v8H1zm5 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0M2 5h2v2H2zm2 4H2v2h2zm8 0h2v2h-2zm2-4h-2v2h2z",
        clipRule: "evenodd"
      }
    )
  }
), dK = /* @__PURE__ */ t.forwardRef(sK), cK = dK, hK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 8a9 9 0 0 0 1.324-.096A4.5 4.5 0 0 1 9 6.256V4.5c0-.357-.217-.617-.426-.782a2.7 2.7 0 0 0-.795-.4C7.173 3.117 6.367 3 5.5 3s-1.673.116-2.28.319c-.3.1-.58.23-.794.399C2.217 3.883 2 4.143 2 4.5v6c0 .357.217.617.426.782.215.169.494.3.795.4.606.202 1.412.318 2.279.318q.383 0 .746-.03a4.5 4.5 0 0 1-.22-.986q-.255.015-.526.016c-.79 0-1.484-.107-1.963-.267a1.7 1.7 0 0 1-.492-.237.4.4 0 0 1-.045-.04v-.855q.108.043.22.08c.607.203 1.413.319 2.28.319q.27 0 .53-.015.06-.532.239-1.02A8 8 0 0 1 5.5 9c-.79 0-1.484-.107-1.963-.267a1.7 1.7 0 0 1-.492-.236.4.4 0 0 1-.045-.04V7.6q.108.043.22.08c.608.204 1.414.32 2.28.32M3.05 4.5c.09.07.248.153.487.233C4.017 4.893 4.71 5 5.5 5s1.484-.107 1.963-.267A1.7 1.7 0 0 0 7.95 4.5a1.7 1.7 0 0 0-.487-.233C6.983 4.107 6.29 4 5.5 4s-1.484.107-1.963.267a1.7 1.7 0 0 0-.487.233M8 5.6a4 4 0 0 1-.22.081C7.172 5.884 6.366 6 5.5 6c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 6.893 4.71 7 5.5 7s1.484-.107 1.963-.267c.243-.081.403-.166.492-.236A.4.4 0 0 0 8 6.457z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" })
    ]
  }
), wK = /* @__PURE__ */ t.forwardRef(hK), vK = wK, fK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708-2.482-2.482a5 5 0 0 1-7.33-1.103L3.28 9.93l1.004.063a4 4 0 0 0 3.435-1.568L1.646 2.354zM10.5 3.67a5 5 0 0 1 2.155 6.157l-4.13-4.13a4 4 0 0 0-.658-1.912l-.556-.839 1.004.063a5 5 0 0 1 2.185.661"
      }
    )
  }
), mK = /* @__PURE__ */ t.forwardRef(fK), pK = mK, gK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m8.315 3.009-1.004-.063.556.839a4 4 0 0 1-3.584 6.208L3.279 9.93l.556.839a5 5 0 1 0 4.48-7.76"
      }
    )
  }
), uK = /* @__PURE__ */ t.forwardRef(gK), xK = uK, RK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5.5 1v3h1V1zM3 2v2h1V2zm5 0v2h1V2z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.393 6H11V5H2v7.566L2.384 14h8.232L11 12.566V12h1.786zm-2.375 5H11V7h2.09z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), jK = /* @__PURE__ */ t.forwardRef(RK), MK = jK, HK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 1a2 2 0 1 0 1.016 3.723l1.718 1.718-1.096.41a2 2 0 1 0 0 2.296l1.096.412-1.718 1.718A2 2 0 1 0 6 13.015l4.242-1.06A1.999 1.999 0 0 0 14 11a2 2 0 0 0-3.016-1.723L9.707 8l1.277-1.277a2 2 0 1 0-.742-2.678L6 2.985A2 2 0 0 0 4 1m3.762 5.055-2.039-2.04.035-.06L10 5.015q0 .1.011.197zm.777.777 1.475-.553L9 7.293zm-1.029.386L8.293 8l-.783.782-1.521-.57a2 2 0 0 0 0-.424zm-1.787 4.766 2.04-2.04 2.248.844a2 2 0 0 0-.01.197l-4.243 1.06zm2.816-2.816 1.475.553L9 8.707z",
        clipRule: "evenodd"
      }
    )
  }
), CK = /* @__PURE__ */ t.forwardRef(HK), yK = CK, bK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M5 6V5h2v1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 2h12v12h-1.185l-.753-.646-1.312.716-1.375-.75L8 14.07l-1.375-.75-1.365.744-1.411-.706-.642.642H2zm6 2H4v3h4zm1 1h3V4H9zm0 2h3V6H9zM4 8v1h8V8zm8 3v-1H4v1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), VK = /* @__PURE__ */ t.forwardRef(bK), LK = VK, zK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 2H2v12h12V2h-4v3H6zm3 8h2.5V9H9zm0 1v1h2v-1zM4.646 7.568 8.51 8.603l-1.035 3.864L3.61 11.43l1.035-3.863Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M7 2h2v2H7z" })
    ]
  }
), SK = /* @__PURE__ */ t.forwardRef(zK), kK = SK, FK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 3H1v2h14z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 7H1v6h14zM3 9h6v1H3zm10 0h-2v1h2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $K = /* @__PURE__ */ t.forwardRef(FK), BK = $K, AK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 2H3v2h.5c3.887 0 7.28 2.112 9.095 5.249l.25.433 1.732-1-.25-.433A12.5 12.5 0 0 0 3.5 2"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 15.366V5h.5a9.5 9.5 0 0 1 8.229 4.75l.25.432zM9.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), EK = /* @__PURE__ */ t.forwardRef(AK), _K = EK, OK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 15v-1h.529l.483-8.22L6.5 1.294l1.5 1.5 1.5-1.5 4.488 4.488.483 8.219H15v1H1Zm4-4.5V8.082l3-5.196 3 5.196V10.5h-1V8.35l-.49-.85H8.5v4.361L9.783 14H6.217L7.5 11.861V7.5H6.49L6 8.35v2.15z",
        clipRule: "evenodd"
      }
    )
  }
), DK = /* @__PURE__ */ t.forwardRef(OK), PK = DK, TK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 2H1v2h14z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 5H2v6h3.92l-.903 3.37.966.26.436-1.63H9.58l.437 1.63.966-.26L10.08 11H14zm-7.313 7 .268-1h2.09l.267 1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), qK = /* @__PURE__ */ t.forwardRef(TK), IK = qK, ZK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.552 1.263 2.436 9.09 2.588-7L11.554 7H15v1h-4.214l-.362-1.352-2.589 7-2.387-8.91L4.36 8H1V7h2.64z",
        clipRule: "evenodd"
      }
    )
  }
), WK = /* @__PURE__ */ t.forwardRef(ZK), GK = WK, NK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 2a2 2 0 0 0-2 2H4v2a2 2 0 1 0 0 4v3h3v-1a1 1 0 1 1 2 0v1h4V9h-1a1 1 0 1 1 0-2h1V4h-3a2 2 0 0 0-2-2"
      }
    )
  }
), UK = /* @__PURE__ */ t.forwardRef(NK), YK = UK, QK = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-8a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m10-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M7 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), KK = /* @__PURE__ */ t.forwardRef(QK), XK = KK, JK = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.694 2.008a6 6 0 1 0 5.344 9.253l.838.544A7 7 0 1 1 7.644 1.009z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.982 5.177a3.001 3.001 0 1 0 2.952 5.116l.645.764a4 4 0 1 1-3.937-6.82z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m9.812 1.237-.483-.13-1.941 7.247 7.246 1.941.13-.483a7.003 7.003 0 0 0-4.951-8.575Z"
        }
      )
    ]
  }
), eX = /* @__PURE__ */ t.forwardRef(JK), lX = eX, oX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a6.97 6.97 0 0 0-3.5.937l-.433.25 2.25 3.898.433-.25A2.5 2.5 0 0 1 8 5.5c.456 0 .883.122 1.25.334l.433.25 2.25-3.897-.432-.25A6.97 6.97 0 0 0 8 1M5.5 7.5H1V8a7 7 0 0 0 3.5 6.063l.432.25 2.25-3.897-.432-.25A2.5 2.5 0 0 1 5.5 8zm9.5 0V8a7 7 0 0 1-3.5 6.063l-.432.25-2.25-3.897.432-.25A2.5 2.5 0 0 0 10.5 8v-.5zM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
      }
    )
  }
), nX = /* @__PURE__ */ t.forwardRef(oX), iX = nX, rX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.808 4.515a8 8 0 0 0-.419.389L4.293 8h-2l-1.5 1.5L2.5 11.207l1-1 .793.793-1.146 1.146.707.708L5 11.707l.793.793-1 1L6.5 15.207l1.5-1.5v-2l3.096-3.096q.201-.2.39-.419zm4.288 2.874c.807-1.217 1.317-2.732.878-4.047l-.079-.237-.237-.08c-1.315-.438-2.83.072-4.046.88z"
      }
    )
  }
), tX = /* @__PURE__ */ t.forwardRef(rX), aX = tX, sX = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m12.418 6.607-6-3.464-2.503 2.503.707.708 1.96-1.961 2.104 1.214-7.54 7.54.708.707 5.228-5.23L9.186 9.84l-2.54 2.54.708.707 3.46-3.461-3-1.732 1.768-1.768 3 1.732 2.504-2.503-.707-.708z"
        }
      )
    ]
  }
), dX = /* @__PURE__ */ t.forwardRef(sX), cX = dX, hX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 3v1H1v1h2v2H.848l.804 3h3.696l.804-3H4V5h3.5v7H6v1h4v-1H8.5V5H12v2H9.848l.804 3h3.696l.804-3H13V5h2V4H8.5V3z"
      }
    )
  }
), wX = /* @__PURE__ */ t.forwardRef(hX), vX = wX, fX = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 2H7.5v2.26l-2.5 2V14h2v-3h2v3h2V6.26l-2.5-2V4H10zM8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 10v4h3v-4zM1 10h3v4H1z" })
    ]
  }
), mX = /* @__PURE__ */ t.forwardRef(fX), pX = mX, gX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m9.353 1.354-.853.853v1.246l4.632 1.241L14.018 8H1.982l.886-3.306L7.5 3.453v-1.66L8.646.646zM12.482 9H3.518l1.095 4.088L8 15.043l3.386-1.955z"
      }
    )
  }
), uX = /* @__PURE__ */ t.forwardRef(gX), xX = uX, RX = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M9 2a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 5a3 3 0 0 1-3-3h-1a4 4 0 0 0 4 4z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14 3a1 1 0 0 1-1-1h-1a2 2 0 0 0 2 2zM4.94 4.111a3.5 3.5 0 0 0-.636 4.079 3.57 3.57 0 0 0 1.527 1.515c.237.121.484.214.733.277A3.5 3.5 0 0 0 9.89 9.06l.707.707a4.5 4.5 0 0 1-4.26 1.188l.815 3.04H1.848l1.48-5.525a4.5 4.5 0 0 1 .904-5.067z"
        }
      )
    ]
  }
), jX = /* @__PURE__ */ t.forwardRef(RX), MX = jX, HX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m1.354.646 13 13-.707.708-2.033-2.033a6.58 6.58 0 0 1-3.493 2.164l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188 16 16 0 0 1-.027-1.016c.002-.252.017-.502.032-.754l.695-.186-2.07-2.07zm12.129 7.922c-.138.51-.313 1.034-.534 1.552L5.506 2.677 8 2.01l5.978 1.601c.015.252.03.502.032.754.002.245-.002.594-.026 1.016a16 16 0 0 1-.501 3.188Z"
      }
    )
  }
), CX = /* @__PURE__ */ t.forwardRef(HX), yX = CX, bX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.978 3.61 8 2.01l-5.978 1.6-.021.36L2.5 4C2 3.97 2 3.972 2 3.972V4a11 11 0 0 0-.01.363c-.002.246.002.595.026 1.017.049.843.177 1.989.501 3.188.645 2.384 2.102 5.102 5.362 5.917l.121.03.121-.03c3.26-.815 4.717-3.533 5.362-5.917.324-1.2.452-2.345.5-3.188A16 16 0 0 0 14.002 4L14 3.98v-.01zM13.5 4l.5-.03z",
        clipRule: "evenodd"
      }
    )
  }
), VX = /* @__PURE__ */ t.forwardRef(bX), LX = VX, zX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 1v1.02a5.97 5.97 0 0 0-3.374 1.398l-.722-.721-.707.707.721.722A5.97 5.97 0 0 0 2.021 7.5H1v1h1.02a5.97 5.97 0 0 0 1.398 3.374l-.721.722.707.707.722-.722A5.97 5.97 0 0 0 7.5 13.98V15h1v-1.02a5.97 5.97 0 0 0 3.374-1.397l.722.721.707-.707-.722-.722A5.97 5.97 0 0 0 13.98 8.5H15v-1h-1.02a5.97 5.97 0 0 0-1.399-3.374l.722-.722-.707-.707-.722.721A5.97 5.97 0 0 0 8.5 2.021V1zM4.836 4.129A4.98 4.98 0 0 1 7.5 3.025v3.038a2 2 0 0 0-.516.214zm4.18 2.148a2 2 0 0 0-.516-.214V3.025c1.006.1 1.924.497 2.664 1.104zm.707.707 2.148-2.148A4.98 4.98 0 0 1 12.976 7.5H9.937a2 2 0 0 0-.214-.516M9.937 8.5h3.038a4.98 4.98 0 0 1-1.104 2.664L9.723 9.016q.142-.24.214-.516m-.921 1.223 2.148 2.148A5 5 0 0 1 8.5 12.976V9.937q.276-.072.516-.214M7.5 9.937v3.038a4.98 4.98 0 0 1-2.664-1.104l2.148-2.148q.24.142.516.214m-1.223-.921-2.148 2.148A4.98 4.98 0 0 1 3.025 8.5h3.038q.072.276.214.516M6.063 7.5H3.025a4.98 4.98 0 0 1 1.104-2.664l2.148 2.148q-.142.24-.214.516",
        clipRule: "evenodd"
      }
    )
  }
), SX = /* @__PURE__ */ t.forwardRef(zX), kX = SX, FX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a3 3 0 0 1 6 0h2v10H3V4zm1 0a2 2 0 1 1 4 0zm0 2a2 2 0 1 0 4 0h1a3 3 0 0 1-6 0z",
        clipRule: "evenodd"
      }
    )
  }
), $X = /* @__PURE__ */ t.forwardRef(FX), BX = $X, AX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.945 2.711 4.795 7H1.849l1.608 6h9.088l1.608-6h-2.948l-1.149-4.289-.966.26L10.17 7H5.83l1.08-4.03-.966-.259Z"
      }
    )
  }
), EX = /* @__PURE__ */ t.forwardRef(AX), _X = EX, OX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.877 3H1V2h2.643l1.343 5h6.058l1.078-4.126.967.252L11.816 8H5.255l.268 1H11v1H4.757zM5.5 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
        clipRule: "evenodd"
      }
    )
  }
), DX = /* @__PURE__ */ t.forwardRef(OX), PX = DX, TX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1 3h1.877l1.88 7H11V9H5.523l-.268-1h6.561l1.306-5h-9.21l-.269-1H1zm4.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      }
    )
  }
), qX = /* @__PURE__ */ t.forwardRef(TX), IX = qX, ZX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 5.5V4.366l-.982.567-.5-.866L9.5 3.5l-.982-.567.5-.866.982.567V1.5h1v1.134l.982-.567.5.866-.982.567.982.567-.5.866L11 4.366V5.5zm1 10v-3.134l-2.714 1.567-.5-.866L10.5 11.5 7.786 9.933l.5-.866L11 10.634V7.5h1v3.134l2.714-1.567.5.866L12.5 11.5l2.714 1.567-.5.866L12 12.366V15.5zm-7.5-8L1.652 6.433l.5-.866L4 6.634V4.5h1v2.134l1.848-1.067.5.866L5.5 7.5l1.848 1.067-.5.866L5 8.366V10.5H4V8.366L2.152 9.433l-.5-.866z"
      }
    )
  }
), WX = /* @__PURE__ */ t.forwardRef(ZX), GX = WX, NX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm-1.44 5.146-.706.708 2 2 .707-.708-2-2Zm.294 3.708.707-.708-2-2-.707.708zM10.5 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
        clipRule: "evenodd"
      }
    )
  }
), UX = /* @__PURE__ */ t.forwardRef(NX), YX = UX, QX = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zM10.5 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
        clipRule: "evenodd"
      }
    )
  }
), KX = /* @__PURE__ */ t.forwardRef(QX), XX = KX, JX = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.867 3.136 5.003 4.707l.99 3.698 1.069-.286-1.548 5.774.966.26.635-2.37a4.5 4.5 0 0 0 2.765.001l.634 2.368.966-.259-1.74-6.492 2.118-.567zM8.775 7.66l-.598.16-.803 2.995a3.5 3.5 0 0 0 2.247.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m13.007 7.258 1.366-.366-1.357-5.064-1.366.366zm-8.162.722L4.22 5.65l-1.766.473-.079-.293-.966.259.777 2.898.966-.26-.074-.272 1.767-.473Z"
        }
      )
    ]
  }
), eJ = /* @__PURE__ */ t.forwardRef(JX), lJ = eJ, oJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 1h4v2H8.5v1H10v1H8.5v1H10v1H8.5v1H10v1.764a3 3 0 1 1-4 0z"
      }
    )
  }
), nJ = /* @__PURE__ */ t.forwardRef(oJ), iJ = nJ, rJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 3H1v3.5h1a1.5 1.5 0 1 1 0 3H1V13h14V9.5h-1a1.5 1.5 0 0 1 0-3h1zM8 5.87l.641 1.299 1.434.208-1.038 1.011.245 1.428L8 9.142l-1.282.674.245-1.428-1.037-1.01 1.433-.209z",
        clipRule: "evenodd"
      }
    )
  }
), tJ = /* @__PURE__ */ t.forwardRef(rJ), aJ = tJ, sJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.614 3h2.768l2.411 9h2.205v1h-12v-1h2.205l.402-1.5H9v-1H4.873l.268-1H8v-1H5.408z"
      }
    )
  }
), dJ = /* @__PURE__ */ t.forwardRef(sJ), cJ = dJ, hJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4h1v3.5h6V4h1v8h-1V8.5H5V12H4zM2 7.5V5h1v6H2V8.5H1v-1zM13 5h1v2.5h1v1h-1V11h-1z",
        clipRule: "evenodd"
      }
    )
  }
), wJ = /* @__PURE__ */ t.forwardRef(hJ), vJ = wJ, fJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4c0 .364-.097.706-.268 1h2.276l2.144 8H1.848l2.144-8h2.276A2 2 0 1 1 10 4M8 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 7v3h1V7zm3 0v3h1V7z",
        clipRule: "evenodd"
      }
    )
  }
), mJ = /* @__PURE__ */ t.forwardRef(fJ), pJ = mJ, gJ = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0M8 6v1h2v1H8v2h3.289l1.587 2.75-.866.5L10.711 11H7V6z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 15A4.5 4.5 0 0 1 6 6.256V12h4.134l.808 1.4A4.5 4.5 0 0 1 7.5 15"
        }
      )
    ]
  }
), uJ = /* @__PURE__ */ t.forwardRef(gJ), xJ = uJ, RJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4M6.662 6h2.677l2.4 6H10v3H9v-3H7v3H6v-3H4.261l2.4-6Z"
      }
    )
  }
), jJ = /* @__PURE__ */ t.forwardRef(RJ), MJ = jJ, HJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 12V6h1v4.293l5.646-5.647.708.708L5.707 11H10v1z",
        clipRule: "evenodd"
      }
    )
  }
), CJ = /* @__PURE__ */ t.forwardRef(HJ), yJ = CJ, bJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 2v7.793l3.146-3.147.708.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2zM13 12v1H3v-1z",
        clipRule: "evenodd"
      }
    )
  }
), VJ = /* @__PURE__ */ t.forwardRef(bJ), LJ = VJ, zJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 12H6v-1h4.293L4.646 5.354l.708-.708L11 10.293V6h1z",
        clipRule: "evenodd"
      }
    )
  }
), SJ = /* @__PURE__ */ t.forwardRef(zJ), kJ = SJ, FJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.5 3v7.793l3.146-3.147.708.708L8 12.707 3.646 8.354l.708-.708L7.5 10.793V3z",
        clipRule: "evenodd"
      }
    )
  }
), $J = /* @__PURE__ */ t.forwardRef(FJ), BJ = $J, AJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 13V3h1v10zm5.646-9.354.708.708L6.207 7.5H14v1H6.207l3.147 3.146-.708.708L4.293 8z",
        clipRule: "evenodd"
      }
    )
  }
), EJ = /* @__PURE__ */ t.forwardRef(AJ), _J = EJ, OJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m3.207 8.5 2.147 2.146-.707.708L1.293 8l3.354-3.354.707.708L3.207 7.5h9.586l-2.146-2.146.707-.708L14.707 8l-3.353 3.354-.707-.707L12.793 8.5z",
        clipRule: "evenodd"
      }
    )
  }
), DJ = /* @__PURE__ */ t.forwardRef(OJ), PJ = DJ, TJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.647 3.646.707.708L5.207 7.5H13v1H5.207l3.147 3.146-.707.708L3.293 8z",
        clipRule: "evenodd"
      }
    )
  }
), qJ = /* @__PURE__ */ t.forwardRef(TJ), IJ = qJ, ZJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 13h-1V3h1zM9.793 7.5 6.646 4.354l.708-.708L11.707 8l-4.353 4.354-.708-.708L9.793 8.5H2v-1z",
        clipRule: "evenodd"
      }
    )
  }
), WJ = /* @__PURE__ */ t.forwardRef(ZJ), GJ = WJ, NJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.793 7.5 7.646 4.354l.708-.708L12.707 8l-4.353 4.354-.708-.707L10.793 8.5H3v-1z",
        clipRule: "evenodd"
      }
    )
  }
), UJ = /* @__PURE__ */ t.forwardRef(NJ), YJ = UJ, QJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.293 3.354 3.353-.707.708L8.5 3.207v9.586l2.146-2.147.708.707L8 14.707l-3.354-3.354.708-.707L7.5 12.793V3.207L5.354 5.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), KJ = /* @__PURE__ */ t.forwardRef(QJ), XJ = KJ, JJ = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4h6v1H5.707l5.647 5.646-.708.708L5 5.707V10H4z",
        clipRule: "evenodd"
      }
    )
  }
), eee = /* @__PURE__ */ t.forwardRef(JJ), lee = eee, oee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4H3V3h10zm-5 .293 4.354 4.353-.708.708L8.5 6.207V14h-1V6.207L4.354 9.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), nee = /* @__PURE__ */ t.forwardRef(oee), iee = nee, ree = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4v6h-1V5.707l-5.646 5.647-.708-.708L10.293 5H6V4z",
        clipRule: "evenodd"
      }
    )
  }
), tee = /* @__PURE__ */ t.forwardRef(ree), aee = tee, see = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 3.293 4.354 4.353-.707.708L8.5 5.207V13h-1V5.207L4.354 8.354l-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), dee = /* @__PURE__ */ t.forwardRef(see), cee = dee, hee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 7.293 4.354 3.646l-.708.708L8 8.707l4.354-4.353-.707-.708zm0 4L4.354 7.646l-.708.708L8 12.707l4.354-4.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), wee = /* @__PURE__ */ t.forwardRef(hee), vee = wee, fee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m7.647 3.646.707.708L4.707 8l3.647 3.646-.707.707L3.293 8zm4 0 .707.708L8.707 8l3.647 3.646-.707.707L7.292 8l4.353-4.354Z",
        clipRule: "evenodd"
      }
    )
  }
), mee = /* @__PURE__ */ t.forwardRef(fee), pee = mee, gee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.354 3.646 8.707 8l-4.353 4.354-.708-.707L7.293 8 3.646 4.354zm4 0L12.707 8l-4.353 4.354-.708-.707L11.293 8 7.646 4.354z",
        clipRule: "evenodd"
      }
    )
  }
), uee = /* @__PURE__ */ t.forwardRef(gee), xee = uee, Ree = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 3.293 4.354 4.353-.707.708L8 4.707 4.354 8.354l-.708-.708zm0 4 4.354 4.353-.707.708L8 8.707l-3.646 3.647-.708-.707L8 7.292Z",
        clipRule: "evenodd"
      }
    )
  }
), jee = /* @__PURE__ */ t.forwardRef(Ree), Mee = jee, Hee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.036 3.964H8.293v-1h4.743v4.743h-1zM2.965 8.293h1v3.743h3.742v1H2.965z",
        clipRule: "evenodd"
      }
    )
  }
), Cee = /* @__PURE__ */ t.forwardRef(Hee), yee = Cee, bee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 9.293 4.354 5.646l-.708.708L8 10.707l4.354-4.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Vee = /* @__PURE__ */ t.forwardRef(bee), Lee = Vee, zee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.647 4.646.707.708L3.707 8l2.647 2.646-.707.708L2.293 8zM12.293 8 9.647 5.354l.707-.708L13.707 8l-3.353 3.354-.707-.707z",
        clipRule: "evenodd"
      }
    )
  }
), See = /* @__PURE__ */ t.forwardRef(zee), kee = See, Fee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m6.707 8 3.647 3.646-.707.708L5.293 8l4.354-4.354.707.708z",
        clipRule: "evenodd"
      }
    )
  }
), $ee = /* @__PURE__ */ t.forwardRef(Fee), Bee = $ee, Aee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.293 8 5.646 4.354l.708-.708L10.707 8l-4.353 4.354-.708-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Eee = /* @__PURE__ */ t.forwardRef(Aee), _ee = Eee, Oee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 2.293 3.354 3.353-.707.708L8 3.707 5.354 6.354l-.708-.708zm0 10L5.354 9.646l-.708.708L8 13.707l3.354-3.353-.707-.708z",
        clipRule: "evenodd"
      }
    )
  }
), Dee = /* @__PURE__ */ t.forwardRef(Oee), Pee = Dee, Tee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.964 2.964h4.743v1H3.964v3.743h-1zm9.072 9.072V8.293h1v4.743H8.293v-1z",
        clipRule: "evenodd"
      }
    )
  }
), qee = /* @__PURE__ */ t.forwardRef(Tee), Iee = qee, Zee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 6.707-3.646 3.647-.708-.708L8 5.293l4.354 4.353-.707.708z",
        clipRule: "evenodd"
      }
    )
  }
), Wee = /* @__PURE__ */ t.forwardRef(Zee), Gee = Wee, Nee = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#shapes-diamond-off_svg__a)", children: /* @__PURE__ */ l.jsx("path", { d: "m15.5 8-2.336 2.336-7.5-7.5L8 .5zm-4.104 4.104 3.25 3.25.708-.708-14-14-.708.708 3.25 3.25L.5 8 8 15.5z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-diamond-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Uee = /* @__PURE__ */ t.forwardRef(Nee), Yee = Uee, Qee = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#shapes-diamond_svg__a)", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15.5 8 8 .5.5 8 8 15.5z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-diamond_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), Kee = /* @__PURE__ */ t.forwardRef(Qee), Xee = Kee, Jee = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m4.707 6 1.647 1.646-.707.708L2.793 5.5l2.854-2.854.707.708L4.707 5h8.615l-2.144 8H3v-1h7.41l1.608-6h-7.31Z",
        clipRule: "evenodd"
      }
    )
  }
), e1e = /* @__PURE__ */ t.forwardRef(Jee), l1e = e1e, o1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.707-1.773-1.771a6 6 0 0 1-8.456-8.456L1.647 2.354zM14 8c0 .926-.21 1.804-.585 2.587L5.413 2.585A6 6 0 0 1 14 8"
      }
    )
  }
), n1e = /* @__PURE__ */ t.forwardRef(o1e), i1e = n1e, r1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
        clipRule: "evenodd"
      }
    )
  }
), t1e = /* @__PURE__ */ t.forwardRef(r1e), a1e = t1e, s1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m2 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464z",
        clipRule: "evenodd"
      }
    )
  }
), d1e = /* @__PURE__ */ t.forwardRef(s1e), c1e = d1e, h1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.515 2h4.97L14 5.515v4.97L10.485 14h-4.97L2 10.485v-4.97z",
        clipRule: "evenodd"
      }
    )
  }
), w1e = /* @__PURE__ */ t.forwardRef(h1e), v1e = w1e, f1e = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#shapes-shape-square-off_svg__a)", children: /* @__PURE__ */ l.jsx("path", { d: "m1.354.646 14 14-.707.707L13.293 14H2V2.707L.646 1.354zM14 2v9.172L4.828 2z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "shapes-shape-square-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), m1e = /* @__PURE__ */ t.forwardRef(f1e), p1e = m1e, g1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v12H2z",
        clipRule: "evenodd"
      }
    )
  }
), u1e = /* @__PURE__ */ t.forwardRef(g1e), x1e = u1e, R1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 1.24 7.366 12.758H.634z",
        clipRule: "evenodd"
      }
    )
  }
), j1e = /* @__PURE__ */ t.forwardRef(R1e), M1e = j1e, H1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.456 8H8.67A4.5 4.5 0 0 0 7 11.5c0 .925.28 1.785.758 2.5h-4.91zM11 14.5V12H8.5v-1H11V8.5h1V11h2.5v1H12v2.5z"
      }
    )
  }
), C1e = /* @__PURE__ */ t.forwardRef(H1e), y1e = C1e, b1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3.671 4H4.456l-1.608 6h4.91A4.5 4.5 0 0 1 7 11.5c0-1.414.652-2.675 1.671-3.5m1.829 6.207 4.854-4.853-.707-.708-4.147 4.147-1.646-1.646-.708.707z"
      }
    )
  }
), V1e = /* @__PURE__ */ t.forwardRef(b1e), L1e = V1e, z1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4H7.67A4.5 4.5 0 0 0 6 11.5c0 .925.28 1.785.758 2.5h-3.91zM8.5 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m1.5 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), S1e = /* @__PURE__ */ t.forwardRef(z1e), k1e = S1e, F1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.456 8H8.67A4.5 4.5 0 0 0 7 11.5c0 .925.28 1.785.758 2.5h-4.91zM8.5 12h6v-1h-6z"
      }
    )
  }
), $1e = /* @__PURE__ */ t.forwardRef(F1e), B1e = $1e, A1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .258 1.19 1.305 1.681-.536.378 1.725 1.724.377-.535 1.682L13.743 6l-1.305 1.189.535 1.682-.973.213v5.655l-4-1.6-4 1.6V9.084l-.973-.213.536-1.682L2.258 6l1.305-1.189-.536-1.682 1.725-.377.377-1.725 1.682.536zM5 10.384v2.877l3-1.2 3 1.2v-2.877l-.129.589-1.682-.536L8 11.742l-1.189-1.305-1.682.536zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
        clipRule: "evenodd"
      }
    )
  }
), E1e = /* @__PURE__ */ t.forwardRef(A1e), _1e = E1e, O1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.934 2h8.132l-.25 2h2.336l-1.34 5h-1.62l-.25 2h-1.79l.535 2H11v1H5v-1h1.312l.536-2h-1.79l-.25-2h-1.62l-1.34-5h2.336zm.375 3H3.15l.804 3h.729l-.375-3Zm3.574 6-.535 2h1.304l-.536-2zm3.433-3h.729l.803-3h-1.157zM9.5 5h-3V4h3z",
        clipRule: "evenodd"
      }
    )
  }
), D1e = /* @__PURE__ */ t.forwardRef(O1e), P1e = D1e, T1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4c0-.508.34-.999.956-1.39a4 4 0 0 1 1.19-.5A6.002 6.002 0 0 1 8 14 6 6 0 0 1 6.983 2.086C6.423 2.56 6 3.205 6 4a2 2 0 0 0 2.517 1.932l-.258-.966A1.002 1.002 0 0 1 7 4M5 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 4a4 4 0 0 1-2.83-1.172l.707-.707A3 3 0 0 0 8 10a3 3 0 0 0 2.121-.879l.707.707A4 4 0 0 1 8 11",
        clipRule: "evenodd"
      }
    )
  }
), q1e = /* @__PURE__ */ t.forwardRef(T1e), I1e = q1e, Z1e = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#social-bookmark-off_svg__a)", children: /* @__PURE__ */ l.jsx("path", { d: "m1.354.646 14 14-.707.708L13 13.707v1.643l-5-2.778-5 2.778V3.707L.646 1.354zM13 1v9.172L3.828 1z" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "social-bookmark-off_svg__a", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), W1e = /* @__PURE__ */ t.forwardRef(Z1e), G1e = W1e, N1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 1H3v14.35l5-2.778 5 2.778z" })
  }
), U1e = /* @__PURE__ */ t.forwardRef(N1e), Y1e = U1e, Q1e = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm9 4H5V5h6zm0 3H5V8h6z",
        clipRule: "evenodd"
      }
    )
  }
), K1e = /* @__PURE__ */ t.forwardRef(Q1e), X1e = K1e, J1e = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 2H4v8h6.29l2.467 2.467.661-2.467H15z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 6H1v7h1.582l.661 2.467L5.71 13H9v-2H8v1H5.296l-1.535 1.536L3.349 12H2V7h1z"
        }
      )
    ]
  }
), ele = /* @__PURE__ */ t.forwardRef(J1e), lle = ele, ole = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M14.002 2h-12v10h2.582l.66 2.467 1.888-1.887a4.5 4.5 0 0 1 6.87-4.822z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.002 14.5V12h-2.5v-1h2.5V8.5h1V11h2.5v1h-2.5v2.5z"
        }
      )
    ]
  }
), nle = /* @__PURE__ */ t.forwardRef(ole), ile = nle, rle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 2H2v10h2.582l.661 2.467L7.71 12H14z" })
  }
), tle = /* @__PURE__ */ t.forwardRef(rle), ale = tle, sle = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.61 7h2.78l.5 2H13v2.5h1V11h1v2h-1v-.5h-1V15H3v-2.5H2v.5H1v-2h1v.5h1V9h3.11zM5 12.5h6v-1H5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M15 1H7v5h3.61l.62 2.48L13.706 6H15z" })
    ]
  }
), dle = /* @__PURE__ */ t.forwardRef(sle), cle = dle, hle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.171 9.828A4 4 0 0 0 8 11a4 4 0 0 0 2.828-1.172l-.707-.707A3 3 0 0 1 8 10a3 3 0 0 1-2.122-.879z",
        clipRule: "evenodd"
      }
    )
  }
), wle = /* @__PURE__ */ t.forwardRef(hle), vle = wle, fle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 9v1h6V9z",
        clipRule: "evenodd"
      }
    )
  }
), mle = /* @__PURE__ */ t.forwardRef(fle), ple = mle, gle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4.122 5.879A3 3 0 0 1 8 10c.828 0 1.578.335 2.121.879l.707-.707A4 4 0 0 0 8 9a4 4 0 0 0-2.829 1.172z",
        clipRule: "evenodd"
      }
    )
  }
), ule = /* @__PURE__ */ t.forwardRef(gle), xle = ule, Rle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4.04 8.57l-.01-.07h7.94l-.011.07a4 4 0 0 1-7.92 0Z",
        clipRule: "evenodd"
      }
    )
  }
), jle = /* @__PURE__ */ t.forwardRef(Rle), Mle = jle, Hle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3.164-.758 1.931-.518-.258-.966-1.932.518zm3.74-.518 1.933.518.258-.966-1.931-.518zM6 11a2 2 0 1 1 4 0h1a3 3 0 1 0-6 0z",
        clipRule: "evenodd"
      }
    )
  }
), Cle = /* @__PURE__ */ t.forwardRef(Hle), yle = Cle, ble = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.001 4.535 6-3.464 6 3.465-3.5 2.02L8 5.114 5.5 6.557v2.887l-3.499 2.02z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 8.867 3-1.733L8 6.268l-1.5.866zm-1 4.618-1-.578 9.501-5.485v1.155zm8.501-2.021-6 3.464-1-.577 7-4.042z"
        }
      )
    ]
  }
), Vle = /* @__PURE__ */ t.forwardRef(ble), Lle = Vle, zle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.001 4.535 6-3.464 6 3.465-12 6.928zm3.499 8.95-1-.578 9.501-5.485v1.155zm8.501-2.021-6 3.464-1-.577 7-4.042z"
      }
    )
  }
), Sle = /* @__PURE__ */ t.forwardRef(zle), kle = Sle, Fle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.001 4.536v6.928l2.817 1.626 9.184-5.301V4.536l-6-3.464zm12 5.774-7 4.041 1 .577 6-3.464z"
      }
    )
  }
), $le = /* @__PURE__ */ t.forwardRef(Fle), Ble = $le, Ale = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m8 9.732-1.5-.866V7.134L8 6.268l1.5.866v1.732z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zM8 5.113 5.5 6.557v2.886L8 10.887l2.5-1.444V6.557z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ele = /* @__PURE__ */ t.forwardRef(Ale), _le = Ele, Ole = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m2.354 1.646 12 12-.707.708-3.07-3.07L8 13.865 2.84 8.694l-.012-.014a3.44 3.44 0 0 1 .33-4.814L1.647 2.354zM13.16 8.694l-.818.82-6.489-6.49a3.43 3.43 0 0 1 1.827.804l.012.01.308.303.308-.302.013-.011a3.44 3.44 0 0 1 4.851 4.852z"
      }
    )
  }
), Dle = /* @__PURE__ */ t.forwardRef(Ole), Ple = Dle, Tle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.992 4.008a3.44 3.44 0 0 0-4.672-.18l-.012.01L8 4.142l-.308-.302-.012-.011A3.44 3.44 0 0 0 2.828 8.68l.012.014L8 13.866l5.16-5.172.012-.014a3.44 3.44 0 0 0-.18-4.672"
      }
    )
  }
), qle = /* @__PURE__ */ t.forwardRef(Tle), Ile = qle, Zle = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.08 3h4.16l1.072 4H4.849z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 0v1h6V0h1v1h2v14H2V1h2V0zm6 2v1h1V2h1v12H3V2h1v1h1V2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Wle = /* @__PURE__ */ t.forwardRef(Zle), Gle = Wle, Nle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 2h14v12H1zm3 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-.5h-1v-1h1zM10 8h3V7h-3zM7.86 9l1 3H3.14l1-3zM10 10h3V9h-3zm3 2h-3v-1h3z",
        clipRule: "evenodd"
      }
    )
  }
), Ule = /* @__PURE__ */ t.forwardRef(Nle), Yle = Ule, Qle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 7.116v2.056L5.404 2.576 5.454 2h-.626L4.5 1.672V1h7v1h-.954l.422 4.84zM9.293 10l4.354 4.354.707-.708-12-12-.708.708 3.475 3.474-.089 1.012L4 7.116V10h3.5v5h1v-5z"
      }
    )
  }
), Kle = /* @__PURE__ */ t.forwardRef(Qle), Xle = Kle, Jle = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 2h.954l-.422 4.84L4 7.116V10h3.5v5h1v-5H12V7.116l-1.032-.276L10.546 2h.954V1h-7z"
      }
    )
  }
), eoe = /* @__PURE__ */ t.forwardRef(Jle), loe = eoe, ooe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6m5.152 13L9.544 8H2.456L.85 14h10.303Zm1.093-4 .804 3h-1.165l.268 1h2.2l-1.34-5h-2.2l.268 1zM11.5 5a1.5 1.5 0 0 0-1.594-1.497l-.062-.998a2.5 2.5 0 0 1 .557 4.963l-.26-.974A1.5 1.5 0 0 0 11.5 5"
      }
    )
  }
), noe = /* @__PURE__ */ t.forwardRef(ooe), ioe = noe, roe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.582 11.875 11.544 8H8.707L7.691 6.984a3 3 0 1 0-2.676-2.676L2.354 1.646l-.708.708 12 12 .708-.708zM2.848 14h8.324l-6-6h-.716z"
      }
    )
  }
), toe = /* @__PURE__ */ t.forwardRef(roe), aoe = toe, soe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.152 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6m5.151 13-1.608-6H4.608L3 14z"
      }
    )
  }
), doe = /* @__PURE__ */ t.forwardRef(soe), coe = doe, hoe = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M10 8h1V7h-1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m8.001 1.072-6 3.464v6.928l6 3.464 6-3.464V4.536zM11 6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1H9V6zM5.5 6h-1v1.44l.7.56-.7.56V10h1v-.96l.5-.4.5.4V10h1V8.56L6.8 8l.7-.56V6h-1v.96l-.5.4-.5-.4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), woe = /* @__PURE__ */ t.forwardRef(hoe), voe = woe, foe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.5 11H14V3h-2.5zm-1-7.518L8.7 3H3.1L1.72 8.152 2.481 11h4.366l-.587 2.19a1.437 1.437 0 0 0 2.633 1.091L10.5 11.5z"
      }
    )
  }
), moe = /* @__PURE__ */ t.forwardRef(foe), poe = moe, goe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 5H2v8h2.5zm1 7.518L7.3 13h5.6l1.38-5.152L13.519 5H9.152l.587-2.19a1.437 1.437 0 0 0-2.633-1.091L5.5 4.5z"
      }
    )
  }
), uoe = /* @__PURE__ */ t.forwardRef(goe), xoe = uoe, Roe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 2H2v5h5zm2 9v1h2v2h1v-2h2v-1h-2V9h-1v2zM7 9H2v5h5zm7-7H9v5h5z"
      }
    )
  }
), joe = /* @__PURE__ */ t.forwardRef(Roe), Moe = joe, Hoe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 2H2v5h5zm0 7H2v5h5zm7 0H9v5h5zm0-7H9v5h5z"
      }
    )
  }
), Coe = /* @__PURE__ */ t.forwardRef(Hoe), yoe = Coe, boe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 2H2v3h3zm4.5 0h-3v3h3zM14 2h-3v3h3zM5 6.5H2v3h3zm4.5 0h-3v3h3zm4.5 0h-3v3h3zM5 11H2v3h3zm4.5 0h-3v3h3zm4.5 0h-3v3h3z"
      }
    )
  }
), Voe = /* @__PURE__ */ t.forwardRef(boe), Loe = Voe, zoe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M4 2h8v1H4zM2 4v8h12V4zm10 9H4v1h8z" })
  }
), Soe = /* @__PURE__ */ t.forwardRef(zoe), koe = Soe, Foe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 2H4v12h8zm1 2v8h1V4zM2 4h1v8H2z" })
  }
), $oe = /* @__PURE__ */ t.forwardRef(Foe), Boe = $oe, Aoe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m8 .293 2.354 2.353-.708.708L8.5 2.207V7h-1V2.207L6.354 3.354l-.708-.708zM2 4h3v1H3v6h10V5h-2V4h3v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268z",
        clipRule: "evenodd"
      }
    )
  }
), Eoe = /* @__PURE__ */ t.forwardRef(Aoe), _oe = Eoe, Ooe = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 14v-1H2V3h5V2h1v12zm0-8.707V4H3v5.293z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 4H9V3h5v10H9V9.135l1.65-.952L13 9.539z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.318 6.318c0 .728-.59 1.318-1.318 1.318V5c.728 0 1.318.59 1.318 1.318"
        }
      )
    ]
  }
), Doe = /* @__PURE__ */ t.forwardRef(Ooe), Poe = Doe, Toe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm5.5 2.5v3h1v-3zm0 4v1h1v-1z",
        clipRule: "evenodd"
      }
    )
  }
), qoe = /* @__PURE__ */ t.forwardRef(Toe), Ioe = qoe, Zoe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.134 2H3v12h10V4.751zm-.884.849V5.6h2.866zM10.002 10V7H7v1h1.295L6 10.291V8.997H5v3h3.001v-1H6.712l2.291-2.29V10z",
        clipRule: "evenodd"
      }
    )
  }
), Woe = /* @__PURE__ */ t.forwardRef(Zoe), Goe = Woe, Noe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5V2h1v4H2V5zm5-3h1v3h3v1h-4zm-8 8h4v4H5v-3H2zm8 0h4v1h-3v3h-1z",
        clipRule: "evenodd"
      }
    )
  }
), Uoe = /* @__PURE__ */ t.forwardRef(Noe), Yoe = Uoe, Qoe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2v1H3v3H2V2zm7 1h-3V2h4v4h-1zM3 13v-3H2v4h4v-1zm10 0v-3h1v4h-4v-1z",
        clipRule: "evenodd"
      }
    )
  }
), Koe = /* @__PURE__ */ t.forwardRef(Qoe), Xoe = Koe, Joe = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 2H4v8h8zM3 12H1v2h2zm3 0H4v2h2zm3 0H7v2h2zm3 0h-2v2h2zm3 0h-2v2h2z"
      }
    )
  }
), ene = /* @__PURE__ */ t.forwardRef(Joe), lne = ene, one = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-9 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-9 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-9 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), nne = /* @__PURE__ */ t.forwardRef(one), ine = nne, rne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), tne = /* @__PURE__ */ t.forwardRef(rne), ane = tne, sne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.5 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-9 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), dne = /* @__PURE__ */ t.forwardRef(sne), cne = dne, hne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), wne = /* @__PURE__ */ t.forwardRef(hne), vne = wne, fne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.5 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      }
    )
  }
), mne = /* @__PURE__ */ t.forwardRef(fne), pne = mne, gne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.333 2H6.667v12h2.666zm1 12H13V2h-2.667zM3 2h2.667v12H3z"
      }
    )
  }
), une = /* @__PURE__ */ t.forwardRef(gne), xne = une, Rne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 2h4v12H2zm5 6.5V14h7V8.5zm7-1V2H7v5.5z" })
  }
), jne = /* @__PURE__ */ t.forwardRef(Rne), Mne = jne, Hne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.5 3h3v4.5h-3zm-1 4.5V3H2v4.5zM2 8.5h3.5V13H2zm4.5 0h3V13h-3zm4 0V13H14V8.5zm3.5-1V3h-3.5v4.5z"
      }
    )
  }
), Cne = /* @__PURE__ */ t.forwardRef(Hne), yne = Cne, bne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 2H2v3h3zm1 2h8V3H6zM5 6H2v3h3zm1 2h8V7H6zm-1 2H2v3h3zm1 2h8v-1H6z"
      }
    )
  }
), Vne = /* @__PURE__ */ t.forwardRef(bne), Lne = Vne, zne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14 3H2v2.667h12zM2 9.333V6.667h12v2.666zm0 1V13h12v-2.667z"
      }
    )
  }
), Sne = /* @__PURE__ */ t.forwardRef(zne), kne = Sne, Fne = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 3h10v10H2zm9 7.293L7.207 6.5l2.5-2.5H11zM3 4v5.293L8.293 4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 4v8h1V4z" })
    ]
  }
), $ne = /* @__PURE__ */ t.forwardRef(Fne), Bne = $ne, Ane = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2h5v5h-1V3.707L7.354 9.354l-.708-.708L12.293 3H9zM2 3h5v1H3v9h9V9h1v5H2z",
        clipRule: "evenodd"
      }
    )
  }
), Ene = /* @__PURE__ */ t.forwardRef(Ane), _ne = Ene, One = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14 2H2v3h12zm0 6H2V7h12zm0 3H2v-1h12zM2 14h12v-1H2z"
      }
    )
  }
), Dne = /* @__PURE__ */ t.forwardRef(One), Pne = Dne, Tne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M8 2H3v6h5zm0 7H2v5h6zm6-5H9v8h5z" })
  }
), qne = /* @__PURE__ */ t.forwardRef(Tne), Ine = qne, Zne = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.455 6.773a1.318 1.318 0 1 1 2.636 0 1.318 1.318 0 0 1-2.636 0"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 3h10v10H4zm9 1v5.54l-2.35-1.357L7.8 9.828 5 8.211V4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 4v8h1V4z" })
    ]
  }
), Wne = /* @__PURE__ */ t.forwardRef(Zne), Gne = Wne, Nne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 3H6v10h8zM4 4h1v8H4zM3 5H2v6h1z" })
  }
), Une = /* @__PURE__ */ t.forwardRef(Nne), Yne = Une, Qne = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 3H2v2h12z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 6H2v7h12zm-7.14 4.842 1.332-4 .95.316-1.334 4-.949-.316ZM5.646 7.146l.707.708L5.207 9l1.147 1.146-.707.708L3.793 9l1.854-1.854ZM10.793 9 9.647 7.854l.707-.708L12.207 9l-1.853 1.854-.707-.708z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Kne = /* @__PURE__ */ t.forwardRef(Qne), Xne = Kne, Jne = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 1H1v2h6zM1 7V4h6v3zm8 0V4h6v3zm6-6v2H9V1zM7 9H1v2h6zm0 3H1v3h6zm2 0h6v3H9zm6-1H9V9h6z"
      }
    )
  }
), eie = /* @__PURE__ */ t.forwardRef(Jne), lie = eie, oie = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h10v2H2zm0 3v5h10V6z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M13 12V5h1v8H3v-1z" })
    ]
  }
), nie = /* @__PURE__ */ t.forwardRef(oie), iie = nie, rie = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 3H2v2h12z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 6H2v7h12zM5.293 9 4.146 7.854l.708-.708L6.707 9l-1.853 1.854-.708-.707zM10 11H7v-1h3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), tie = /* @__PURE__ */ t.forwardRef(rie), aie = tie, sie = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M2 3h12v2H2zm0 3v7h12V6z" })
  }
), die = /* @__PURE__ */ t.forwardRef(sie), cie = die, hie = (e, o) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: [
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M12 3H2v3h10zM5 7H2v4h3zm1 4V7h6v4z" }),
      /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M3 12v1h11V5h-1v7z" })
    ]
  }
), wie = /* @__PURE__ */ t.forwardRef(hie), vie = wie, fie = (e, o) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    display: "inline-block",
    ref: o,
    ...e,
    children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M14 3H2v4h12zM2 13V8h4v5zm5 0h7V8H7z" })
  }
), mie = /* @__PURE__ */ t.forwardRef(fie), pie = mie, jie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-3-d-axis",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Gl, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ab, { ...i, ...r, ref: n });
  }
), Mie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-cloth",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Yl, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cb, { ...i, ...r, ref: n });
  }
), Hie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-cube",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xl, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vb, { ...i, ...r, ref: n });
  }
), Cie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-dolly",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(lo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pb, { ...i, ...r, ref: n });
  }
), yie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-emissive",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(io, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xb, { ...i, ...r, ref: n });
}), bie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-explode",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ao, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mb, { ...i, ...r, ref: n });
}), Vie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-instance",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ho, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yb, { ...i, ...r, ref: n });
}), Lie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-light-rect",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(fo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lb, { ...i, ...r, ref: n });
}), zie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-light-rotate",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(go, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kb, { ...i, ...r, ref: n });
}), Sie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-material",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ro, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bb, { ...i, ...r, ref: n });
}), kie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-move-global",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ho, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_b, { ...i, ...r, ref: n });
}), Fie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-reference",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(bo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pb, { ...i, ...r, ref: n });
}), $ie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-rotate-3-d",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(zo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ib, { ...i, ...r, ref: n });
}), Bie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-rotate-global",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Fo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gb, { ...i, ...r, ref: n });
}), Aie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-segment",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ao, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yb, { ...i, ...r, ref: n });
}), Eie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-shader-ball",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Oo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xb, { ...i, ...r, ref: n });
}), _ie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-shader",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(To, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lV, { ...i, ...r, ref: n });
  }
), Oie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-skeleton",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Zo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iV, { ...i, ...r, ref: n });
}), Die = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "svg-3-d-teapot",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(No, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aV, { ...i, ...r, ref: n });
  }
), Pie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-teleport",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Qo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cV, { ...i, ...r, ref: n });
}), Tie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "svg-3-d-texture",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Jo, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vV, { ...i, ...r, ref: n });
}), qie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-auto-record-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(on, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pV, { ...i, ...r, ref: n });
}), Iie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-auto-record",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(tn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xV, { ...i, ...r, ref: n });
}), Zie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-broadcast",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(dn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MV, { ...i, ...r, ref: n });
  }
), Wie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-camera-add",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(wn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yV, { ...i, ...r, ref: n });
  }
), Gie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-camera-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(mn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LV, { ...i, ...r, ref: n });
  }
), Nie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-camera",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(un, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kV, { ...i, ...r, ref: n });
  }
), Uie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-clap-board",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(jn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BV, { ...i, ...r, ref: n });
  }
), Yie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-display-surround",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Cn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_V, { ...i, ...r, ref: n });
}), Qie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-eject",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Vn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PV, { ...i, ...r, ref: n });
  }
), Kie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-equalizer",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Sn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IV, { ...i, ...r, ref: n });
  }
), Xie = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-faders",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($n, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GV, { ...i, ...r, ref: n });
  }
), Jie = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-fast-forward",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(En, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YV, { ...i, ...r, ref: n });
}), e0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-fast-reverse",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XV, { ...i, ...r, ref: n });
}), l0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-film-add",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(qn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lL, { ...i, ...r, ref: n });
  }
), o0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-film-collection",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iL, { ...i, ...r, ref: n });
}), n0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-film",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Un, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aL, { ...i, ...r, ref: n });
  }
), i0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-forward-10",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Kn, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cL, { ...i, ...r, ref: n });
  }
), r0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-fps",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ei, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vL, { ...i, ...r, ref: n });
  }
), t0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-high-quality",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ni, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pL, { ...i, ...r, ref: n });
}), a0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-hud",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ti, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xL, { ...i, ...r, ref: n });
  }
), s0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-loop-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(di, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ML, { ...i, ...r, ref: n });
  }
), d0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-loop",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(wi, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yL, { ...i, ...r, ref: n });
  }
), c0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-microphone-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mi, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LL, { ...i, ...r, ref: n });
}), h0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-microphone",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ui, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kL, { ...i, ...r, ref: n });
}), w0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-next",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ji, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BL, { ...i, ...r, ref: n });
  }
), v0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-notes",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ci, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_L, { ...i, ...r, ref: n });
  }
), f0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-pause",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Vi, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PL, { ...i, ...r, ref: n });
  }
), m0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-picture-in-picture",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Si, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IL, { ...i, ...r, ref: n });
}), p0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-play",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($i, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GL, { ...i, ...r, ref: n });
  }
), g0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-previous",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ei, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YL, { ...i, ...r, ref: n });
  }
), u0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-record",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Di, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XL, { ...i, ...r, ref: n });
  }
), x0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-replay-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(qi, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lz, { ...i, ...r, ref: n });
  }
), R0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-replay",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Wi, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iz, { ...i, ...r, ref: n });
  }
), j0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-reverse-10",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ui, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(az, { ...i, ...r, ref: n });
  }
), M0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-soundwaves",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ki, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cz, { ...i, ...r, ref: n });
}), H0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-speaker-high",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vz, { ...i, ...r, ref: n });
}), C0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-speaker-low",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(n0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pz, { ...i, ...r, ref: n });
}), y0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-speaker-medium",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xz, { ...i, ...r, ref: n });
}), b0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-speaker-mute",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mz, { ...i, ...r, ref: n });
}), V0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-speaker-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yz, { ...i, ...r, ref: n });
}), L0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-speaker",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(m0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lz, { ...i, ...r, ref: n });
  }
), z0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-step-forward",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kz, { ...i, ...r, ref: n });
}), S0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-step-reverse",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bz, { ...i, ...r, ref: n });
}), k0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-stop",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(C0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_z, { ...i, ...r, ref: n });
  }
), F0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-videocam-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pz, { ...i, ...r, ref: n });
}), $0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "av-videocam",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(S0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Iz, { ...i, ...r, ref: n });
  }
), B0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "av-watch-party",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gz, { ...i, ...r, ref: n });
}), A0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-add-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yz, { ...i, ...r, ref: n });
}), E0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-add",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(D0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xz, { ...i, ...r, ref: n });
  }
), _0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-alarm",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(q0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lS, { ...i, ...r, ref: n });
  }
), O0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-bell-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iS, { ...i, ...r, ref: n });
}), D0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-bell",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(U0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aS, { ...i, ...r, ref: n });
  }
), P0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-calendar-event",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(K0, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cS, { ...i, ...r, ref: n });
}), T0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-calendar",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(er, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vS, { ...i, ...r, ref: n });
}), q0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-cancel",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pS, { ...i, ...r, ref: n });
}), I0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-check-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(tr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xS, { ...i, ...r, ref: n });
}), Z0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-check-multi-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MS, { ...i, ...r, ref: n });
}), W0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-check",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(wr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yS, { ...i, ...r, ref: n });
  }
), G0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-clipboard",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LS, { ...i, ...r, ref: n });
}), N0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-clock",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ur, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kS, { ...i, ...r, ref: n });
  }
), U0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-close-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(jr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BS, { ...i, ...r, ref: n });
}), Y0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-close",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Cr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_S, { ...i, ...r, ref: n });
  }
), Q0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-cog-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PS, { ...i, ...r, ref: n });
}), K0e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-cog",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Sr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IS, { ...i, ...r, ref: n });
  }
), X0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-copy-doc",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($r, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GS, { ...i, ...r, ref: n });
}), J0e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-copy-generic",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Er, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YS, { ...i, ...r, ref: n });
}), ere = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-enter",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Dr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XS, { ...i, ...r, ref: n });
  }
), lre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-error",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(qr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lk, { ...i, ...r, ref: n });
  }
), ore = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-exit",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Wr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ik, { ...i, ...r, ref: n });
  }
), nre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-eye-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ur, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ak, { ...i, ...r, ref: n });
}), ire = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-eye",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Kr, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ck, { ...i, ...r, ref: n });
  }
), rre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-filter",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(et, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vk, { ...i, ...r, ref: n });
}), tre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-help-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pk, { ...i, ...r, ref: n });
}), are = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-history",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(tt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xk, { ...i, ...r, ref: n });
}), sre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-home-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mk, { ...i, ...r, ref: n });
}), dre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-home",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(wt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yk, { ...i, ...r, ref: n });
  }
), cre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-info-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lk, { ...i, ...r, ref: n });
}), hre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-link-break",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ut, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kk, { ...i, ...r, ref: n });
}), wre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-link",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(jt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bk, { ...i, ...r, ref: n });
  }
), vre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-lock-closed",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ct, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_k, { ...i, ...r, ref: n });
}), fre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-lock-open",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pk, { ...i, ...r, ref: n });
}), mre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-magnifying-glass-minus",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    St,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    Ik,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), pre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-magnifying-glass-plus",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    $t,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    Gk,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), gre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-magnifying-glass",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Et, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yk, { ...i, ...r, ref: n });
}), ure = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-menu",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Dt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xk, { ...i, ...r, ref: n });
  }
), xre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-more-horiz",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lF, { ...i, ...r, ref: n });
}), Rre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-more-vert",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iF, { ...i, ...r, ref: n });
}), jre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-paperplane",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ut, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aF, { ...i, ...r, ref: n });
}), Mre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-redo",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Kt, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cF, { ...i, ...r, ref: n });
  }
), Hre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-refresh",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ea, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vF, { ...i, ...r, ref: n });
}), Cre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-reset",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(na, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pF, { ...i, ...r, ref: n });
  }
), yre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-retry",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ta, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xF, { ...i, ...r, ref: n });
  }
), bre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-share",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(da, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MF, { ...i, ...r, ref: n });
  }
), Vre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-sort",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(wa, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yF, { ...i, ...r, ref: n });
  }
), Lre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-star",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ma, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LF, { ...i, ...r, ref: n });
  }
), zre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-subtract-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ua, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kF, { ...i, ...r, ref: n });
}), Sre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-subtract",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ja, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BF, { ...i, ...r, ref: n });
}), kre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-sync-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ca, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_F, { ...i, ...r, ref: n });
}), Fre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-sync",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Va, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PF, { ...i, ...r, ref: n });
  }
), $re = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-timer",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Sa, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IF, { ...i, ...r, ref: n });
  }
), Bre = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-trash",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($a, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GF, { ...i, ...r, ref: n });
  }
), Are = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "common-undo",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ea, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YF, { ...i, ...r, ref: n });
  }
), Ere = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "common-warning",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Da, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XF, { ...i, ...r, ref: n });
}), _re = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-cloud-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qa, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(l$, { ...i, ...r, ref: n });
}), Ore = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-cloud",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wa, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(i$, { ...i, ...r, ref: n });
}), Dre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-data",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ua, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(a$, { ...i, ...r, ref: n });
}), Pre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-download",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ka, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(c$, { ...i, ...r, ref: n });
}), Tre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-envelope-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    es,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    v$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), qre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-envelope",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ns, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(p$, { ...i, ...r, ref: n });
}), Ire = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-firewall-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    ts,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    x$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Zre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-firewall",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ds, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(M$, { ...i, ...r, ref: n });
}), Wre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-forward",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ws, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(y$, { ...i, ...r, ref: n });
}), Gre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-isp-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ms, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(L$, { ...i, ...r, ref: n });
}), Nre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-isp",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(us, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(k$, { ...i, ...r, ref: n });
}), Ure = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-network-signal-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    js,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    B$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Yre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-network-signal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    Cs,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    _$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Qre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-reply",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vs, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(P$, { ...i, ...r, ref: n });
}), Kre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-sync-warning",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    Ss,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    I$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Xre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-transfer-horizontal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    $s,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    G$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Jre = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-transfer-vertical",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    Es,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    Y$,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), ete = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-upload",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ds, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(X$, { ...i, ...r, ref: n });
}), lte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-wifi-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qs, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lB, { ...i, ...r, ref: n });
}), ote = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "communication-wifi",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ws, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iB, { ...i, ...r, ref: n });
}), nte = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "cursor-arrow",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Us, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aB, { ...i, ...r, ref: n });
  }
), ite = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-crosshair",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ks, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cB, { ...i, ...r, ref: n });
}), rte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hand-closed",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ed, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vB, { ...i, ...r, ref: n });
}), tte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hand-open",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pB, { ...i, ...r, ref: n });
}), ate = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hand-pinch",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(td, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xB, { ...i, ...r, ref: n });
}), ste = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hand-point",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MB, { ...i, ...r, ref: n });
}), dte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hourglass-end",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(wd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yB, { ...i, ...r, ref: n });
}), cte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hourglass-mid",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(md, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LB, { ...i, ...r, ref: n });
}), hte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hourglass-start",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ud, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kB, { ...i, ...r, ref: n });
}), wte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "cursor-hourglass",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(jd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BB, { ...i, ...r, ref: n });
}), vte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-center",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Cd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_B, { ...i, ...r, ref: n });
}), fte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-e",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PB, { ...i, ...r, ref: n });
}), mte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-n",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Sd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IB, { ...i, ...r, ref: n });
}), pte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-ne",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($d, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GB, { ...i, ...r, ref: n });
}), gte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-nw",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ed, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YB, { ...i, ...r, ref: n });
}), ute = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-s",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XB, { ...i, ...r, ref: n });
}), xte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-se",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lA, { ...i, ...r, ref: n });
}), Rte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-sw",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iA, { ...i, ...r, ref: n });
}), jte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-anchor-w",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ud, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aA, { ...i, ...r, ref: n });
}), Mte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-at-symbol",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Kd, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cA, { ...i, ...r, ref: n });
}), Hte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-backspace",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vA, { ...i, ...r, ref: n });
}), Cte = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-bold",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(n2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pA, { ...i, ...r, ref: n });
  }
), yte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-branch",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xA, { ...i, ...r, ref: n });
}), bte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-bar",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MA, { ...i, ...r, ref: n });
}), Vte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-flow",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yA, { ...i, ...r, ref: n });
}), Lte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-hierarchy",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(m2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LA, { ...i, ...r, ref: n });
}), zte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-performance",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kA, { ...i, ...r, ref: n });
}), Ste = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-pie",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BA, { ...i, ...r, ref: n });
}), kte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-chart-tree",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(C2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_A, { ...i, ...r, ref: n });
}), Fte = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-chart",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(V2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PA, { ...i, ...r, ref: n });
  }
), $te = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-collapse",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IA, { ...i, ...r, ref: n });
}), Bte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-commit",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GA, { ...i, ...r, ref: n });
}), Ate = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-compare",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YA, { ...i, ...r, ref: n });
}), Ete = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-connection",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XA, { ...i, ...r, ref: n });
}), _te = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-expand",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(q2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lE, { ...i, ...r, ref: n });
}), Ote = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-export-to-clipboard",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iE, { ...i, ...r, ref: n });
}), Dte = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-fit",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(U2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aE, { ...i, ...r, ref: n });
  }
), Pte = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-fork",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(K2, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cE, { ...i, ...r, ref: n });
  }
), Tte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-freehand",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ec, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vE, { ...i, ...r, ref: n });
}), qte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-grid-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pE, { ...i, ...r, ref: n });
}), Ite = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-grid",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(tc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xE, { ...i, ...r, ref: n });
  }
), Zte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-h-align-center",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ME, { ...i, ...r, ref: n });
}), Wte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-h-align-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(wc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yE, { ...i, ...r, ref: n });
}), Gte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-h-align-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LE, { ...i, ...r, ref: n });
}), Nte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-header",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(uc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kE, { ...i, ...r, ref: n });
}), Ute = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-image",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(jc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BE, { ...i, ...r, ref: n });
  }
), Yte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-italic",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Cc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_E, { ...i, ...r, ref: n });
}), Qte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-iterate",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PE, { ...i, ...r, ref: n });
}), Kte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-keyframe",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Sc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IE, { ...i, ...r, ref: n });
}), Xte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-layers-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($c, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GE, { ...i, ...r, ref: n });
}), Jte = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-layers",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ec, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YE, { ...i, ...r, ref: n });
}), eae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-line-segment",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XE, { ...i, ...r, ref: n });
}), lae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-list-bullet",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(l_, { ...i, ...r, ref: n });
}), oae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-list-checkmark",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(i_, { ...i, ...r, ref: n });
}), nae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-list-number",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Uc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(a_, { ...i, ...r, ref: n });
}), iae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-markdown",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Kc, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(c_, { ...i, ...r, ref: n });
}), rae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-merge",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(eh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(v_, { ...i, ...r, ref: n });
  }
), tae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-move",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(nh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(p_, { ...i, ...r, ref: n });
  }
), aae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-numbers",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(th, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(x_, { ...i, ...r, ref: n });
}), sae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-paperclip",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(M_, { ...i, ...r, ref: n });
}), dae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-paragraph",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(wh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(y_, { ...i, ...r, ref: n });
}), cae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-pencil",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(L_, { ...i, ...r, ref: n });
}), hae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-pull-close",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(uh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(k_, { ...i, ...r, ref: n });
}), wae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-pull-draft",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(jh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(B_, { ...i, ...r, ref: n });
}), vae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-pull",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ch, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(__, { ...i, ...r, ref: n });
  }
), fae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-rotate-90-clockwise",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(P_, { ...i, ...r, ref: n });
}), mae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-rotate-90-counter",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Sh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(I_, { ...i, ...r, ref: n });
}), pae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-rotate",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($h, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(G_, { ...i, ...r, ref: n });
}), gae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-ruler",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Eh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Y_, { ...i, ...r, ref: n });
  }
), uae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-scale-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(X_, { ...i, ...r, ref: n });
}), xae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-scale-reset",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lO, { ...i, ...r, ref: n });
}), Rae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-scale-up",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iO, { ...i, ...r, ref: n });
}), jae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-scissors",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Uh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aO, { ...i, ...r, ref: n });
}), Mae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-section-bottom",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Kh, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cO, { ...i, ...r, ref: n });
}), Hae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-section-top",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vO, { ...i, ...r, ref: n });
}), Cae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-section",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(n3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pO, { ...i, ...r, ref: n });
}), yae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-select-brush",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xO, { ...i, ...r, ref: n });
}), bae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-signature",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MO, { ...i, ...r, ref: n });
}), Vae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-skip",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(w3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yO, { ...i, ...r, ref: n });
  }
), Lae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sliders",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(m3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LO, { ...i, ...r, ref: n });
}), zae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sort-ascending",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kO, { ...i, ...r, ref: n });
}), Sae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sort-descending",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BO, { ...i, ...r, ref: n });
}), kae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sticker-image",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(C3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_O, { ...i, ...r, ref: n });
}), Fae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sticker-shape",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PO, { ...i, ...r, ref: n });
}), $ae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sticker-text",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IO, { ...i, ...r, ref: n });
}), Bae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sticker-zoom",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GO, { ...i, ...r, ref: n });
}), Aae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-sticker",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YO, { ...i, ...r, ref: n });
}), Eae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-strikethrough",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XO, { ...i, ...r, ref: n });
}), _ae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-stroke-width",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(q3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lD, { ...i, ...r, ref: n });
}), Oae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-style",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(W3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iD, { ...i, ...r, ref: n });
  }
), Dae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-swatches",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aD, { ...i, ...r, ref: n });
}), Pae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-text-align-center",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(K3, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cD, { ...i, ...r, ref: n });
}), Tae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-text-align-full",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vD, { ...i, ...r, ref: n });
}), qae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-text-align-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(n5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pD, { ...i, ...r, ref: n });
}), Iae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-text-align-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xD, { ...i, ...r, ref: n });
}), Zae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-text-framed",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MD, { ...i, ...r, ref: n });
}), Wae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-text",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(w5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yD, { ...i, ...r, ref: n });
  }
), Gae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-trash-delete",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(m5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LD, { ...i, ...r, ref: n });
}), Nae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-typography",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kD, { ...i, ...r, ref: n });
}), Uae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-underline",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BD, { ...i, ...r, ref: n });
}), Yae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-v-align-bottom",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(C5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_D, { ...i, ...r, ref: n });
}), Qae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-v-align-center",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PD, { ...i, ...r, ref: n });
}), Kae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-v-align-top",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ID, { ...i, ...r, ref: n });
}), Xae = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "editor-wand",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GD, { ...i, ...r, ref: n });
  }
), Jae = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "editor-wrench",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YD, { ...i, ...r, ref: n });
}), ese = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-archive",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XD, { ...i, ...r, ref: n });
}), lse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "files-db",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(q5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lP, { ...i, ...r, ref: n });
  }
), ose = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-document-checkmark",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iP, { ...i, ...r, ref: n });
}), nse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-document-new",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aP, { ...i, ...r, ref: n });
}), ise = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-document-preview",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(K5, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cP, { ...i, ...r, ref: n });
}), rse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-document",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vP, { ...i, ...r, ref: n });
}), tse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "files-export",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(n6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pP, { ...i, ...r, ref: n });
  }
), ase = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "files-floppy",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(t6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xP, { ...i, ...r, ref: n });
  }
), sse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-folder-closed",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MP, { ...i, ...r, ref: n });
}), dse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "files-folder-open",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yP, { ...i, ...r, ref: n });
}), cse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "files-import",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(m6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LP, { ...i, ...r, ref: n });
  }
), hse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-2-b-left-click",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kP, { ...i, ...r, ref: n });
}), wse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-0-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BP, { ...i, ...r, ref: n });
}), vse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-0",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(C6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_P, { ...i, ...r, ref: n });
}), fse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-100",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PP, { ...i, ...r, ref: n });
}), mse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-25",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IP, { ...i, ...r, ref: n });
}), pse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-50",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GP, { ...i, ...r, ref: n });
}), gse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-75",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YP, { ...i, ...r, ref: n });
}), use = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-boost",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XP, { ...i, ...r, ref: n });
}), xse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-battery-charging",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(q6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lT, { ...i, ...r, ref: n });
}), Rse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-bluetooth-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iT, { ...i, ...r, ref: n });
}), jse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-bluetooth",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aT, { ...i, ...r, ref: n });
}), Mse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-calculator",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(K6, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cT, { ...i, ...r, ref: n });
}), Hse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-cpu",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(e4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vT, { ...i, ...r, ref: n });
  }
), Cse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-display-collection",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    n4,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    pT,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), yse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-display-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xT, { ...i, ...r, ref: n });
}), bse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-display",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MT, { ...i, ...r, ref: n });
}), Vse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-cloud-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yT, { ...i, ...r, ref: n });
}), Lse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-cloud",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(m4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LT, { ...i, ...r, ref: n });
}), zse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-network-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kT, { ...i, ...r, ref: n });
}), Sse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-network",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BT, { ...i, ...r, ref: n });
}), kse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-removable-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    C4,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    _T,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Fse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-removable",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PT, { ...i, ...r, ref: n });
}), $se = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-usb-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IT, { ...i, ...r, ref: n });
}), Bse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-drive-usb",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GT, { ...i, ...r, ref: n });
}), Ase = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-ethernet",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YT, { ...i, ...r, ref: n });
}), Ese = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-fan-loud",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XT, { ...i, ...r, ref: n });
}), _se = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-fan-quiet",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(q4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lq, { ...i, ...r, ref: n });
}), Ose = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-fan",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(W4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iq, { ...i, ...r, ref: n });
  }
), Dse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gamepad-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aq, { ...i, ...r, ref: n });
}), Pse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gamepad-start",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(K4, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cq, { ...i, ...r, ref: n });
}), Tse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gamepad",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(e7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vq, { ...i, ...r, ref: n });
}), qse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gpu-card-multi",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(n7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pq, { ...i, ...r, ref: n });
}), Ise = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gpu-card-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(t7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xq, { ...i, ...r, ref: n });
}), Zse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gpu-card",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(d7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mq, { ...i, ...r, ref: n });
}), Wse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-gpu-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yq, { ...i, ...r, ref: n });
}), Gse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-gpu",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(m7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lq, { ...i, ...r, ref: n });
  }
), Nse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-headset",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kq, { ...i, ...r, ref: n });
}), Use = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-keyboard",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bq, { ...i, ...r, ref: n });
}), Yse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-laptop",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(C7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_q, { ...i, ...r, ref: n });
}), Qse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-lightning",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pq, { ...i, ...r, ref: n });
}), Kse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mac-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(S7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Iq, { ...i, ...r, ref: n });
}), Xse = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-mac",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gq, { ...i, ...r, ref: n });
  }
), Jse = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-media-optical",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yq, { ...i, ...r, ref: n });
}), ede = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mosaic",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(D7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xq, { ...i, ...r, ref: n });
}), lde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mouse-2-b-right-click",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    q7,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    lI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), ode = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mouse-2-b",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iI, { ...i, ...r, ref: n });
}), nde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mouse-3-b",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U7, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aI, { ...i, ...r, ref: n });
}), ide = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mouse-scrollwheel-active",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    K7,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    cI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), rde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-mouse-scrollwheel",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    ew,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    vI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), tde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-multidrive",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pI, { ...i, ...r, ref: n });
}), ade = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-network-connection",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    tw,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    xI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), sde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-network-pcs",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MI, { ...i, ...r, ref: n });
}), dde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-network",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ww, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yI, { ...i, ...r, ref: n });
}), cde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-nvidia-shield-stand",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    mw,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    LI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), hde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-nvidia-shield",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(uw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kI, { ...i, ...r, ref: n });
}), wde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-performance-high",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(jw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BI, { ...i, ...r, ref: n });
}), vde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-performance-low",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Cw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_I, { ...i, ...r, ref: n });
}), fde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-performance-medium",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    Vw,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    PI,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), mde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-phone-laptop",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Sw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(II, { ...i, ...r, ref: n });
}), pde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-plug-recepticle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($w, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GI, { ...i, ...r, ref: n });
}), gde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-plug-usb",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ew, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YI, { ...i, ...r, ref: n });
}), ude = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-plugin",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XI, { ...i, ...r, ref: n });
}), xde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-power",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(qw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lZ, { ...i, ...r, ref: n });
}), Rde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-ram",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ww, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iZ, { ...i, ...r, ref: n });
  }
), jde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-remote",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Uw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aZ, { ...i, ...r, ref: n });
}), Mde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-robot-arm",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Kw, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cZ, { ...i, ...r, ref: n });
}), Hde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-sd-card",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ev, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vZ, { ...i, ...r, ref: n });
}), Cde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-smartphone-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pZ, { ...i, ...r, ref: n });
}), yde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-smartphone",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(tv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xZ, { ...i, ...r, ref: n });
}), bde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-tablet-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(dv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MZ, { ...i, ...r, ref: n });
}), Vde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-tablet",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(wv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yZ, { ...i, ...r, ref: n });
}), Lde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-telephone-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(mv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LZ, { ...i, ...r, ref: n });
}), zde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-telephone",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(uv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kZ, { ...i, ...r, ref: n });
}), Sde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-usb",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(jv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BZ, { ...i, ...r, ref: n });
  }
), kde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "hardware-vr",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Cv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_Z, { ...i, ...r, ref: n });
  }
), Fde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-watch",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Vv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PZ, { ...i, ...r, ref: n });
}), $de = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-webcam-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Sv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IZ, { ...i, ...r, ref: n });
}), Bde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-webcam-settings",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx($v, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GZ, { ...i, ...r, ref: n });
}), Ade = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-webcam",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ev, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YZ, { ...i, ...r, ref: n });
}), Ede = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-whispermode",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Dv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XZ, { ...i, ...r, ref: n });
}), _de = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-wireless-modem-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    qv,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    lW,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Ode = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-wireless-modem",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Wv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iW, { ...i, ...r, ref: n });
}), Dde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-workstation-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Uv, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aW, { ...i, ...r, ref: n });
}), Pde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-workstation-system-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    Kv,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    cW,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Tde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-workstation-system",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    e8,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    vW,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), qde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "hardware-workstation",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(n8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pW, { ...i, ...r, ref: n });
}), Ide = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-brush",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(t8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xW, { ...i, ...r, ref: n });
  }
), Zde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-bucket",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(d8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MW, { ...i, ...r, ref: n });
  }
), Wde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-camera-360",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(w8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yW, { ...i, ...r, ref: n });
}), Gde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-camera-linked",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(m8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LW, { ...i, ...r, ref: n });
}), Nde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-camera-super",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(u8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kW, { ...i, ...r, ref: n });
}), Ude = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-collection",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(j8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BW, { ...i, ...r, ref: n });
}), Yde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-crop",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(C8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_W, { ...i, ...r, ref: n });
  }
), Qde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-denoise",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(V8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PW, { ...i, ...r, ref: n });
}), Kde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-easel",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(S8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IW, { ...i, ...r, ref: n });
  }
), Xde = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-eraser",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx($8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GW, { ...i, ...r, ref: n });
  }
), Jde = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-eyedropper",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(E8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YW, { ...i, ...r, ref: n });
}), e2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-group",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(D8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XW, { ...i, ...r, ref: n });
  }
), l2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-import-image",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(q8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lG, { ...i, ...r, ref: n });
}), o2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-mask-inside",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(W8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iG, { ...i, ...r, ref: n });
}), n2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-mask-outside",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(U8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aG, { ...i, ...r, ref: n });
}), i2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-mirror",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(K8, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cG, { ...i, ...r, ref: n });
  }
), r2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-outpainting",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ef, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vG, { ...i, ...r, ref: n });
}), t2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-palette",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(nf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pG, { ...i, ...r, ref: n });
}), a2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-scale-relative-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(af, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xG, { ...i, ...r, ref: n });
}), s2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-scale-relative",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MG, { ...i, ...r, ref: n });
}), d2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-scale",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(vf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yG, { ...i, ...r, ref: n });
  }
), c2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-select-ellipse",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LG, { ...i, ...r, ref: n });
}), h2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-select-polygon",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kG, { ...i, ...r, ref: n });
}), w2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-select-rectangle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BG, { ...i, ...r, ref: n });
}), v2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-shapes",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(yf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_G, { ...i, ...r, ref: n });
  }
), f2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-sun-high",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Lf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PG, { ...i, ...r, ref: n });
}), m2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "image-sun-low",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(kf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IG, { ...i, ...r, ref: n });
  }
), p2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-sun-off-high",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Bf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GG, { ...i, ...r, ref: n });
}), g2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "image-transparency",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_f, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YG, { ...i, ...r, ref: n });
}), u2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-airplane",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Pf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XG, { ...i, ...r, ref: n });
}), x2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-briefcase",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(If, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lN, { ...i, ...r, ref: n });
}), R2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-bush",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Gf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iN, { ...i, ...r, ref: n });
  }
), j2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-business",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Yf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aN, { ...i, ...r, ref: n });
}), M2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-dirt",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xf, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cN, { ...i, ...r, ref: n });
  }
), H2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-elevator",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vN, { ...i, ...r, ref: n });
}), C2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-escalator",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(im, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pN, { ...i, ...r, ref: n });
}), y2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-factory",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(am, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xN, { ...i, ...r, ref: n });
  }
), b2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-flag",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(cm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MN, { ...i, ...r, ref: n });
  }
), V2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-flower",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(vm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yN, { ...i, ...r, ref: n });
  }
), L2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-fog",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(pm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LN, { ...i, ...r, ref: n });
  }
), z2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-grass",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(xm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kN, { ...i, ...r, ref: n });
  }
), S2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-gravel",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Mm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BN, { ...i, ...r, ref: n });
  }
), k2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-hill",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ym, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_N, { ...i, ...r, ref: n });
  }
), F2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-location-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Lm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PN, { ...i, ...r, ref: n });
}), $2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-location",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(km, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IN, { ...i, ...r, ref: n });
}), B2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-map-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Bm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GN, { ...i, ...r, ref: n });
  }
), A2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-map",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(_m, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YN, { ...i, ...r, ref: n });
  }
), E2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-mountain",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Pm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XN, { ...i, ...r, ref: n });
}), _2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-mud",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Im, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lU, { ...i, ...r, ref: n });
  }
), O2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-river",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Gm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iU, { ...i, ...r, ref: n });
  }
), D2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-rock",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ym, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aU, { ...i, ...r, ref: n });
  }
), P2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-sand",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xm, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cU, { ...i, ...r, ref: n });
  }
), T2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-sea",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(lp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vU, { ...i, ...r, ref: n });
  }
), q2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-signpost",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ip, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pU, { ...i, ...r, ref: n });
}), I2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-sky",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ap, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xU, { ...i, ...r, ref: n });
  }
), Z2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-snow",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(cp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MU, { ...i, ...r, ref: n });
  }
), W2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-stair",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(vp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yU, { ...i, ...r, ref: n });
  }
), G2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-stone",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(pp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LU, { ...i, ...r, ref: n });
  }
), N2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-straw",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(xp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kU, { ...i, ...r, ref: n });
  }
), U2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-suitcase",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BU, { ...i, ...r, ref: n });
}), Y2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-toolbox",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(yp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_U, { ...i, ...r, ref: n });
  }
), Q2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-tree",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Lp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PU, { ...i, ...r, ref: n });
  }
), K2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-trees",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(kp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IU, { ...i, ...r, ref: n });
  }
), X2e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-water",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Bp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GU, { ...i, ...r, ref: n });
  }
), J2e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "maps-world-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_p, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YU, { ...i, ...r, ref: n });
}), ece = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "maps-world",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Pp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XU, { ...i, ...r, ref: n });
  }
), lce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-bandaid",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Ip, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lY, { ...i, ...r, ref: n });
  }
), oce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-beaker",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Gp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iY, { ...i, ...r, ref: n });
  }
), nce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-blackboard",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Yp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aY, { ...i, ...r, ref: n });
}), ice = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-book",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xp, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cY, { ...i, ...r, ref: n });
  }
), rce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-bug-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(lg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vY, { ...i, ...r, ref: n });
  }
), tce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-bug",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ig, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pY, { ...i, ...r, ref: n });
  }
), ace = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-car",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ag, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xY, { ...i, ...r, ref: n });
  }
), sce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-checkmark-badge",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MY, { ...i, ...r, ref: n });
}), dce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-circle-1-q",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yY, { ...i, ...r, ref: n });
}), cce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-circle-2-q",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LY, { ...i, ...r, ref: n });
}), hce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-circle-3-q",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kY, { ...i, ...r, ref: n });
}), wce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-circle-tick",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BY, { ...i, ...r, ref: n });
}), vce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-code",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(yg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_Y, { ...i, ...r, ref: n });
  }
), fce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-compass",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Lg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PY, { ...i, ...r, ref: n });
  }
), mce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-delivery-truck",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(kg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IY, { ...i, ...r, ref: n });
}), pce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-ekg",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Bg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GY, { ...i, ...r, ref: n });
  }
), gce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-function",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_g, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YY, { ...i, ...r, ref: n });
}), uce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-gift",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Pg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XY, { ...i, ...r, ref: n });
  }
), xce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-graduate",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ig, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lQ, { ...i, ...r, ref: n });
}), Rce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-graph-node-connect",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Gg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iQ, { ...i, ...r, ref: n });
}), jce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-graph-node-delete",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Yg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aQ, { ...i, ...r, ref: n });
}), Mce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-graph-node",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Xg, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cQ, { ...i, ...r, ref: n });
}), Hce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-health",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(l9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vQ, { ...i, ...r, ref: n });
  }
), Cce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-hot-air-balloon",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(i9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pQ, { ...i, ...r, ref: n });
}), yce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-ime",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(a9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xQ, { ...i, ...r, ref: n });
  }
), bce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-infinity",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(c9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MQ, { ...i, ...r, ref: n });
}), Vce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-key",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(v9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yQ, { ...i, ...r, ref: n });
  }
), Lce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-library-games",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(p9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LQ, { ...i, ...r, ref: n });
}), zce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-library",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(x9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kQ, { ...i, ...r, ref: n });
  }
), Sce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-lifebouy",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(M9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BQ, { ...i, ...r, ref: n });
}), kce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-lightbulb",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(y9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_Q, { ...i, ...r, ref: n });
}), Fce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-magnet",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(L9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PQ, { ...i, ...r, ref: n });
  }
), $ce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-man-woman",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(k9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IQ, { ...i, ...r, ref: n });
}), Bce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-man",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(B9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GQ, { ...i, ...r, ref: n });
  }
), Ace = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-math",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(_9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YQ, { ...i, ...r, ref: n });
  }
), Ece = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-megaphone",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(P9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XQ, { ...i, ...r, ref: n });
}), _ce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-microscope",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(I9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lK, { ...i, ...r, ref: n });
}), Oce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-mode-component",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(G9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iK, { ...i, ...r, ref: n });
}), Dce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-money-coin",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Y9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aK, { ...i, ...r, ref: n });
}), Pce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-money-paper",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(X9, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cK, { ...i, ...r, ref: n });
}), Tce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-money",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(lu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vK, { ...i, ...r, ref: n });
  }
), qce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-moon-off",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(iu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pK, { ...i, ...r, ref: n });
  }
), Ice = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-moon",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(au, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xK, { ...i, ...r, ref: n });
  }
), Zce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-mug",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(cu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MK, { ...i, ...r, ref: n });
  }
), Wce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-neural-network",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yK, { ...i, ...r, ref: n });
}), Gce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-news",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(pu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LK, { ...i, ...r, ref: n });
  }
), Nce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-package",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(xu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kK, { ...i, ...r, ref: n });
  }
), Uce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-payment-card",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BK, { ...i, ...r, ref: n });
}), Yce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-pizza",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(yu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_K, { ...i, ...r, ref: n });
  }
), Qce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-prayer-room",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Lu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PK, { ...i, ...r, ref: n });
}), Kce = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-projector",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ku, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IK, { ...i, ...r, ref: n });
}), Xce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-pulse",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Bu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GK, { ...i, ...r, ref: n });
  }
), Jce = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-puzzle",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(_u, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YK, { ...i, ...r, ref: n });
  }
), ehe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-qrcode",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Pu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XK, { ...i, ...r, ref: n });
  }
), lhe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-radar",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Iu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lX, { ...i, ...r, ref: n });
  }
), ohe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-radioactive",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Gu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iX, { ...i, ...r, ref: n });
}), nhe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-rocket",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Yu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aX, { ...i, ...r, ref: n });
  }
), ihe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-running",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xu, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cX, { ...i, ...r, ref: n });
  }
), rhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-scale-balance",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vX, { ...i, ...r, ref: n });
}), the = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-school",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ix, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pX, { ...i, ...r, ref: n });
  }
), ahe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-seed",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(ax, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xX, { ...i, ...r, ref: n });
  }
), she = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-sensor",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(cx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MX, { ...i, ...r, ref: n });
  }
), dhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-shield-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yX, { ...i, ...r, ref: n });
}), che = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-shield",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(px, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LX, { ...i, ...r, ref: n });
  }
), hhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-ship-wheel",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kX, { ...i, ...r, ref: n });
}), whe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-shopping-bag",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BX, { ...i, ...r, ref: n });
}), vhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-shopping-basket",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_X, { ...i, ...r, ref: n });
}), fhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-shopping-cart-open",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Lx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PX, { ...i, ...r, ref: n });
}), mhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-shopping-cart",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(kx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IX, { ...i, ...r, ref: n });
}), phe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-sparkle",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Bx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GX, { ...i, ...r, ref: n });
  }
), ghe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-tag-label",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_x, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YX, { ...i, ...r, ref: n });
}), uhe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-tag",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Px, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XX, { ...i, ...r, ref: n });
  }
), xhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-telescope",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ix, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lJ, { ...i, ...r, ref: n });
}), Rhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-thermometer",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Gx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iJ, { ...i, ...r, ref: n });
}), jhe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-ticket",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Yx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aJ, { ...i, ...r, ref: n });
  }
), Mhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-traffic-cone",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Xx, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cJ, { ...i, ...r, ref: n });
}), Hhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-weight-bar",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vJ, { ...i, ...r, ref: n });
}), Che = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-weight",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(iR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pJ, { ...i, ...r, ref: n });
  }
), yhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "misc-wheelchair",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(aR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xJ, { ...i, ...r, ref: n });
}), bhe = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "misc-woman",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(cR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(MJ, { ...i, ...r, ref: n });
  }
), Vhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-down-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yJ, { ...i, ...r, ref: n });
}), Lhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-down-max",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(LJ, { ...i, ...r, ref: n });
}), zhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-down-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kJ, { ...i, ...r, ref: n });
}), She = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(MR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(BJ, { ...i, ...r, ref: n });
}), khe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-left-max",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_J, { ...i, ...r, ref: n });
}), Fhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-left-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(LR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(PJ, { ...i, ...r, ref: n });
}), $he = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(kR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(IJ, { ...i, ...r, ref: n });
}), Bhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-right-max",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(BR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(GJ, { ...i, ...r, ref: n });
}), Ahe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_R, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(YJ, { ...i, ...r, ref: n });
}), Ehe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-up-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(PR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(XJ, { ...i, ...r, ref: n });
}), _he = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-up-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(IR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lee, { ...i, ...r, ref: n });
}), Ohe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-up-max",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(GR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iee, { ...i, ...r, ref: n });
}), Dhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-up-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(YR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aee, { ...i, ...r, ref: n });
}), Phe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-arrow-up",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(XR, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cee, { ...i, ...r, ref: n });
}), The = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-double-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vee, { ...i, ...r, ref: n });
}), qhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-double-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ij, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pee, { ...i, ...r, ref: n });
}), Ihe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-double-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    aj,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    xee,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Zhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-double-up",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mee, { ...i, ...r, ref: n });
}), Whe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-down-left-up-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    vj,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    yee,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Ghe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lee, { ...i, ...r, ref: n });
}), Nhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-left-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kee, { ...i, ...r, ref: n });
}), Uhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-left",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Mj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bee, { ...i, ...r, ref: n });
}), Yhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_ee, { ...i, ...r, ref: n });
}), Qhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-up-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Lj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pee, { ...i, ...r, ref: n });
}), Khe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-up-left-down-right",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(
    kj,
    {
      ...i,
      ...r,
      ref: n
    }
  ) : /* @__PURE__ */ l.jsx(
    Iee,
    {
      ...i,
      ...r,
      ref: n
    }
  );
}), Xhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-chevron-up",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Bj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gee, { ...i, ...r, ref: n });
}), Jhe = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-diamond-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_j, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yee, { ...i, ...r, ref: n });
}), e3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-diamond",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Pj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xee, { ...i, ...r, ref: n });
}), l3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-return",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ij, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(l1e, { ...i, ...r, ref: n });
}), o3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-circle-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Gj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(i1e, { ...i, ...r, ref: n });
}), n3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-circle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Yj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(a1e, { ...i, ...r, ref: n });
}), i3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-hexagon",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Xj, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(c1e, { ...i, ...r, ref: n });
}), r3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-octogon",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(v1e, { ...i, ...r, ref: n });
}), t3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-square-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(iM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(p1e, { ...i, ...r, ref: n });
}), a3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-square",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(aM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(x1e, { ...i, ...r, ref: n });
}), s3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "shapes-shape-triangle",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(M1e, { ...i, ...r, ref: n });
}), d3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-account-add",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(y1e, { ...i, ...r, ref: n });
}), c3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-account-check",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(L1e, { ...i, ...r, ref: n });
}), h3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-account-more",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(k1e, { ...i, ...r, ref: n });
}), w3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-account-remove",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(MM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(B1e, { ...i, ...r, ref: n });
}), v3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-award-ribbon",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_1e, { ...i, ...r, ref: n });
}), f3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-award-trophy",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(LM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(P1e, { ...i, ...r, ref: n });
}), m3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "social-baby",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(kM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(I1e, { ...i, ...r, ref: n });
  }
), p3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-bookmark-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(BM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(G1e, { ...i, ...r, ref: n });
}), g3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-bookmark",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_M, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Y1e, { ...i, ...r, ref: n });
}), u3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-chat-message",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(PM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(X1e, { ...i, ...r, ref: n });
}), x3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-chat-multi",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(IM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lle, { ...i, ...r, ref: n });
}), R3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-chat-new",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(GM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ile, { ...i, ...r, ref: n });
}), j3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-chat-single",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(YM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ale, { ...i, ...r, ref: n });
}), M3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-chatbot",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(XM, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cle, { ...i, ...r, ref: n });
}), H3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-feeling-happy",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vle, { ...i, ...r, ref: n });
}), C3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-feeling-neutral",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(iH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ple, { ...i, ...r, ref: n });
}), y3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-feeling-sad",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(aH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xle, { ...i, ...r, ref: n });
}), b3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-feeling-very-happy",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mle, { ...i, ...r, ref: n });
}), V3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-feeling-very-sad",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yle, { ...i, ...r, ref: n });
}), L3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-founders-tier-1",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(pH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lle, { ...i, ...r, ref: n });
}), z3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-founders-tier-2",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kle, { ...i, ...r, ref: n });
}), S3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-founders-tier-3",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(MH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ble, { ...i, ...r, ref: n });
}), k3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-founders",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_le, { ...i, ...r, ref: n });
}), F3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-heart-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(LH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ple, { ...i, ...r, ref: n });
}), $3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "social-heart",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(kH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ile, { ...i, ...r, ref: n });
  }
), B3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-identification",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(BH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gle, { ...i, ...r, ref: n });
}), A3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-license",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_H, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yle, { ...i, ...r, ref: n });
}), E3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-pin-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(PH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xle, { ...i, ...r, ref: n });
}), _3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "social-pin",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(IH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(loe, { ...i, ...r, ref: n });
  }
), O3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-profile-group",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(GH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ioe, { ...i, ...r, ref: n });
}), D3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-profile-off",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(YH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aoe, { ...i, ...r, ref: n });
}), P3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-profile",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(XH, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(coe, { ...i, ...r, ref: n });
}), T3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-ranking-xp",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(voe, { ...i, ...r, ref: n });
}), q3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-thumb-down",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(iC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(poe, { ...i, ...r, ref: n });
}), I3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "social-thumb-up",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(aC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xoe, { ...i, ...r, ref: n });
}), Z3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-3-square-plus",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Moe, { ...i, ...r, ref: n });
}), W3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-4-square",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(vC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yoe, { ...i, ...r, ref: n });
  }
), G3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-apps",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(pC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Loe, { ...i, ...r, ref: n });
  }
), N3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-carousel-horizontal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(koe, { ...i, ...r, ref: n });
}), U3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-carousel-vertical",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(MC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Boe, { ...i, ...r, ref: n });
}), Y3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-display-share",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_oe, { ...i, ...r, ref: n });
}), Q3e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-dual",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(LC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Poe, { ...i, ...r, ref: n });
  }
), K3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-feedback",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(kC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ioe, { ...i, ...r, ref: n });
}), X3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-fit-to-page",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(BC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Goe, { ...i, ...r, ref: n });
}), J3e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-fullscreen-exit",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_C, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yoe, { ...i, ...r, ref: n });
}), e5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-fullscreen",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(PC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xoe, { ...i, ...r, ref: n });
}), l5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-gallery-strip",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(IC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lne, { ...i, ...r, ref: n });
}), o5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-grip-area",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(GC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ine, { ...i, ...r, ref: n });
}), n5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-grip-corner",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(YC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(ane, { ...i, ...r, ref: n });
}), i5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-grip-edge-horizontal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(XC, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cne, { ...i, ...r, ref: n });
}), r5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-grip-edge-vertical",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ly, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vne, { ...i, ...r, ref: n });
}), t5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-grip-mini",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(iy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pne, { ...i, ...r, ref: n });
}), a5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-layout-columns",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ay, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(xne, { ...i, ...r, ref: n });
}), s5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-layout-detail",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(cy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Mne, { ...i, ...r, ref: n });
}), d5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-layout-grid",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(vy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(yne, { ...i, ...r, ref: n });
}), c5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-layout-list",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(py, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Lne, { ...i, ...r, ref: n });
}), h5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-layout-rows",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(xy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(kne, { ...i, ...r, ref: n });
}), w5e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-map",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(My, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Bne, { ...i, ...r, ref: n });
  }
), v5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-open-external",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(yy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(_ne, { ...i, ...r, ref: n });
}), f5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-pill-bar-stack",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Ly, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Pne, { ...i, ...r, ref: n });
}), m5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-rectangle-group",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ky, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Ine, { ...i, ...r, ref: n });
}), p5e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-render",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(By, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Gne, { ...i, ...r, ref: n });
  }
), g5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-stack-horizontal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(_y, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Yne, { ...i, ...r, ref: n });
}), u5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-window-code",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Py, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(Xne, { ...i, ...r, ref: n });
}), x5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-window-grid",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Iy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(lie, { ...i, ...r, ref: n });
}), R5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-window-stack",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Gy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(iie, { ...i, ...r, ref: n });
}), j5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-window-terminal",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(Yy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(aie, { ...i, ...r, ref: n });
}), M5e = /* @__PURE__ */ t.forwardRef(
  ({ size: e, variant: o = "line", ...r }, n) => {
    const i = {
      "data-icon-name": "view-window",
      ...e ? { height: e, width: e } : {}
    };
    return o === "line" ? /* @__PURE__ */ l.jsx(Xy, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(cie, { ...i, ...r, ref: n });
  }
), H5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-workspace-group",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(lb, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(vie, { ...i, ...r, ref: n });
}), C5e = /* @__PURE__ */ t.forwardRef(({ size: e, variant: o = "line", ...r }, n) => {
  const i = {
    "data-icon-name": "view-workspace",
    ...e ? { height: e, width: e } : {}
  };
  return o === "line" ? /* @__PURE__ */ l.jsx(ib, { ...i, ...r, ref: n }) : /* @__PURE__ */ l.jsx(pie, { ...i, ...r, ref: n });
}), gie = [
  "3d-3d-axis",
  "3d-cloth",
  "3d-cube",
  "3d-dolly",
  "3d-emissive",
  "3d-explode",
  "3d-instance",
  "3d-light-rect",
  "3d-light-rotate",
  "3d-material",
  "3d-move-global",
  "3d-reference",
  "3d-rotate-3d",
  "3d-rotate-global",
  "3d-segment",
  "3d-shader",
  "3d-shader-ball",
  "3d-skeleton",
  "3d-teapot",
  "3d-teleport",
  "3d-texture",
  "av-auto-record",
  "av-auto-record-off",
  "av-broadcast",
  "av-camera",
  "av-camera-add",
  "av-camera-off",
  "av-clap-board",
  "av-display-surround",
  "av-eject",
  "av-equalizer",
  "av-faders",
  "av-fast-forward",
  "av-fast-reverse",
  "av-film",
  "av-film-add",
  "av-film-collection",
  "av-forward-10",
  "av-fps",
  "av-high-quality",
  "av-hud",
  "av-loop",
  "av-loop-off",
  "av-microphone",
  "av-microphone-off",
  "av-next",
  "av-notes",
  "av-pause",
  "av-picture-in-picture",
  "av-play",
  "av-previous",
  "av-record",
  "av-replay",
  "av-replay-off",
  "av-reverse-10",
  "av-soundwaves",
  "av-speaker",
  "av-speaker-high",
  "av-speaker-low",
  "av-speaker-medium",
  "av-speaker-mute",
  "av-speaker-off",
  "av-step-forward",
  "av-step-reverse",
  "av-stop",
  "av-videocam",
  "av-videocam-off",
  "av-watch-party",
  "common-add",
  "common-add-circle",
  "common-alarm",
  "common-bell",
  "common-bell-off",
  "common-calendar",
  "common-calendar-event",
  "common-cancel",
  "common-check",
  "common-check-circle",
  "common-check-multi-circle",
  "common-clipboard",
  "common-clock",
  "common-close",
  "common-close-circle",
  "common-cog",
  "common-cog-off",
  "common-copy-doc",
  "common-copy-generic",
  "common-enter",
  "common-error",
  "common-exit",
  "common-eye",
  "common-eye-off",
  "common-filter",
  "common-help-circle",
  "common-history",
  "common-home",
  "common-home-off",
  "common-info-circle",
  "common-link",
  "common-link-break",
  "common-lock-closed",
  "common-lock-open",
  "common-magnifying-glass",
  "common-magnifying-glass-minus",
  "common-magnifying-glass-plus",
  "common-menu",
  "common-more-horiz",
  "common-more-vert",
  "common-paperplane",
  "common-redo",
  "common-refresh",
  "common-reset",
  "common-retry",
  "common-share",
  "common-sort",
  "common-star",
  "common-subtract",
  "common-subtract-circle",
  "common-sync",
  "common-sync-off",
  "common-timer",
  "common-trash",
  "common-undo",
  "common-warning",
  "communication-cloud",
  "communication-cloud-off",
  "communication-data",
  "communication-download",
  "communication-envelope",
  "communication-envelope-off",
  "communication-firewall",
  "communication-firewall-off",
  "communication-forward",
  "communication-isp",
  "communication-isp-off",
  "communication-network-signal",
  "communication-network-signal-off",
  "communication-reply",
  "communication-sync-warning",
  "communication-transfer-horizontal",
  "communication-transfer-vertical",
  "communication-upload",
  "communication-wifi",
  "communication-wifi-off",
  "cursor-arrow",
  "cursor-crosshair",
  "cursor-hand-closed",
  "cursor-hand-open",
  "cursor-hand-pinch",
  "cursor-hand-point",
  "cursor-hourglass",
  "cursor-hourglass-end",
  "cursor-hourglass-mid",
  "cursor-hourglass-start",
  "editor-anchor-center",
  "editor-anchor-e",
  "editor-anchor-n",
  "editor-anchor-ne",
  "editor-anchor-nw",
  "editor-anchor-s",
  "editor-anchor-se",
  "editor-anchor-sw",
  "editor-anchor-w",
  "editor-at-symbol",
  "editor-backspace",
  "editor-bold",
  "editor-branch",
  "editor-chart",
  "editor-chart-bar",
  "editor-chart-flow",
  "editor-chart-hierarchy",
  "editor-chart-performance",
  "editor-chart-pie",
  "editor-chart-tree",
  "editor-collapse",
  "editor-commit",
  "editor-compare",
  "editor-connection",
  "editor-expand",
  "editor-export-to-clipboard",
  "editor-fit",
  "editor-fork",
  "editor-freehand",
  "editor-grid",
  "editor-grid-off",
  "editor-h-align-center",
  "editor-h-align-left",
  "editor-h-align-right",
  "editor-header",
  "editor-image",
  "editor-italic",
  "editor-iterate",
  "editor-keyframe",
  "editor-layers",
  "editor-layers-off",
  "editor-line-segment",
  "editor-list-bullet",
  "editor-list-checkmark",
  "editor-list-number",
  "editor-markdown",
  "editor-merge",
  "editor-move",
  "editor-numbers",
  "editor-paperclip",
  "editor-paragraph",
  "editor-pencil",
  "editor-pull",
  "editor-pull-close",
  "editor-pull-draft",
  "editor-rotate",
  "editor-rotate-90-clockwise",
  "editor-rotate-90-counter",
  "editor-ruler",
  "editor-scale-down",
  "editor-scale-reset",
  "editor-scale-up",
  "editor-scissors",
  "editor-section",
  "editor-section-bottom",
  "editor-section-top",
  "editor-select-brush",
  "editor-signature",
  "editor-skip",
  "editor-sliders",
  "editor-sort-ascending",
  "editor-sort-descending",
  "editor-sticker",
  "editor-sticker-image",
  "editor-sticker-shape",
  "editor-sticker-text",
  "editor-sticker-zoom",
  "editor-strikethrough",
  "editor-stroke-width",
  "editor-style",
  "editor-swatches",
  "editor-text",
  "editor-text-align-center",
  "editor-text-align-full",
  "editor-text-align-left",
  "editor-text-align-right",
  "editor-text-framed",
  "editor-trash-delete",
  "editor-typography",
  "editor-underline",
  "editor-v-align-bottom",
  "editor-v-align-center",
  "editor-v-align-top",
  "editor-wand",
  "editor-wrench",
  "files-archive",
  "files-db",
  "files-document",
  "files-document-checkmark",
  "files-document-new",
  "files-document-preview",
  "files-export",
  "files-floppy",
  "files-folder-closed",
  "files-folder-open",
  "files-import",
  "hardware-2-b-left-click",
  "hardware-battery-0",
  "hardware-battery-0-off",
  "hardware-battery-100",
  "hardware-battery-25",
  "hardware-battery-50",
  "hardware-battery-75",
  "hardware-battery-boost",
  "hardware-battery-charging",
  "hardware-bluetooth",
  "hardware-bluetooth-off",
  "hardware-calculator",
  "hardware-cpu",
  "hardware-display",
  "hardware-display-collection",
  "hardware-display-off",
  "hardware-drive-cloud",
  "hardware-drive-cloud-off",
  "hardware-drive-network",
  "hardware-drive-network-off",
  "hardware-drive-removable",
  "hardware-drive-removable-off",
  "hardware-drive-usb",
  "hardware-drive-usb-off",
  "hardware-ethernet",
  "hardware-fan",
  "hardware-fan-loud",
  "hardware-fan-quiet",
  "hardware-gamepad",
  "hardware-gamepad-off",
  "hardware-gamepad-start",
  "hardware-gpu",
  "hardware-gpu-card",
  "hardware-gpu-card-multi",
  "hardware-gpu-card-off",
  "hardware-gpu-off",
  "hardware-headset",
  "hardware-keyboard",
  "hardware-laptop",
  "hardware-lightning",
  "hardware-mac",
  "hardware-mac-off",
  "hardware-media-optical",
  "hardware-mosaic",
  "hardware-mouse-2-b",
  "hardware-mouse-2-b-right-click",
  "hardware-mouse-3-b",
  "hardware-mouse-scrollwheel",
  "hardware-mouse-scrollwheel-active",
  "hardware-multidrive",
  "hardware-network",
  "hardware-network-connection",
  "hardware-network-pcs",
  "hardware-nvidia-shield",
  "hardware-nvidia-shield-stand",
  "hardware-performance-high",
  "hardware-performance-low",
  "hardware-performance-medium",
  "hardware-phone-laptop",
  "hardware-plug-recepticle",
  "hardware-plug-usb",
  "hardware-plugin",
  "hardware-power",
  "hardware-ram",
  "hardware-remote",
  "hardware-robot-arm",
  "hardware-sd-card",
  "hardware-smartphone",
  "hardware-smartphone-off",
  "hardware-tablet",
  "hardware-tablet-off",
  "hardware-telephone",
  "hardware-telephone-off",
  "hardware-usb",
  "hardware-vr",
  "hardware-watch",
  "hardware-webcam",
  "hardware-webcam-off",
  "hardware-webcam-settings",
  "hardware-whispermode",
  "hardware-wireless-modem",
  "hardware-wireless-modem-off",
  "hardware-workstation",
  "hardware-workstation-off",
  "hardware-workstation-system",
  "hardware-workstation-system-off",
  "image-brush",
  "image-bucket",
  "image-camera-360",
  "image-camera-linked",
  "image-camera-super",
  "image-collection",
  "image-crop",
  "image-denoise",
  "image-easel",
  "image-eraser",
  "image-eyedropper",
  "image-group",
  "image-import-image",
  "image-mask-inside",
  "image-mask-outside",
  "image-mirror",
  "image-outpainting",
  "image-palette",
  "image-scale",
  "image-scale-relative",
  "image-scale-relative-off",
  "image-select-ellipse",
  "image-select-polygon",
  "image-select-rectangle",
  "image-shapes",
  "image-sun-high",
  "image-sun-low",
  "image-sun-off-high",
  "image-transparency",
  "maps-airplane",
  "maps-briefcase",
  "maps-bush",
  "maps-business",
  "maps-dirt",
  "maps-elevator",
  "maps-escalator",
  "maps-factory",
  "maps-flag",
  "maps-flower",
  "maps-fog",
  "maps-grass",
  "maps-gravel",
  "maps-hill",
  "maps-location",
  "maps-location-off",
  "maps-map",
  "maps-map-off",
  "maps-mountain",
  "maps-mud",
  "maps-river",
  "maps-rock",
  "maps-sand",
  "maps-sea",
  "maps-signpost",
  "maps-sky",
  "maps-snow",
  "maps-stair",
  "maps-stone",
  "maps-straw",
  "maps-suitcase",
  "maps-toolbox",
  "maps-tree",
  "maps-trees",
  "maps-water",
  "maps-world",
  "maps-world-off",
  "misc-bandaid",
  "misc-beaker",
  "misc-blackboard",
  "misc-book",
  "misc-bug",
  "misc-bug-off",
  "misc-car",
  "misc-checkmark-badge",
  "misc-circle-1-q",
  "misc-circle-2-q",
  "misc-circle-3-q",
  "misc-circle-tick",
  "misc-code",
  "misc-compass",
  "misc-delivery-truck",
  "misc-ekg",
  "misc-function",
  "misc-gift",
  "misc-graduate",
  "misc-graph-node",
  "misc-graph-node-connect",
  "misc-graph-node-delete",
  "misc-health",
  "misc-hot-air-balloon",
  "misc-ime",
  "misc-infinity",
  "misc-key",
  "misc-library",
  "misc-library-games",
  "misc-lifebouy",
  "misc-lightbulb",
  "misc-magnet",
  "misc-man",
  "misc-man-woman",
  "misc-math",
  "misc-megaphone",
  "misc-microscope",
  "misc-mode-component",
  "misc-money",
  "misc-money-coin",
  "misc-money-paper",
  "misc-moon",
  "misc-moon-off",
  "misc-mug",
  "misc-neural-network",
  "misc-news",
  "misc-package",
  "misc-payment-card",
  "misc-pizza",
  "misc-prayer-room",
  "misc-projector",
  "misc-pulse",
  "misc-puzzle",
  "misc-qrcode",
  "misc-radar",
  "misc-radioactive",
  "misc-rocket",
  "misc-running",
  "misc-scale-balance",
  "misc-school",
  "misc-seed",
  "misc-sensor",
  "misc-shield",
  "misc-shield-off",
  "misc-ship-wheel",
  "misc-shopping-bag",
  "misc-shopping-basket",
  "misc-shopping-cart",
  "misc-shopping-cart-open",
  "misc-sparkle",
  "misc-tag",
  "misc-tag-label",
  "misc-telescope",
  "misc-thermometer",
  "misc-ticket",
  "misc-traffic-cone",
  "misc-weight",
  "misc-weight-bar",
  "misc-wheelchair",
  "misc-woman",
  "shapes-arrow-down",
  "shapes-arrow-down-left",
  "shapes-arrow-down-max",
  "shapes-arrow-down-right",
  "shapes-arrow-left",
  "shapes-arrow-left-max",
  "shapes-arrow-left-right",
  "shapes-arrow-right",
  "shapes-arrow-right-max",
  "shapes-arrow-up",
  "shapes-arrow-up-down",
  "shapes-arrow-up-left",
  "shapes-arrow-up-max",
  "shapes-arrow-up-right",
  "shapes-chevron-double-down",
  "shapes-chevron-double-left",
  "shapes-chevron-double-right",
  "shapes-chevron-double-up",
  "shapes-chevron-down",
  "shapes-chevron-down-left-up-right",
  "shapes-chevron-left",
  "shapes-chevron-left-right",
  "shapes-chevron-right",
  "shapes-chevron-up",
  "shapes-chevron-up-down",
  "shapes-chevron-up-left-down-right",
  "shapes-diamond",
  "shapes-diamond-off",
  "shapes-return",
  "shapes-shape-circle",
  "shapes-shape-circle-off",
  "shapes-shape-hexagon",
  "shapes-shape-octogon",
  "shapes-shape-square",
  "shapes-shape-square-off",
  "shapes-shape-triangle",
  "social-account-add",
  "social-account-check",
  "social-account-more",
  "social-account-remove",
  "social-award-ribbon",
  "social-award-trophy",
  "social-baby",
  "social-bookmark",
  "social-bookmark-off",
  "social-chat-message",
  "social-chat-multi",
  "social-chat-new",
  "social-chat-single",
  "social-chatbot",
  "social-feeling-happy",
  "social-feeling-neutral",
  "social-feeling-sad",
  "social-feeling-very-happy",
  "social-feeling-very-sad",
  "social-founders",
  "social-founders-tier-1",
  "social-founders-tier-2",
  "social-founders-tier-3",
  "social-heart",
  "social-heart-off",
  "social-identification",
  "social-license",
  "social-pin",
  "social-pin-off",
  "social-profile",
  "social-profile-group",
  "social-profile-off",
  "social-ranking-xp",
  "social-thumb-down",
  "social-thumb-up",
  "view-3-square-plus",
  "view-4-square",
  "view-apps",
  "view-carousel-horizontal",
  "view-carousel-vertical",
  "view-display-share",
  "view-dual",
  "view-feedback",
  "view-fit-to-page",
  "view-fullscreen",
  "view-fullscreen-exit",
  "view-gallery-strip",
  "view-grip-area",
  "view-grip-corner",
  "view-grip-edge-horizontal",
  "view-grip-edge-vertical",
  "view-grip-mini",
  "view-layout-columns",
  "view-layout-detail",
  "view-layout-grid",
  "view-layout-list",
  "view-layout-rows",
  "view-map",
  "view-open-external",
  "view-pill-bar-stack",
  "view-rectangle-group",
  "view-render",
  "view-stack-horizontal",
  "view-window",
  "view-window-code",
  "view-window-grid",
  "view-window-stack",
  "view-window-terminal",
  "view-workspace",
  "view-workspace-group"
];
function y5e(e) {
  return !!gie.find((o) => o === e);
}
function b5e(e) {
  return e.split("-")[1];
}
function V5e(e) {
  return e.split("-")[0];
}
const L5e = [
  "6",
  "8",
  "access",
  "accessibility",
  "account",
  "accounts",
  "achievement",
  "acorn",
  "action",
  "actions",
  "activity",
  "ada",
  "add",
  "addition",
  "additional",
  "address",
  "adjust",
  "advance",
  "affect",
  "aft",
  "after",
  "again",
  "against",
  "age",
  "ai",
  "aid",
  "aim",
  "air",
  "alarm",
  "alert",
  "algorithm",
  "all",
  "all up",
  "amount",
  "amplify",
  "amplitude",
  "android",
  "angle brackets",
  "animation",
  "announce",
  "answer",
  "answers",
  "anti",
  "appearance",
  "apple",
  "application",
  "applications",
  "approve",
  "approved",
  "apps",
  "archive",
  "area",
  "areas",
  "arrange",
  "array",
  "arrow",
  "arrows",
  "art",
  "artboard",
  "articles",
  "articulation",
  "artificial intelligence",
  "aspect ratio",
  "astronomy",
  "attached",
  "attachment",
  "attempt",
  "attention",
  "attraction",
  "audio",
  "authentication",
  "autograph",
  "automatic",
  "automation",
  "automobile",
  "av",
  "avatar",
  "avatars",
  "avoid",
  "award",
  "back",
  "background",
  "backup",
  "backward",
  "backwards",
  "bad",
  "badge",
  "bag",
  "baggage",
  "balanced",
  "bar",
  "barbell",
  "barrier",
  "bars",
  "base",
  "basic",
  "bee",
  "before",
  "begin",
  "beginning",
  "bell",
  "benchmark",
  "bernoulli",
  "beverage",
  "big",
  "bigger",
  "bill",
  "billboard",
  "bin",
  "binary",
  "birds",
  "bit",
  "bits",
  "block",
  "blocked",
  "blocker",
  "blocks",
  "boat",
  "body",
  "boil",
  "bones",
  "books",
  "boot",
  "border",
  "bottom",
  "boulder",
  "boundary",
  "bounds",
  "bow",
  "box",
  "branches",
  "break",
  "bridge",
  "bright",
  "broadcast",
  "broken",
  "browse",
  "browser",
  "build",
  "building",
  "bulb",
  "bulk",
  "bullhorn",
  "bundle",
  "burger",
  "burst",
  "business",
  "busy",
  "buttons",
  "buy",
  "buzzer",
  "cable",
  "cactus",
  "call",
  "camera",
  "can",
  "cancel",
  "canvas",
  "capacity",
  "capsule",
  "capture",
  "card",
  "cards",
  "care",
  "cargo",
  "carriage",
  "categories",
  "categorize",
  "caution",
  "cave",
  "cd",
  "cells",
  "central processing unit",
  "certificate",
  "chain",
  "chalk",
  "change",
  "channel",
  "chapel",
  "character",
  "characters",
  "charged",
  "chat",
  "check",
  "checkin",
  "checkout",
  "child",
  "chip",
  "choose",
  "circle",
  "circuit",
  "city",
  "clapper",
  "clarify",
  "classic",
  "classroom",
  "cli",
  "click",
  "clip",
  "clips",
  "clock",
  "clone",
  "close",
  "clothes",
  "clothing",
  "cluster",
  "code",
  "coffee",
  "coin",
  "cold",
  "collaboration",
  "collapse",
  "colleagues",
  "collection",
  "college",
  "color",
  "colorful",
  "coloring",
  "colors",
  "combined displays",
  "combo",
  "command line interface",
  "commerce",
  "communications",
  "community",
  "compare",
  "complex",
  "component",
  "components",
  "compute",
  "computed",
  "computer",
  "computers",
  "config",
  "configuration",
  "confirm",
  "confirmed",
  "conform",
  "connect",
  "connected",
  "connection",
  "connections",
  "connector",
  "connectors",
  "console",
  "construction",
  "container",
  "containers",
  "content",
  "contents",
  "contextual",
  "continuous",
  "control",
  "controller",
  "controls",
  "conversation",
  "convert",
  "copy",
  "corner",
  "corners",
  "count",
  "couple",
  "cover",
  "coworkers",
  "crash",
  "create",
  "credit",
  "crescent",
  "critical",
  "cross",
  "crosshair",
  "crunch",
  "crystal",
  "cuisine",
  "cup",
  "currency",
  "cursor",
  "custom",
  "customize",
  "cut",
  "cycle",
  "cycles",
  "danger",
  "dark",
  "dashboard",
  "data",
  "data center",
  "data entry",
  "data viz",
  "database",
  "date",
  "day",
  "debit",
  "dedicated",
  "deep",
  "delay",
  "delete",
  "demo",
  "desert",
  "desktop",
  "details",
  "developer",
  "development",
  "device",
  "dexterity",
  "diagonal",
  "diagram",
  "dialogue",
  "dictate",
  "diff",
  "digits",
  "dim",
  "dimensions",
  "direct",
  "direction",
  "directions",
  "directory",
  "dirt",
  "disable",
  "disabled",
  "disapprove",
  "disc",
  "discover",
  "discreet",
  "discs",
  "dish",
  "disk",
  "dislike",
  "dismiss",
  "displace",
  "display",
  "distance",
  "distribute",
  "divide",
  "divided",
  "dl",
  "doctor",
  "document",
  "documentation",
  "documents",
  "dollar",
  "done",
  "dot",
  "dots",
  "double",
  "down",
  "down arrow",
  "dpad",
  "draft",
  "drag",
  "drape",
  "draw",
  "drawer",
  "drawing",
  "drink",
  "drive",
  "drivers",
  "driving",
  "drop",
  "dry",
  "dry erase",
  "dunes",
  "duplicate",
  "dvd",
  "earth",
  "east",
  "eclipse",
  "edge",
  "edges",
  "edit",
  "education",
  "eight",
  "electricity",
  "electromagnetism",
  "electronics",
  "elevation",
  "ellipses",
  "ellipsis",
  "email",
  "embed",
  "emergency",
  "emit",
  "emotion",
  "emphasis",
  "empty",
  "enable",
  "encode",
  "end",
  "energy",
  "enlarge",
  "enter",
  "entry",
  "environment",
  "eq",
  "error",
  "escape",
  "ethernet",
  "even",
  "evening",
  "event",
  "events",
  "example",
  "exchange",
  "exercise",
  "exit",
  "expand",
  "expansion",
  "experience",
  "experiment",
  "expire",
  "explore",
  "extend",
  "exterior",
  "extra",
  "eye",
  "eyeball",
  "fabric",
  "face",
  "faces",
  "fail",
  "failure",
  "fan",
  "faq",
  "father",
  "favorite",
  "feature",
  "feedback",
  "female",
  "figure",
  "file",
  "files",
  "fill",
  "filled",
  "final",
  "finance",
  "find",
  "finish",
  "finished",
  "fit",
  "fix",
  "flag",
  "flake",
  "flash",
  "flight",
  "float",
  "flood",
  "floors",
  "floppy",
  "flow",
  "flush",
  "fly",
  "flying",
  "fold",
  "folded",
  "font",
  "food",
  "force",
  "forest",
  "form",
  "format",
  "forward",
  "four",
  "fraction",
  "frame",
  "frames",
  "frames per second",
  "frank",
  "freestyle",
  "freight",
  "frequencies",
  "frequency",
  "friends",
  "full",
  "funnel",
  "fyi",
  "gadget",
  "garbage",
  "garbage can",
  "gather",
  "gauge",
  "gear",
  "generic",
  "geography",
  "gesture",
  "get",
  "get out",
  "git",
  "give",
  "glass",
  "global",
  "globe",
  "go",
  "goal",
  "goggles",
  "good",
  "grab",
  "graph",
  "graphic",
  "graphics processing unit",
  "grassland",
  "green",
  "grid",
  "ground",
  "group",
  "grouping",
  "groups",
  "grove",
  "grow",
  "guard",
  "guidance",
  "guidelines",
  "half",
  "hamburger",
  "handicap",
  "hands",
  "handset",
  "hang",
  "hanger",
  "happened",
  "hard drives",
  "hardware",
  "hat",
  "hdd",
  "headline",
  "headlines",
  "headphones",
  "heads up display",
  "health",
  "healthy",
  "heart",
  "heartbeat",
  "heavy",
  "help",
  "hertz",
  "hewn",
  "hexagonal",
  "hidden",
  "hide",
  "hierarchy",
  "high",
  "high point",
  "high power",
  "hike",
  "histogram",
  "hold",
  "honeycomb",
  "honor",
  "hook",
  "horizon",
  "horizontal",
  "hospital",
  "hot",
  "hot chocolate",
  "hotspot",
  "house",
  "hub",
  "hybrid",
  "hyperlink",
  "ide",
  "idea",
  "identification",
  "identity",
  "ignore",
  "illumination",
  "imac",
  "image",
  "images",
  "importance",
  "improve",
  "incident",
  "increase",
  "index finger",
  "indicator",
  "individual",
  "industry",
  "information",
  "input",
  "insert",
  "inset",
  "inspect",
  "installer",
  "instance",
  "instant",
  "integrated development environment",
  "intensity",
  "interior",
  "internet",
  "invisibility",
  "invisible",
  "ios",
  "ipad",
  "iphone",
  "iq",
  "irregular",
  "issue",
  "italian",
  "items",
  "iterations",
  "jet",
  "job",
  "joints",
  "juice",
  "jump",
  "justified",
  "keep",
  "key",
  "keyhole",
  "keynote",
  "keys",
  "keystroke",
  "kid",
  "kindle",
  "lab",
  "label",
  "lake",
  "lan",
  "landmark",
  "landscape",
  "language",
  "larger",
  "lattice",
  "launch",
  "launcher",
  "lda",
  "leaf",
  "learn",
  "learning",
  "leave",
  "leaves",
  "left",
  "legal",
  "legibility",
  "lens",
  "letters",
  "level",
  "levels",
  "library",
  "lift",
  "light",
  "lighting",
  "like",
  "likeness",
  "limbs",
  "line",
  "lines",
  "link",
  "liquid",
  "list",
  "live",
  "llm",
  "local area",
  "local area network",
  "location",
  "lock",
  "locked",
  "login",
  "look",
  "loop",
  "loud",
  "loudspeaker",
  "low",
  "low clouds",
  "low power",
  "lower",
  "machine",
  "macintosh",
  "magic",
  "magnetism",
  "magnifier",
  "magnify",
  "mail",
  "main",
  "maintain",
  "male",
  "malware",
  "manual",
  "manufacture",
  "mark",
  "marker",
  "marquee",
  "mask",
  "mass",
  "material",
  "materials",
  "math",
  "max",
  "maximize",
  "measure",
  "measurement",
  "measures",
  "mechanical",
  "media",
  "medical",
  "meditation",
  "medium",
  "meeting",
  "meetings",
  "melody",
  "memory",
  "men",
  "menu",
  "message",
  "method",
  "micro",
  "microphone",
  "middle",
  "mids",
  "migrate",
  "min",
  "mini",
  "minimize",
  "minus",
  "mist",
  "ml",
  "mobile",
  "modify",
  "modules",
  "money",
  "monitor",
  "month",
  "more",
  "mosaic",
  "mother",
  "motherboard",
  "motion",
  "mount",
  "mouse",
  "move",
  "movement",
  "movie",
  "movies",
  "moving",
  "multimon",
  "multiple",
  "multiply",
  "music",
  "mute",
  "mystery",
  "name",
  "natural",
  "nav",
  "navigate",
  "navigation",
  "negative",
  "network",
  "networking",
  "neutral",
  "neverending",
  "new",
  "new line",
  "news",
  "next",
  "night",
  "no alarm",
  "no camera",
  "no connection",
  "no email",
  "no enlarge",
  "no eye",
  "no feature",
  "no gear",
  "no guidelines",
  "no network",
  "no networking",
  "no order",
  "no origin",
  "no picture",
  "no repeat",
  "no shape",
  "no simple",
  "no start",
  "no thumbtack",
  "no user",
  "no voice",
  "no weather",
  "node",
  "nodes",
  "noise",
  "normal",
  "north",
  "northeast",
  "northwest",
  "notation",
  "note",
  "notebook",
  "notes",
  "notification",
  "nuclear",
  "numbers",
  "numeric",
  "nurse",
  "object",
  "objects",
  "oblique",
  "occupation",
  "ocean",
  "office",
  "official",
  "ok",
  "old",
  "on top",
  "one",
  "onion",
  "online",
  "opacity",
  "open",
  "open water",
  "opinion",
  "optical",
  "optics",
  "options",
  "order",
  "ordered",
  "organic",
  "origin",
  "original",
  "output",
  "outside",
  "over",
  "overlay",
  "package",
  "padlock",
  "page",
  "pages",
  "paint",
  "painting",
  "pair",
  "pan",
  "panels",
  "panorama",
  "panoramic",
  "paper",
  "parents",
  "parking",
  "part",
  "particles",
  "parts",
  "pass",
  "pass along",
  "passenger",
  "passes",
  "password",
  "past",
  "paste",
  "pasture",
  "patch",
  "patch cable",
  "path",
  "pathfinding",
  "pattern",
  "pause",
  "pc",
  "pci",
  "peak",
  "pebbles",
  "pencil",
  "people",
  "perforations",
  "performance",
  "period",
  "periodical",
  "peripheral",
  "permanent",
  "person",
  "personal",
  "petals",
  "photo",
  "photography",
  "photos",
  "pick",
  "picker",
  "pickup",
  "picture",
  "pie",
  "piece",
  "pieces",
  "pile",
  "pin",
  "ping",
  "pivot",
  "place",
  "planet",
  "planets",
  "plant",
  "plants",
  "playback",
  "plugged in",
  "plus",
  "point",
  "pointer",
  "points",
  "poof",
  "poor",
  "port",
  "portable",
  "portfolio",
  "portion",
  "position",
  "positive",
  "pound",
  "power",
  "preferences",
  "present",
  "presentation",
  "press",
  "preview",
  "previous",
  "price",
  "primitive",
  "primitives",
  "print",
  "prior",
  "privacy",
  "private",
  "prize",
  "problem",
  "process",
  "processor",
  "production",
  "prongs",
  "proof",
  "properties",
  "protection",
  "proxy",
  "public address",
  "pull",
  "pulse",
  "purchase",
  "push",
  "put",
  "quadrants",
  "query",
  "question",
  "quick redirect",
  "quiet",
  "race",
  "ragged",
  "raid",
  "ramp",
  "random access memory",
  "randomization",
  "range",
  "rank",
  "rate",
  "rating",
  "rays",
  "react",
  "read",
  "readability",
  "recall",
  "recant",
  "receive",
  "receiver",
  "reception",
  "receptor",
  "recipient",
  "record",
  "recording",
  "records",
  "rectangular",
  "recurring",
  "recycle",
  "redact",
  "redeem",
  "reduce",
  "reel",
  "refine",
  "reflect",
  "reflection",
  "refresh",
  "refresh rate",
  "region",
  "regions",
  "reject",
  "religion",
  "relocate",
  "remember",
  "reminder",
  "remove",
  "render",
  "repair",
  "repeat",
  "repeats",
  "replay",
  "replenish",
  "replies",
  "reply",
  "resize",
  "resolution",
  "response",
  "restore",
  "restrooms",
  "reticle",
  "return",
  "reverse",
  "revert",
  "reward",
  "rewind",
  "right",
  "ring",
  "rise",
  "river bank",
  "rock",
  "rocks",
  "rocky",
  "roll",
  "rolling",
  "romance",
  "rotate",
  "rough",
  "roughness",
  "round",
  "router",
  "row",
  "rubbish",
  "rule",
  "safe",
  "safety",
  "same",
  "sampler",
  "sash",
  "satisfaction",
  "save",
  "savings",
  "scan",
  "scene",
  "schedule",
  "school",
  "science",
  "screen",
  "scribble",
  "scrub",
  "search",
  "sections",
  "secure",
  "security",
  "see through",
  "segment",
  "segmentation",
  "segments",
  "select",
  "send",
  "send back",
  "sensor",
  "separate",
  "sequence",
  "server",
  "session",
  "set",
  "set top box",
  "sets",
  "settings",
  "setup",
  "shadowplay",
  "share",
  "sheet",
  "shelf",
  "shield",
  "shift",
  "shiny",
  "shipment",
  "shop",
  "short",
  "shorthand",
  "show",
  "showcase",
  "shrink",
  "shrubbery",
  "shutdown",
  "shuttle",
  "side",
  "sides",
  "sideways",
  "sight",
  "sign",
  "signal",
  "signals",
  "signin",
  "silent",
  "simple",
  "simplify",
  "simulation",
  "single",
  "singular",
  "six",
  "size",
  "skill",
  "skin",
  "skip",
  "skyscraper",
  "slant",
  "slash",
  "slate",
  "sli",
  "slice",
  "sliders",
  "slow",
  "small",
  "smaller",
  "smart",
  "smooth",
  "snapshot",
  "social",
  "socket",
  "soil",
  "solo",
  "solution",
  "solve",
  "sonar",
  "sort",
  "sound",
  "soundboard",
  "soupy",
  "source",
  "south",
  "southeast",
  "southwest",
  "space",
  "speaker",
  "special",
  "speech bubble",
  "speech bubbles",
  "speed",
  "spin",
  "spinner",
  "split",
  "spring",
  "sql",
  "square",
  "stack",
  "staircase",
  "stairs",
  "stairwell",
  "stalks",
  "stand",
  "standard",
  "star",
  "stars",
  "start",
  "start over",
  "state",
  "statistic",
  "stb",
  "steam",
  "steer",
  "stems",
  "steps",
  "sticky",
  "still",
  "stones",
  "stop",
  "stop repeating",
  "stop watch",
  "stopped",
  "storage",
  "store",
  "straight",
  "straightedge",
  "streaming",
  "stretch",
  "strip",
  "stripe",
  "strips",
  "stroke",
  "strokes",
  "strong",
  "structure",
  "students",
  "study",
  "style",
  "styles",
  "stylus",
  "sub",
  "subtract",
  "success",
  "summary",
  "sunset",
  "superimpose",
  "support",
  "surface",
  "surprise",
  "surround",
  "swipe",
  "switch",
  "swivel",
  "symbol",
  "sync",
  "syntax",
  "tabloid",
  "tactile",
  "tag",
  "tags",
  "tall",
  "tap",
  "target",
  "tasks",
  "tassle",
  "taxonomy",
  "tea",
  "teachers",
  "team",
  "television",
  "temperature",
  "template",
  "temporary",
  "tender",
  "terminal",
  "test",
  "text",
  "textures",
  "thickness",
  "thought",
  "three",
  "threshold",
  "thumbnails",
  "thumbtack",
  "tick",
  "tie",
  "tile",
  "tiled",
  "time",
  "time series",
  "timing",
  "tip",
  "title",
  "tix",
  "to",
  "to do",
  "together",
  "tool",
  "top",
  "toppings",
  "total",
  "touch",
  "tower",
  "track",
  "translate",
  "translation",
  "translucency",
  "transmit",
  "transport",
  "travel",
  "treble",
  "trend",
  "trial",
  "triangle",
  "trim",
  "trunk",
  "try again",
  "turn",
  "tv",
  "tween",
  "twinkle",
  "twirl",
  "type",
  "types",
  "under",
  "undo",
  "unique",
  "universal",
  "university",
  "unlimited",
  "unlocked",
  "unmount",
  "unordered",
  "up",
  "up arrow",
  "update",
  "upper",
  "url",
  "user",
  "users",
  "utilities",
  "valid",
  "validate",
  "validated",
  "validation",
  "values",
  "vehicle",
  "vellum",
  "version",
  "vertical",
  "vial",
  "video",
  "video chat",
  "video games",
  "videos",
  "view",
  "virtual",
  "virtual reality",
  "virus",
  "visibility",
  "visible",
  "visual",
  "visualization",
  "visuals",
  "voice",
  "volume",
  "volumes",
  "vr",
  "wait",
  "waiting",
  "wake",
  "wall",
  "wallet",
  "wan",
  "wap",
  "warm",
  "warning",
  "waste",
  "watch",
  "water",
  "wave",
  "wavelength",
  "waves",
  "waypoint",
  "wearable",
  "weather",
  "web",
  "week",
  "weights",
  "west",
  "wet",
  "wheel",
  "whimsical",
  "whole",
  "whoosh",
  "wide area network",
  "widgets",
  "wifi",
  "wild",
  "win",
  "window",
  "wired",
  "wireless",
  "wizard",
  "women",
  "woods",
  "words",
  "work",
  "work out",
  "workflow",
  "working",
  "wormhole",
  "wrap around",
  "wrapped",
  "wrist",
  "write",
  "www",
  "wysiwyg",
  "year",
  "young",
  "zip",
  "zoom",
  "zoom in",
  "zoom out"
], z5e = {
  "3d-3d-axis": ["dimensions", "directions", "guidelines", "rays"],
  "3d-cloth": ["clothing", "drape", "hang", "hanger", "materials", "type"],
  "3d-cube": ["bounds", "box", "container", "frame", "primitive", "square"],
  "3d-dolly": ["aft", "backward", "forward", "move"],
  "3d-emissive": ["emit", "send"],
  "3d-explode": ["divide", "faces", "parts", "pieces", "separate"],
  "3d-instance": [
    "clone",
    "copy",
    "image",
    "likeness",
    "reflection",
    "same",
    "virtual"
  ],
  "3d-light-rect": ["illumination", "square"],
  "3d-light-rotate": ["bulb", "spin"],
  "3d-material": ["lighting", "reflection", "render", "surface"],
  "3d-move-global": [
    "adjust",
    "arrows",
    "change",
    "cross",
    "object",
    "relocate"
  ],
  "3d-reference": ["image", "likeness", "pointer", "proxy", "same"],
  "3d-rotate-3d": [
    "arrows",
    "circle",
    "dimensions",
    "pivot",
    "roll",
    "spin",
    "swivel",
    "twirl"
  ],
  "3d-rotate-global": ["object", "spin"],
  "3d-segment": [
    "bit",
    "divide",
    "object",
    "part",
    "piece",
    "portion",
    "separate",
    "split"
  ],
  "3d-shader": [
    "algorithm",
    "computed",
    "lighting",
    "look",
    "materials",
    "render"
  ],
  "3d-shader-ball": [
    "demo",
    "example",
    "lighting",
    "materials",
    "object",
    "showcase",
    "textures"
  ],
  "3d-skeleton": ["bones", "joints", "limbs", "parts", "pieces", "segments"],
  "3d-teapot": ["beverage", "boil", "cup", "example", "hot"],
  "3d-teleport": ["translation", "transport", "travel", "wormhole"],
  "3d-texture": ["material", "render", "roughness", "surface"],
  "av-auto-record": [],
  "av-auto-record-off": ["movies", "no feature", "shadowplay", "videos"],
  "av-broadcast": ["send", "signal", "tower", "waves"],
  "av-camera": ["body", "image", "lens", "photography", "picture", "snapshot"],
  "av-camera-add": [
    "body",
    "image",
    "increase",
    "lens",
    "more",
    "new",
    "photography",
    "picture",
    "snapshot"
  ],
  "av-camera-off": [
    "body",
    "disabled",
    "image",
    "lens",
    "no picture",
    "snapshot"
  ],
  "av-clap-board": [
    "begin",
    "clapper",
    "information",
    "movie",
    "recording",
    "scene",
    "tv"
  ],
  "av-display-surround": ["panorama", "panoramic", "screen", "wrap around"],
  "av-eject": ["media", "remove", "unmount"],
  "av-equalizer": [
    "bars",
    "base",
    "eq",
    "frequencies",
    "frequency",
    "levels",
    "mids",
    "treble",
    "volume"
  ],
  "av-faders": ["levels", "mute", "settings", "sliders", "solo", "soundboard"],
  "av-fast-forward": ["control", "playback", "transport"],
  "av-fast-reverse": ["control", "playback", "rewind", "transport"],
  "av-film": [
    "cells",
    "clip",
    "movie",
    "perforations",
    "reel",
    "strip",
    "video"
  ],
  "av-film-add": ["animation", "media", "more", "movie", "plus"],
  "av-film-collection": [
    "cells",
    "clips",
    "group",
    "movies",
    "perforations",
    "reel",
    "stack",
    "strips",
    "videos"
  ],
  "av-forward-10": ["advance", "jump", "skip"],
  "av-fps": [
    "frames per second",
    "hertz",
    "performance",
    "refresh rate",
    "speed"
  ],
  "av-high-quality": ["image", "iq", "performance", "video"],
  "av-hud": ["components", "heads up display", "overlay", "widgets"],
  "av-loop": ["again", "audio", "music", "repeat"],
  "av-loop-off": ["audio", "disabled", "music", "no repeat", "stop repeating"],
  "av-microphone": ["audio", "capsule", "receive", "record", "stand", "voice"],
  "av-microphone-off": [
    "audio",
    "capsule",
    "disabled",
    "no voice",
    "receive",
    "stand"
  ],
  "av-next": ["after", "end", "jump", "skip"],
  "av-notes": ["bar", "melody", "music", "notation"],
  "av-pause": ["control", "playback", "stop", "transport"],
  "av-picture-in-picture": ["mini", "preview", "small", "video", "window"],
  "av-play": [
    "begin",
    "control",
    "go",
    "move",
    "playback",
    "start",
    "transport"
  ],
  "av-previous": ["before", "beginning", "jump", "prior", "skip"],
  "av-record": ["capture", "control", "grab", "media", "playback", "transport"],
  "av-replay": ["again", "feature", "movies", "shadowplay", "videos"],
  "av-replay-off": ["again", "movies", "no feature", "shadowplay", "videos"],
  "av-reverse-10": ["backward", "jump", "rewind", "skip"],
  "av-soundwaves": ["amplitude", "audio", "levels"],
  "av-speaker": ["audio", "music", "sound", "volume"],
  "av-speaker-high": ["audio", "loud", "max", "music", "sound", "volume"],
  "av-speaker-low": ["audio", "min", "music", "quiet", "sound", "volume"],
  "av-speaker-medium": [
    "audio",
    "medium",
    "music",
    "normal",
    "sound",
    "volume"
  ],
  "av-speaker-mute": ["audio", "music", "quiet", "sound", "volume"],
  "av-speaker-off": ["audio", "disabled", "music", "sound", "volume"],
  "av-step-forward": ["frame", "jump", "next", "skip", "slow"],
  "av-step-reverse": ["frame", "jump", "previous", "prior", "skip", "slow"],
  "av-stop": ["control", "end", "playback", "transport"],
  "av-videocam": ["action", "camera", "live", "movie", "playback", "record"],
  "av-videocam-off": [
    "action",
    "disabled",
    "live",
    "movie",
    "no camera",
    "playback",
    "record"
  ],
  "av-watch-party": [
    "event",
    "group",
    "keynote",
    "presentation",
    "session",
    "streaming",
    "video",
    "view"
  ],
  "common-add": ["create", "cross", "crosshair", "expand", "new", "plus"],
  "common-add-circle": [
    "create",
    "cross",
    "crosshair",
    "expand",
    "new",
    "plus"
  ],
  "common-alarm": [
    "alert",
    "bell",
    "buzzer",
    "clock",
    "expire",
    "reminder",
    "ring",
    "signal",
    "time",
    "wake"
  ],
  "common-bell": ["alarm", "alert", "notification", "reminder", "ring"],
  "common-bell-off": ["alert", "no alarm", "notification", "reminder", "ring"],
  "common-calendar": [
    "date",
    "day",
    "event",
    "incident",
    "month",
    "picker",
    "schedule",
    "week",
    "year"
  ],
  "common-calendar-event": [
    "date",
    "day",
    "event",
    "incident",
    "month",
    "picker",
    "schedule",
    "special",
    "week",
    "year"
  ],
  "common-cancel": ["against", "anti", "delete", "remove"],
  "common-check": [
    "approve",
    "done",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid"
  ],
  "common-check-circle": [
    "approve",
    "done",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid"
  ],
  "common-check-multi-circle": [
    "approve",
    "bulk",
    "done",
    "double",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid",
    "validated"
  ],
  "common-clipboard": ["copy", "edit", "paste", "store", "temporary"],
  "common-clock": [
    "delay",
    "face",
    "hands",
    "period",
    "time",
    "timing",
    "wait",
    "watch"
  ],
  "common-close": [
    "cancel",
    "delete",
    "dismiss",
    "exit",
    "fail",
    "failure",
    "remove"
  ],
  "common-close-circle": [
    "cancel",
    "delete",
    "dismiss",
    "exit",
    "fail",
    "failure",
    "remove"
  ],
  "common-cog": [
    "configuration",
    "gear",
    "preferences",
    "settings",
    "setup",
    "setup"
  ],
  "common-cog-off": [
    "configuration",
    "no gear",
    "preferences",
    "settings",
    "setup",
    "setup"
  ],
  "common-copy-doc": ["clone", "duplicate", "pages"],
  "common-copy-generic": ["clone", "duplicate"],
  "common-enter": ["access", "go", "login", "signin"],
  "common-error": [
    "blocker",
    "crash",
    "critical",
    "failure",
    "issue",
    "terminal"
  ],
  "common-exit": ["close", "escape", "exit", "get out", "leave", "shutdown"],
  "common-eye": [
    "enable",
    "eye",
    "eyeball",
    "open",
    "show",
    "visibility",
    "visible"
  ],
  "common-eye-off": [
    "close",
    "disable",
    "eyeball",
    "hidden",
    "invisibility",
    "invisible",
    "no eye"
  ],
  "common-filter": ["funnel", "reduce", "refine"],
  "common-help-circle": [
    "answers",
    "faq",
    "mark",
    "query",
    "question",
    "support"
  ],
  "common-history": [
    "archive",
    "backup",
    "events",
    "happened",
    "old",
    "past",
    "previous",
    "recall",
    "sequence",
    "time"
  ],
  "common-home": ["building", "house", "main", "start"],
  "common-home-off": ["building", "house", "main", "no start"],
  "common-info-circle": [
    "attention",
    "contextual",
    "fyi",
    "help",
    "information",
    "news",
    "tip"
  ],
  "common-link": ["chain", "connection", "hyperlink", "jump", "url", "web"],
  "common-link-break": [
    "chain",
    "connection",
    "hyperlink",
    "jump",
    "remove",
    "url",
    "web"
  ],
  "common-lock-closed": [
    "access",
    "key",
    "keyhole",
    "locked",
    "padlock",
    "password",
    "privacy",
    "private",
    "protection",
    "safe",
    "secure",
    "security"
  ],
  "common-lock-open": [
    "access",
    "key",
    "keyhole",
    "padlock",
    "password",
    "privacy",
    "private",
    "protection",
    "safe",
    "secure",
    "security",
    "unlocked"
  ],
  "common-magnifying-glass": [
    "enlarge",
    "find",
    "inspect",
    "magnifier",
    "shrink",
    "view",
    "zoom"
  ],
  "common-magnifying-glass-minus": [
    "magnifier",
    "reduce",
    "shrink",
    "view",
    "zoom out"
  ],
  "common-magnifying-glass-plus": ["enlarge", "magnifier", "view", "zoom in"],
  "common-menu": [
    "burger",
    "drawer",
    "hamburger",
    "list",
    "nav",
    "navigation",
    "stack"
  ],
  "common-more-horiz": [
    "configuration",
    "dots",
    "ellipses",
    "ellipsis",
    "menu",
    "options"
  ],
  "common-more-vert": [
    "configuration",
    "dots",
    "ellipses",
    "ellipsis",
    "menu",
    "options"
  ],
  "common-paperplane": ["email", "flying", "folded", "message", "send"],
  "common-redo": ["again", "arrow", "forward", "next", "restore"],
  "common-refresh": ["check", "replenish", "restore", "try again", "update"],
  "common-reset": ["boot", "cycle", "replay", "start over", "try again"],
  "common-retry": ["again", "attempt"],
  "common-share": [
    "colleagues",
    "community",
    "coworkers",
    "distribute",
    "friends",
    "give",
    "message",
    "send",
    "social"
  ],
  "common-sort": ["hierarchy", "order", "sequence"],
  "common-star": ["award", "favorite", "level", "rate", "rating"],
  "common-subtract": ["delete", "minus", "remove"],
  "common-subtract-circle": ["delete", "minus", "remove"],
  "common-sync": [
    "activity",
    "arrows",
    "connection",
    "feedback",
    "recurring",
    "schedule"
  ],
  "common-sync-off": [
    "activity",
    "arrows",
    "feedback",
    "no connection",
    "recurring",
    "schedule"
  ],
  "common-timer": ["clock", "measure", "period", "race", "stop watch", "time"],
  "common-trash": [
    "bin",
    "can",
    "delete",
    "garbage",
    "recycle",
    "remove",
    "rubbish",
    "waste"
  ],
  "common-undo": [
    "arrow",
    "back",
    "backwards",
    "previous",
    "reverse",
    "revert"
  ],
  "common-warning": [
    "alert",
    "attention",
    "caution",
    "danger",
    "error",
    "feedback",
    "issue",
    "triangle"
  ],
  "communication-cloud": [
    "data center",
    "internet",
    "server",
    "wan",
    "weather",
    "wide area network"
  ],
  "communication-cloud-off": [
    "data center",
    "internet",
    "no weather",
    "server",
    "wan",
    "wide area network"
  ],
  "communication-data": [
    "binary",
    "bits",
    "information",
    "process",
    "receive",
    "send",
    "transmit"
  ],
  "communication-download": ["down arrow", "get", "pull", "save"],
  "communication-envelope": ["email", "mail", "message", "send"],
  "communication-envelope-off": ["mail", "message", "no email", "send"],
  "communication-firewall": ["block", "networking", "security"],
  "communication-firewall-off": ["block", "no networking", "security"],
  "communication-forward": ["next", "pass along", "send"],
  "communication-isp": ["internet", "network", "online", "wan", "web", "www"],
  "communication-isp-off": [
    "internet",
    "no network",
    "online",
    "wan",
    "web",
    "www"
  ],
  "communication-network-signal": ["activity", "node", "origin", "pulse"],
  "communication-network-signal-off": [
    "activity",
    "no origin",
    "node",
    "pulse"
  ],
  "communication-reply": ["react", "response", "return", "send back"],
  "communication-sync-warning": [
    "blocked",
    "broken",
    "error",
    "issue",
    "stopped"
  ],
  "communication-transfer-horizontal": [
    "displace",
    "exchange",
    "horizontal",
    "migrate",
    "move",
    "relocate",
    "shift",
    "sideways",
    "switch"
  ],
  "communication-transfer-vertical": [
    "displace",
    "exchange",
    "migrate",
    "move",
    "relocate",
    "shift",
    "switch",
    "vertical"
  ],
  "communication-upload": ["push", "put", "send", "up arrow"],
  "communication-wifi": [
    "hotspot",
    "internet",
    "reception",
    "signal",
    "waves",
    "wireless"
  ],
  "communication-wifi-off": [
    "disabled",
    "hotspot",
    "internet",
    "reception",
    "signal",
    "waves",
    "wireless"
  ],
  "cursor-arrow": ["click", "mouse", "pointer", "select"],
  "cursor-crosshair": ["aim", "drop", "reticle", "sight", "target"],
  "cursor-hand-closed": ["choose", "grab", "hold", "select"],
  "cursor-hand-open": ["choose", "pan", "select", "wave"],
  "cursor-hand-pinch": ["gesture", "motion", "pull", "zoom"],
  "cursor-hand-point": [
    "choose",
    "direct",
    "index finger",
    "point",
    "select",
    "tap",
    "touch"
  ],
  "cursor-hourglass": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-end": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-mid": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-start": ["busy", "delay", "pause", "process", "wait"],
  "editor-anchor-center": ["lock", "middle", "origin", "point", "tie"],
  "editor-anchor-e": ["lock", "origin", "point", "right", "tie"],
  "editor-anchor-n": ["lock", "origin", "point", "tie", "top", "up"],
  "editor-anchor-ne": ["lock", "origin", "point", "right", "tie", "top", "up"],
  "editor-anchor-nw": ["left", "lock", "origin", "point", "tie", "top", "up"],
  "editor-anchor-s": ["bottom", "lock", "origin", "point", "tie"],
  "editor-anchor-se": ["bottom", "lock", "origin", "point", "right", "tie"],
  "editor-anchor-sw": ["bottom", "left", "lock", "origin", "point", "tie"],
  "editor-anchor-w": ["left", "lock", "origin", "point", "tie"],
  "editor-at-symbol": ["email", "receiver", "recipient", "target", "to"],
  "editor-backspace": ["character", "delete", "keystroke", "undo"],
  "editor-bold": ["document", "emphasis", "format", "heavy", "strong", "text"],
  "editor-branch": [
    "change",
    "control",
    "git",
    "new",
    "source",
    "test",
    "version"
  ],
  "editor-chart": [
    "change",
    "data viz",
    "diagram",
    "graph",
    "time series",
    "visualization"
  ],
  "editor-chart-bar": [
    "amount",
    "data viz",
    "diagram",
    "graph",
    "groups",
    "histogram",
    "vertical",
    "visualization"
  ],
  "editor-chart-flow": [
    "connectors",
    "diagram",
    "direction",
    "graph",
    "lines",
    "nodes"
  ],
  "editor-chart-hierarchy": [
    "diagram",
    "graph",
    "position",
    "rank",
    "structure",
    "taxonomy",
    "team"
  ],
  "editor-chart-performance": [
    "change",
    "data viz",
    "direction",
    "goal",
    "movement",
    "trend",
    "visualization"
  ],
  "editor-chart-pie": [
    "circle",
    "data viz",
    "diagram",
    "fraction",
    "graph",
    "segment",
    "visualization",
    "whole"
  ],
  "editor-chart-tree": [
    "diagram",
    "graph",
    "leaf",
    "leaves",
    "structure",
    "taxonomy",
    "team",
    "trunk"
  ],
  "editor-collapse": ["hide", "minimize", "reduce", "smaller"],
  "editor-commit": ["base", "code", "control", "git", "source", "version"],
  "editor-compare": [
    "check",
    "code",
    "control",
    "diff",
    "git",
    "source",
    "text",
    "version"
  ],
  "editor-connection": ["bridge", "line", "link", "nodes", "together"],
  "editor-expand": ["bigger", "expand", "larger", "show"],
  "editor-export-to-clipboard": ["copy", "memory"],
  "editor-fit": ["conform", "enlarge", "expand", "fill", "reduce", "shrink"],
  "editor-fork": [
    "clone",
    "control",
    "copy",
    "git",
    "new",
    "source",
    "version"
  ],
  "editor-freehand": ["draw", "form", "natural", "organic", "scribble"],
  "editor-grid": [
    "blocks",
    "edges",
    "frames",
    "lattice",
    "no guidelines",
    "regions"
  ],
  "editor-grid-off": [
    "blocks",
    "edges",
    "frames",
    "lattice",
    "no guidelines",
    "regions"
  ],
  "editor-h-align-center": [
    "arrange",
    "horizontal",
    "middle",
    "objects",
    "side"
  ],
  "editor-h-align-left": ["arrange", "flush", "horizontal", "objects", "side"],
  "editor-h-align-right": ["arrange", "flush", "horizontal", "objects", "side"],
  "editor-header": ["headline", "hook", "main", "sub", "summary", "title"],
  "editor-image": [
    "drawing",
    "graphic",
    "media",
    "painting",
    "photography",
    "picture",
    "print"
  ],
  "editor-italic": ["document", "emphasis", "oblique", "slant", "text"],
  "editor-iterate": ["cycles", "iterations", "passes", "repeats", "steps"],
  "editor-keyframe": ["adjust", "change", "node", "point", "stop", "tween"],
  "editor-layers": ["order", "overlay", "pile", "stack"],
  "editor-layers-off": ["no order", "overlay", "pile", "stack"],
  "editor-line-segment": ["line", "nodes", "piece", "straight"],
  "editor-list-bullet": ["collection", "group", "sequence", "unordered"],
  "editor-list-checkmark": [
    "collection",
    "group",
    "notes",
    "reminder",
    "schedule",
    "sequence",
    "summary",
    "tasks",
    "to do",
    "unordered",
    "work"
  ],
  "editor-list-number": ["collection", "group", "ordered", "sequence", "steps"],
  "editor-markdown": ["documentation", "format", "shorthand", "syntax"],
  "editor-merge": [
    "checkin",
    "control",
    "git",
    "source",
    "sync",
    "update",
    "version"
  ],
  "editor-move": ["adjust", "arrows", "change", "cross", "relocate"],
  "editor-numbers": ["count", "digits", "numeric", "values"],
  "editor-paperclip": ["addition", "attachment", "extra", "file"],
  "editor-paragraph": [
    "characters",
    "document",
    "hidden",
    "new",
    "processor",
    "special",
    "start",
    "text"
  ],
  "editor-pencil": [
    "change",
    "create",
    "draw",
    "edit",
    "modify",
    "pencil",
    "stylus",
    "write"
  ],
  "editor-pull": [
    "code",
    "control",
    "git",
    "refresh",
    "source",
    "sync",
    "version"
  ],
  "editor-pull-close": [
    "cancel",
    "close",
    "code",
    "control",
    "delete",
    "git",
    "remove",
    "source",
    "version"
  ],
  "editor-pull-draft": [
    "code",
    "control",
    "git",
    "source",
    "temporary",
    "version",
    "working"
  ],
  "editor-rotate": [
    "arrows",
    "circle",
    "pivot",
    "roll",
    "spin",
    "swivel",
    "twirl"
  ],
  "editor-rotate-90-clockwise": [
    "rectangular",
    "right",
    "spin",
    "square",
    "turn"
  ],
  "editor-rotate-90-counter": ["left", "rectangular", "spin", "square", "turn"],
  "editor-ruler": ["distance", "measurement", "size", "straightedge"],
  "editor-scale-down": ["collapse", "reduce", "resize", "shrink"],
  "editor-scale-reset": ["original", "resize", "start"],
  "editor-scale-up": ["expand", "grow", "resize", "stretch"],
  "editor-scissors": ["break", "copy", "cut", "slice", "split"],
  "editor-section": ["choose", "mark", "pick", "portion"],
  "editor-section-bottom": [
    "choose",
    "lower",
    "mark",
    "pick",
    "portion",
    "under"
  ],
  "editor-section-top": ["choose", "mark", "over", "pick", "portion", "upper"],
  "editor-select-brush": ["choose", "mark", "paint", "pick", "stroke"],
  "editor-signature": ["autograph", "sign"],
  "editor-skip": ["avoid", "ignore", "over"],
  "editor-sliders": [
    "adjust",
    "configuration",
    "continuous",
    "controls",
    "options",
    "refine",
    "settings"
  ],
  "editor-sort-ascending": ["direction", "hierarchy", "order", "sequence"],
  "editor-sort-descending": ["direction", "hierarchy", "order", "sequence"],
  "editor-sticker": ["cover", "overlay", "superimpose", "tag"],
  "editor-sticker-image": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-shape": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-text": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-zoom": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-strikethrough": ["document", "recant", "redact", "remove", "text"],
  "editor-stroke-width": ["edge", "line", "thickness"],
  "editor-style": ["customize", "freestyle", "look", "visuals"],
  "editor-swatches": [
    "cards",
    "categories",
    "fan",
    "sets",
    "stack",
    "styles",
    "types"
  ],
  "editor-text": ["dictate", "document", "letters", "type", "words", "write"],
  "editor-text-align-center": [
    "balanced",
    "format",
    "middle",
    "ragged",
    "text"
  ],
  "editor-text-align-full": ["flush", "format", "full", "justified", "text"],
  "editor-text-align-left": ["flush", "format", "justified", "text"],
  "editor-text-align-right": ["flush", "format", "justified", "text"],
  "editor-text-framed": ["background", "boundary", "box", "color", "region"],
  "editor-trash-delete": ["empty", "files", "garbage can", "permanent"],
  "editor-typography": [
    "appearance",
    "font",
    "format",
    "legibility",
    "letters",
    "readability",
    "style",
    "words"
  ],
  "editor-underline": ["document", "emphasis", "hyperlink", "rule", "text"],
  "editor-v-align-bottom": ["arrange", "flush", "objects", "side", "vertical"],
  "editor-v-align-center": ["arrange", "middle", "objects", "side", "vertical"],
  "editor-v-align-top": ["arrange", "flush", "objects", "side", "vertical"],
  "editor-wand": ["automatic", "fix", "improve", "instant", "magic", "wizard"],
  "editor-wrench": ["adjust", "build", "customize", "fix", "repair", "tool"],
  "files-archive": ["box", "deep", "save", "shelf", "storage", "store"],
  "files-db": ["database", "records", "save", "sql", "storage"],
  "files-document": ["corner", "empty", "fold", "new", "page", "sheet"],
  "files-document-checkmark": [
    "confirmed",
    "corner",
    "done",
    "empty",
    "finished",
    "fold",
    "new",
    "page",
    "sheet",
    "validated"
  ],
  "files-document-new": [
    "corner",
    "empty",
    "fold",
    "new",
    "page",
    "plus",
    "sheet"
  ],
  "files-document-preview": [
    "find",
    "look",
    "render",
    "search",
    "wysiwyg",
    "zoom"
  ],
  "files-export": ["convert", "process", "send", "share", "translate"],
  "files-floppy": ["data", "disk", "save", "storage", "store"],
  "files-folder-closed": ["container", "directory", "files", "path"],
  "files-folder-open": ["container", "directory", "files", "get", "path"],
  "files-import": ["convert", "embed", "insert", "process", "translate"],
  "hardware-2-b-left-click": ["action", "buttons", "indicator"],
  "hardware-battery-0": ["empty", "level", "power"],
  "hardware-battery-0-off": ["empty", "level", "power"],
  "hardware-battery-100": ["charged", "full", "level", "power"],
  "hardware-battery-25": ["level", "low", "power"],
  "hardware-battery-50": ["half", "level", "medium", "power"],
  "hardware-battery-75": ["healthy", "level", "power"],
  "hardware-battery-boost": ["feature", "power", "savings"],
  "hardware-battery-charging": ["level", "plugged in", "power"],
  "hardware-bluetooth": [
    "format",
    "peripheral",
    "standard",
    "type",
    "wireless"
  ],
  "hardware-bluetooth-off": [
    "format",
    "peripheral",
    "standard",
    "type",
    "wireless"
  ],
  "hardware-calculator": ["classic", "crunch", "display", "numbers", "old"],
  "hardware-cpu": ["central processing unit", "chip", "micro", "processor"],
  "hardware-display": ["landscape", "monitor", "screen"],
  "hardware-display-collection": ["monitor", "mosaic", "multimon", "surround"],
  "hardware-display-off": ["landscape", "monitor", "screen"],
  "hardware-drive-cloud": [
    "data center",
    "internet",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-cloud-off": [
    "data center",
    "internet",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-network": [
    "attached",
    "data center",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-network-off": [
    "attached",
    "data center",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-removable": [
    "bernoulli",
    "disk",
    "floppy",
    "media",
    "optical",
    "save",
    "storage",
    "store",
    "zip"
  ],
  "hardware-drive-removable-off": [
    "bernoulli",
    "disk",
    "floppy",
    "media",
    "optical",
    "save",
    "storage",
    "store",
    "zip"
  ],
  "hardware-drive-usb": ["data", "flash", "memory", "save", "storage", "store"],
  "hardware-drive-usb-off": [
    "data",
    "flash",
    "memory",
    "save",
    "storage",
    "store"
  ],
  "hardware-ethernet": [
    "connector",
    "internet",
    "lan",
    "local area network",
    "patch cable",
    "port",
    "server"
  ],
  "hardware-fan": ["flow", "hardware", "noise", "temperature"],
  "hardware-fan-loud": ["air", "high power", "noise", "speed", "volume"],
  "hardware-fan-quiet": [
    "air",
    "low power",
    "noise",
    "silent",
    "speed",
    "volume"
  ],
  "hardware-gamepad": [
    "buttons",
    "console",
    "controller",
    "dpad",
    "shield",
    "video games"
  ],
  "hardware-gamepad-off": [
    "buttons",
    "console",
    "controller",
    "dpad",
    "shield",
    "video games"
  ],
  "hardware-gamepad-start": ["controller", "start"],
  "hardware-gpu": ["chip", "graphics processing unit", "micro", "processor"],
  "hardware-gpu-card": [
    "dedicated",
    "discreet",
    "expansion",
    "motherboard",
    "pci"
  ],
  "hardware-gpu-card-multi": [
    "dedicated",
    "discreet",
    "expansion",
    "group",
    "lda",
    "motherboard",
    "multiple",
    "pci",
    "sli"
  ],
  "hardware-gpu-card-off": [
    "dedicated",
    "discreet",
    "expansion",
    "motherboard",
    "pci"
  ],
  "hardware-gpu-off": [
    "chip",
    "graphics processing unit",
    "micro",
    "processor"
  ],
  "hardware-headset": [
    "audio",
    "av",
    "chat",
    "headphones",
    "microphone",
    "sound",
    "speaker",
    "voice"
  ],
  "hardware-keyboard": ["data entry", "input", "keys", "peripheral", "type"],
  "hardware-laptop": ["computer", "notebook", "portable"],
  "hardware-lightning": [
    "electricity",
    "event",
    "instance",
    "juice",
    "power",
    "surprise"
  ],
  "hardware-mac": [
    "apple",
    "display",
    "imac",
    "macintosh",
    "monitor",
    "screen"
  ],
  "hardware-mac-off": [
    "apple",
    "display",
    "imac",
    "macintosh",
    "monitor",
    "screen"
  ],
  "hardware-media-optical": ["cd", "disc", "dvd", "installer"],
  "hardware-mosaic": [
    "cave",
    "combined displays",
    "fabric",
    "resolution",
    "wall"
  ],
  "hardware-mouse-2-b": ["buttons", "cursor", "input", "peripheral", "track"],
  "hardware-mouse-2-b-right-click": ["action", "buttons", "indicator"],
  "hardware-mouse-3-b": ["buttons", "cursor", "input", "peripheral", "track"],
  "hardware-mouse-scrollwheel": [
    "buttons",
    "cursor",
    "input",
    "peripheral",
    "track"
  ],
  "hardware-mouse-scrollwheel-active": [
    "action",
    "buttons",
    "indicator",
    "wheel"
  ],
  "hardware-multidrive": [
    "array",
    "discs",
    "hard drives",
    "hdd",
    "raid",
    "save",
    "storage",
    "store",
    "stripe"
  ],
  "hardware-network": [
    "connections",
    "diagram",
    "hub",
    "lines",
    "nodes",
    "web"
  ],
  "hardware-network-connection": ["ethernet", "lan", "local area network"],
  "hardware-network-pcs": [
    "cluster",
    "computers",
    "connection",
    "group",
    "lan",
    "local area"
  ],
  "hardware-nvidia-shield": ["console", "set top box", "stb"],
  "hardware-nvidia-shield-stand": ["console", "set top box", "stb", "vertical"],
  "hardware-performance-high": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "high",
    "measure",
    "threshold"
  ],
  "hardware-performance-low": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "low",
    "measure",
    "threshold"
  ],
  "hardware-performance-medium": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "measure",
    "medium",
    "threshold"
  ],
  "hardware-phone-laptop": [
    "android",
    "combo",
    "computer",
    "gadget",
    "handset",
    "iphone",
    "notebook",
    "pair",
    "portable"
  ],
  "hardware-plug-recepticle": [
    "connect",
    "couple",
    "electricity",
    "power",
    "socket"
  ],
  "hardware-plug-usb": ["cable", "connect"],
  "hardware-plugin": ["electricity", "power", "prongs"],
  "hardware-power": [
    "circuit",
    "device",
    "electronics",
    "flow",
    "hardware",
    "state"
  ],
  "hardware-ram": ["chip", "micro", "random access memory", "storage"],
  "hardware-remote": [
    "control",
    "distance",
    "gadget",
    "shield",
    "television",
    "tv"
  ],
  "hardware-robot-arm": [
    "articulation",
    "automation",
    "dexterity",
    "simulation"
  ],
  "hardware-sd-card": ["camera", "data", "memory", "save", "storage", "store"],
  "hardware-smartphone": ["android", "gadget", "handset", "iphone"],
  "hardware-smartphone-off": ["android", "gadget", "handset", "iphone"],
  "hardware-tablet": ["android", "gadget", "ipad", "kindle", "slate"],
  "hardware-tablet-off": ["android", "gadget", "ipad", "kindle", "slate"],
  "hardware-telephone": [
    "answer",
    "call",
    "communications",
    "handset",
    "pickup"
  ],
  "hardware-telephone-off": [
    "answer",
    "call",
    "communications",
    "handset",
    "pickup"
  ],
  "hardware-usb": ["format", "peripheral", "standard", "type", "wired"],
  "hardware-vr": ["goggles", "peripheral", "track", "virtual reality"],
  "hardware-watch": ["clock", "time", "wearable", "wrist"],
  "hardware-webcam": ["camera", "meetings", "mount", "video chat"],
  "hardware-webcam-off": ["camera", "meetings", "mount", "video chat"],
  "hardware-webcam-settings": [
    "adjust",
    "camera",
    "config",
    "meetings",
    "mount",
    "settings",
    "video chat"
  ],
  "hardware-whispermode": [
    "fan",
    "feature",
    "noise",
    "quiet",
    "silent",
    "volume"
  ],
  "hardware-wireless-modem": [
    "internet",
    "lan",
    "network",
    "router",
    "signal",
    "wap",
    "wifi"
  ],
  "hardware-wireless-modem-off": [
    "internet",
    "lan",
    "network",
    "router",
    "signal",
    "wap",
    "wifi"
  ],
  "hardware-workstation": ["computer", "desktop", "pc", "tower"],
  "hardware-workstation-off": ["computer", "desktop", "pc", "tower"],
  "hardware-workstation-system": [
    "computer",
    "desktop",
    "display",
    "monitor",
    "pc",
    "tower"
  ],
  "hardware-workstation-system-off": [
    "computer",
    "desktop",
    "display",
    "monitor",
    "pc",
    "tower"
  ],
  "image-brush": ["coloring", "drawing", "painting", "strokes"],
  "image-bucket": ["art", "colors", "fill", "flood", "paint"],
  "image-camera-360": ["environment", "surround", "vr"],
  "image-camera-linked": [
    "attached",
    "connected",
    "images",
    "photos",
    "wireless"
  ],
  "image-camera-super": [],
  "image-collection": [
    "collection",
    "drawing",
    "graphic",
    "group",
    "media",
    "painting",
    "photography",
    "picture",
    "print",
    "stack"
  ],
  "image-crop": ["area", "artboard", "aspect ratio", "clip", "trim"],
  "image-denoise": ["clarify", "refine", "simplify"],
  "image-easel": ["display", "present", "showcase", "stand"],
  "image-eraser": ["delete", "remove", "scrub"],
  "image-eyedropper": ["color", "format", "picker", "sampler", "style"],
  "image-group": ["cluster", "collection", "surround", "team", "together"],
  "image-import-image": [
    "convert",
    "embed",
    "insert",
    "picture",
    "process",
    "translate",
    "visual"
  ],
  "image-mask-inside": ["affect", "area", "interior", "region", "select"],
  "image-mask-outside": ["affect", "area", "exterior", "region", "select"],
  "image-mirror": ["reflect", "reverse"],
  "image-outpainting": ["canvas", "create", "extend", "grow", "stretch"],
  "image-palette": ["collection", "colors", "picker"],
  "image-scale": ["adjust", "bigger", "expand", "reduce", "resize", "shrink"],
  "image-scale-relative": [
    "aspect ratio",
    "enlarge",
    "maintain",
    "reduce",
    "shrink"
  ],
  "image-scale-relative-off": [
    "aspect ratio",
    "maintain",
    "no enlarge",
    "reduce",
    "shrink"
  ],
  "image-select-ellipse": [
    "area",
    "border",
    "boundary",
    "circle",
    "mask",
    "portion",
    "region",
    "round",
    "segment"
  ],
  "image-select-polygon": [
    "area",
    "border",
    "boundary",
    "custom",
    "irregular",
    "mask",
    "portion",
    "region",
    "segment"
  ],
  "image-select-rectangle": [
    "area",
    "border",
    "boundary",
    "corner",
    "mask",
    "portion",
    "region",
    "segment",
    "square"
  ],
  "image-shapes": [
    "basic",
    "collection",
    "containers",
    "objects",
    "primitives",
    "simple"
  ],
  "image-sun-high": ["astronomy", "bright", "intensity", "light", "space"],
  "image-sun-low": ["astronomy", "dim", "intensity", "light", "space"],
  "image-sun-off-high": ["astronomy", "bright", "intensity", "light", "space"],
  "image-transparency": [
    "onion",
    "opacity",
    "see through",
    "skin",
    "translucency",
    "vellum"
  ],
  "maps-airplane": ["air", "flight", "fly", "jet", "travel"],
  "maps-briefcase": [
    "business",
    "documents",
    "job",
    "occupation",
    "portfolio",
    "work"
  ],
  "maps-bush": ["low", "plants", "shrubbery"],
  "maps-business": ["building", "city", "office", "skyscraper", "work"],
  "maps-dirt": ["ground", "particles", "soil"],
  "maps-elevator": ["floors", "lift", "mechanical"],
  "maps-escalator": ["floors", "mechanical", "stairs"],
  "maps-factory": ["building", "industry", "manufacture", "production"],
  "maps-flag": ["landmark", "location", "remember", "save"],
  "maps-flower": [
    "colorful",
    "grow",
    "leaves",
    "petals",
    "spring",
    "stems",
    "wild"
  ],
  "maps-fog": ["low clouds", "mist", "soupy", "visibility"],
  "maps-grass": ["green", "low", "pasture", "short"],
  "maps-gravel": ["pebbles", "river bank", "rocks", "stones"],
  "maps-hill": ["rise", "rolling"],
  "maps-location": ["geography", "marker", "pin", "place", "position"],
  "maps-location-off": ["geography", "marker", "pin", "place", "position"],
  "maps-map": ["directions", "fold", "geography", "location", "paper"],
  "maps-map-off": ["directions", "fold", "geography", "location", "paper"],
  "maps-mountain": ["high point", "peak", "range", "rocky"],
  "maps-mud": ["dirt", "water"],
  "maps-river": ["channel", "flow", "water"],
  "maps-rock": ["boulder", "ground"],
  "maps-sand": ["cactus", "desert", "dry", "dunes"],
  "maps-sea": ["ocean", "open water", "waves"],
  "maps-signpost": ["direction", "goal", "marker", "pointer", "waypoint"],
  "maps-sky": ["air", "birds", "horizon", "ocean", "sunset"],
  "maps-snow": [
    "cold",
    "crystal",
    "flake",
    "hexagonal",
    "temperature",
    "water"
  ],
  "maps-stair": ["emergency", "floors", "staircase", "stairwell"],
  "maps-stone": ["face", "hewn", "rock"],
  "maps-straw": ["grassland", "stalks", "tall"],
  "maps-suitcase": ["baggage", "clothes", "personal", "travel"],
  "maps-toolbox": [
    "adjust",
    "configuration",
    "customize",
    "fix",
    "repair",
    "utilities"
  ],
  "maps-tree": ["branches", "forest", "leaves", "trunk", "woods"],
  "maps-trees": ["forest", "grove", "stand", "woods"],
  "maps-water": ["lake", "liquid", "smooth", "still", "wet"],
  "maps-world": [
    "earth",
    "global",
    "globe",
    "internet",
    "planet",
    "wan",
    "www"
  ],
  "maps-world-off": [
    "earth",
    "global",
    "globe",
    "internet",
    "planet",
    "wan",
    "www"
  ],
  "misc-bandaid": ["fix", "health", "help", "medical", "patch"],
  "misc-beaker": [
    "experiment",
    "glass",
    "lab",
    "liquid",
    "science",
    "trial",
    "vial"
  ],
  "misc-blackboard": [
    "chalk",
    "classroom",
    "display",
    "dry erase",
    "education",
    "learning"
  ],
  "misc-book": [
    "content",
    "education",
    "learn",
    "library",
    "manual",
    "pages",
    "read",
    "study",
    "text"
  ],
  "misc-bug": ["code", "development", "error", "issue", "problem"],
  "misc-bug-off": ["code", "development", "error", "issue", "problem"],
  "misc-car": [
    "automobile",
    "drive",
    "driving",
    "passenger",
    "travel",
    "vehicle"
  ],
  "misc-checkmark-badge": ["approved", "award", "special", "star", "validated"],
  "misc-circle-1-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-2-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-3-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-tick": ["burst", "delay", "ios", "spinner", "waiting"],
  "misc-code": [
    "angle brackets",
    "cli",
    "close",
    "development",
    "open",
    "slash",
    "tags"
  ],
  "misc-compass": [
    "directions",
    "hike",
    "location",
    "magnetism",
    "north",
    "pathfinding"
  ],
  "misc-delivery-truck": ["cargo", "freight", "moving", "vehicle"],
  "misc-ekg": ["health", "heart", "monitor", "pulse"],
  "misc-function": [
    "algorithm",
    "complex",
    "compute",
    "input",
    "output",
    "process"
  ],
  "misc-gift": ["bow", "package", "present", "reward", "sash", "wrapped"],
  "misc-graduate": [
    "college",
    "education",
    "hat",
    "learning",
    "school",
    "tassle",
    "university"
  ],
  "misc-graph-node": [
    "activity",
    "input",
    "object",
    "output",
    "piece",
    "process"
  ],
  "misc-graph-node-connect": [
    "activity",
    "bridge",
    "input",
    "link",
    "object",
    "output",
    "piece",
    "process"
  ],
  "misc-graph-node-delete": [
    "activity",
    "input",
    "object",
    "output",
    "piece",
    "process",
    "remove"
  ],
  "misc-health": [
    "aid",
    "cross",
    "doctor",
    "emergency",
    "hospital",
    "medical",
    "nurse"
  ],
  "misc-hot-air-balloon": [
    "air",
    "classic",
    "explore",
    "rise",
    "travel",
    "whimsical"
  ],
  "misc-ime": ["input", "language", "method"],
  "misc-infinity": ["loop", "math", "neverending", "symbol", "unlimited"],
  "misc-key": ["access", "authentication", "entry", "lock", "open", "password"],
  "misc-library": [
    "books",
    "collection",
    "objects",
    "shelf",
    "stack",
    "volumes"
  ],
  "misc-library-games": [],
  "misc-lifebouy": ["float", "help", "ring", "safety"],
  "misc-lightbulb": ["bright", "idea", "thought"],
  "misc-magnet": ["attraction", "connection", "electromagnetism", "sticky"],
  "misc-man": ["male", "men", "restrooms"],
  "misc-man-woman": ["female", "male", "men", "restrooms", "women"],
  "misc-math": [
    "add",
    "divide",
    "multiply",
    "process",
    "solution",
    "solve",
    "subtract"
  ],
  "misc-megaphone": [
    "amplify",
    "announce",
    "bullhorn",
    "loudspeaker",
    "public address",
    "volume"
  ],
  "misc-microscope": ["inspect", "lab", "magnify", "science", "zoom"],
  "misc-mode-component": [
    "individual",
    "one",
    "single",
    "singular",
    "solo",
    "unique"
  ],
  "misc-money": [
    "bill",
    "coin",
    "currency",
    "generic",
    "stack",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-money-coin": [
    "change",
    "currency",
    "generic",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-money-paper": [
    "bill",
    "currency",
    "dollar",
    "frank",
    "generic",
    "note",
    "pound",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-moon": ["crescent", "dark", "eclipse", "evening", "night", "space"],
  "misc-moon-off": ["crescent", "dark", "eclipse", "evening", "night", "space"],
  "misc-mug": [
    "beverage",
    "coffee",
    "cup",
    "drink",
    "hot",
    "hot chocolate",
    "steam",
    "tea",
    "warm"
  ],
  "misc-neural-network": [
    "ai",
    "artificial intelligence",
    "deep",
    "dl",
    "learning",
    "machine",
    "ml"
  ],
  "misc-news": [
    "articles",
    "headlines",
    "information",
    "pages",
    "periodical",
    "press",
    "tabloid",
    "update"
  ],
  "misc-package": ["address", "box", "label", "order", "send", "shipment"],
  "misc-payment-card": [
    "buy",
    "commerce",
    "credit",
    "debit",
    "finance",
    "money",
    "purchase",
    "shop",
    "swipe"
  ],
  "misc-pizza": ["cuisine", "food", "italian", "pie", "slice", "toppings"],
  "misc-prayer-room": ["chapel", "meditation", "quiet", "religion"],
  "misc-projector": ["display", "present", "showcase", "stand"],
  "misc-pulse": [
    "audio",
    "health",
    "heartbeat",
    "sound",
    "statistic",
    "wavelength"
  ],
  "misc-puzzle": ["component", "fit", "mystery", "piece"],
  "misc-qrcode": [
    "dots",
    "encode",
    "link",
    "mobile",
    "pattern",
    "quick redirect"
  ],
  "misc-radar": ["ping", "scan", "sensor", "sonar", "waves"],
  "misc-radioactive": ["energy", "nuclear", "warning"],
  "misc-rocket": [
    "explore",
    "launch",
    "science",
    "send",
    "shuttle",
    "space",
    "space",
    "start",
    "travel"
  ],
  "misc-running": [
    "action",
    "activity",
    "exercise",
    "figure",
    "movement",
    "person"
  ],
  "misc-scale-balance": ["compare", "even", "measures", "weights"],
  "misc-school": [
    "building",
    "education",
    "learning",
    "location",
    "place",
    "students",
    "teachers"
  ],
  "misc-seed": ["acorn", "grow", "plant", "randomization"],
  "misc-sensor": ["dish", "pickup", "receiver", "receptor", "signals"],
  "misc-shield": [
    "block",
    "elevation",
    "guard",
    "malware",
    "protection",
    "safety",
    "security",
    "virus"
  ],
  "misc-shield-off": [
    "block",
    "elevation",
    "guard",
    "malware",
    "protection",
    "safety",
    "security",
    "virus"
  ],
  "misc-ship-wheel": [
    "boat",
    "directions",
    "discover",
    "explore",
    "navigate",
    "steer"
  ],
  "misc-shopping-bag": [
    "bundle",
    "buy",
    "choose",
    "commerce",
    "purchase",
    "shop"
  ],
  "misc-shopping-basket": [
    "bag",
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "items",
    "purchase",
    "store"
  ],
  "misc-shopping-cart": [
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "items",
    "purchase",
    "store"
  ],
  "misc-shopping-cart-open": [
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "contents",
    "filled",
    "items",
    "purchase",
    "store"
  ],
  "misc-sparkle": ["magic", "poof", "shiny", "stars", "twinkle", "whoosh"],
  "misc-tag": ["categorize", "flag", "label", "mark", "price"],
  "misc-tag-label": ["categorize", "flag", "label", "mark", "price"],
  "misc-telescope": [
    "astronomy",
    "explore",
    "optics",
    "planets",
    "science",
    "space",
    "stars",
    "zoom"
  ],
  "misc-thermometer": ["gauge", "measure", "temperature"],
  "misc-ticket": ["event", "pass", "redeem", "tix", "validation"],
  "misc-traffic-cone": [
    "barrier",
    "construction",
    "guidance",
    "marker",
    "safety",
    "warning"
  ],
  "misc-weight": ["big", "force", "heavy", "mass", "measurement"],
  "misc-weight-bar": ["barbell", "exercise", "heavy", "lift", "work out"],
  "misc-wheelchair": [
    "accessibility",
    "ada",
    "disabled",
    "handicap",
    "parking",
    "ramp",
    "space"
  ],
  "misc-woman": ["female", "restrooms", "women"],
  "shapes-arrow-down": ["bottom", "south"],
  "shapes-arrow-down-left": ["bottom", "diagonal", "south", "west"],
  "shapes-arrow-down-max": ["bottom", "edge", "end", "south"],
  "shapes-arrow-down-right": ["bottom", "diagonal", "east", "south"],
  "shapes-arrow-left": ["side", "west"],
  "shapes-arrow-left-max": ["edge", "end", "side", "west"],
  "shapes-arrow-left-right": [
    "expand",
    "horizontal",
    "left",
    "right",
    "sides",
    "stretch"
  ],
  "shapes-arrow-right": ["east", "side"],
  "shapes-arrow-right-max": ["east", "edge", "end", "side"],
  "shapes-arrow-up": ["north", "top"],
  "shapes-arrow-up-down": ["down", "expand", "stretch", "up", "vertical"],
  "shapes-arrow-up-left": ["diagonal", "north", "top", "west"],
  "shapes-arrow-up-max": ["edge", "end", "north", "top"],
  "shapes-arrow-up-right": ["diagonal", "east", "north", "top"],
  "shapes-chevron-double-down": ["arrows", "bottom", "south"],
  "shapes-chevron-double-left": ["arrows", "side", "west"],
  "shapes-chevron-double-right": ["arrows", "east", "side"],
  "shapes-chevron-double-up": ["arrows", "north", "top"],
  "shapes-chevron-down": ["arrow", "bottom", "south"],
  "shapes-chevron-down-left-up-right": [
    "arrows",
    "corners",
    "diagonal",
    "northeast",
    "southwest"
  ],
  "shapes-chevron-left": ["arrow", "west"],
  "shapes-chevron-left-right": ["arrows", "east", "sides", "west"],
  "shapes-chevron-right": ["arrow", "east"],
  "shapes-chevron-up": ["arrow", "north", "top"],
  "shapes-chevron-up-down": [
    "arrows",
    "bottom",
    "north",
    "sides",
    "south",
    "top"
  ],
  "shapes-chevron-up-left-down-right": [
    "arrows",
    "corners",
    "diagonal",
    "northwest",
    "southeast"
  ],
  "shapes-diamond": ["block", "instance", "mark", "simple"],
  "shapes-diamond-off": ["block", "instance", "mark", "no shape", "simple"],
  "shapes-return": ["carriage", "enter", "new line"],
  "shapes-shape-circle": ["basic", "dot", "ring", "simple"],
  "shapes-shape-circle-off": ["basic", "dot", "no simple", "ring"],
  "shapes-shape-hexagon": [
    "6",
    "basic",
    "bee",
    "honeycomb",
    "simple",
    "six",
    "tile"
  ],
  "shapes-shape-octogon": [
    "8",
    "alert",
    "basic",
    "eight",
    "sign",
    "simple",
    "stop"
  ],
  "shapes-shape-square": ["basic", "box", "simple"],
  "shapes-shape-square-off": [],
  "shapes-shape-triangle": ["alert", "basic", "danger", "simple", "warning"],
  "social-account-add": [
    "account",
    "add",
    "avatar",
    "new",
    "person",
    "photo",
    "user"
  ],
  "social-account-check": [
    "account",
    "avatar",
    "confirm",
    "inspect",
    "person",
    "photo",
    "user",
    "validate"
  ],
  "social-account-more": [
    "account",
    "actions",
    "additional",
    "avatar",
    "details",
    "information",
    "person",
    "photo",
    "user"
  ],
  "social-account-remove": [
    "account",
    "avatar",
    "delete",
    "person",
    "photo",
    "user"
  ],
  "social-award-ribbon": [
    "achievement",
    "certificate",
    "honor",
    "official",
    "prize",
    "reward",
    "win"
  ],
  "social-award-trophy": ["achievement", "honor", "prize", "reward", "win"],
  "social-baby": [
    "age",
    "care",
    "child",
    "father",
    "kid",
    "mother",
    "parents",
    "young"
  ],
  "social-bookmark": [
    "location",
    "mark",
    "note",
    "place",
    "position",
    "sash",
    "save"
  ],
  "social-bookmark-off": [
    "location",
    "mark",
    "note",
    "place",
    "position",
    "sash",
    "save"
  ],
  "social-chat-message": ["content", "speech bubble"],
  "social-chat-multi": ["conversation", "dialogue", "speech bubbles"],
  "social-chat-new": ["add", "new", "speech bubble"],
  "social-chat-single": ["empty", "speech bubble"],
  "social-chatbot": [
    "ai",
    "automation",
    "conversation",
    "llm",
    "replies",
    "reply",
    "smart",
    "virtual"
  ],
  "social-feeling-happy": [
    "emotion",
    "good",
    "positive",
    "rating",
    "satisfaction"
  ],
  "social-feeling-neutral": [
    "emotion",
    "neutral",
    "ok",
    "rating",
    "satisfaction"
  ],
  "social-feeling-sad": [
    "bad",
    "emotion",
    "negative",
    "poor",
    "rating",
    "satisfaction"
  ],
  "social-feeling-very-happy": [
    "emotion",
    "good",
    "positive",
    "rating",
    "satisfaction"
  ],
  "social-feeling-very-sad": [
    "bad",
    "emotion",
    "negative",
    "poor",
    "rating",
    "satisfaction"
  ],
  "social-founders": ["badge", "importance", "level"],
  "social-founders-tier-1": ["badge", "importance", "level"],
  "social-founders-tier-2": ["badge", "importance", "level"],
  "social-founders-tier-3": ["badge", "importance", "level"],
  "social-heart": ["favorite", "like", "rate", "rating", "romance", "save"],
  "social-heart-off": ["favorite", "like", "rate", "rating", "romance", "save"],
  "social-identification": [
    "badge",
    "card",
    "identity",
    "name",
    "photo",
    "security",
    "tag"
  ],
  "social-license": [
    "drivers",
    "identification",
    "identity",
    "legal",
    "name",
    "photo",
    "proof"
  ],
  "social-pin": ["keep", "present", "remember", "set", "thumbtack"],
  "social-pin-off": ["keep", "no thumbtack", "present", "remember", "set"],
  "social-profile": ["account", "avatar", "person", "photo", "user"],
  "social-profile-group": ["accounts", "avatars", "people", "photos", "users"],
  "social-profile-off": ["account", "avatar", "no user", "person", "photo"],
  "social-ranking-xp": ["badge", "experience", "level", "points", "skill"],
  "social-thumb-down": [
    "disapprove",
    "dislike",
    "negative",
    "opinion",
    "rate",
    "rating",
    "reject"
  ],
  "social-thumb-up": [
    "approve",
    "like",
    "opinion",
    "positive",
    "rate",
    "rating"
  ],
  "view-3-square-plus": [
    "add",
    "blocks",
    "four",
    "new",
    "quadrants",
    "sections",
    "split",
    "three"
  ],
  "view-4-square": ["blocks", "four", "quadrants", "sections", "split"],
  "view-apps": ["applications", "dashboard", "launcher"],
  "view-carousel-horizontal": [
    "billboard",
    "flow",
    "marquee",
    "order",
    "rotate"
  ],
  "view-carousel-vertical": ["billboard", "flow", "marquee", "order", "rotate"],
  "view-display-share": [
    "broadcast",
    "collaboration",
    "meeting",
    "screen",
    "send"
  ],
  "view-dual": [
    "draft",
    "final",
    "hybrid",
    "image",
    "landscape",
    "rough",
    "segmentation"
  ],
  "view-feedback": ["message", "speech bubble"],
  "view-fit-to-page": ["find", "look", "render", "search", "wysiwyg", "zoom"],
  "view-fullscreen": [
    "all",
    "bigger",
    "cover",
    "display",
    "enlarge",
    "fill",
    "maximize",
    "total"
  ],
  "view-fullscreen-exit": ["inset", "reduce", "restore", "smaller", "window"],
  "view-gallery-strip": ["browse", "images", "row", "thumbnails", "view"],
  "view-grip-area": ["drag", "grab", "region", "tactile"],
  "view-grip-corner": ["corner", "drag", "grab", "tactile"],
  "view-grip-edge-horizontal": ["drag", "grab", "strip", "tactile"],
  "view-grip-edge-vertical": ["drag", "grab", "strip", "tactile"],
  "view-grip-mini": ["drag", "grab", "strip", "tactile"],
  "view-layout-columns": ["grid", "template", "vertical"],
  "view-layout-detail": [
    "information",
    "list",
    "navigation",
    "panels",
    "sections"
  ],
  "view-layout-grid": ["blocks", "modules", "template"],
  "view-layout-list": ["grid", "template"],
  "view-layout-rows": ["grid", "horizontal", "template"],
  "view-map": ["draft", "rough", "segmentation"],
  "view-open-external": ["launch", "new", "outside", "share"],
  "view-pill-bar-stack": ["collection", "grouping", "properties", "tags"],
  "view-rectangle-group": ["areas", "arrange", "blocks", "gather", "sort"],
  "view-render": ["final", "hybrid", "image", "landscape"],
  "view-stack-horizontal": ["flow", "order", "overlay", "pile", "stack"],
  "view-window": ["application", "browser", "frame"],
  "view-window-code": [
    "developer",
    "ide",
    "integrated development environment"
  ],
  "view-window-grid": ["all up", "apps", "divided", "quadrants", "tiled"],
  "view-window-stack": [
    "applications",
    "apps",
    "collection",
    "group",
    "overlay"
  ],
  "view-window-terminal": [
    "cli",
    "command line interface",
    "console",
    "terminal"
  ],
  "view-workspace": [
    "applications",
    "apps",
    "desktop",
    "files",
    "job",
    "structure",
    "workflow"
  ],
  "view-workspace-group": [
    "applications",
    "apps",
    "collection",
    "desktop",
    "files",
    "job",
    "structure",
    "workflow"
  ]
}, S5e = [
  "av-camera-add",
  "av-forward-10",
  "av-reverse-10",
  "av-watch-party",
  "common-calendar-event",
  "common-check-multi-circle",
  "common-enter",
  "cursor-hourglass-end",
  "cursor-hourglass-mid",
  "cursor-hourglass-start",
  "editor-at-symbol",
  "editor-backspace",
  "editor-collapse",
  "editor-compare",
  "editor-connection",
  "editor-expand",
  "editor-header",
  "editor-markdown",
  "editor-numbers",
  "editor-pull-close",
  "editor-pull-draft",
  "editor-scissors",
  "editor-sort-ascending",
  "editor-sort-descending",
  "editor-typography",
  "files-document-checkmark",
  "hardware-headset",
  "hardware-phone-laptop",
  // normalization images-denoise -> image-denoise
  // "image-denoise",
  "maps-elevator",
  "maps-escalator",
  "maps-signpost",
  "maps-stair",
  "misc-car",
  "misc-checkmark-badge",
  "misc-circle-1-q",
  "misc-circle-2-q",
  "misc-circle-3-q",
  "misc-circle-tick",
  "misc-delivery-truck",
  "misc-graph-node-connect",
  "misc-graph-node-delete",
  "misc-infinity",
  "misc-lifebouy",
  "misc-man",
  "misc-man-woman",
  "misc-megaphone",
  "misc-money",
  "misc-money-coin",
  "misc-money-paper",
  "misc-pizza",
  "misc-prayer-room",
  "misc-projector",
  "misc-puzzle",
  "misc-sparkle",
  "misc-ticket",
  "misc-traffic-cone",
  "misc-wheelchair",
  "misc-woman",
  "shapes-arrow-left-right",
  "shapes-arrow-up-down",
  // normalization shape-diamond -> shapes-diamond
  // "shapes-diamond",
  // "shapes-diamond-off",
  "social-account-add",
  "social-account-check",
  "social-account-more",
  "social-account-remove",
  "social-baby",
  "social-chat-new",
  "social-chatbot",
  "social-identification",
  "social-license",
  "view-3-square-plus",
  "view-4-square",
  "view-carousel-horizontal",
  "view-carousel-vertical",
  "view-pill-bar-stack",
  "view-rectangle-group",
  "view-stack-horizontal"
], uie = "2.2.2", xie = "assets/icons", Rie = "brand-assets.cne.ngc.nvidia.com", k5e = (e, o) => `https://${Rie}/${xie}/${uie}/${o}/${e}.svg`;
export {
  Iie as AvAutoRecord,
  qie as AvAutoRecordOff,
  Zie as AvBroadcast,
  Nie as AvCamera,
  Wie as AvCameraAdd,
  Gie as AvCameraOff,
  Uie as AvClapBoard,
  Yie as AvDisplaySurround,
  Qie as AvEject,
  Kie as AvEqualizer,
  Xie as AvFaders,
  Jie as AvFastForward,
  e0e as AvFastReverse,
  n0e as AvFilm,
  l0e as AvFilmAdd,
  o0e as AvFilmCollection,
  i0e as AvForward10,
  r0e as AvFps,
  t0e as AvHighQuality,
  a0e as AvHud,
  d0e as AvLoop,
  s0e as AvLoopOff,
  h0e as AvMicrophone,
  c0e as AvMicrophoneOff,
  w0e as AvNext,
  v0e as AvNotes,
  f0e as AvPause,
  m0e as AvPictureInPicture,
  p0e as AvPlay,
  g0e as AvPrevious,
  u0e as AvRecord,
  R0e as AvReplay,
  x0e as AvReplayOff,
  j0e as AvReverse10,
  M0e as AvSoundwaves,
  L0e as AvSpeaker,
  H0e as AvSpeakerHigh,
  C0e as AvSpeakerLow,
  y0e as AvSpeakerMedium,
  b0e as AvSpeakerMute,
  V0e as AvSpeakerOff,
  z0e as AvStepForward,
  S0e as AvStepReverse,
  k0e as AvStop,
  $0e as AvVideocam,
  F0e as AvVideocamOff,
  B0e as AvWatchParty,
  E0e as CommonAdd,
  A0e as CommonAddCircle,
  _0e as CommonAlarm,
  D0e as CommonBell,
  O0e as CommonBellOff,
  T0e as CommonCalendar,
  P0e as CommonCalendarEvent,
  q0e as CommonCancel,
  W0e as CommonCheck,
  I0e as CommonCheckCircle,
  Z0e as CommonCheckMultiCircle,
  G0e as CommonClipboard,
  N0e as CommonClock,
  Y0e as CommonClose,
  U0e as CommonCloseCircle,
  K0e as CommonCog,
  Q0e as CommonCogOff,
  X0e as CommonCopyDoc,
  J0e as CommonCopyGeneric,
  ere as CommonEnter,
  lre as CommonError,
  ore as CommonExit,
  ire as CommonEye,
  nre as CommonEyeOff,
  rre as CommonFilter,
  tre as CommonHelpCircle,
  are as CommonHistory,
  dre as CommonHome,
  sre as CommonHomeOff,
  cre as CommonInfoCircle,
  wre as CommonLink,
  hre as CommonLinkBreak,
  vre as CommonLockClosed,
  fre as CommonLockOpen,
  gre as CommonMagnifyingGlass,
  mre as CommonMagnifyingGlassMinus,
  pre as CommonMagnifyingGlassPlus,
  ure as CommonMenu,
  xre as CommonMoreHoriz,
  Rre as CommonMoreVert,
  jre as CommonPaperplane,
  Mre as CommonRedo,
  Hre as CommonRefresh,
  Cre as CommonReset,
  yre as CommonRetry,
  bre as CommonShare,
  Vre as CommonSort,
  Lre as CommonStar,
  Sre as CommonSubtract,
  zre as CommonSubtractCircle,
  Fre as CommonSync,
  kre as CommonSyncOff,
  $re as CommonTimer,
  Bre as CommonTrash,
  Are as CommonUndo,
  Ere as CommonWarning,
  Ore as CommunicationCloud,
  _re as CommunicationCloudOff,
  Dre as CommunicationData,
  Pre as CommunicationDownload,
  qre as CommunicationEnvelope,
  Tre as CommunicationEnvelopeOff,
  Zre as CommunicationFirewall,
  Ire as CommunicationFirewallOff,
  Wre as CommunicationForward,
  Nre as CommunicationIsp,
  Gre as CommunicationIspOff,
  Yre as CommunicationNetworkSignal,
  Ure as CommunicationNetworkSignalOff,
  Qre as CommunicationReply,
  Kre as CommunicationSyncWarning,
  Xre as CommunicationTransferHorizontal,
  Jre as CommunicationTransferVertical,
  ete as CommunicationUpload,
  ote as CommunicationWifi,
  lte as CommunicationWifiOff,
  nte as CursorArrow,
  ite as CursorCrosshair,
  rte as CursorHandClosed,
  tte as CursorHandOpen,
  ate as CursorHandPinch,
  ste as CursorHandPoint,
  wte as CursorHourglass,
  dte as CursorHourglassEnd,
  cte as CursorHourglassMid,
  hte as CursorHourglassStart,
  vte as EditorAnchorCenter,
  fte as EditorAnchorE,
  mte as EditorAnchorN,
  pte as EditorAnchorNe,
  gte as EditorAnchorNw,
  ute as EditorAnchorS,
  xte as EditorAnchorSe,
  Rte as EditorAnchorSw,
  jte as EditorAnchorW,
  Mte as EditorAtSymbol,
  Hte as EditorBackspace,
  Cte as EditorBold,
  yte as EditorBranch,
  Fte as EditorChart,
  bte as EditorChartBar,
  Vte as EditorChartFlow,
  Lte as EditorChartHierarchy,
  zte as EditorChartPerformance,
  Ste as EditorChartPie,
  kte as EditorChartTree,
  $te as EditorCollapse,
  Bte as EditorCommit,
  Ate as EditorCompare,
  Ete as EditorConnection,
  _te as EditorExpand,
  Ote as EditorExportToClipboard,
  Dte as EditorFit,
  Pte as EditorFork,
  Tte as EditorFreehand,
  Ite as EditorGrid,
  qte as EditorGridOff,
  Zte as EditorHAlignCenter,
  Wte as EditorHAlignLeft,
  Gte as EditorHAlignRight,
  Nte as EditorHeader,
  Ute as EditorImage,
  Yte as EditorItalic,
  Qte as EditorIterate,
  Kte as EditorKeyframe,
  Jte as EditorLayers,
  Xte as EditorLayersOff,
  eae as EditorLineSegment,
  lae as EditorListBullet,
  oae as EditorListCheckmark,
  nae as EditorListNumber,
  iae as EditorMarkdown,
  rae as EditorMerge,
  tae as EditorMove,
  aae as EditorNumbers,
  sae as EditorPaperclip,
  dae as EditorParagraph,
  cae as EditorPencil,
  vae as EditorPull,
  hae as EditorPullClose,
  wae as EditorPullDraft,
  pae as EditorRotate,
  fae as EditorRotate90Clockwise,
  mae as EditorRotate90Counter,
  gae as EditorRuler,
  uae as EditorScaleDown,
  xae as EditorScaleReset,
  Rae as EditorScaleUp,
  jae as EditorScissors,
  Cae as EditorSection,
  Mae as EditorSectionBottom,
  Hae as EditorSectionTop,
  yae as EditorSelectBrush,
  bae as EditorSignature,
  Vae as EditorSkip,
  Lae as EditorSliders,
  zae as EditorSortAscending,
  Sae as EditorSortDescending,
  Aae as EditorSticker,
  kae as EditorStickerImage,
  Fae as EditorStickerShape,
  $ae as EditorStickerText,
  Bae as EditorStickerZoom,
  Eae as EditorStrikethrough,
  _ae as EditorStrokeWidth,
  Oae as EditorStyle,
  Dae as EditorSwatches,
  Wae as EditorText,
  Pae as EditorTextAlignCenter,
  Tae as EditorTextAlignFull,
  qae as EditorTextAlignLeft,
  Iae as EditorTextAlignRight,
  Zae as EditorTextFramed,
  Gae as EditorTrashDelete,
  Nae as EditorTypography,
  Uae as EditorUnderline,
  Yae as EditorVAlignBottom,
  Qae as EditorVAlignCenter,
  Kae as EditorVAlignTop,
  Xae as EditorWand,
  Jae as EditorWrench,
  ese as FilesArchive,
  lse as FilesDb,
  rse as FilesDocument,
  ose as FilesDocumentCheckmark,
  nse as FilesDocumentNew,
  ise as FilesDocumentPreview,
  tse as FilesExport,
  ase as FilesFloppy,
  sse as FilesFolderClosed,
  dse as FilesFolderOpen,
  cse as FilesImport,
  hse as Hardware2BLeftClick,
  vse as HardwareBattery0,
  wse as HardwareBattery0Off,
  fse as HardwareBattery100,
  mse as HardwareBattery25,
  pse as HardwareBattery50,
  gse as HardwareBattery75,
  use as HardwareBatteryBoost,
  xse as HardwareBatteryCharging,
  jse as HardwareBluetooth,
  Rse as HardwareBluetoothOff,
  Mse as HardwareCalculator,
  Hse as HardwareCpu,
  bse as HardwareDisplay,
  Cse as HardwareDisplayCollection,
  yse as HardwareDisplayOff,
  Lse as HardwareDriveCloud,
  Vse as HardwareDriveCloudOff,
  Sse as HardwareDriveNetwork,
  zse as HardwareDriveNetworkOff,
  Fse as HardwareDriveRemovable,
  kse as HardwareDriveRemovableOff,
  Bse as HardwareDriveUsb,
  $se as HardwareDriveUsbOff,
  Ase as HardwareEthernet,
  Ose as HardwareFan,
  Ese as HardwareFanLoud,
  _se as HardwareFanQuiet,
  Tse as HardwareGamepad,
  Dse as HardwareGamepadOff,
  Pse as HardwareGamepadStart,
  Gse as HardwareGpu,
  Zse as HardwareGpuCard,
  qse as HardwareGpuCardMulti,
  Ise as HardwareGpuCardOff,
  Wse as HardwareGpuOff,
  Nse as HardwareHeadset,
  Use as HardwareKeyboard,
  Yse as HardwareLaptop,
  Qse as HardwareLightning,
  Xse as HardwareMac,
  Kse as HardwareMacOff,
  Jse as HardwareMediaOptical,
  ede as HardwareMosaic,
  ode as HardwareMouse2B,
  lde as HardwareMouse2BRightClick,
  nde as HardwareMouse3B,
  rde as HardwareMouseScrollwheel,
  ide as HardwareMouseScrollwheelActive,
  tde as HardwareMultidrive,
  dde as HardwareNetwork,
  ade as HardwareNetworkConnection,
  sde as HardwareNetworkPcs,
  hde as HardwareNvidiaShield,
  cde as HardwareNvidiaShieldStand,
  wde as HardwarePerformanceHigh,
  vde as HardwarePerformanceLow,
  fde as HardwarePerformanceMedium,
  mde as HardwarePhoneLaptop,
  pde as HardwarePlugRecepticle,
  gde as HardwarePlugUsb,
  ude as HardwarePlugin,
  xde as HardwarePower,
  Rde as HardwareRam,
  jde as HardwareRemote,
  Mde as HardwareRobotArm,
  Hde as HardwareSdCard,
  yde as HardwareSmartphone,
  Cde as HardwareSmartphoneOff,
  Vde as HardwareTablet,
  bde as HardwareTabletOff,
  zde as HardwareTelephone,
  Lde as HardwareTelephoneOff,
  Sde as HardwareUsb,
  kde as HardwareVr,
  Fde as HardwareWatch,
  Ade as HardwareWebcam,
  $de as HardwareWebcamOff,
  Bde as HardwareWebcamSettings,
  Ede as HardwareWhispermode,
  Ode as HardwareWirelessModem,
  _de as HardwareWirelessModemOff,
  qde as HardwareWorkstation,
  Dde as HardwareWorkstationOff,
  Tde as HardwareWorkstationSystem,
  Pde as HardwareWorkstationSystemOff,
  gie as IconNames,
  z5e as IconTagMap,
  L5e as IconTags,
  Ide as ImageBrush,
  Zde as ImageBucket,
  Wde as ImageCamera360,
  Gde as ImageCameraLinked,
  Nde as ImageCameraSuper,
  Ude as ImageCollection,
  Yde as ImageCrop,
  Qde as ImageDenoise,
  Kde as ImageEasel,
  Xde as ImageEraser,
  Jde as ImageEyedropper,
  e2e as ImageGroup,
  l2e as ImageImportImage,
  o2e as ImageMaskInside,
  n2e as ImageMaskOutside,
  i2e as ImageMirror,
  r2e as ImageOutpainting,
  t2e as ImagePalette,
  d2e as ImageScale,
  s2e as ImageScaleRelative,
  a2e as ImageScaleRelativeOff,
  c2e as ImageSelectEllipse,
  h2e as ImageSelectPolygon,
  w2e as ImageSelectRectangle,
  v2e as ImageShapes,
  f2e as ImageSunHigh,
  m2e as ImageSunLow,
  p2e as ImageSunOffHigh,
  g2e as ImageTransparency,
  u2e as MapsAirplane,
  x2e as MapsBriefcase,
  R2e as MapsBush,
  j2e as MapsBusiness,
  M2e as MapsDirt,
  H2e as MapsElevator,
  C2e as MapsEscalator,
  y2e as MapsFactory,
  b2e as MapsFlag,
  V2e as MapsFlower,
  L2e as MapsFog,
  z2e as MapsGrass,
  S2e as MapsGravel,
  k2e as MapsHill,
  $2e as MapsLocation,
  F2e as MapsLocationOff,
  A2e as MapsMap,
  B2e as MapsMapOff,
  E2e as MapsMountain,
  _2e as MapsMud,
  O2e as MapsRiver,
  D2e as MapsRock,
  P2e as MapsSand,
  T2e as MapsSea,
  q2e as MapsSignpost,
  I2e as MapsSky,
  Z2e as MapsSnow,
  W2e as MapsStair,
  G2e as MapsStone,
  N2e as MapsStraw,
  U2e as MapsSuitcase,
  Y2e as MapsToolbox,
  Q2e as MapsTree,
  K2e as MapsTrees,
  X2e as MapsWater,
  ece as MapsWorld,
  J2e as MapsWorldOff,
  lce as MiscBandaid,
  oce as MiscBeaker,
  nce as MiscBlackboard,
  ice as MiscBook,
  tce as MiscBug,
  rce as MiscBugOff,
  ace as MiscCar,
  sce as MiscCheckmarkBadge,
  dce as MiscCircle1Q,
  cce as MiscCircle2Q,
  hce as MiscCircle3Q,
  wce as MiscCircleTick,
  vce as MiscCode,
  fce as MiscCompass,
  mce as MiscDeliveryTruck,
  pce as MiscEkg,
  gce as MiscFunction,
  uce as MiscGift,
  xce as MiscGraduate,
  Mce as MiscGraphNode,
  Rce as MiscGraphNodeConnect,
  jce as MiscGraphNodeDelete,
  Hce as MiscHealth,
  Cce as MiscHotAirBalloon,
  yce as MiscIme,
  bce as MiscInfinity,
  Vce as MiscKey,
  zce as MiscLibrary,
  Lce as MiscLibraryGames,
  Sce as MiscLifebouy,
  kce as MiscLightbulb,
  Fce as MiscMagnet,
  Bce as MiscMan,
  $ce as MiscManWoman,
  Ace as MiscMath,
  Ece as MiscMegaphone,
  _ce as MiscMicroscope,
  Oce as MiscModeComponent,
  Tce as MiscMoney,
  Dce as MiscMoneyCoin,
  Pce as MiscMoneyPaper,
  Ice as MiscMoon,
  qce as MiscMoonOff,
  Zce as MiscMug,
  Wce as MiscNeuralNetwork,
  Gce as MiscNews,
  Nce as MiscPackage,
  Uce as MiscPaymentCard,
  Yce as MiscPizza,
  Qce as MiscPrayerRoom,
  Kce as MiscProjector,
  Xce as MiscPulse,
  Jce as MiscPuzzle,
  ehe as MiscQrcode,
  lhe as MiscRadar,
  ohe as MiscRadioactive,
  nhe as MiscRocket,
  ihe as MiscRunning,
  rhe as MiscScaleBalance,
  the as MiscSchool,
  ahe as MiscSeed,
  she as MiscSensor,
  che as MiscShield,
  dhe as MiscShieldOff,
  hhe as MiscShipWheel,
  whe as MiscShoppingBag,
  vhe as MiscShoppingBasket,
  mhe as MiscShoppingCart,
  fhe as MiscShoppingCartOpen,
  phe as MiscSparkle,
  uhe as MiscTag,
  ghe as MiscTagLabel,
  xhe as MiscTelescope,
  Rhe as MiscThermometer,
  jhe as MiscTicket,
  Mhe as MiscTrafficCone,
  Che as MiscWeight,
  Hhe as MiscWeightBar,
  yhe as MiscWheelchair,
  bhe as MiscWoman,
  S5e as NewIcons,
  She as ShapesArrowDown,
  Vhe as ShapesArrowDownLeft,
  Lhe as ShapesArrowDownMax,
  zhe as ShapesArrowDownRight,
  $he as ShapesArrowLeft,
  khe as ShapesArrowLeftMax,
  Fhe as ShapesArrowLeftRight,
  Ahe as ShapesArrowRight,
  Bhe as ShapesArrowRightMax,
  Phe as ShapesArrowUp,
  Ehe as ShapesArrowUpDown,
  _he as ShapesArrowUpLeft,
  Ohe as ShapesArrowUpMax,
  Dhe as ShapesArrowUpRight,
  The as ShapesChevronDoubleDown,
  qhe as ShapesChevronDoubleLeft,
  Ihe as ShapesChevronDoubleRight,
  Zhe as ShapesChevronDoubleUp,
  Ghe as ShapesChevronDown,
  Whe as ShapesChevronDownLeftUpRight,
  Uhe as ShapesChevronLeft,
  Nhe as ShapesChevronLeftRight,
  Yhe as ShapesChevronRight,
  Xhe as ShapesChevronUp,
  Qhe as ShapesChevronUpDown,
  Khe as ShapesChevronUpLeftDownRight,
  e3e as ShapesDiamond,
  Jhe as ShapesDiamondOff,
  l3e as ShapesReturn,
  n3e as ShapesShapeCircle,
  o3e as ShapesShapeCircleOff,
  i3e as ShapesShapeHexagon,
  r3e as ShapesShapeOctogon,
  a3e as ShapesShapeSquare,
  t3e as ShapesShapeSquareOff,
  s3e as ShapesShapeTriangle,
  d3e as SocialAccountAdd,
  c3e as SocialAccountCheck,
  h3e as SocialAccountMore,
  w3e as SocialAccountRemove,
  v3e as SocialAwardRibbon,
  f3e as SocialAwardTrophy,
  m3e as SocialBaby,
  g3e as SocialBookmark,
  p3e as SocialBookmarkOff,
  u3e as SocialChatMessage,
  x3e as SocialChatMulti,
  R3e as SocialChatNew,
  j3e as SocialChatSingle,
  M3e as SocialChatbot,
  H3e as SocialFeelingHappy,
  C3e as SocialFeelingNeutral,
  y3e as SocialFeelingSad,
  b3e as SocialFeelingVeryHappy,
  V3e as SocialFeelingVerySad,
  k3e as SocialFounders,
  L3e as SocialFoundersTier1,
  z3e as SocialFoundersTier2,
  S3e as SocialFoundersTier3,
  $3e as SocialHeart,
  F3e as SocialHeartOff,
  B3e as SocialIdentification,
  A3e as SocialLicense,
  _3e as SocialPin,
  E3e as SocialPinOff,
  P3e as SocialProfile,
  O3e as SocialProfileGroup,
  D3e as SocialProfileOff,
  T3e as SocialRankingXp,
  q3e as SocialThumbDown,
  I3e as SocialThumbUp,
  jie as Svg3D3DAxis,
  Mie as Svg3DCloth,
  Hie as Svg3DCube,
  Cie as Svg3DDolly,
  yie as Svg3DEmissive,
  bie as Svg3DExplode,
  Vie as Svg3DInstance,
  Lie as Svg3DLightRect,
  zie as Svg3DLightRotate,
  Sie as Svg3DMaterial,
  kie as Svg3DMoveGlobal,
  Fie as Svg3DReference,
  $ie as Svg3DRotate3D,
  Bie as Svg3DRotateGlobal,
  Aie as Svg3DSegment,
  _ie as Svg3DShader,
  Eie as Svg3DShaderBall,
  Oie as Svg3DSkeleton,
  Die as Svg3DTeapot,
  Pie as Svg3DTeleport,
  Tie as Svg3DTexture,
  Z3e as View3SquarePlus,
  W3e as View4Square,
  G3e as ViewApps,
  N3e as ViewCarouselHorizontal,
  U3e as ViewCarouselVertical,
  Y3e as ViewDisplayShare,
  Q3e as ViewDual,
  K3e as ViewFeedback,
  X3e as ViewFitToPage,
  e5e as ViewFullscreen,
  J3e as ViewFullscreenExit,
  l5e as ViewGalleryStrip,
  o5e as ViewGripArea,
  n5e as ViewGripCorner,
  i5e as ViewGripEdgeHorizontal,
  r5e as ViewGripEdgeVertical,
  t5e as ViewGripMini,
  a5e as ViewLayoutColumns,
  s5e as ViewLayoutDetail,
  d5e as ViewLayoutGrid,
  c5e as ViewLayoutList,
  h5e as ViewLayoutRows,
  w5e as ViewMap,
  v5e as ViewOpenExternal,
  f5e as ViewPillBarStack,
  m5e as ViewRectangleGroup,
  p5e as ViewRender,
  g5e as ViewStackHorizontal,
  M5e as ViewWindow,
  u5e as ViewWindowCode,
  x5e as ViewWindowGrid,
  R5e as ViewWindowStack,
  j5e as ViewWindowTerminal,
  C5e as ViewWorkspace,
  H5e as ViewWorkspaceGroup,
  V5e as getCategory,
  b5e as getName,
  k5e as iconNameToURL,
  y5e as isIconName
};
